
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire477f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire477f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1w3iG", function(module, exports) {
module.exports = import("4UhOE").then(()=>parcelRequire('eWCnu'));

});

parcelRegister("9YdkG", function(module, exports) {
module.exports = import("f6wym").then(()=>parcelRequire('4hXHW'));

});

parcelRegister("aQoU1", function(module, exports) {
module.exports = import("6WaZd").then(()=>parcelRequire('YbPvx'));

});

parcelRegister("hzrbh", function(module, exports) {
module.exports = import("iPVtH").then(()=>parcelRequire('kcqGg'));

});

parcelRegister("lF5JF", function(module, exports) {
module.exports = import("k3uqD").then(()=>parcelRequire('e5bKi'));

});

parcelRegister("iXU3J", function(module, exports) {
module.exports = import("8JmQi").then(()=>parcelRequire('9woOh'));

});

parcelRegister("2A9Ys", function(module, exports) {
module.exports = import("lv4v7").then(()=>parcelRequire('gUHZP'));

});

parcelRegister("4txnj", function(module, exports) {
module.exports = import("bXrbs").then(()=>parcelRequire('jgoaH'));

});

parcelRegister("4L4zI", function(module, exports) {
module.exports = import("dphcD").then(()=>parcelRequire('kM4BM'));

});

parcelRegister("gWhDP", function(module, exports) {
module.exports = import("bPjDu").then(()=>parcelRequire('hkX0i'));

});

parcelRegister("89S4Q", function(module, exports) {
module.exports = import("jBpoG").then(()=>parcelRequire('an0pl'));

});

parcelRegister("2ou14", function(module, exports) {
module.exports = import("b3fhB").then(()=>parcelRequire('5wn9A'));

});

parcelRegister("dopJd", function(module, exports) {
module.exports = Promise.all([
    import("gZdpT"),
    import("ikmEj")
]).then(()=>parcelRequire('7ZYQ0'));

});

parcelRegister("br9et", function(module, exports) {
module.exports = import("gZdpT").then(()=>parcelRequire('5uBnt'));

});

parcelRegister("1NPpz", function(module, exports) {
module.exports = import("2BlOa").then(()=>parcelRequire('ka41K'));

});

parcelRegister("juElA", function(module, exports) {
module.exports = Promise.all([
    import("2BlOa"),
    import("8mMk9")
]).then(()=>parcelRequire('fbRR2'));

});

parcelRegister("hurMy", function(module, exports) {
module.exports = Promise.all([
    import("2BlOa"),
    import("6gomB")
]).then(()=>parcelRequire('fSRel'));

});

parcelRegister("29OTa", function(module, exports) {
module.exports = import("lrn6H").then(()=>parcelRequire('doY6r'));

});

parcelRegister("hsnp5", function(module, exports) {
module.exports = import("3vDBZ").then(()=>parcelRequire('bEcHv'));

});

parcelRegister("aiMqA", function(module, exports) {
module.exports = import("axPWZ").then(()=>parcelRequire('7nZJU'));

});

parcelRegister("gU2yy", function(module, exports) {
module.exports = import("8LTzO").then(()=>parcelRequire('10lm7'));

});

parcelRegister("9adXA", function(module, exports) {
module.exports = Promise.all([
    import("b3fhB"),
    import("2SHyA")
]).then(()=>parcelRequire('etDXy'));

});

parcelRegister("1l09q", function(module, exports) {

$parcel$export(module.exports, "ROM", () => $0f97de98c68d8a49$export$c643cc54d6326a6f);
/**
 * Represents a chip ROM with basic registers field and abstract functions.
 */ class $0f97de98c68d8a49$export$c643cc54d6326a6f {
    /**
     * Get the chip erase size.
     * @param {number} offset - Offset to start erase.
     * @param {number} size - Size to erase.
     * @returns {number} The erase size of the chip as number.
     */ getEraseSize(offset, size) {
        return size;
    }
}

});

parcelRegister("cgCz9", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("dOqqi")), (parcelRequire("dkHeo")), (parcelRequire("33Dov")), (parcelRequire("4Gs7i")), (parcelRequire("3v7ey")), (parcelRequire("9xtq3")), (parcelRequire("dCBbD")), (parcelRequire("ch0KT")), (parcelRequire("QV0jx")), (parcelRequire("9jPYZ")), (parcelRequire("1z9jS")), (parcelRequire("k6BGg")), (parcelRequire("6gSsW")), (parcelRequire("4QIA3")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")), (parcelRequire("jl5kK")), (parcelRequire("5F0ko")), (parcelRequire("lxABR")), (parcelRequire("2Qhlr")), (parcelRequire("dITey")), (parcelRequire("cVYKW")), (parcelRequire("2MnMp")), (parcelRequire("5n9UW")), (parcelRequire("2X3cT")), (parcelRequire("fXAPg")), (parcelRequire("6AdsH")), (parcelRequire("52GAb")), (parcelRequire("fWyuT")), (parcelRequire("8A2QT")), (parcelRequire("4lLjY")), (parcelRequire("iHWrV")), (parcelRequire("en8DC")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("jN34i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dkHeo", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("4Gs7i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("3v7ey", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("9xtq3", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("ch0KT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("QV0jx", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("9jPYZ", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("QV0jx")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("1z9jS", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("k6BGg", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("4QIA3", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("8fUCE", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("9xtq3")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("lgRCb", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("8fUCE")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == 'string') return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("jl5kK", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("5F0ko", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("lxABR", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("2Qhlr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("dITey", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cVYKW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("2MnMp", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("5n9UW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("2X3cT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("fXAPg", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("6AdsH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("52GAb", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("fWyuT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("8A2QT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("4lLjY", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("iHWrV", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("en8DC", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


// ═══════════════════════════════════════════════════════════
// ESP Tool – Main Application
// ═══════════════════════════════════════════════════════════
/**
 * Represents a Espressif chip error.
 */ class $2c3fa0bce65af7c3$export$5b519f82636185ec extends Error {
}
/**
 * Represents a Espressif timeout chip error.
 */ class $2c3fa0bce65af7c3$export$66d311bf29d5c89c extends $2c3fa0bce65af7c3$export$5b519f82636185ec {
}


/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $d39304d744af7f63$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $d39304d744af7f63$var$Z_BINARY = 0;
const $d39304d744af7f63$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $d39304d744af7f63$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $d39304d744af7f63$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $d39304d744af7f63$var$STORED_BLOCK = 0;
const $d39304d744af7f63$var$STATIC_TREES = 1;
const $d39304d744af7f63$var$DYN_TREES = 2;
/* The three kinds of block type */ const $d39304d744af7f63$var$MIN_MATCH$1 = 3;
const $d39304d744af7f63$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $d39304d744af7f63$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $d39304d744af7f63$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $d39304d744af7f63$var$L_CODES$1 = $d39304d744af7f63$var$LITERALS$1 + 1 + $d39304d744af7f63$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $d39304d744af7f63$var$D_CODES$1 = 30;
/* number of distance codes */ const $d39304d744af7f63$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $d39304d744af7f63$var$HEAP_SIZE$1 = 2 * $d39304d744af7f63$var$L_CODES$1 + 1;
/* maximum heap size */ const $d39304d744af7f63$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $d39304d744af7f63$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $d39304d744af7f63$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $d39304d744af7f63$var$END_BLOCK = 256;
/* end of block literal code */ const $d39304d744af7f63$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $d39304d744af7f63$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $d39304d744af7f63$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $d39304d744af7f63$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $d39304d744af7f63$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $d39304d744af7f63$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $d39304d744af7f63$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $d39304d744af7f63$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $d39304d744af7f63$var$static_ltree = new Array(($d39304d744af7f63$var$L_CODES$1 + 2) * 2);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $d39304d744af7f63$var$static_dtree = new Array($d39304d744af7f63$var$D_CODES$1 * 2);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $d39304d744af7f63$var$_dist_code = new Array($d39304d744af7f63$var$DIST_CODE_LEN);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $d39304d744af7f63$var$_length_code = new Array($d39304d744af7f63$var$MAX_MATCH$1 - $d39304d744af7f63$var$MIN_MATCH$1 + 1);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $d39304d744af7f63$var$base_length = new Array($d39304d744af7f63$var$LENGTH_CODES$1);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $d39304d744af7f63$var$base_dist = new Array($d39304d744af7f63$var$D_CODES$1);
$d39304d744af7f63$var$zero$1($d39304d744af7f63$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $d39304d744af7f63$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $d39304d744af7f63$var$static_l_desc;
let $d39304d744af7f63$var$static_d_desc;
let $d39304d744af7f63$var$static_bl_desc;
function $d39304d744af7f63$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $d39304d744af7f63$var$d_code = (dist)=>{
    return dist < 256 ? $d39304d744af7f63$var$_dist_code[dist] : $d39304d744af7f63$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $d39304d744af7f63$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $d39304d744af7f63$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $d39304d744af7f63$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $d39304d744af7f63$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $d39304d744af7f63$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $d39304d744af7f63$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $d39304d744af7f63$var$send_code = (s, c, tree)=>{
    $d39304d744af7f63$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $d39304d744af7f63$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $d39304d744af7f63$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $d39304d744af7f63$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $d39304d744af7f63$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $d39304d744af7f63$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $d39304d744af7f63$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $d39304d744af7f63$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($d39304d744af7f63$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $d39304d744af7f63$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $d39304d744af7f63$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $d39304d744af7f63$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($d39304d744af7f63$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $d39304d744af7f63$var$LENGTH_CODES$1 - 1; code++){
        $d39304d744af7f63$var$base_length[code] = length;
        for(n = 0; n < 1 << $d39304d744af7f63$var$extra_lbits[code]; n++)$d39304d744af7f63$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $d39304d744af7f63$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $d39304d744af7f63$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $d39304d744af7f63$var$extra_dbits[code]; n++)$d39304d744af7f63$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $d39304d744af7f63$var$D_CODES$1; code++){
        $d39304d744af7f63$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $d39304d744af7f63$var$extra_dbits[code] - 7; n++)$d39304d744af7f63$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $d39304d744af7f63$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $d39304d744af7f63$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $d39304d744af7f63$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $d39304d744af7f63$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $d39304d744af7f63$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $d39304d744af7f63$var$gen_codes($d39304d744af7f63$var$static_ltree, $d39304d744af7f63$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $d39304d744af7f63$var$D_CODES$1; n++){
        $d39304d744af7f63$var$static_dtree[n * 2 + 1] = 5;
        $d39304d744af7f63$var$static_dtree[n * 2] = $d39304d744af7f63$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $d39304d744af7f63$var$static_l_desc = new $d39304d744af7f63$var$StaticTreeDesc($d39304d744af7f63$var$static_ltree, $d39304d744af7f63$var$extra_lbits, $d39304d744af7f63$var$LITERALS$1 + 1, $d39304d744af7f63$var$L_CODES$1, $d39304d744af7f63$var$MAX_BITS$1);
    $d39304d744af7f63$var$static_d_desc = new $d39304d744af7f63$var$StaticTreeDesc($d39304d744af7f63$var$static_dtree, $d39304d744af7f63$var$extra_dbits, 0, $d39304d744af7f63$var$D_CODES$1, $d39304d744af7f63$var$MAX_BITS$1);
    $d39304d744af7f63$var$static_bl_desc = new $d39304d744af7f63$var$StaticTreeDesc(new Array(0), $d39304d744af7f63$var$extra_blbits, 0, $d39304d744af7f63$var$BL_CODES$1, $d39304d744af7f63$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $d39304d744af7f63$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $d39304d744af7f63$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $d39304d744af7f63$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $d39304d744af7f63$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$d39304d744af7f63$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $d39304d744af7f63$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $d39304d744af7f63$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $d39304d744af7f63$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $d39304d744af7f63$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $d39304d744af7f63$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($d39304d744af7f63$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $d39304d744af7f63$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $d39304d744af7f63$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $d39304d744af7f63$var$_length_code[lc];
            $d39304d744af7f63$var$send_code(s, code + $d39304d744af7f63$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $d39304d744af7f63$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $d39304d744af7f63$var$base_length[code];
                $d39304d744af7f63$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $d39304d744af7f63$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $d39304d744af7f63$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $d39304d744af7f63$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $d39304d744af7f63$var$base_dist[code];
                $d39304d744af7f63$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $d39304d744af7f63$var$send_code(s, $d39304d744af7f63$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $d39304d744af7f63$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $d39304d744af7f63$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$d39304d744af7f63$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $d39304d744af7f63$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $d39304d744af7f63$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $d39304d744af7f63$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $d39304d744af7f63$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $d39304d744af7f63$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$d39304d744af7f63$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$d39304d744af7f63$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$d39304d744af7f63$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $d39304d744af7f63$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $d39304d744af7f63$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $d39304d744af7f63$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $d39304d744af7f63$var$send_code(s, $d39304d744af7f63$var$REP_3_6, s.bl_tree);
            $d39304d744af7f63$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $d39304d744af7f63$var$send_code(s, $d39304d744af7f63$var$REPZ_3_10, s.bl_tree);
            $d39304d744af7f63$var$send_bits(s, count - 3, 3);
        } else {
            $d39304d744af7f63$var$send_code(s, $d39304d744af7f63$var$REPZ_11_138, s.bl_tree);
            $d39304d744af7f63$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $d39304d744af7f63$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $d39304d744af7f63$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $d39304d744af7f63$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $d39304d744af7f63$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $d39304d744af7f63$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$d39304d744af7f63$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $d39304d744af7f63$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $d39304d744af7f63$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $d39304d744af7f63$var$send_bits(s, dcodes - 1, 5);
    $d39304d744af7f63$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $d39304d744af7f63$var$send_bits(s, s.bl_tree[$d39304d744af7f63$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $d39304d744af7f63$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $d39304d744af7f63$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $d39304d744af7f63$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $d39304d744af7f63$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $d39304d744af7f63$var$Z_TEXT;
    for(n = 32; n < $d39304d744af7f63$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $d39304d744af7f63$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $d39304d744af7f63$var$Z_BINARY;
};
let $d39304d744af7f63$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $d39304d744af7f63$var$_tr_init$1 = (s)=>{
    if (!$d39304d744af7f63$var$static_init_done) {
        $d39304d744af7f63$var$tr_static_init();
        $d39304d744af7f63$var$static_init_done = true;
    }
    s.l_desc = new $d39304d744af7f63$var$TreeDesc(s.dyn_ltree, $d39304d744af7f63$var$static_l_desc);
    s.d_desc = new $d39304d744af7f63$var$TreeDesc(s.dyn_dtree, $d39304d744af7f63$var$static_d_desc);
    s.bl_desc = new $d39304d744af7f63$var$TreeDesc(s.bl_tree, $d39304d744af7f63$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $d39304d744af7f63$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $d39304d744af7f63$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $d39304d744af7f63$var$send_bits(s, ($d39304d744af7f63$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $d39304d744af7f63$var$bi_windup(s); /* align on byte boundary */ 
    $d39304d744af7f63$var$put_short(s, stored_len);
    $d39304d744af7f63$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $d39304d744af7f63$var$_tr_align$1 = (s)=>{
    $d39304d744af7f63$var$send_bits(s, $d39304d744af7f63$var$STATIC_TREES << 1, 3);
    $d39304d744af7f63$var$send_code(s, $d39304d744af7f63$var$END_BLOCK, $d39304d744af7f63$var$static_ltree);
    $d39304d744af7f63$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $d39304d744af7f63$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $d39304d744af7f63$var$Z_UNKNOWN$1) s.strm.data_type = $d39304d744af7f63$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $d39304d744af7f63$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $d39304d744af7f63$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $d39304d744af7f63$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $d39304d744af7f63$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $d39304d744af7f63$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $d39304d744af7f63$var$send_bits(s, ($d39304d744af7f63$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $d39304d744af7f63$var$compress_block(s, $d39304d744af7f63$var$static_ltree, $d39304d744af7f63$var$static_dtree);
    } else {
        $d39304d744af7f63$var$send_bits(s, ($d39304d744af7f63$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $d39304d744af7f63$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $d39304d744af7f63$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $d39304d744af7f63$var$init_block(s);
    if (last) $d39304d744af7f63$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $d39304d744af7f63$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($d39304d744af7f63$var$_length_code[lc] + $d39304d744af7f63$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$d39304d744af7f63$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $d39304d744af7f63$var$_tr_init_1 = $d39304d744af7f63$var$_tr_init$1;
var $d39304d744af7f63$var$_tr_stored_block_1 = $d39304d744af7f63$var$_tr_stored_block$1;
var $d39304d744af7f63$var$_tr_flush_block_1 = $d39304d744af7f63$var$_tr_flush_block$1;
var $d39304d744af7f63$var$_tr_tally_1 = $d39304d744af7f63$var$_tr_tally$1;
var $d39304d744af7f63$var$_tr_align_1 = $d39304d744af7f63$var$_tr_align$1;
var $d39304d744af7f63$var$trees = {
    _tr_init: $d39304d744af7f63$var$_tr_init_1,
    _tr_stored_block: $d39304d744af7f63$var$_tr_stored_block_1,
    _tr_flush_block: $d39304d744af7f63$var$_tr_flush_block_1,
    _tr_tally: $d39304d744af7f63$var$_tr_tally_1,
    _tr_align: $d39304d744af7f63$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $d39304d744af7f63$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $d39304d744af7f63$var$adler32_1 = $d39304d744af7f63$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $d39304d744af7f63$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $d39304d744af7f63$var$crcTable = new Uint32Array($d39304d744af7f63$var$makeTable());
const $d39304d744af7f63$var$crc32 = (crc, buf, len, pos)=>{
    const t = $d39304d744af7f63$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $d39304d744af7f63$var$crc32_1 = $d39304d744af7f63$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $d39304d744af7f63$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $d39304d744af7f63$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $d39304d744af7f63$var$_tr_init, _tr_stored_block: $d39304d744af7f63$var$_tr_stored_block, _tr_flush_block: $d39304d744af7f63$var$_tr_flush_block, _tr_tally: $d39304d744af7f63$var$_tr_tally, _tr_align: $d39304d744af7f63$var$_tr_align } = $d39304d744af7f63$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $d39304d744af7f63$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $d39304d744af7f63$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $d39304d744af7f63$var$Z_FULL_FLUSH$1, Z_FINISH: $d39304d744af7f63$var$Z_FINISH$3, Z_BLOCK: $d39304d744af7f63$var$Z_BLOCK$1, Z_OK: $d39304d744af7f63$var$Z_OK$3, Z_STREAM_END: $d39304d744af7f63$var$Z_STREAM_END$3, Z_STREAM_ERROR: $d39304d744af7f63$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $d39304d744af7f63$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $d39304d744af7f63$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $d39304d744af7f63$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $d39304d744af7f63$var$Z_FILTERED, Z_HUFFMAN_ONLY: $d39304d744af7f63$var$Z_HUFFMAN_ONLY, Z_RLE: $d39304d744af7f63$var$Z_RLE, Z_FIXED: $d39304d744af7f63$var$Z_FIXED, Z_DEFAULT_STRATEGY: $d39304d744af7f63$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $d39304d744af7f63$var$Z_UNKNOWN, Z_DEFLATED: $d39304d744af7f63$var$Z_DEFLATED$2 } = $d39304d744af7f63$var$constants$2;
/*============================================================================*/ const $d39304d744af7f63$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $d39304d744af7f63$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $d39304d744af7f63$var$DEF_MEM_LEVEL = 8;
const $d39304d744af7f63$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $d39304d744af7f63$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $d39304d744af7f63$var$L_CODES = $d39304d744af7f63$var$LITERALS + 1 + $d39304d744af7f63$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $d39304d744af7f63$var$D_CODES = 30;
/* number of distance codes */ const $d39304d744af7f63$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $d39304d744af7f63$var$HEAP_SIZE = 2 * $d39304d744af7f63$var$L_CODES + 1;
/* maximum heap size */ const $d39304d744af7f63$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $d39304d744af7f63$var$MIN_MATCH = 3;
const $d39304d744af7f63$var$MAX_MATCH = 258;
const $d39304d744af7f63$var$MIN_LOOKAHEAD = $d39304d744af7f63$var$MAX_MATCH + $d39304d744af7f63$var$MIN_MATCH + 1;
const $d39304d744af7f63$var$PRESET_DICT = 0x20;
const $d39304d744af7f63$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $d39304d744af7f63$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $d39304d744af7f63$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $d39304d744af7f63$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $d39304d744af7f63$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $d39304d744af7f63$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $d39304d744af7f63$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $d39304d744af7f63$var$FINISH_STATE = 666; /* stream complete */ 
const $d39304d744af7f63$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $d39304d744af7f63$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $d39304d744af7f63$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $d39304d744af7f63$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $d39304d744af7f63$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $d39304d744af7f63$var$err = (strm, errorCode)=>{
    strm.msg = $d39304d744af7f63$var$messages[errorCode];
    return errorCode;
};
const $d39304d744af7f63$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $d39304d744af7f63$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $d39304d744af7f63$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $d39304d744af7f63$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $d39304d744af7f63$var$HASH = $d39304d744af7f63$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $d39304d744af7f63$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $d39304d744af7f63$var$flush_block_only = (s, last)=>{
    $d39304d744af7f63$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $d39304d744af7f63$var$flush_pending(s.strm);
};
const $d39304d744af7f63$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $d39304d744af7f63$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $d39304d744af7f63$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $d39304d744af7f63$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $d39304d744af7f63$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $d39304d744af7f63$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $d39304d744af7f63$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $d39304d744af7f63$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $d39304d744af7f63$var$MAX_MATCH - (strend - scan);
        scan = strend - $d39304d744af7f63$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $d39304d744af7f63$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $d39304d744af7f63$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $d39304d744af7f63$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $d39304d744af7f63$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $d39304d744af7f63$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[str + $d39304d744af7f63$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $d39304d744af7f63$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $d39304d744af7f63$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $d39304d744af7f63$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $d39304d744af7f63$var$Z_FINISH$3 || flush === $d39304d744af7f63$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $d39304d744af7f63$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $d39304d744af7f63$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $d39304d744af7f63$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $d39304d744af7f63$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $d39304d744af7f63$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $d39304d744af7f63$var$Z_NO_FLUSH$2 && flush !== $d39304d744af7f63$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $d39304d744af7f63$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $d39304d744af7f63$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $d39304d744af7f63$var$Z_FINISH$3) && flush !== $d39304d744af7f63$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $d39304d744af7f63$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $d39304d744af7f63$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $d39304d744af7f63$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $d39304d744af7f63$var$BS_FINISH_STARTED : $d39304d744af7f63$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $d39304d744af7f63$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $d39304d744af7f63$var$MIN_LOOKAHEAD) {
            $d39304d744af7f63$var$fill_window(s);
            if (s.lookahead < $d39304d744af7f63$var$MIN_LOOKAHEAD && flush === $d39304d744af7f63$var$Z_NO_FLUSH$2) return $d39304d744af7f63$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $d39304d744af7f63$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[s.strstart + $d39304d744af7f63$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $d39304d744af7f63$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $d39304d744af7f63$var$longest_match(s, hash_head);
        if (s.match_length >= $d39304d744af7f63$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $d39304d744af7f63$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $d39304d744af7f63$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[s.strstart + $d39304d744af7f63$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $d39304d744af7f63$var$MIN_MATCH - 1 ? s.strstart : $d39304d744af7f63$var$MIN_MATCH - 1;
    if (flush === $d39304d744af7f63$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $d39304d744af7f63$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_FINISH_STARTED;
        /***/ return $d39304d744af7f63$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
    /***/ }
    return $d39304d744af7f63$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $d39304d744af7f63$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $d39304d744af7f63$var$MIN_LOOKAHEAD) {
            $d39304d744af7f63$var$fill_window(s);
            if (s.lookahead < $d39304d744af7f63$var$MIN_LOOKAHEAD && flush === $d39304d744af7f63$var$Z_NO_FLUSH$2) return $d39304d744af7f63$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $d39304d744af7f63$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[s.strstart + $d39304d744af7f63$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $d39304d744af7f63$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $d39304d744af7f63$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $d39304d744af7f63$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $d39304d744af7f63$var$Z_FILTERED || s.match_length === $d39304d744af7f63$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $d39304d744af7f63$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $d39304d744af7f63$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $d39304d744af7f63$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $d39304d744af7f63$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $d39304d744af7f63$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[s.strstart + $d39304d744af7f63$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $d39304d744af7f63$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $d39304d744af7f63$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $d39304d744af7f63$var$MIN_MATCH - 1 ? s.strstart : $d39304d744af7f63$var$MIN_MATCH - 1;
    if (flush === $d39304d744af7f63$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $d39304d744af7f63$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_FINISH_STARTED;
        /***/ return $d39304d744af7f63$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
    /***/ }
    return $d39304d744af7f63$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $d39304d744af7f63$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $d39304d744af7f63$var$MAX_MATCH) {
            $d39304d744af7f63$var$fill_window(s);
            if (s.lookahead <= $d39304d744af7f63$var$MAX_MATCH && flush === $d39304d744af7f63$var$Z_NO_FLUSH$2) return $d39304d744af7f63$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $d39304d744af7f63$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $d39304d744af7f63$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $d39304d744af7f63$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $d39304d744af7f63$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 1, s.match_length - $d39304d744af7f63$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $d39304d744af7f63$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $d39304d744af7f63$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_FINISH_STARTED;
        /***/ return $d39304d744af7f63$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
    /***/ }
    return $d39304d744af7f63$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $d39304d744af7f63$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $d39304d744af7f63$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $d39304d744af7f63$var$Z_NO_FLUSH$2) return $d39304d744af7f63$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $d39304d744af7f63$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $d39304d744af7f63$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $d39304d744af7f63$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_FINISH_STARTED;
        /***/ return $d39304d744af7f63$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $d39304d744af7f63$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $d39304d744af7f63$var$BS_NEED_MORE;
    /***/ }
    return $d39304d744af7f63$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $d39304d744af7f63$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $d39304d744af7f63$var$configuration_table = [
    /*      good lazy nice chain */ new $d39304d744af7f63$var$Config(0, 0, 0, 0, $d39304d744af7f63$var$deflate_stored),
    /* 0 store only */ new $d39304d744af7f63$var$Config(4, 4, 8, 4, $d39304d744af7f63$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $d39304d744af7f63$var$Config(4, 5, 16, 8, $d39304d744af7f63$var$deflate_fast),
    /* 2 */ new $d39304d744af7f63$var$Config(4, 6, 32, 32, $d39304d744af7f63$var$deflate_fast),
    /* 3 */ new $d39304d744af7f63$var$Config(4, 4, 16, 16, $d39304d744af7f63$var$deflate_slow),
    /* 4 lazy matches */ new $d39304d744af7f63$var$Config(8, 16, 32, 32, $d39304d744af7f63$var$deflate_slow),
    /* 5 */ new $d39304d744af7f63$var$Config(8, 16, 128, 128, $d39304d744af7f63$var$deflate_slow),
    /* 6 */ new $d39304d744af7f63$var$Config(8, 32, 128, 256, $d39304d744af7f63$var$deflate_slow),
    /* 7 */ new $d39304d744af7f63$var$Config(32, 128, 258, 1024, $d39304d744af7f63$var$deflate_slow),
    /* 8 */ new $d39304d744af7f63$var$Config(32, 258, 258, 4096, $d39304d744af7f63$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $d39304d744af7f63$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $d39304d744af7f63$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $d39304d744af7f63$var$configuration_table[s.level].max_lazy;
    s.good_match = $d39304d744af7f63$var$configuration_table[s.level].good_length;
    s.nice_match = $d39304d744af7f63$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $d39304d744af7f63$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $d39304d744af7f63$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $d39304d744af7f63$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $d39304d744af7f63$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($d39304d744af7f63$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $d39304d744af7f63$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $d39304d744af7f63$var$BL_CODES + 1) * 2);
    $d39304d744af7f63$var$zero(this.dyn_ltree);
    $d39304d744af7f63$var$zero(this.dyn_dtree);
    $d39304d744af7f63$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($d39304d744af7f63$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $d39304d744af7f63$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $d39304d744af7f63$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $d39304d744af7f63$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $d39304d744af7f63$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $d39304d744af7f63$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $d39304d744af7f63$var$INIT_STATE && //#ifdef GZIP
    s.status !== $d39304d744af7f63$var$GZIP_STATE && //#endif
    s.status !== $d39304d744af7f63$var$EXTRA_STATE && s.status !== $d39304d744af7f63$var$NAME_STATE && s.status !== $d39304d744af7f63$var$COMMENT_STATE && s.status !== $d39304d744af7f63$var$HCRC_STATE && s.status !== $d39304d744af7f63$var$BUSY_STATE && s.status !== $d39304d744af7f63$var$FINISH_STATE) return 1;
    return 0;
};
const $d39304d744af7f63$var$deflateResetKeep = (strm)=>{
    if ($d39304d744af7f63$var$deflateStateCheck(strm)) return $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $d39304d744af7f63$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $d39304d744af7f63$var$GZIP_STATE : //#endif
    s.wrap ? $d39304d744af7f63$var$INIT_STATE : $d39304d744af7f63$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $d39304d744af7f63$var$_tr_init(s);
    return $d39304d744af7f63$var$Z_OK$3;
};
const $d39304d744af7f63$var$deflateReset = (strm)=>{
    const ret = $d39304d744af7f63$var$deflateResetKeep(strm);
    if (ret === $d39304d744af7f63$var$Z_OK$3) $d39304d744af7f63$var$lm_init(strm.state);
    return ret;
};
const $d39304d744af7f63$var$deflateSetHeader = (strm, head)=>{
    if ($d39304d744af7f63$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $d39304d744af7f63$var$Z_OK$3;
};
const $d39304d744af7f63$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $d39304d744af7f63$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $d39304d744af7f63$var$MAX_MEM_LEVEL || method !== $d39304d744af7f63$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $d39304d744af7f63$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $d39304d744af7f63$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $d39304d744af7f63$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $d39304d744af7f63$var$MIN_MATCH - 1) / $d39304d744af7f63$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $d39304d744af7f63$var$deflateReset(strm);
};
const $d39304d744af7f63$var$deflateInit = (strm, level)=>{
    return $d39304d744af7f63$var$deflateInit2(strm, level, $d39304d744af7f63$var$Z_DEFLATED$2, $d39304d744af7f63$var$MAX_WBITS$1, $d39304d744af7f63$var$DEF_MEM_LEVEL, $d39304d744af7f63$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $d39304d744af7f63$var$deflate$2 = (strm, flush)=>{
    if ($d39304d744af7f63$var$deflateStateCheck(strm) || flush > $d39304d744af7f63$var$Z_BLOCK$1 || flush < 0) return strm ? $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_STREAM_ERROR$2) : $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $d39304d744af7f63$var$FINISH_STATE && flush !== $d39304d744af7f63$var$Z_FINISH$3) return $d39304d744af7f63$var$err(strm, strm.avail_out === 0 ? $d39304d744af7f63$var$Z_BUF_ERROR$1 : $d39304d744af7f63$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $d39304d744af7f63$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $d39304d744af7f63$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $d39304d744af7f63$var$rank(flush) <= $d39304d744af7f63$var$rank(old_flush) && flush !== $d39304d744af7f63$var$Z_FINISH$3) return $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $d39304d744af7f63$var$FINISH_STATE && strm.avail_in !== 0) return $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $d39304d744af7f63$var$INIT_STATE && s.wrap === 0) s.status = $d39304d744af7f63$var$BUSY_STATE;
    if (s.status === $d39304d744af7f63$var$INIT_STATE) {
        /* zlib header */ let header = $d39304d744af7f63$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $d39304d744af7f63$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $d39304d744af7f63$var$PRESET_DICT;
        header += 31 - header % 31;
        $d39304d744af7f63$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $d39304d744af7f63$var$putShortMSB(s, strm.adler >>> 16);
            $d39304d744af7f63$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $d39304d744af7f63$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $d39304d744af7f63$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $d39304d744af7f63$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $d39304d744af7f63$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $d39304d744af7f63$var$put_byte(s, 31);
        $d39304d744af7f63$var$put_byte(s, 139);
        $d39304d744af7f63$var$put_byte(s, 8);
        if (!s.gzhead) {
            $d39304d744af7f63$var$put_byte(s, 0);
            $d39304d744af7f63$var$put_byte(s, 0);
            $d39304d744af7f63$var$put_byte(s, 0);
            $d39304d744af7f63$var$put_byte(s, 0);
            $d39304d744af7f63$var$put_byte(s, 0);
            $d39304d744af7f63$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $d39304d744af7f63$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $d39304d744af7f63$var$put_byte(s, $d39304d744af7f63$var$OS_CODE);
            s.status = $d39304d744af7f63$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $d39304d744af7f63$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $d39304d744af7f63$var$Z_OK$3;
            }
        } else {
            $d39304d744af7f63$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $d39304d744af7f63$var$put_byte(s, s.gzhead.time & 0xff);
            $d39304d744af7f63$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $d39304d744af7f63$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $d39304d744af7f63$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $d39304d744af7f63$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $d39304d744af7f63$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $d39304d744af7f63$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $d39304d744af7f63$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $d39304d744af7f63$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $d39304d744af7f63$var$EXTRA_STATE;
        }
    }
    if (s.status === $d39304d744af7f63$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $d39304d744af7f63$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $d39304d744af7f63$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $d39304d744af7f63$var$NAME_STATE;
    }
    if (s.status === $d39304d744af7f63$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $d39304d744af7f63$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $d39304d744af7f63$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $d39304d744af7f63$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $d39304d744af7f63$var$COMMENT_STATE;
    }
    if (s.status === $d39304d744af7f63$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $d39304d744af7f63$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $d39304d744af7f63$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $d39304d744af7f63$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $d39304d744af7f63$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $d39304d744af7f63$var$HCRC_STATE;
    }
    if (s.status === $d39304d744af7f63$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $d39304d744af7f63$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $d39304d744af7f63$var$Z_OK$3;
                }
            }
            $d39304d744af7f63$var$put_byte(s, strm.adler & 0xff);
            $d39304d744af7f63$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $d39304d744af7f63$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $d39304d744af7f63$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $d39304d744af7f63$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $d39304d744af7f63$var$Z_NO_FLUSH$2 && s.status !== $d39304d744af7f63$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $d39304d744af7f63$var$deflate_stored(s, flush) : s.strategy === $d39304d744af7f63$var$Z_HUFFMAN_ONLY ? $d39304d744af7f63$var$deflate_huff(s, flush) : s.strategy === $d39304d744af7f63$var$Z_RLE ? $d39304d744af7f63$var$deflate_rle(s, flush) : $d39304d744af7f63$var$configuration_table[s.level].func(s, flush);
        if (bstate === $d39304d744af7f63$var$BS_FINISH_STARTED || bstate === $d39304d744af7f63$var$BS_FINISH_DONE) s.status = $d39304d744af7f63$var$FINISH_STATE;
        if (bstate === $d39304d744af7f63$var$BS_NEED_MORE || bstate === $d39304d744af7f63$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $d39304d744af7f63$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $d39304d744af7f63$var$BS_BLOCK_DONE) {
            if (flush === $d39304d744af7f63$var$Z_PARTIAL_FLUSH) $d39304d744af7f63$var$_tr_align(s);
            else if (flush !== $d39304d744af7f63$var$Z_BLOCK$1) {
                $d39304d744af7f63$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $d39304d744af7f63$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $d39304d744af7f63$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $d39304d744af7f63$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $d39304d744af7f63$var$Z_OK$3;
            }
        }
    }
    if (flush !== $d39304d744af7f63$var$Z_FINISH$3) return $d39304d744af7f63$var$Z_OK$3;
    if (s.wrap <= 0) return $d39304d744af7f63$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $d39304d744af7f63$var$put_byte(s, strm.adler & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.adler >> 8 & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.adler >> 16 & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.adler >> 24 & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.total_in & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $d39304d744af7f63$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $d39304d744af7f63$var$putShortMSB(s, strm.adler >>> 16);
        $d39304d744af7f63$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $d39304d744af7f63$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $d39304d744af7f63$var$Z_OK$3 : $d39304d744af7f63$var$Z_STREAM_END$3;
};
const $d39304d744af7f63$var$deflateEnd = (strm)=>{
    if ($d39304d744af7f63$var$deflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $d39304d744af7f63$var$BUSY_STATE ? $d39304d744af7f63$var$err(strm, $d39304d744af7f63$var$Z_DATA_ERROR$2) : $d39304d744af7f63$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $d39304d744af7f63$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($d39304d744af7f63$var$deflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $d39304d744af7f63$var$INIT_STATE || s.lookahead) return $d39304d744af7f63$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $d39304d744af7f63$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $d39304d744af7f63$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $d39304d744af7f63$var$fill_window(s);
    while(s.lookahead >= $d39304d744af7f63$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($d39304d744af7f63$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $d39304d744af7f63$var$HASH(s, s.ins_h, s.window[str + $d39304d744af7f63$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $d39304d744af7f63$var$MIN_MATCH - 1;
        $d39304d744af7f63$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $d39304d744af7f63$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $d39304d744af7f63$var$Z_OK$3;
};
var $d39304d744af7f63$var$deflateInit_1 = $d39304d744af7f63$var$deflateInit;
var $d39304d744af7f63$var$deflateInit2_1 = $d39304d744af7f63$var$deflateInit2;
var $d39304d744af7f63$var$deflateReset_1 = $d39304d744af7f63$var$deflateReset;
var $d39304d744af7f63$var$deflateResetKeep_1 = $d39304d744af7f63$var$deflateResetKeep;
var $d39304d744af7f63$var$deflateSetHeader_1 = $d39304d744af7f63$var$deflateSetHeader;
var $d39304d744af7f63$var$deflate_2$1 = $d39304d744af7f63$var$deflate$2;
var $d39304d744af7f63$var$deflateEnd_1 = $d39304d744af7f63$var$deflateEnd;
var $d39304d744af7f63$var$deflateSetDictionary_1 = $d39304d744af7f63$var$deflateSetDictionary;
var $d39304d744af7f63$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $d39304d744af7f63$var$deflate_1$2 = {
    deflateInit: $d39304d744af7f63$var$deflateInit_1,
    deflateInit2: $d39304d744af7f63$var$deflateInit2_1,
    deflateReset: $d39304d744af7f63$var$deflateReset_1,
    deflateResetKeep: $d39304d744af7f63$var$deflateResetKeep_1,
    deflateSetHeader: $d39304d744af7f63$var$deflateSetHeader_1,
    deflate: $d39304d744af7f63$var$deflate_2$1,
    deflateEnd: $d39304d744af7f63$var$deflateEnd_1,
    deflateSetDictionary: $d39304d744af7f63$var$deflateSetDictionary_1,
    deflateInfo: $d39304d744af7f63$var$deflateInfo
};
const $d39304d744af7f63$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $d39304d744af7f63$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($d39304d744af7f63$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $d39304d744af7f63$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $d39304d744af7f63$var$common = {
    assign: $d39304d744af7f63$var$assign,
    flattenChunks: $d39304d744af7f63$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $d39304d744af7f63$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d39304d744af7f63$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $d39304d744af7f63$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$d39304d744af7f63$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$d39304d744af7f63$var$_utf8len[254] = $d39304d744af7f63$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $d39304d744af7f63$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $d39304d744af7f63$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d39304d744af7f63$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $d39304d744af7f63$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $d39304d744af7f63$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d39304d744af7f63$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d39304d744af7f63$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d39304d744af7f63$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $d39304d744af7f63$var$strings = {
    string2buf: $d39304d744af7f63$var$string2buf,
    buf2string: $d39304d744af7f63$var$buf2string,
    utf8border: $d39304d744af7f63$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $d39304d744af7f63$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $d39304d744af7f63$var$zstream = $d39304d744af7f63$var$ZStream;
const $d39304d744af7f63$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $d39304d744af7f63$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $d39304d744af7f63$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $d39304d744af7f63$var$Z_FULL_FLUSH, Z_FINISH: $d39304d744af7f63$var$Z_FINISH$2, Z_OK: $d39304d744af7f63$var$Z_OK$2, Z_STREAM_END: $d39304d744af7f63$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $d39304d744af7f63$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $d39304d744af7f63$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $d39304d744af7f63$var$Z_DEFLATED$1 } = $d39304d744af7f63$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $d39304d744af7f63$var$Deflate$1(options) {
    this.options = $d39304d744af7f63$var$common.assign({
        level: $d39304d744af7f63$var$Z_DEFAULT_COMPRESSION,
        method: $d39304d744af7f63$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $d39304d744af7f63$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $d39304d744af7f63$var$zstream();
    this.strm.avail_out = 0;
    let status = $d39304d744af7f63$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $d39304d744af7f63$var$Z_OK$2) throw new Error($d39304d744af7f63$var$messages[status]);
    if (opt.header) $d39304d744af7f63$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $d39304d744af7f63$var$strings.string2buf(opt.dictionary);
        else if ($d39304d744af7f63$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $d39304d744af7f63$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $d39304d744af7f63$var$Z_OK$2) throw new Error($d39304d744af7f63$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $d39304d744af7f63$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $d39304d744af7f63$var$Z_FINISH$2 : $d39304d744af7f63$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $d39304d744af7f63$var$strings.string2buf(data);
    else if ($d39304d744af7f63$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $d39304d744af7f63$var$Z_SYNC_FLUSH || _flush_mode === $d39304d744af7f63$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $d39304d744af7f63$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $d39304d744af7f63$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $d39304d744af7f63$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $d39304d744af7f63$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $d39304d744af7f63$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $d39304d744af7f63$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $d39304d744af7f63$var$Z_OK$2) this.result = $d39304d744af7f63$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $d39304d744af7f63$var$deflate$1(input, options) {
    const deflator = new $d39304d744af7f63$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $d39304d744af7f63$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $d39304d744af7f63$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $d39304d744af7f63$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $d39304d744af7f63$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $d39304d744af7f63$var$deflate$1(input, options);
}
var $d39304d744af7f63$var$Deflate_1$1 = $d39304d744af7f63$var$Deflate$1;
var $d39304d744af7f63$var$deflate_2 = $d39304d744af7f63$var$deflate$1;
var $d39304d744af7f63$var$deflateRaw_1$1 = $d39304d744af7f63$var$deflateRaw$1;
var $d39304d744af7f63$var$gzip_1$1 = $d39304d744af7f63$var$gzip$1;
var $d39304d744af7f63$var$constants$1 = $d39304d744af7f63$var$constants$2;
var $d39304d744af7f63$var$deflate_1$1 = {
    Deflate: $d39304d744af7f63$var$Deflate_1$1,
    deflate: $d39304d744af7f63$var$deflate_2,
    deflateRaw: $d39304d744af7f63$var$deflateRaw_1$1,
    gzip: $d39304d744af7f63$var$gzip_1$1,
    constants: $d39304d744af7f63$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $d39304d744af7f63$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $d39304d744af7f63$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $d39304d744af7f63$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $d39304d744af7f63$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $d39304d744af7f63$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $d39304d744af7f63$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $d39304d744af7f63$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $d39304d744af7f63$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $d39304d744af7f63$var$MAXBITS = 15;
const $d39304d744af7f63$var$ENOUGH_LENS$1 = 852;
const $d39304d744af7f63$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $d39304d744af7f63$var$CODES$1 = 0;
const $d39304d744af7f63$var$LENS$1 = 1;
const $d39304d744af7f63$var$DISTS$1 = 2;
const $d39304d744af7f63$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $d39304d744af7f63$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $d39304d744af7f63$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $d39304d744af7f63$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $d39304d744af7f63$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($d39304d744af7f63$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($d39304d744af7f63$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $d39304d744af7f63$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $d39304d744af7f63$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $d39304d744af7f63$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $d39304d744af7f63$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $d39304d744af7f63$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $d39304d744af7f63$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $d39304d744af7f63$var$LENS$1) {
        base = $d39304d744af7f63$var$lbase;
        extra = $d39304d744af7f63$var$lext;
        match = 257;
    } else {
        base = $d39304d744af7f63$var$dbase;
        extra = $d39304d744af7f63$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $d39304d744af7f63$var$LENS$1 && used > $d39304d744af7f63$var$ENOUGH_LENS$1 || type === $d39304d744af7f63$var$DISTS$1 && used > $d39304d744af7f63$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $d39304d744af7f63$var$LENS$1 && used > $d39304d744af7f63$var$ENOUGH_LENS$1 || type === $d39304d744af7f63$var$DISTS$1 && used > $d39304d744af7f63$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $d39304d744af7f63$var$inftrees = $d39304d744af7f63$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $d39304d744af7f63$var$CODES = 0;
const $d39304d744af7f63$var$LENS = 1;
const $d39304d744af7f63$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $d39304d744af7f63$var$Z_FINISH$1, Z_BLOCK: $d39304d744af7f63$var$Z_BLOCK, Z_TREES: $d39304d744af7f63$var$Z_TREES, Z_OK: $d39304d744af7f63$var$Z_OK$1, Z_STREAM_END: $d39304d744af7f63$var$Z_STREAM_END$1, Z_NEED_DICT: $d39304d744af7f63$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $d39304d744af7f63$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $d39304d744af7f63$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $d39304d744af7f63$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $d39304d744af7f63$var$Z_BUF_ERROR, Z_DEFLATED: $d39304d744af7f63$var$Z_DEFLATED } = $d39304d744af7f63$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $d39304d744af7f63$var$HEAD = 16180; /* i: waiting for magic header */ 
const $d39304d744af7f63$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $d39304d744af7f63$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $d39304d744af7f63$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $d39304d744af7f63$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $d39304d744af7f63$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $d39304d744af7f63$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $d39304d744af7f63$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $d39304d744af7f63$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $d39304d744af7f63$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $d39304d744af7f63$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $d39304d744af7f63$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $d39304d744af7f63$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $d39304d744af7f63$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $d39304d744af7f63$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $d39304d744af7f63$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $d39304d744af7f63$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $d39304d744af7f63$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $d39304d744af7f63$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $d39304d744af7f63$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $d39304d744af7f63$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $d39304d744af7f63$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $d39304d744af7f63$var$DIST = 16202; /* i: waiting for distance code */ 
const $d39304d744af7f63$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $d39304d744af7f63$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $d39304d744af7f63$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $d39304d744af7f63$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $d39304d744af7f63$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $d39304d744af7f63$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $d39304d744af7f63$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $d39304d744af7f63$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $d39304d744af7f63$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $d39304d744af7f63$var$ENOUGH_LENS = 852;
const $d39304d744af7f63$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $d39304d744af7f63$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $d39304d744af7f63$var$DEF_WBITS = $d39304d744af7f63$var$MAX_WBITS;
const $d39304d744af7f63$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $d39304d744af7f63$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $d39304d744af7f63$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $d39304d744af7f63$var$HEAD || state.mode > $d39304d744af7f63$var$SYNC) return 1;
    return 0;
};
const $d39304d744af7f63$var$inflateResetKeep = (strm)=>{
    if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $d39304d744af7f63$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($d39304d744af7f63$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($d39304d744af7f63$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $d39304d744af7f63$var$Z_OK$1;
};
const $d39304d744af7f63$var$inflateReset = (strm)=>{
    if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $d39304d744af7f63$var$inflateResetKeep(strm);
};
const $d39304d744af7f63$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $d39304d744af7f63$var$inflateReset(strm);
};
const $d39304d744af7f63$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $d39304d744af7f63$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $d39304d744af7f63$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $d39304d744af7f63$var$inflateReset2(strm, windowBits);
    if (ret !== $d39304d744af7f63$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $d39304d744af7f63$var$inflateInit = (strm)=>{
    return $d39304d744af7f63$var$inflateInit2(strm, $d39304d744af7f63$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $d39304d744af7f63$var$virgin = true;
let $d39304d744af7f63$var$lenfix, $d39304d744af7f63$var$distfix; // We have no pointers in JS, so keep tables separate
const $d39304d744af7f63$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($d39304d744af7f63$var$virgin) {
        $d39304d744af7f63$var$lenfix = new Int32Array(512);
        $d39304d744af7f63$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $d39304d744af7f63$var$inftrees($d39304d744af7f63$var$LENS, state.lens, 0, 288, $d39304d744af7f63$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $d39304d744af7f63$var$inftrees($d39304d744af7f63$var$DISTS, state.lens, 0, 32, $d39304d744af7f63$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $d39304d744af7f63$var$virgin = false;
    }
    state.lencode = $d39304d744af7f63$var$lenfix;
    state.lenbits = 9;
    state.distcode = $d39304d744af7f63$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $d39304d744af7f63$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $d39304d744af7f63$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($d39304d744af7f63$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $d39304d744af7f63$var$TYPE) state.mode = $d39304d744af7f63$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $d39304d744af7f63$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $d39304d744af7f63$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $d39304d744af7f63$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $d39304d744af7f63$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $d39304d744af7f63$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $d39304d744af7f63$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $d39304d744af7f63$var$DICTID : $d39304d744af7f63$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $d39304d744af7f63$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $d39304d744af7f63$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $d39304d744af7f63$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $d39304d744af7f63$var$TIME;
        /* falls through */ case $d39304d744af7f63$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $d39304d744af7f63$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $d39304d744af7f63$var$OS;
        /* falls through */ case $d39304d744af7f63$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $d39304d744af7f63$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $d39304d744af7f63$var$EXLEN;
        /* falls through */ case $d39304d744af7f63$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $d39304d744af7f63$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $d39304d744af7f63$var$EXTRA;
        /* falls through */ case $d39304d744af7f63$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $d39304d744af7f63$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $d39304d744af7f63$var$NAME;
        /* falls through */ case $d39304d744af7f63$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $d39304d744af7f63$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $d39304d744af7f63$var$COMMENT;
        /* falls through */ case $d39304d744af7f63$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $d39304d744af7f63$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $d39304d744af7f63$var$HCRC;
        /* falls through */ case $d39304d744af7f63$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $d39304d744af7f63$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $d39304d744af7f63$var$TYPE;
            break;
        case $d39304d744af7f63$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $d39304d744af7f63$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $d39304d744af7f63$var$DICT;
        /* falls through */ case $d39304d744af7f63$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $d39304d744af7f63$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $d39304d744af7f63$var$TYPE;
        /* falls through */ case $d39304d744af7f63$var$TYPE:
            if (flush === $d39304d744af7f63$var$Z_BLOCK || flush === $d39304d744af7f63$var$Z_TREES) break inf_leave;
        /* falls through */ case $d39304d744af7f63$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $d39304d744af7f63$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $d39304d744af7f63$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $d39304d744af7f63$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $d39304d744af7f63$var$LEN_; /* decode codes */ 
                    if (flush === $d39304d744af7f63$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $d39304d744af7f63$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $d39304d744af7f63$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $d39304d744af7f63$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $d39304d744af7f63$var$COPY_;
            if (flush === $d39304d744af7f63$var$Z_TREES) break inf_leave;
        /* falls through */ case $d39304d744af7f63$var$COPY_:
            state.mode = $d39304d744af7f63$var$COPY;
        /* falls through */ case $d39304d744af7f63$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $d39304d744af7f63$var$TYPE;
            break;
        case $d39304d744af7f63$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $d39304d744af7f63$var$LENLENS;
        /* falls through */ case $d39304d744af7f63$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $d39304d744af7f63$var$inftrees($d39304d744af7f63$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $d39304d744af7f63$var$CODELENS;
        /* falls through */ case $d39304d744af7f63$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $d39304d744af7f63$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $d39304d744af7f63$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $d39304d744af7f63$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $d39304d744af7f63$var$inftrees($d39304d744af7f63$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $d39304d744af7f63$var$inftrees($d39304d744af7f63$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $d39304d744af7f63$var$LEN_;
            if (flush === $d39304d744af7f63$var$Z_TREES) break inf_leave;
        /* falls through */ case $d39304d744af7f63$var$LEN_:
            state.mode = $d39304d744af7f63$var$LEN;
        /* falls through */ case $d39304d744af7f63$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $d39304d744af7f63$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $d39304d744af7f63$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $d39304d744af7f63$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $d39304d744af7f63$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $d39304d744af7f63$var$LENEXT;
        /* falls through */ case $d39304d744af7f63$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $d39304d744af7f63$var$DIST;
        /* falls through */ case $d39304d744af7f63$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $d39304d744af7f63$var$DISTEXT;
        /* falls through */ case $d39304d744af7f63$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $d39304d744af7f63$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $d39304d744af7f63$var$MATCH;
        /* falls through */ case $d39304d744af7f63$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $d39304d744af7f63$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $d39304d744af7f63$var$LEN;
            break;
        case $d39304d744af7f63$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $d39304d744af7f63$var$LEN;
            break;
        case $d39304d744af7f63$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $d39304d744af7f63$var$crc32_1(state.check, output, _out, put - _out) : $d39304d744af7f63$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $d39304d744af7f63$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $d39304d744af7f63$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $d39304d744af7f63$var$LENGTH;
        /* falls through */ case $d39304d744af7f63$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $d39304d744af7f63$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $d39304d744af7f63$var$DONE;
        /* falls through */ case $d39304d744af7f63$var$DONE:
            ret = $d39304d744af7f63$var$Z_STREAM_END$1;
            break inf_leave;
        case $d39304d744af7f63$var$BAD:
            ret = $d39304d744af7f63$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $d39304d744af7f63$var$MEM:
            return $d39304d744af7f63$var$Z_MEM_ERROR$1;
        case $d39304d744af7f63$var$SYNC:
        /* falls through */ default:
            return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $d39304d744af7f63$var$BAD && (state.mode < $d39304d744af7f63$var$CHECK || flush !== $d39304d744af7f63$var$Z_FINISH$1)) $d39304d744af7f63$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $d39304d744af7f63$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $d39304d744af7f63$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $d39304d744af7f63$var$TYPE ? 128 : 0) + (state.mode === $d39304d744af7f63$var$LEN_ || state.mode === $d39304d744af7f63$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $d39304d744af7f63$var$Z_FINISH$1) && ret === $d39304d744af7f63$var$Z_OK$1) ret = $d39304d744af7f63$var$Z_BUF_ERROR;
    return ret;
};
const $d39304d744af7f63$var$inflateEnd = (strm)=>{
    if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $d39304d744af7f63$var$Z_OK$1;
};
const $d39304d744af7f63$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $d39304d744af7f63$var$Z_OK$1;
};
const $d39304d744af7f63$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($d39304d744af7f63$var$inflateStateCheck(strm)) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $d39304d744af7f63$var$DICT) return $d39304d744af7f63$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $d39304d744af7f63$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $d39304d744af7f63$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $d39304d744af7f63$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $d39304d744af7f63$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $d39304d744af7f63$var$MEM;
        return $d39304d744af7f63$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $d39304d744af7f63$var$Z_OK$1;
};
var $d39304d744af7f63$var$inflateReset_1 = $d39304d744af7f63$var$inflateReset;
var $d39304d744af7f63$var$inflateReset2_1 = $d39304d744af7f63$var$inflateReset2;
var $d39304d744af7f63$var$inflateResetKeep_1 = $d39304d744af7f63$var$inflateResetKeep;
var $d39304d744af7f63$var$inflateInit_1 = $d39304d744af7f63$var$inflateInit;
var $d39304d744af7f63$var$inflateInit2_1 = $d39304d744af7f63$var$inflateInit2;
var $d39304d744af7f63$var$inflate_2$1 = $d39304d744af7f63$var$inflate$2;
var $d39304d744af7f63$var$inflateEnd_1 = $d39304d744af7f63$var$inflateEnd;
var $d39304d744af7f63$var$inflateGetHeader_1 = $d39304d744af7f63$var$inflateGetHeader;
var $d39304d744af7f63$var$inflateSetDictionary_1 = $d39304d744af7f63$var$inflateSetDictionary;
var $d39304d744af7f63$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $d39304d744af7f63$var$inflate_1$2 = {
    inflateReset: $d39304d744af7f63$var$inflateReset_1,
    inflateReset2: $d39304d744af7f63$var$inflateReset2_1,
    inflateResetKeep: $d39304d744af7f63$var$inflateResetKeep_1,
    inflateInit: $d39304d744af7f63$var$inflateInit_1,
    inflateInit2: $d39304d744af7f63$var$inflateInit2_1,
    inflate: $d39304d744af7f63$var$inflate_2$1,
    inflateEnd: $d39304d744af7f63$var$inflateEnd_1,
    inflateGetHeader: $d39304d744af7f63$var$inflateGetHeader_1,
    inflateSetDictionary: $d39304d744af7f63$var$inflateSetDictionary_1,
    inflateInfo: $d39304d744af7f63$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $d39304d744af7f63$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $d39304d744af7f63$var$gzheader = $d39304d744af7f63$var$GZheader;
const $d39304d744af7f63$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $d39304d744af7f63$var$Z_NO_FLUSH, Z_FINISH: $d39304d744af7f63$var$Z_FINISH, Z_OK: $d39304d744af7f63$var$Z_OK, Z_STREAM_END: $d39304d744af7f63$var$Z_STREAM_END, Z_NEED_DICT: $d39304d744af7f63$var$Z_NEED_DICT, Z_STREAM_ERROR: $d39304d744af7f63$var$Z_STREAM_ERROR, Z_DATA_ERROR: $d39304d744af7f63$var$Z_DATA_ERROR, Z_MEM_ERROR: $d39304d744af7f63$var$Z_MEM_ERROR } = $d39304d744af7f63$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $d39304d744af7f63$var$Inflate$1(options) {
    this.options = $d39304d744af7f63$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $d39304d744af7f63$var$zstream();
    this.strm.avail_out = 0;
    let status = $d39304d744af7f63$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $d39304d744af7f63$var$Z_OK) throw new Error($d39304d744af7f63$var$messages[status]);
    this.header = new $d39304d744af7f63$var$gzheader();
    $d39304d744af7f63$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $d39304d744af7f63$var$strings.string2buf(opt.dictionary);
        else if ($d39304d744af7f63$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $d39304d744af7f63$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $d39304d744af7f63$var$Z_OK) throw new Error($d39304d744af7f63$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $d39304d744af7f63$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $d39304d744af7f63$var$Z_FINISH : $d39304d744af7f63$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($d39304d744af7f63$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $d39304d744af7f63$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $d39304d744af7f63$var$Z_NEED_DICT && dictionary) {
            status = $d39304d744af7f63$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $d39304d744af7f63$var$Z_OK) status = $d39304d744af7f63$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $d39304d744af7f63$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $d39304d744af7f63$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $d39304d744af7f63$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $d39304d744af7f63$var$inflate_1$2.inflateReset(strm);
            status = $d39304d744af7f63$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $d39304d744af7f63$var$Z_STREAM_ERROR:
            case $d39304d744af7f63$var$Z_DATA_ERROR:
            case $d39304d744af7f63$var$Z_NEED_DICT:
            case $d39304d744af7f63$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $d39304d744af7f63$var$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $d39304d744af7f63$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $d39304d744af7f63$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $d39304d744af7f63$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $d39304d744af7f63$var$Z_STREAM_END) {
            status = $d39304d744af7f63$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $d39304d744af7f63$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $d39304d744af7f63$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $d39304d744af7f63$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $d39304d744af7f63$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $d39304d744af7f63$var$inflate$1(input, options) {
    const inflator = new $d39304d744af7f63$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $d39304d744af7f63$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $d39304d744af7f63$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $d39304d744af7f63$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $d39304d744af7f63$var$Inflate_1$1 = $d39304d744af7f63$var$Inflate$1;
var $d39304d744af7f63$var$inflate_2 = $d39304d744af7f63$var$inflate$1;
var $d39304d744af7f63$var$inflateRaw_1$1 = $d39304d744af7f63$var$inflateRaw$1;
var $d39304d744af7f63$var$ungzip$1 = $d39304d744af7f63$var$inflate$1;
var $d39304d744af7f63$var$constants = $d39304d744af7f63$var$constants$2;
var $d39304d744af7f63$var$inflate_1$1 = {
    Inflate: $d39304d744af7f63$var$Inflate_1$1,
    inflate: $d39304d744af7f63$var$inflate_2,
    inflateRaw: $d39304d744af7f63$var$inflateRaw_1$1,
    ungzip: $d39304d744af7f63$var$ungzip$1,
    constants: $d39304d744af7f63$var$constants
};
const { Deflate: $d39304d744af7f63$var$Deflate, deflate: $d39304d744af7f63$var$deflate, deflateRaw: $d39304d744af7f63$var$deflateRaw, gzip: $d39304d744af7f63$var$gzip } = $d39304d744af7f63$var$deflate_1$1;
const { Inflate: $d39304d744af7f63$var$Inflate, inflate: $d39304d744af7f63$var$inflate, inflateRaw: $d39304d744af7f63$var$inflateRaw, ungzip: $d39304d744af7f63$var$ungzip } = $d39304d744af7f63$var$inflate_1$1;
var $d39304d744af7f63$export$ae157b6234afe138 = $d39304d744af7f63$var$Deflate;
var $d39304d744af7f63$export$2316623ecd1285ab = $d39304d744af7f63$var$deflate;
var $d39304d744af7f63$export$e95d6a8f69fb340a = $d39304d744af7f63$var$deflateRaw;
var $d39304d744af7f63$export$69f0ea7cf3a331a8 = $d39304d744af7f63$var$gzip;
var $d39304d744af7f63$export$d1de70a877d6e43c = $d39304d744af7f63$var$Inflate;
var $d39304d744af7f63$export$cae1ce83fe4a1782 = $d39304d744af7f63$var$inflate;
var $d39304d744af7f63$export$d0f0aa2d05c905c5 = $d39304d744af7f63$var$inflateRaw;
var $d39304d744af7f63$export$95adf9d270383091 = $d39304d744af7f63$var$ungzip;
var $d39304d744af7f63$export$1a988e7317c65621 = $d39304d744af7f63$var$constants$2;
var $d39304d744af7f63$export$2e2bcd8739ae039 = {
    Deflate: $d39304d744af7f63$export$ae157b6234afe138,
    deflate: $d39304d744af7f63$export$2316623ecd1285ab,
    deflateRaw: $d39304d744af7f63$export$e95d6a8f69fb340a,
    gzip: $d39304d744af7f63$export$69f0ea7cf3a331a8,
    Inflate: $d39304d744af7f63$export$d1de70a877d6e43c,
    inflate: $d39304d744af7f63$export$cae1ce83fe4a1782,
    inflateRaw: $d39304d744af7f63$export$d0f0aa2d05c905c5,
    ungzip: $d39304d744af7f63$export$95adf9d270383091,
    constants: $d39304d744af7f63$export$1a988e7317c65621
};


/* global SerialPort, ParityType, FlowControlType */ /**
 * Wrapper class around Webserial API to communicate with the serial device.
 * @param {typeof import("w3c-web-serial").SerialPort} device - Requested device prompted by the browser.
 *
 * ```
 * const port = await navigator.serial.requestPort();
 * ```
 */ class $d59a45d20490e0bc$export$86495b081fef8e52 {
    constructor(device, tracing = false, enableSlipReader = true){
        this.device = device;
        this.tracing = tracing;
        this.slipReaderEnabled = false;
        this.baudrate = 0;
        this.traceLog = "";
        this.lastTraceTime = Date.now();
        this.buffer = new Uint8Array(0);
        this.SLIP_END = 0xc0;
        this.SLIP_ESC = 0xdb;
        this.SLIP_ESC_END = 0xdc;
        this.SLIP_ESC_ESC = 0xdd;
        this._DTR_state = false;
        this.slipReaderEnabled = enableSlipReader;
    }
    /**
     * Request the serial device vendor ID and Product ID as string.
     * @returns {string} Return the device VendorID and ProductID from SerialPortInfo as formatted string.
     */ getInfo() {
        const info = this.device.getInfo();
        return info.usbVendorId && info.usbProductId ? `WebSerial VendorID 0x${info.usbVendorId.toString(16)} ProductID 0x${info.usbProductId.toString(16)}` : "";
    }
    /**
     * Request the serial device product id from SerialPortInfo.
     * @returns {number | undefined} Return the product ID.
     */ getPid() {
        return this.device.getInfo().usbProductId;
    }
    /**
     * Format received or sent data for tracing output.
     * @param {string} message Message to format as trace line.
     */ trace(message) {
        const delta = Date.now() - this.lastTraceTime;
        const prefix = `TRACE ${delta.toFixed(3)}`;
        const traceMessage = `${prefix} ${message}`;
        console.log(traceMessage);
        this.traceLog += traceMessage + "\n";
    }
    async returnTrace() {
        try {
            await navigator.clipboard.writeText(this.traceLog);
            console.log("Text copied to clipboard!");
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    }
    hexify(s) {
        return Array.from(s).map((byte)=>byte.toString(16).padStart(2, "0")).join("").padEnd(16, " ");
    }
    hexConvert(uint8Array, autoSplit = true) {
        if (autoSplit && uint8Array.length > 16) {
            let result = "";
            let s = uint8Array;
            while(s.length > 0){
                const line = s.slice(0, 16);
                const asciiLine = String.fromCharCode(...line).split("").map((c)=>c === " " || c >= " " && c <= "~" && c !== "  " ? c : ".").join("");
                s = s.slice(16);
                result += `\n    ${this.hexify(line.slice(0, 8))} ${this.hexify(line.slice(8))} | ${asciiLine}`;
            }
            return result;
        } else return this.hexify(uint8Array);
    }
    /**
     * Format data packet using the Serial Line Internet Protocol (SLIP).
     * @param {Uint8Array} data Binary unsigned 8 bit array data to format.
     * @returns {Uint8Array} Formatted unsigned 8 bit data array.
     */ slipWriter(data) {
        const outData = [];
        outData.push(0xc0);
        for(let i = 0; i < data.length; i++){
            if (data[i] === 0xdb) outData.push(0xdb, 0xdd);
            else if (data[i] === 0xc0) outData.push(0xdb, 0xdc);
            else outData.push(data[i]);
        }
        outData.push(0xc0);
        return new Uint8Array(outData);
    }
    /**
     * Write binary data to device using the WebSerial device writable stream.
     * @param {Uint8Array} data 8 bit unsigned data array to write to device.
     */ async write(data) {
        const outData = this.slipWriter(data);
        if (this.device.writable) {
            const writer = this.device.writable.getWriter();
            if (this.tracing) {
                console.log("Write bytes");
                this.trace(`Write ${outData.length} bytes: ${this.hexConvert(outData)}`);
            }
            await writer.write(outData);
            writer.releaseLock();
        }
    }
    /**
     * Append a buffer array after another buffer array
     * @param {Uint8Array} arr1 - First array buffer.
     * @param {Uint8Array} arr2 - magic hex number to select ROM.
     * @returns {Uint8Array} Return a 8 bit unsigned array.
     */ appendArray(arr1, arr2) {
        const combined = new Uint8Array(arr1.length + arr2.length);
        combined.set(arr1);
        combined.set(arr2, arr1.length);
        return combined;
    }
    // Asynchronous generator to yield incoming data chunks
    async *readLoop(timeout) {
        if (!this.reader) return;
        try {
            while(true){
                const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error("Read timeout exceeded")), timeout));
                // Await the race between the timeout and the reader read
                const result = await Promise.race([
                    this.reader.read(),
                    timeoutPromise
                ]);
                // If a timeout occurs, result will be null; otherwise, it will have { value, done }
                if (result === null) break;
                const { value: value, done: done } = result;
                if (done || !value) break;
                yield value; // Yield each data chunk
            }
        } catch (error) {
            console.error("Error reading from serial port:", error);
        } finally{
            this.buffer = new Uint8Array(0);
        }
    }
    // Read a specific number of bytes
    async newRead(numBytes, timeout) {
        if (this.buffer.length >= numBytes) {
            const output = this.buffer.slice(0, numBytes);
            this.buffer = this.buffer.slice(numBytes); // Remove the returned data from buffer
            return output;
        }
        while(this.buffer.length < numBytes){
            const readLoop = this.readLoop(timeout);
            const { value: value, done: done } = await readLoop.next();
            if (done || !value) break;
            // Append the newly read data to the buffer
            this.buffer = this.appendArray(this.buffer, value);
        }
        // Return as much data as possible
        const output = this.buffer.slice(0, numBytes);
        this.buffer = this.buffer.slice(numBytes);
        return output;
    }
    async flushInput() {
        var _a;
        if (this.reader && !await this.reader.closed) {
            await this.reader.cancel();
            this.reader.releaseLock();
            this.reader = (_a = this.device.readable) === null || _a === void 0 ? void 0 : _a.getReader();
        }
    }
    async flushOutput() {
        var _a, _b;
        this.buffer = new Uint8Array(0);
        await ((_a = this.device.writable) === null || _a === void 0 ? void 0 : _a.getWriter().close());
        (_b = this.device.writable) === null || _b === void 0 || _b.getWriter().releaseLock();
    }
    // `inWaiting` returns the count of bytes in the buffer
    inWaiting() {
        return this.buffer.length;
    }
    /**
     * Detect if the data read from device is a Fatal or Guru meditation error.
     * @param {Uint8Array} input Data read from device
     */ detectPanicHandler(input) {
        const guruMeditationRegex = /G?uru Meditation Error: (?:Core \d panic'ed \(([a-zA-Z ]*)\))?/;
        const fatalExceptionRegex = /F?atal exception \(\d+\): (?:([a-zA-Z ]*)?.*epc)?/;
        const inputString = new TextDecoder("utf-8").decode(input);
        const match = inputString.match(guruMeditationRegex) || inputString.match(fatalExceptionRegex);
        if (match) {
            const cause = match[1] || match[2];
            const msg = `Guru Meditation Error detected${cause ? ` (${cause})` : ""}`;
            throw new Error(msg);
        }
    }
    /**
     * Take a data array and return the first well formed packet after
     * replacing the escape sequence. Reads at least 8 bytes.
     * @param {number} timeout Timeout read data.
     * @yields {Uint8Array} Formatted packet using SLIP escape sequences.
     */ async *read(timeout) {
        var _a;
        if (!this.reader) this.reader = (_a = this.device.readable) === null || _a === void 0 ? void 0 : _a.getReader();
        let partialPacket = null;
        let isEscaping = false;
        let successfulSlip = false;
        while(true){
            const waitingBytes = this.inWaiting();
            const readBytes = await this.newRead(waitingBytes > 0 ? waitingBytes : 1, timeout);
            if (!readBytes || readBytes.length === 0) {
                const msg = partialPacket === null ? successfulSlip ? "Serial data stream stopped: Possible serial noise or corruption." : "No serial data received." : `Packet content transfer stopped`;
                this.trace(msg);
                throw new Error(msg);
            }
            this.trace(`Read ${readBytes.length} bytes: ${this.hexConvert(readBytes)}`);
            let i = 0; // Track position in readBytes
            while(i < readBytes.length){
                const byte = readBytes[i++];
                if (partialPacket === null) {
                    if (byte === this.SLIP_END) partialPacket = new Uint8Array(0); // Start of a new packet
                    else {
                        this.trace(`Read invalid data: ${this.hexConvert(readBytes)}`);
                        const remainingData = await this.newRead(this.inWaiting(), timeout);
                        this.trace(`Remaining data in serial buffer: ${this.hexConvert(remainingData)}`);
                        this.detectPanicHandler(new Uint8Array([
                            ...readBytes,
                            ...remainingData || []
                        ]));
                        throw new Error(`Invalid head of packet (0x${byte.toString(16)}): Possible serial noise or corruption.`);
                    }
                } else if (isEscaping) {
                    isEscaping = false;
                    if (byte === this.SLIP_ESC_END) partialPacket = this.appendArray(partialPacket, new Uint8Array([
                        this.SLIP_END
                    ]));
                    else if (byte === this.SLIP_ESC_ESC) partialPacket = this.appendArray(partialPacket, new Uint8Array([
                        this.SLIP_ESC
                    ]));
                    else {
                        this.trace(`Read invalid data: ${this.hexConvert(readBytes)}`);
                        const remainingData = await this.newRead(this.inWaiting(), timeout);
                        this.trace(`Remaining data in serial buffer: ${this.hexConvert(remainingData)}`);
                        this.detectPanicHandler(new Uint8Array([
                            ...readBytes,
                            ...remainingData || []
                        ]));
                        throw new Error(`Invalid SLIP escape (0xdb, 0x${byte.toString(16)})`);
                    }
                } else if (byte === this.SLIP_ESC) isEscaping = true;
                else if (byte === this.SLIP_END) {
                    this.trace(`Received full packet: ${this.hexConvert(partialPacket)}`);
                    this.buffer = this.appendArray(this.buffer, readBytes.slice(i));
                    yield partialPacket;
                    partialPacket = null;
                    successfulSlip = true;
                } else partialPacket = this.appendArray(partialPacket, new Uint8Array([
                    byte
                ]));
            }
        }
    }
    /**
     * Read from serial device without slip formatting.
     * @yields {Uint8Array} The next number in the Fibonacci sequence.
     */ async *rawRead() {
        if (!this.reader) return;
        try {
            while(true){
                const { value: value, done: done } = await this.reader.read();
                if (done || !value) break;
                if (this.tracing) {
                    console.log("Raw Read bytes");
                    this.trace(`Read ${value.length} bytes: ${this.hexConvert(value)}`);
                }
                yield value; // Yield each data chunk
            }
        } catch (error) {
            console.error("Error reading from serial port:", error);
        } finally{
            this.buffer = new Uint8Array(0);
        }
    }
    /**
     * Send the RequestToSend (RTS) signal to given state
     * # True for EN=LOW, chip in reset and False EN=HIGH, chip out of reset
     * @param {boolean} state Boolean state to set the signal
     */ async setRTS(state) {
        await this.device.setSignals({
            requestToSend: state
        });
        // # Work-around for adapters on Windows using the usbser.sys driver:
        // # generate a dummy change to DTR so that the set-control-line-state
        // # request is sent with the updated RTS state and the same DTR state
        // Referenced to esptool.py
        await this.setDTR(this._DTR_state);
    }
    /**
     * Send the dataTerminalReady (DTS) signal to given state
     * # True for IO0=LOW, chip in reset and False IO0=HIGH
     * @param {boolean} state Boolean state to set the signal
     */ async setDTR(state) {
        this._DTR_state = state;
        await this.device.setSignals({
            dataTerminalReady: state
        });
    }
    /**
     * Connect to serial device using the Webserial open method.
     * @param {number} baud Number baud rate for serial connection. Default is 115200.
     * @param {typeof import("w3c-web-serial").SerialOptions} serialOptions Serial Options for WebUSB SerialPort class.
     */ async connect(baud = 115200, serialOptions = {}) {
        var _a;
        await this.device.open({
            baudRate: baud,
            dataBits: serialOptions === null || serialOptions === void 0 ? void 0 : serialOptions.dataBits,
            stopBits: serialOptions === null || serialOptions === void 0 ? void 0 : serialOptions.stopBits,
            bufferSize: serialOptions === null || serialOptions === void 0 ? void 0 : serialOptions.bufferSize,
            parity: serialOptions === null || serialOptions === void 0 ? void 0 : serialOptions.parity,
            flowControl: serialOptions === null || serialOptions === void 0 ? void 0 : serialOptions.flowControl
        });
        this.baudrate = baud;
        this.reader = (_a = this.device.readable) === null || _a === void 0 ? void 0 : _a.getReader();
    }
    async sleep(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    /**
     * Wait for a given timeout ms for serial device unlock.
     * @param {number} timeout Timeout time in milliseconds (ms) to sleep
     */ async waitForUnlock(timeout) {
        while(this.device.readable && this.device.readable.locked || this.device.writable && this.device.writable.locked)await this.sleep(timeout);
    }
    /**
     * Disconnect from serial device by running SerialPort.close() after streams unlock.
     */ async disconnect() {
        var _a, _b;
        if ((_a = this.device.readable) === null || _a === void 0 ? void 0 : _a.locked) await ((_b = this.reader) === null || _b === void 0 ? void 0 : _b.cancel());
        await this.waitForUnlock(400);
        await this.device.close();
        this.reader = undefined;
    }
}


/**
 * Sleep for ms milliseconds
 * @param {number} ms Milliseconds to wait
 * @returns {Promise<void>}
 */ function $f873055648c01006$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
class $f873055648c01006$export$4de7cfbc0d78cb8e {
    constructor(transport, resetDelay){
        this.resetDelay = resetDelay;
        this.transport = transport;
    }
    async reset() {
        await this.transport.setDTR(false);
        await this.transport.setRTS(true);
        await $f873055648c01006$var$sleep(100);
        await this.transport.setDTR(true);
        await this.transport.setRTS(false);
        await $f873055648c01006$var$sleep(this.resetDelay);
        await this.transport.setDTR(false);
    }
}
class $f873055648c01006$export$f728aa04f347362c {
    constructor(transport){
        this.transport = transport;
    }
    async reset() {
        await this.transport.setRTS(false);
        await this.transport.setDTR(false);
        await $f873055648c01006$var$sleep(100);
        await this.transport.setDTR(true);
        await this.transport.setRTS(false);
        await $f873055648c01006$var$sleep(100);
        await this.transport.setRTS(true);
        await this.transport.setDTR(false);
        await this.transport.setRTS(true);
        await $f873055648c01006$var$sleep(100);
        await this.transport.setRTS(false);
        await this.transport.setDTR(false);
    }
}
class $f873055648c01006$export$529f1679a228f28a {
    constructor(transport, usingUsbOtg = false){
        this.transport = transport;
        this.usingUsbOtg = usingUsbOtg;
        this.transport = transport;
    }
    async reset() {
        if (this.usingUsbOtg) {
            await $f873055648c01006$var$sleep(200);
            await this.transport.setRTS(false);
            await $f873055648c01006$var$sleep(200);
        } else {
            await $f873055648c01006$var$sleep(100);
            await this.transport.setRTS(false);
        }
    }
}
function $f873055648c01006$export$929a22f56823f4cb(seqStr) {
    const commands = [
        "D",
        "R",
        "W"
    ];
    const commandsList = seqStr.split("|");
    for (const cmd of commandsList){
        const code = cmd[0];
        const arg = cmd.slice(1);
        if (!commands.includes(code)) return false; // Invalid command code
        if (code === "D" || code === "R") {
            if (arg !== "0" && arg !== "1") return false; // Invalid argument for D and R commands
        } else if (code === "W") {
            const delay = parseInt(arg);
            if (isNaN(delay) || delay <= 0) return false; // Invalid argument for W command
        }
    }
    return true; // All commands are valid
}
class $f873055648c01006$export$587746fadce59bb9 {
    constructor(transport, sequenceString){
        this.transport = transport;
        this.sequenceString = sequenceString;
        this.transport = transport;
    }
    async reset() {
        const resetDictionary = {
            D: async (arg)=>await this.transport.setDTR(arg),
            R: async (arg)=>await this.transport.setRTS(arg),
            W: async (delay)=>await $f873055648c01006$var$sleep(delay)
        };
        try {
            const isValidSequence = $f873055648c01006$export$929a22f56823f4cb(this.sequenceString);
            if (!isValidSequence) return;
            const cmds = this.sequenceString.split("|");
            for (const cmd of cmds){
                const cmdKey = cmd[0];
                const cmdVal = cmd.slice(1);
                if (cmdKey === "W") await resetDictionary["W"](Number(cmdVal));
                else if (cmdKey === "D" || cmdKey === "R") await resetDictionary[cmdKey](cmdVal === "1");
            }
        } catch (error) {
            throw new Error("Invalid custom reset sequence");
        }
    }
}
var $f873055648c01006$export$2e2bcd8739ae039 = {
    ClassicReset: $f873055648c01006$export$4de7cfbc0d78cb8e,
    CustomReset: $f873055648c01006$export$587746fadce59bb9,
    HardReset: $f873055648c01006$export$529f1679a228f28a,
    UsbJtagSerialReset: $f873055648c01006$export$f728aa04f347362c,
    validateCustomResetStringSequence: $f873055648c01006$export$929a22f56823f4cb
};


var $c9381f0d76fb539b$exports = {};
$c9381f0d76fb539b$exports = function _atob(str) {
    return atob(str);
};













async function $cc3a88799d80a5ec$export$575862e1d5c85871(chipName) {
    let jsonStub;
    switch(chipName){
        case "ESP32":
            jsonStub = await (parcelRequire("1w3iG"));
            break;
        case "ESP32-C2":
            jsonStub = await (parcelRequire("9YdkG"));
            break;
        case "ESP32-C3":
            jsonStub = await (parcelRequire("aQoU1"));
            break;
        case "ESP32-C5":
            jsonStub = await (parcelRequire("hzrbh"));
            break;
        case "ESP32-C6":
            jsonStub = await (parcelRequire("lF5JF"));
            break;
        case "ESP32-C61":
            jsonStub = await (parcelRequire("iXU3J"));
            break;
        case "ESP32-H2":
            jsonStub = await (parcelRequire("2A9Ys"));
            break;
        case "ESP32-P4":
            jsonStub = await (parcelRequire("4txnj"));
            break;
        case "ESP32-S2":
            jsonStub = await (parcelRequire("4L4zI"));
            break;
        case "ESP32-S3":
            jsonStub = await (parcelRequire("gWhDP"));
            break;
        case "ESP8266":
            jsonStub = await (parcelRequire("89S4Q"));
            break;
    }
    if (jsonStub) return {
        bss_start: jsonStub.bss_start,
        data: jsonStub.data,
        data_start: jsonStub.data_start,
        entry: jsonStub.entry,
        text: jsonStub.text,
        text_start: jsonStub.text_start,
        decodedData: $cc3a88799d80a5ec$export$7e57cd56df6c9bb5(jsonStub.data),
        decodedText: $cc3a88799d80a5ec$export$7e57cd56df6c9bb5(jsonStub.text)
    };
    return;
}
function $cc3a88799d80a5ec$export$7e57cd56df6c9bb5(dataStr) {
    const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($c9381f0d76fb539b$exports)))(dataStr);
    const chardata = decoded.split("").map(function(x) {
        return x.charCodeAt(0);
    });
    return new Uint8Array(chardata);
}


/**
 * Pad to the next alignment boundary
 * @param {Uint8Array} data Uint8Array data to pad
 * @param {number} alignment Alignment boundary to fulfill
 * @param {number} padCharacter Character to fill with
 * @returns {Uint8Array} Padded UInt8Array image
 */ function $52023bd15cbc1421$export$fcbe1efa6919329(data, alignment, padCharacter = 0xff) {
    const padMod = data.length % alignment;
    if (padMod !== 0) {
        const padding = new Uint8Array(alignment - padMod).fill(padCharacter);
        const paddedData = new Uint8Array(data.length + padding.length);
        paddedData.set(data);
        paddedData.set(padding, data.length);
        return paddedData;
    }
    return data;
}













/**
 * Return the chip ROM based on the given magic number
 * @param {number} magic - magic hex number to select ROM.
 * @returns {ROM} The chip ROM class related to given magic hex number.
 */ async function $3dfdd479d6d4e3ee$var$magic2Chip(magic) {
    switch(magic){
        case 0x00f01d83:
            {
                const { ESP32ROM: ESP32ROM } = await (parcelRequire("2ou14"));
                return new ESP32ROM();
            }
        case 0xc21e06f:
        case 0x6f51306f:
        case 0x7c41a06f:
            {
                const { ESP32C2ROM: ESP32C2ROM } = await (parcelRequire("dopJd"));
                return new ESP32C2ROM();
            }
        case 0x6921506f:
        case 0x1b31506f:
        case 0x4881606f:
        case 0x4361606f:
            {
                const { ESP32C3ROM: ESP32C3ROM } = await (parcelRequire("br9et"));
                return new ESP32C3ROM();
            }
        case 0x2ce0806f:
            {
                const { ESP32C6ROM: ESP32C6ROM } = await (parcelRequire("1NPpz"));
                return new ESP32C6ROM();
            }
        case 0x2421606f:
        case 0x33f0206f:
        case 0x4f81606f:
            {
                const { ESP32C61ROM: ESP32C61ROM } = await (parcelRequire("juElA"));
                return new ESP32C61ROM();
            }
        case 0x1101406f:
        case 0x63e1406f:
            {
                const { ESP32C5ROM: ESP32C5ROM } = await (parcelRequire("hurMy"));
                return new ESP32C5ROM();
            }
        case 0xd7b73e80:
            {
                const { ESP32H2ROM: ESP32H2ROM } = await (parcelRequire("29OTa"));
                return new ESP32H2ROM();
            }
        case 0x09:
            {
                const { ESP32S3ROM: ESP32S3ROM } = await (parcelRequire("hsnp5"));
                return new ESP32S3ROM();
            }
        case 0x000007c6:
            {
                const { ESP32S2ROM: ESP32S2ROM } = await (parcelRequire("aiMqA"));
                return new ESP32S2ROM();
            }
        case 0xfff0c101:
            {
                const { ESP8266ROM: ESP8266ROM } = await (parcelRequire("gU2yy"));
                return new ESP8266ROM();
            }
        case 0x0:
        case 0x0addbad0:
        case 0x7039ad9:
            {
                const { ESP32P4ROM: ESP32P4ROM } = await (parcelRequire("9adXA"));
                return new ESP32P4ROM();
            }
        default:
            return null;
    }
}
class $3dfdd479d6d4e3ee$export$b0f7a6c745790308 {
    /**
     * Create a new ESPLoader to perform serial communication
     * such as read/write flash memory and registers using a LoaderOptions object.
     * @param {LoaderOptions} options - LoaderOptions object argument for ESPLoader.
     * ```
     * const myLoader = new ESPLoader({ transport: Transport, baudrate: number, terminal?: IEspLoaderTerminal });
     * ```
     */ constructor(options){
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.ESP_RAM_BLOCK = 0x1800;
        this.ESP_FLASH_BEGIN = 0x02;
        this.ESP_FLASH_DATA = 0x03;
        this.ESP_FLASH_END = 0x04;
        this.ESP_MEM_BEGIN = 0x05;
        this.ESP_MEM_END = 0x06;
        this.ESP_MEM_DATA = 0x07;
        this.ESP_WRITE_REG = 0x09;
        this.ESP_READ_REG = 0x0a;
        this.ESP_SPI_ATTACH = 0x0d;
        this.ESP_CHANGE_BAUDRATE = 0x0f;
        this.ESP_FLASH_DEFL_BEGIN = 0x10;
        this.ESP_FLASH_DEFL_DATA = 0x11;
        this.ESP_FLASH_DEFL_END = 0x12;
        this.ESP_SPI_FLASH_MD5 = 0x13;
        // Only Stub supported commands
        this.ESP_ERASE_FLASH = 0xd0;
        this.ESP_ERASE_REGION = 0xd1;
        this.ESP_READ_FLASH = 0xd2;
        this.ESP_RUN_USER_CODE = 0xd3;
        this.ESP_IMAGE_MAGIC = 0xe9;
        this.ESP_CHECKSUM_MAGIC = 0xef;
        // Response code(s) sent by ROM
        this.ROM_INVALID_RECV_MSG = 0x05; // response if an invalid message is received
        this.DEFAULT_TIMEOUT = 3000;
        this.ERASE_REGION_TIMEOUT_PER_MB = 30000;
        this.ERASE_WRITE_TIMEOUT_PER_MB = 40000;
        this.MD5_TIMEOUT_PER_MB = 8000;
        this.CHIP_ERASE_TIMEOUT = 120000;
        this.FLASH_READ_TIMEOUT = 100000;
        this.MAX_TIMEOUT = this.CHIP_ERASE_TIMEOUT * 2;
        this.CHIP_DETECT_MAGIC_REG_ADDR = 0x40001000;
        this.DETECTED_FLASH_SIZES = {
            0x12: "256KB",
            0x13: "512KB",
            0x14: "1MB",
            0x15: "2MB",
            0x16: "4MB",
            0x17: "8MB",
            0x18: "16MB"
        };
        this.DETECTED_FLASH_SIZES_NUM = {
            0x12: 256,
            0x13: 512,
            0x14: 1024,
            0x15: 2048,
            0x16: 4096,
            0x17: 8192,
            0x18: 16384
        };
        this.USB_JTAG_SERIAL_PID = 0x1001;
        this.romBaudrate = 115200;
        this.debugLogging = false;
        this.syncStubDetected = false;
        /**
         * Get flash size bytes from flash size string.
         * @param {string} flashSize Flash Size string
         * @returns {number} Flash size bytes
         */ this.flashSizeBytes = function(flashSize) {
            let flashSizeB = -1;
            if (flashSize.indexOf("KB") !== -1) flashSizeB = parseInt(flashSize.slice(0, flashSize.indexOf("KB"))) * 1024;
            else if (flashSize.indexOf("MB") !== -1) flashSizeB = parseInt(flashSize.slice(0, flashSize.indexOf("MB"))) * 1048576;
            return flashSizeB;
        };
        this.IS_STUB = false;
        this.FLASH_WRITE_SIZE = 0x4000;
        this.transport = options.transport;
        this.baudrate = options.baudrate;
        this.resetConstructors = {
            classicReset: (transport, resetDelay)=>new (0, $f873055648c01006$export$4de7cfbc0d78cb8e)(transport, resetDelay),
            customReset: (transport, sequenceString)=>new (0, $f873055648c01006$export$587746fadce59bb9)(transport, sequenceString),
            hardReset: (transport, usingUsbOtg)=>new (0, $f873055648c01006$export$529f1679a228f28a)(transport, usingUsbOtg),
            usbJTAGSerialReset: (transport)=>new (0, $f873055648c01006$export$f728aa04f347362c)(transport)
        };
        if (options.serialOptions) this.serialOptions = options.serialOptions;
        if (options.romBaudrate) this.romBaudrate = options.romBaudrate;
        if (options.terminal) {
            this.terminal = options.terminal;
            this.terminal.clean();
        }
        if (typeof options.debugLogging !== "undefined") this.debugLogging = options.debugLogging;
        if (options.port) this.transport = new (0, $d59a45d20490e0bc$export$86495b081fef8e52)(options.port);
        if (typeof options.enableTracing !== "undefined") this.transport.tracing = options.enableTracing;
        if ((_a = options.resetConstructors) === null || _a === void 0 ? void 0 : _a.classicReset) this.resetConstructors.classicReset = (_b = options.resetConstructors) === null || _b === void 0 ? void 0 : _b.classicReset;
        if ((_c = options.resetConstructors) === null || _c === void 0 ? void 0 : _c.customReset) this.resetConstructors.customReset = (_d = options.resetConstructors) === null || _d === void 0 ? void 0 : _d.customReset;
        if ((_e = options.resetConstructors) === null || _e === void 0 ? void 0 : _e.hardReset) this.resetConstructors.hardReset = (_f = options.resetConstructors) === null || _f === void 0 ? void 0 : _f.hardReset;
        if ((_g = options.resetConstructors) === null || _g === void 0 ? void 0 : _g.usbJTAGSerialReset) this.resetConstructors.usbJTAGSerialReset = (_h = options.resetConstructors) === null || _h === void 0 ? void 0 : _h.usbJTAGSerialReset;
        this.info("esptool.js");
        this.info("Serial port " + this.transport.getInfo());
    }
    _sleep(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    /**
     * Write to ESP Loader constructor's terminal with or without new line.
     * @param {string} str - String to write.
     * @param {boolean} withNewline - Add new line at the end ?
     */ write(str, withNewline = true) {
        if (this.terminal) {
            if (withNewline) this.terminal.writeLine(str);
            else this.terminal.write(str);
        } else // eslint-disable-next-line no-console
        console.log(str);
    }
    /**
     * Write error message to ESP Loader constructor's terminal with or without new line.
     * @param {string} str - String to write.
     * @param {boolean} withNewline - Add new line at the end ?
     */ error(str, withNewline = true) {
        this.write(`Error: ${str}`, withNewline);
    }
    /**
     * Write information message to ESP Loader constructor's terminal with or without new line.
     * @param {string} str - String to write.
     * @param {boolean} withNewline - Add new line at the end ?
     */ info(str, withNewline = true) {
        this.write(str, withNewline);
    }
    /**
     * Write debug message to ESP Loader constructor's terminal with or without new line.
     * @param {string} str - String to write.
     * @param {boolean} withNewline - Add new line at the end ?
     */ debug(str, withNewline = true) {
        if (this.debugLogging) this.write(`Debug: ${str}`, withNewline);
    }
    /**
     * Convert short integer to byte array
     * @param {number} i - Number to convert.
     * @returns {Uint8Array} Byte array.
     */ _shortToBytearray(i) {
        return new Uint8Array([
            i & 0xff,
            i >> 8 & 0xff
        ]);
    }
    /**
     * Convert an integer to byte array
     * @param {number} i - Number to convert.
     * @returns {ROM} The chip ROM class related to given magic hex number.
     */ _intToByteArray(i) {
        return new Uint8Array([
            i & 0xff,
            i >> 8 & 0xff,
            i >> 16 & 0xff,
            i >> 24 & 0xff
        ]);
    }
    /**
     * Convert a byte array to short integer.
     * @param {number} i - Number to convert.
     * @param {number} j - Number to convert.
     * @returns {number} Return a short integer number.
     */ _byteArrayToShort(i, j) {
        return i | j >> 8;
    }
    /**
     * Convert a byte array to integer.
     * @param {number} i - Number to convert.
     * @param {number} j - Number to convert.
     * @param {number} k - Number to convert.
     * @param {number} l - Number to convert.
     * @returns {number} Return a integer number.
     */ _byteArrayToInt(i, j, k, l) {
        return i | j << 8 | k << 16 | l << 24;
    }
    /**
     * Append a buffer array after another buffer array
     * @param {ArrayBuffer} buffer1 - First array buffer.
     * @param {ArrayBuffer} buffer2 - magic hex number to select ROM.
     * @returns {ArrayBufferLike} Return an array buffer.
     */ _appendBuffer(buffer1, buffer2) {
        const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
        tmp.set(new Uint8Array(buffer1), 0);
        tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
        return tmp.buffer;
    }
    /**
     * Append a buffer array after another buffer array
     * @param {Uint8Array} arr1 - First array buffer.
     * @param {Uint8Array} arr2 - magic hex number to select ROM.
     * @returns {Uint8Array} Return a 8 bit unsigned array.
     */ _appendArray(arr1, arr2) {
        const c = new Uint8Array(arr1.length + arr2.length);
        c.set(arr1, 0);
        c.set(arr2, arr1.length);
        return c;
    }
    /**
     * Convert a unsigned 8 bit integer array to byte string.
     * @param {Uint8Array} u8Array - magic hex number to select ROM.
     * @returns {string} Return the equivalent string.
     */ ui8ToBstr(u8Array) {
        let bStr = "";
        for(let i = 0; i < u8Array.length; i++)bStr += String.fromCharCode(u8Array[i]);
        return bStr;
    }
    /**
     * Convert a byte string to unsigned 8 bit integer array.
     * @param {string} bStr - binary string input
     * @returns {Uint8Array} Return a 8 bit unsigned integer array.
     */ bstrToUi8(bStr) {
        const u8Array = new Uint8Array(bStr.length);
        for(let i = 0; i < bStr.length; i++)u8Array[i] = bStr.charCodeAt(i);
        return u8Array;
    }
    /**
     * Flush the serial input by raw read with 200 ms timeout.
     */ async flushInput() {
        try {
            await this.transport.flushInput();
        } catch (e) {
            this.error(e.message);
        }
    }
    /**
     * Use the device serial port read function with given timeout to create a valid packet.
     * @param {number} op Operation number
     * @param {number} timeout timeout number in milliseconds
     * @returns {[number, Uint8Array]} valid response packet.
     */ async readPacket(op = null, timeout = this.DEFAULT_TIMEOUT) {
        // Check up-to next 100 packets for valid response packet
        for(let i = 0; i < 100; i++){
            const { value: p } = await this.transport.read(timeout).next();
            if (!p || p.length < 8) continue;
            const resp = p[0];
            if (resp !== 1) continue;
            const opRet = p[1];
            const val = this._byteArrayToInt(p[4], p[5], p[6], p[7]);
            const data = p.slice(8);
            if (resp == 1) {
                if (op == null || opRet == op) return [
                    val,
                    data
                ];
                else if (data[0] != 0 && data[1] == this.ROM_INVALID_RECV_MSG) {
                    await this.flushInput();
                    throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("unsupported command error");
                }
            }
        }
        throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("invalid response");
    }
    /**
     * Write a serial command to the chip
     * @param {number} op - Operation number
     * @param {Uint8Array} data - Unsigned 8 bit array
     * @param {number} chk - channel number
     * @param {boolean} waitResponse - wait for response ?
     * @param {number} timeout - timeout number in milliseconds
     * @returns {Promise<[number, Uint8Array]>} Return a number and a 8 bit unsigned integer array.
     */ async command(op = null, data = new Uint8Array(0), chk = 0, waitResponse = true, timeout = this.DEFAULT_TIMEOUT) {
        if (op != null) {
            if (this.transport.tracing) this.transport.trace(`command op:0x${op.toString(16).padStart(2, "0")} data len=${data.length} wait_response=${waitResponse ? 1 : 0} timeout=${(timeout / 1000).toFixed(3)} data=${this.transport.hexConvert(data)}`);
            const pkt = new Uint8Array(8 + data.length);
            pkt[0] = 0x00;
            pkt[1] = op;
            pkt[2] = this._shortToBytearray(data.length)[0];
            pkt[3] = this._shortToBytearray(data.length)[1];
            pkt[4] = this._intToByteArray(chk)[0];
            pkt[5] = this._intToByteArray(chk)[1];
            pkt[6] = this._intToByteArray(chk)[2];
            pkt[7] = this._intToByteArray(chk)[3];
            let i;
            for(i = 0; i < data.length; i++)pkt[8 + i] = data[i];
            await this.transport.write(pkt);
        }
        if (!waitResponse) return [
            0,
            new Uint8Array(0)
        ];
        return this.readPacket(op, timeout);
    }
    /**
     * Read a register from chip.
     * @param {number} addr - Register address number
     * @param {number} timeout - Timeout in milliseconds (Default: 3000ms)
     * @returns {number} - Command number value
     */ async readReg(addr, timeout = this.DEFAULT_TIMEOUT) {
        const pkt = this._intToByteArray(addr);
        const val = await this.command(this.ESP_READ_REG, pkt, undefined, undefined, timeout);
        return val[0];
    }
    /**
     * Write a number value to register address in chip.
     * @param {number} addr - Register address number
     * @param {number} value - Number value to write in register
     * @param {number} mask - Hex number for mask
     * @param {number} delayUs Delay number
     * @param {number} delayAfterUs Delay after previous delay
     */ async writeReg(addr, value, mask = 0xffffffff, delayUs = 0, delayAfterUs = 0) {
        let pkt = this._appendArray(this._intToByteArray(addr), this._intToByteArray(value));
        pkt = this._appendArray(pkt, this._intToByteArray(mask));
        pkt = this._appendArray(pkt, this._intToByteArray(delayUs));
        if (delayAfterUs > 0) {
            pkt = this._appendArray(pkt, this._intToByteArray(this.chip.UART_DATE_REG_ADDR));
            pkt = this._appendArray(pkt, this._intToByteArray(0));
            pkt = this._appendArray(pkt, this._intToByteArray(0));
            pkt = this._appendArray(pkt, this._intToByteArray(delayAfterUs));
        }
        await this.checkCommand("write target memory", this.ESP_WRITE_REG, pkt);
    }
    /**
     * Sync chip by sending sync command.
     * @returns {[number, Uint8Array]} Command result
     */ async sync() {
        this.debug("Sync");
        const cmd = new Uint8Array(36);
        let i;
        cmd[0] = 0x07;
        cmd[1] = 0x07;
        cmd[2] = 0x12;
        cmd[3] = 0x20;
        for(i = 0; i < 32; i++)cmd[4 + i] = 0x55;
        try {
            let resp = await this.command(0x08, cmd, undefined, undefined, 100);
            // ROM bootloaders send some non-zero "val" response. The flasher stub sends 0.
            // If we receive 0 then it probably indicates that the chip wasn't or couldn't be
            // reset properly and esptool is talking to the flasher stub.
            this.syncStubDetected = resp[0] === 0;
            for(let i = 0; i < 7; i++){
                resp = await this.command();
                this.syncStubDetected = this.syncStubDetected && resp[0] === 0;
            }
            return resp;
        } catch (e) {
            this.debug("Sync err " + e);
            throw e;
        }
    }
    /**
     * Attempt to connect to the chip by sending a reset sequence and later a sync command.
     * @param {string} mode - Reset mode to use
     * @param {ResetStrategy} resetStrategy - Reset strategy class to use for connect
     * @returns {string} - Returns 'success' or 'error' message.
     */ async _connectAttempt(mode = "default_reset", resetStrategy) {
        this.debug("_connect_attempt " + mode);
        if (resetStrategy) await resetStrategy.reset();
        const waitingBytes = this.transport.inWaiting();
        const readBytes = await this.transport.newRead(waitingBytes > 0 ? waitingBytes : 1, this.DEFAULT_TIMEOUT);
        const binaryString = Array.from(readBytes, (byte)=>String.fromCharCode(byte)).join("");
        const regex = /boot:(0x[0-9a-fA-F]+)(.*waiting for download)?/;
        const match = binaryString.match(regex);
        let bootLogDetected = false, bootMode = "", downloadMode = false;
        if (match) {
            bootLogDetected = true;
            bootMode = match[1];
            downloadMode = !!match[2];
        }
        let lastError = "";
        for(let i = 0; i < 5; i++)try {
            this.debug(`Sync connect attempt ${i}`);
            const resp = await this.sync();
            this.debug(resp[0].toString());
            return "success";
        } catch (error) {
            this.debug(`Error at sync ${error}`);
            if (error instanceof Error) lastError = error.message;
            else if (typeof error === "string") lastError = error;
            else lastError = JSON.stringify(error);
        }
        if (bootLogDetected) {
            lastError = `Wrong boot mode detected (${bootMode}).
        This chip needs to be in download mode.`;
            if (downloadMode) lastError = `Download mode successfully detected, but getting no sync reply:
           The serial TX path seems to be down.`;
        }
        return lastError;
    }
    /**
     * Constructs a sequence of reset strategies based on the OS,
     * used ESP chip, external settings, and environment variables.
     * Returns a tuple of one or more reset strategies to be tried sequentially.
     * @param {string} mode - Reset mode to use
     * @returns {ResetStrategy[]} - Array of reset strategies
     */ constructResetSequence(mode) {
        if (mode !== "no_reset") {
            if (mode === "usb_reset" || this.transport.getPid() === this.USB_JTAG_SERIAL_PID) // Custom reset sequence, which is required when the device
            // is connecting via its USB-JTAG-Serial peripheral
            {
                if (this.resetConstructors.usbJTAGSerialReset) {
                    this.debug("using USB JTAG Serial Reset");
                    return [
                        this.resetConstructors.usbJTAGSerialReset(this.transport)
                    ];
                }
            } else {
                const DEFAULT_RESET_DELAY = 50;
                const EXTRA_DELAY = DEFAULT_RESET_DELAY + 500;
                if (this.resetConstructors.classicReset) {
                    this.debug("using Classic Serial Reset");
                    return [
                        this.resetConstructors.classicReset(this.transport, DEFAULT_RESET_DELAY),
                        this.resetConstructors.classicReset(this.transport, EXTRA_DELAY)
                    ];
                }
            }
        }
        return [];
    }
    /**
     * Perform a connection to chip.
     * @param {string} mode - Reset mode to use. Example: 'default_reset' | 'no_reset'
     * @param {number} attempts - Number of connection attempts
     * @param {boolean} detecting - Detect the connected chip
     */ async connect(mode = "default_reset", attempts = 7, detecting = true) {
        let resp;
        this.info("Connecting...", false);
        await this.transport.connect(this.romBaudrate, this.serialOptions);
        const resetSequences = this.constructResetSequence(mode);
        for(let i = 0; i < attempts; i++){
            const resetSequence = resetSequences.length > 0 ? resetSequences[i % resetSequences.length] : null;
            resp = await this._connectAttempt(mode, resetSequence);
            if (resp === "success") break;
        }
        if (resp !== "success") throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Failed to connect with the device");
        this.debug("Connect attempt successful.");
        this.info("\n\r", false);
        if (detecting) {
            const chipMagicValue = await this.readReg(this.CHIP_DETECT_MAGIC_REG_ADDR) >>> 0;
            this.debug("Chip Magic " + chipMagicValue.toString(16));
            const chip = await $3dfdd479d6d4e3ee$var$magic2Chip(chipMagicValue);
            if (this.chip === null) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)(`Unexpected CHIP magic value ${chipMagicValue}. Failed to autodetect chip type.`);
            else this.chip = chip;
        }
    }
    /**
     * Connect and detect the existing chip.
     * @param {string} mode Reset mode to use for connection.
     */ async detectChip(mode = "default_reset") {
        await this.connect(mode);
        this.info("Detecting chip type... ", false);
        if (this.chip != null) this.info(this.chip.CHIP_NAME);
        else this.info("unknown!");
    }
    /**
     * Execute the command and check the command response.
     * @param {string} opDescription Command operation description.
     * @param {number} op Command operation number
     * @param {Uint8Array} data Command value
     * @param {number} chk Checksum to use
     * @param {number} timeout TImeout number in milliseconds (ms)
     * @returns {number} Command result
     */ async checkCommand(opDescription = "", op = null, data = new Uint8Array(0), chk = 0, timeout = this.DEFAULT_TIMEOUT) {
        this.debug("check_command " + opDescription);
        const resp = await this.command(op, data, chk, undefined, timeout);
        if (resp[1].length > 4) return resp[1];
        else return resp[0];
    }
    /**
     * Start downloading an application image to RAM
     * @param {number} size Image size number
     * @param {number} blocks Number of data blocks
     * @param {number} blocksize Size of each data block
     * @param {number} offset Image offset number
     */ async memBegin(size, blocks, blocksize, offset) {
        /* XXX: Add check to ensure that STUB is not getting overwritten */ if (this.IS_STUB) {
            const loadStart = offset;
            const loadEnd = offset + size;
            const stub = await (0, $cc3a88799d80a5ec$export$575862e1d5c85871)(this.chip.CHIP_NAME);
            if (stub) {
                const areasToCheck = [
                    [
                        stub.bss_start || stub.data_start,
                        stub.data_start + stub.decodedData.length
                    ],
                    [
                        stub.text_start,
                        stub.text_start + stub.decodedText.length
                    ]
                ];
                for (const [stubStart, stubEnd] of areasToCheck){
                    if (loadStart < stubEnd && loadEnd > stubStart) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)(`Software loader is resident at 0x${stubStart.toString(16).padStart(8, "0")}-0x${stubEnd.toString(16).padStart(8, "0")}.
            Can't load binary at overlapping address range 0x${loadStart.toString(16).padStart(8, "0")}-0x${loadEnd.toString(16).padStart(8, "0")}.
            Either change binary loading address, or use the no-stub option to disable the software loader.`);
                }
            }
        }
        this.debug("mem_begin " + size + " " + blocks + " " + blocksize + " " + offset.toString(16));
        let pkt = this._appendArray(this._intToByteArray(size), this._intToByteArray(blocks));
        pkt = this._appendArray(pkt, this._intToByteArray(blocksize));
        pkt = this._appendArray(pkt, this._intToByteArray(offset));
        await this.checkCommand("enter RAM download mode", this.ESP_MEM_BEGIN, pkt);
    }
    /**
     * Get the checksum for given unsigned 8-bit array
     * @param {Uint8Array} data Unsigned 8-bit integer array
     * @param {number} state Initial checksum
     * @returns {number} - Array checksum
     */ checksum(data, state = this.ESP_CHECKSUM_MAGIC) {
        for(let i = 0; i < data.length; i++)state ^= data[i];
        return state;
    }
    /**
     * Send a block of image to RAM
     * @param {Uint8Array} buffer Unsigned 8-bit array
     * @param {number} seq Sequence number
     */ async memBlock(buffer, seq) {
        let pkt = this._appendArray(this._intToByteArray(buffer.length), this._intToByteArray(seq));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, buffer);
        const checksum = this.checksum(buffer);
        await this.checkCommand("write to target RAM", this.ESP_MEM_DATA, pkt, checksum);
    }
    /**
     * Leave RAM download mode and run application
     * @param {number} entrypoint - Entrypoint number
     */ async memFinish(entrypoint) {
        const isEntry = entrypoint === 0 ? 1 : 0;
        const pkt = this._appendArray(this._intToByteArray(isEntry), this._intToByteArray(entrypoint));
        await this.checkCommand("leave RAM download mode", this.ESP_MEM_END, pkt, undefined, 200); // XXX: handle non-stub with diff timeout
    }
    /**
     * Configure SPI flash pins
     * @param {number} hspiArg -  Argument for SPI attachment
     */ async flashSpiAttach(hspiArg) {
        const pkt = this._intToByteArray(hspiArg);
        await this.checkCommand("configure SPI flash pins", this.ESP_SPI_ATTACH, pkt);
    }
    /**
     * Scale timeouts which are size-specific.
     * @param {number} secondsPerMb Seconds per megabytes as number
     * @param {number} sizeBytes Size bytes number
     * @returns {number} - Scaled timeout for specified size.
     */ timeoutPerMb(secondsPerMb, sizeBytes) {
        const result = secondsPerMb * (sizeBytes / 1000000);
        if (result < 3000) return 3000;
        else return result;
    }
    /**
     * Start downloading to Flash (performs an erase)
     * @param {number} size Size to erase
     * @param {number} offset Offset to erase
     * @returns {number} Number of blocks (of size self.FLASH_WRITE_SIZE) to write.
     */ async flashBegin(size, offset) {
        const numBlocks = Math.floor((size + this.FLASH_WRITE_SIZE - 1) / this.FLASH_WRITE_SIZE);
        const eraseSize = this.chip.getEraseSize(offset, size);
        const d = new Date();
        const t1 = d.getTime();
        let timeout = 3000;
        if (this.IS_STUB == false) timeout = this.timeoutPerMb(this.ERASE_REGION_TIMEOUT_PER_MB, size);
        this.debug("flash begin " + eraseSize + " " + numBlocks + " " + this.FLASH_WRITE_SIZE + " " + offset + " " + size);
        let pkt = this._appendArray(this._intToByteArray(eraseSize), this._intToByteArray(numBlocks));
        pkt = this._appendArray(pkt, this._intToByteArray(this.FLASH_WRITE_SIZE));
        pkt = this._appendArray(pkt, this._intToByteArray(offset));
        if (this.IS_STUB == false) pkt = this._appendArray(pkt, this._intToByteArray(0)); // XXX: Support encrypted
        await this.checkCommand("enter Flash download mode", this.ESP_FLASH_BEGIN, pkt, undefined, timeout);
        const t2 = d.getTime();
        if (size != 0 && this.IS_STUB == false) this.info("Took " + (t2 - t1) / 1000 + "." + (t2 - t1) % 1000 + "s to erase flash block");
        return numBlocks;
    }
    /**
     * Start downloading compressed data to Flash (performs an erase)
     * @param {number} size Write size
     * @param {number} compsize Compressed size
     * @param {number} offset Offset for write
     * @returns {number} Returns number of blocks (size self.FLASH_WRITE_SIZE) to write.
     */ async flashDeflBegin(size, compsize, offset) {
        const numBlocks = Math.floor((compsize + this.FLASH_WRITE_SIZE - 1) / this.FLASH_WRITE_SIZE);
        const eraseBlocks = Math.floor((size + this.FLASH_WRITE_SIZE - 1) / this.FLASH_WRITE_SIZE);
        const d = new Date();
        const t1 = d.getTime();
        let writeSize, timeout;
        if (this.IS_STUB) {
            writeSize = size;
            timeout = this.DEFAULT_TIMEOUT;
        } else {
            writeSize = eraseBlocks * this.FLASH_WRITE_SIZE;
            timeout = this.timeoutPerMb(this.ERASE_REGION_TIMEOUT_PER_MB, writeSize);
        }
        this.info("Compressed " + size + " bytes to " + compsize + "...");
        let pkt = this._appendArray(this._intToByteArray(writeSize), this._intToByteArray(numBlocks));
        pkt = this._appendArray(pkt, this._intToByteArray(this.FLASH_WRITE_SIZE));
        pkt = this._appendArray(pkt, this._intToByteArray(offset));
        if ((this.chip.CHIP_NAME === "ESP32-S2" || this.chip.CHIP_NAME === "ESP32-S3" || this.chip.CHIP_NAME === "ESP32-C3" || this.chip.CHIP_NAME === "ESP32-C2") && this.IS_STUB === false) pkt = this._appendArray(pkt, this._intToByteArray(0));
        await this.checkCommand("enter compressed flash mode", this.ESP_FLASH_DEFL_BEGIN, pkt, undefined, timeout);
        const t2 = d.getTime();
        if (size != 0 && this.IS_STUB === false) this.info("Took " + (t2 - t1) / 1000 + "." + (t2 - t1) % 1000 + "s to erase flash block");
        return numBlocks;
    }
    /**
     * Write block to flash, retry if fail
     * @param {Uint8Array} data Unsigned 8-bit array data.
     * @param {number} seq Sequence number
     * @param {number} timeout Timeout in milliseconds (ms)
     */ async flashBlock(data, seq, timeout) {
        let pkt = this._appendArray(this._intToByteArray(data.length), this._intToByteArray(seq));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, data);
        const checksum = this.checksum(data);
        await this.checkCommand("write to target Flash after seq " + seq, this.ESP_FLASH_DATA, pkt, checksum, timeout);
    }
    /**
     * Write block to flash, send compressed, retry if fail
     * @param {Uint8Array} data Unsigned int 8-bit array data to write
     * @param {number} seq Sequence number
     * @param {number} timeout Timeout in milliseconds (ms)
     */ async flashDeflBlock(data, seq, timeout) {
        let pkt = this._appendArray(this._intToByteArray(data.length), this._intToByteArray(seq));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, data);
        const checksum = this.checksum(data);
        this.debug("flash_defl_block " + data[0].toString(16) + " " + data[1].toString(16));
        await this.checkCommand("write compressed data to flash after seq " + seq, this.ESP_FLASH_DEFL_DATA, pkt, checksum, timeout);
    }
    /**
     * Leave flash mode and run/reboot
     * @param {boolean} reboot Reboot after leaving flash mode ?
     */ async flashFinish(reboot = false) {
        const val = reboot ? 0 : 1;
        const pkt = this._intToByteArray(val);
        await this.checkCommand("leave Flash mode", this.ESP_FLASH_END, pkt);
    }
    /**
     * Leave compressed flash mode and run/reboot
     * @param {boolean} reboot Reboot after leaving flash mode ?
     */ async flashDeflFinish(reboot = false) {
        const val = reboot ? 0 : 1;
        const pkt = this._intToByteArray(val);
        await this.checkCommand("leave compressed flash mode", this.ESP_FLASH_DEFL_END, pkt);
    }
    /**
     * Run an arbitrary SPI flash command.
     *
     * This function uses the "USR_COMMAND" functionality in the ESP
     * SPI hardware, rather than the precanned commands supported by
     * hardware. So the value of spiflashCommand is an actual command
     * byte, sent over the wire.
     *
     * After writing command byte, writes 'data' to MOSI and then
     * reads back 'readBits' of reply on MISO. Result is a number.
     * @param {number} spiflashCommand Command to execute in SPI
     * @param {Uint8Array} data Data to send
     * @param {number} readBits Number of bits to read
     * @returns {number} Register SPI_W0_REG value
     */ async runSpiflashCommand(spiflashCommand, data, readBits) {
        // SPI_USR register flags
        const SPI_USR_COMMAND = -2147483648;
        const SPI_USR_MISO = 268435456;
        const SPI_USR_MOSI = 134217728;
        // SPI registers, base address differs ESP32* vs 8266
        const base = this.chip.SPI_REG_BASE;
        const SPI_CMD_REG = base + 0x00;
        const SPI_USR_REG = base + this.chip.SPI_USR_OFFS;
        const SPI_USR1_REG = base + this.chip.SPI_USR1_OFFS;
        const SPI_USR2_REG = base + this.chip.SPI_USR2_OFFS;
        const SPI_W0_REG = base + this.chip.SPI_W0_OFFS;
        let setDataLengths;
        if (this.chip.SPI_MOSI_DLEN_OFFS != null) setDataLengths = async (mosiBits, misoBits)=>{
            const SPI_MOSI_DLEN_REG = base + this.chip.SPI_MOSI_DLEN_OFFS;
            const SPI_MISO_DLEN_REG = base + this.chip.SPI_MISO_DLEN_OFFS;
            if (mosiBits > 0) await this.writeReg(SPI_MOSI_DLEN_REG, mosiBits - 1);
            if (misoBits > 0) await this.writeReg(SPI_MISO_DLEN_REG, misoBits - 1);
        };
        else setDataLengths = async (mosiBits, misoBits)=>{
            const SPI_DATA_LEN_REG = SPI_USR1_REG;
            const SPI_MOSI_BITLEN_S = 17;
            const SPI_MISO_BITLEN_S = 8;
            const mosiMask = mosiBits === 0 ? 0 : mosiBits - 1;
            const misoMask = misoBits === 0 ? 0 : misoBits - 1;
            const val = misoMask << SPI_MISO_BITLEN_S | mosiMask << SPI_MOSI_BITLEN_S;
            await this.writeReg(SPI_DATA_LEN_REG, val);
        };
        const SPI_CMD_USR = 262144;
        const SPI_USR2_COMMAND_LEN_SHIFT = 28;
        if (readBits > 32) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Reading more than 32 bits back from a SPI flash operation is unsupported");
        if (data.length > 64) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Writing more than 64 bytes of data with one SPI command is unsupported");
        const dataBits = data.length * 8;
        const oldSpiUsr = await this.readReg(SPI_USR_REG);
        const oldSpiUsr2 = await this.readReg(SPI_USR2_REG);
        let flags = SPI_USR_COMMAND;
        let i;
        if (readBits > 0) flags |= SPI_USR_MISO;
        if (dataBits > 0) flags |= SPI_USR_MOSI;
        await setDataLengths(dataBits, readBits);
        await this.writeReg(SPI_USR_REG, flags);
        let val = 7 << SPI_USR2_COMMAND_LEN_SHIFT | spiflashCommand;
        await this.writeReg(SPI_USR2_REG, val);
        if (dataBits == 0) await this.writeReg(SPI_W0_REG, 0);
        else {
            if (data.length % 4 != 0) {
                const padding = new Uint8Array(data.length % 4);
                data = this._appendArray(data, padding);
            }
            let nextReg = SPI_W0_REG;
            for(i = 0; i < data.length - 4; i += 4){
                val = this._byteArrayToInt(data[i], data[i + 1], data[i + 2], data[i + 3]);
                await this.writeReg(nextReg, val);
                nextReg += 4;
            }
        }
        await this.writeReg(SPI_CMD_REG, SPI_CMD_USR);
        for(i = 0; i < 10; i++){
            val = await this.readReg(SPI_CMD_REG) & SPI_CMD_USR;
            if (val == 0) break;
        }
        if (i === 10) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("SPI command did not complete in time");
        const stat = await this.readReg(SPI_W0_REG);
        await this.writeReg(SPI_USR_REG, oldSpiUsr);
        await this.writeReg(SPI_USR2_REG, oldSpiUsr2);
        return stat;
    }
    /**
     * Read flash id by executing the SPIFLASH_RDID flash command.
     * @returns {Promise<number>} Register SPI_W0_REG value
     */ async readFlashId() {
        const SPIFLASH_RDID = 0x9f;
        const pkt = new Uint8Array(0);
        return await this.runSpiflashCommand(SPIFLASH_RDID, pkt, 24);
    }
    /**
     * Execute the erase flash command
     * @returns {Promise<number | Uint8Array>} Erase flash command result
     */ async eraseFlash() {
        this.info("Erasing flash (this may take a while)...");
        let d = new Date();
        const t1 = d.getTime();
        const ret = await this.checkCommand("erase flash", this.ESP_ERASE_FLASH, undefined, undefined, this.CHIP_ERASE_TIMEOUT);
        d = new Date();
        const t2 = d.getTime();
        this.info("Chip erase completed successfully in " + (t2 - t1) / 1000 + "s");
        return ret;
    }
    /**
     * Convert a number or unsigned 8-bit array to hex string
     * @param {number | Uint8Array } buffer Data to convert to hex string.
     * @returns {string} A hex string
     */ toHex(buffer) {
        return Array.prototype.map.call(buffer, (x)=>("00" + x.toString(16)).slice(-2)).join("");
    }
    /**
     * Calculate the MD5 Checksum command
     * @param {number} addr Address number
     * @param {number} size Package size
     * @returns {string} MD5 Checksum string
     */ async flashMd5sum(addr, size) {
        const timeout = this.timeoutPerMb(this.MD5_TIMEOUT_PER_MB, size);
        let pkt = this._appendArray(this._intToByteArray(addr), this._intToByteArray(size));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        pkt = this._appendArray(pkt, this._intToByteArray(0));
        let res = await this.checkCommand("calculate md5sum", this.ESP_SPI_FLASH_MD5, pkt, undefined, timeout);
        if (res instanceof Uint8Array && res.length > 16) res = res.slice(0, 16);
        const strmd5 = this.toHex(res);
        return strmd5;
    }
    async readFlash(addr, size, onPacketReceived = null) {
        let pkt = this._appendArray(this._intToByteArray(addr), this._intToByteArray(size));
        pkt = this._appendArray(pkt, this._intToByteArray(0x1000));
        pkt = this._appendArray(pkt, this._intToByteArray(1024));
        const res = await this.checkCommand("read flash", this.ESP_READ_FLASH, pkt);
        if (res != 0) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Failed to read memory: " + res);
        let resp = new Uint8Array(0);
        while(resp.length < size){
            const { value: packet } = await this.transport.read(this.FLASH_READ_TIMEOUT).next();
            if (packet instanceof Uint8Array) {
                if (packet.length > 0) {
                    resp = this._appendArray(resp, packet);
                    await this.transport.write(this._intToByteArray(resp.length));
                    if (onPacketReceived) onPacketReceived(packet, resp.length, size);
                }
            } else throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Failed to read memory: " + packet);
        }
        return resp;
    }
    /**
     * Upload the flasher ROM bootloader (flasher stub) to the chip.
     * @returns {ROM} The Chip ROM
     */ async runStub() {
        if (this.syncStubDetected) {
            this.info("Stub is already running. No upload is necessary.");
            return this.chip;
        }
        this.info("Uploading stub...");
        const stubFlasher = await (0, $cc3a88799d80a5ec$export$575862e1d5c85871)(this.chip.CHIP_NAME);
        if (stubFlasher === undefined) {
            this.debug("Error loading Stub json");
            throw new Error("Error loading Stub json");
        }
        const stub = [
            stubFlasher.decodedText,
            stubFlasher.decodedData
        ];
        for(let i = 0; i < stub.length; i++)if (stub[i]) {
            const offs = i === 0 ? stubFlasher.text_start : stubFlasher.data_start;
            const length = stub[i].length;
            const blocks = Math.floor((length + this.ESP_RAM_BLOCK - 1) / this.ESP_RAM_BLOCK);
            await this.memBegin(length, blocks, this.ESP_RAM_BLOCK, offs);
            for(let seq = 0; seq < blocks; seq++){
                const fromOffs = seq * this.ESP_RAM_BLOCK;
                const toOffs = fromOffs + this.ESP_RAM_BLOCK;
                await this.memBlock(stub[i].slice(fromOffs, toOffs), seq);
            }
        }
        this.info("Running stub...");
        await this.memFinish(stubFlasher.entry);
        const { value: packetResult } = await this.transport.read(this.DEFAULT_TIMEOUT).next();
        const packetStr = String.fromCharCode(...packetResult);
        if (packetStr !== "OHAI") throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)(`Failed to start stub. Unexpected response ${packetStr}`);
        this.info("Stub running...");
        this.IS_STUB = true;
        return this.chip;
    }
    /**
     * Change the chip baudrate.
     */ async changeBaud() {
        this.info("Changing baudrate to " + this.baudrate);
        const secondArg = this.IS_STUB ? this.romBaudrate : 0;
        const pkt = this._appendArray(this._intToByteArray(this.baudrate), this._intToByteArray(secondArg));
        await this.command(this.ESP_CHANGE_BAUDRATE, pkt);
        this.info("Changed");
        await this.transport.disconnect();
        await this._sleep(50);
        await this.transport.connect(this.baudrate, this.serialOptions);
    }
    /**
     * Execute the main function of ESPLoader.
     * @param {string} mode Reset mode to use
     * @returns {string} chip ROM
     */ async main(mode = "default_reset") {
        await this.detectChip(mode);
        const chip = await this.chip.getChipDescription(this);
        this.info("Chip is " + chip);
        this.info("Features: " + await this.chip.getChipFeatures(this));
        this.info("Crystal is " + await this.chip.getCrystalFreq(this) + "MHz");
        this.info("MAC: " + await this.chip.readMac(this));
        await this.chip.readMac(this);
        if (typeof this.chip.postConnect != "undefined") await this.chip.postConnect(this);
        await this.runStub();
        if (this.romBaudrate !== this.baudrate) await this.changeBaud();
        return chip;
    }
    /**
     * Parse a given flash size string to a number
     * @param {string} flsz Flash size to request
     * @returns {number} Flash size number
     */ parseFlashSizeArg(flsz) {
        if (typeof this.chip.FLASH_SIZES[flsz] === "undefined") throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Flash size " + flsz + " is not supported by this chip type. Supported sizes: " + this.chip.FLASH_SIZES);
        return this.chip.FLASH_SIZES[flsz];
    }
    /**
     * Update the image flash parameters with given arguments.
     * @param {string} image binary image as string
     * @param {number} address flash address number
     * @param {string} flashSize Flash size string
     * @param {string} flashMode Flash mode string
     * @param {string} flashFreq Flash frequency string
     * @returns {string} modified image string
     */ _updateImageFlashParams(image, address, flashSize, flashMode, flashFreq) {
        this.debug("_update_image_flash_params " + flashSize + " " + flashMode + " " + flashFreq);
        if (image.length < 8) return image;
        if (address != this.chip.BOOTLOADER_FLASH_OFFSET) return image;
        if (flashSize === "keep" && flashMode === "keep" && flashFreq === "keep") {
            this.info("Not changing the image");
            return image;
        }
        const magic = parseInt(image[0]);
        let aFlashMode = parseInt(image[2]);
        const flashSizeFreq = parseInt(image[3]);
        if (magic !== this.ESP_IMAGE_MAGIC) {
            this.info("Warning: Image file at 0x" + address.toString(16) + " doesn't look like an image file, so not changing any flash settings.");
            return image;
        }
        /* XXX: Yet to implement actual image verification */ if (flashMode !== "keep") {
            const flashModes = {
                qio: 0,
                qout: 1,
                dio: 2,
                dout: 3
            };
            aFlashMode = flashModes[flashMode];
        }
        let aFlashFreq = flashSizeFreq & 0x0f;
        if (flashFreq !== "keep") {
            const flashFreqs = {
                "40m": 0,
                "26m": 1,
                "20m": 2,
                "80m": 0xf
            };
            aFlashFreq = flashFreqs[flashFreq];
        }
        let aFlashSize = flashSizeFreq & 0xf0;
        if (flashSize !== "keep") aFlashSize = this.parseFlashSizeArg(flashSize);
        const flashParams = aFlashMode << 8 | aFlashFreq + aFlashSize;
        this.info("Flash params set to " + flashParams.toString(16));
        if (parseInt(image[2]) !== aFlashMode << 8) image = image.substring(0, 2) + (aFlashMode << 8).toString() + image.substring(3);
        if (parseInt(image[3]) !== aFlashFreq + aFlashSize) image = image.substring(0, 3) + (aFlashFreq + aFlashSize).toString() + image.substring(4);
        return image;
    }
    /**
     * Write set of file images into given address based on given FlashOptions object.
     * @param {FlashOptions} options FlashOptions to configure how and what to write into flash.
     */ async writeFlash(options) {
        this.debug("EspLoader program");
        if (options.flashSize !== "keep") {
            const flashEnd = this.flashSizeBytes(options.flashSize);
            for(let i = 0; i < options.fileArray.length; i++){
                if (options.fileArray[i].data.length + options.fileArray[i].address > flashEnd) throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)(`File ${i + 1} doesn't fit in the available flash`);
            }
        }
        if (this.IS_STUB === true && options.eraseAll === true) await this.eraseFlash();
        let image, address;
        for(let i = 0; i < options.fileArray.length; i++){
            this.debug("Data Length " + options.fileArray[i].data.length);
            image = options.fileArray[i].data;
            this.debug("Image Length " + image.length);
            if (image.length === 0) {
                this.debug("Warning: File is empty");
                continue;
            }
            image = this.ui8ToBstr((0, $52023bd15cbc1421$export$fcbe1efa6919329)(this.bstrToUi8(image), 4));
            address = options.fileArray[i].address;
            image = this._updateImageFlashParams(image, address, options.flashSize, options.flashMode, options.flashFreq);
            let calcmd5 = null;
            if (options.calculateMD5Hash) {
                calcmd5 = options.calculateMD5Hash(image);
                this.debug("Image MD5 " + calcmd5);
            }
            const uncsize = image.length;
            let blocks;
            if (options.compress) {
                const uncimage = this.bstrToUi8(image);
                image = this.ui8ToBstr((0, $d39304d744af7f63$export$2316623ecd1285ab)(uncimage, {
                    level: 9
                }));
                blocks = await this.flashDeflBegin(uncsize, image.length, address);
            } else blocks = await this.flashBegin(uncsize, address);
            let seq = 0;
            let bytesSent = 0;
            const totalBytes = image.length;
            if (options.reportProgress) options.reportProgress(i, 0, totalBytes);
            let d = new Date();
            const t1 = d.getTime();
            let timeout = 5000;
            // Create a decompressor to keep track of the size of uncompressed data
            // to be written in each chunk.
            const inflate = new (0, $d39304d744af7f63$export$d1de70a877d6e43c)({
                chunkSize: 1
            });
            let totalLenUncompressed = 0;
            inflate.onData = function(chunk) {
                totalLenUncompressed += chunk.byteLength;
            };
            while(image.length > 0){
                this.debug("Write loop " + address + " " + seq + " " + blocks);
                this.info("Writing at 0x" + (address + totalLenUncompressed).toString(16) + "... (" + Math.floor(100 * (seq + 1) / blocks) + "%)");
                const block = this.bstrToUi8(image.slice(0, this.FLASH_WRITE_SIZE));
                if (options.compress) {
                    const lenUncompressedPrevious = totalLenUncompressed;
                    inflate.push(block, false);
                    const blockUncompressed = totalLenUncompressed - lenUncompressedPrevious;
                    let blockTimeout = 3000;
                    if (this.timeoutPerMb(this.ERASE_WRITE_TIMEOUT_PER_MB, blockUncompressed) > 3000) blockTimeout = this.timeoutPerMb(this.ERASE_WRITE_TIMEOUT_PER_MB, blockUncompressed);
                    if (this.IS_STUB === false) // ROM code writes block to flash before ACKing
                    timeout = blockTimeout;
                    await this.flashDeflBlock(block, seq, timeout);
                    if (this.IS_STUB) // Stub ACKs when block is received, then writes to flash while receiving the block after it
                    timeout = blockTimeout;
                } else throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Yet to handle Non Compressed writes");
                bytesSent += block.length;
                image = image.slice(this.FLASH_WRITE_SIZE, image.length);
                seq++;
                if (options.reportProgress) options.reportProgress(i, bytesSent, totalBytes);
            }
            if (this.IS_STUB) await this.readReg(this.CHIP_DETECT_MAGIC_REG_ADDR, timeout);
            d = new Date();
            const t = d.getTime() - t1;
            if (options.compress) this.info("Wrote " + uncsize + " bytes (" + bytesSent + " compressed) at 0x" + address.toString(16) + " in " + t / 1000 + " seconds.");
            if (calcmd5) {
                const res = await this.flashMd5sum(address, uncsize);
                if (new String(res).valueOf() != new String(calcmd5).valueOf()) {
                    this.info("File  md5: " + calcmd5);
                    this.info("Flash md5: " + res);
                    throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("MD5 of file does not match data in flash!");
                } else this.info("Hash of data verified.");
            }
        }
        this.info("Leaving...");
        if (this.IS_STUB) {
            await this.flashBegin(0, 0);
            if (options.compress) await this.flashDeflFinish();
            else await this.flashFinish();
        }
    }
    /**
     * Read SPI flash manufacturer and device id.
     */ async flashId() {
        this.debug("flash_id");
        const flashid = await this.readFlashId();
        this.info("Manufacturer: " + (flashid & 0xff).toString(16));
        const flidLowbyte = flashid >> 16 & 0xff;
        this.info("Device: " + (flashid >> 8 & 0xff).toString(16) + flidLowbyte.toString(16));
        this.info("Detected flash size: " + this.DETECTED_FLASH_SIZES[flidLowbyte]);
    }
    async getFlashSize() {
        this.debug("flash_id");
        const flashid = await this.readFlashId();
        const flidLowbyte = flashid >> 16 & 0xff;
        return this.DETECTED_FLASH_SIZES_NUM[flidLowbyte];
    }
    /**
     * Soft reset the device chip. Soft reset with run user code is the closest.
     * @param {boolean} stayInBootloader Flag to indicate if to stay in bootloader
     */ async softReset(stayInBootloader) {
        if (!this.IS_STUB) {
            if (stayInBootloader) return; // ROM bootloader is already in bootloader!
            // "run user code" is as close to a soft reset as we can do
            await this.flashBegin(0, 0);
            await this.flashFinish(false);
        } else if (this.chip.CHIP_NAME != "ESP8266") throw new (0, $2c3fa0bce65af7c3$export$5b519f82636185ec)("Soft resetting is currently only supported on ESP8266");
        else if (stayInBootloader) {
            // soft resetting from the stub loader
            // will re-load the ROM bootloader
            await this.flashBegin(0, 0);
            await this.flashFinish(true);
        } else // running user code from stub loader requires some hacks
        // in the stub loader
        await this.command(this.ESP_RUN_USER_CODE, undefined, undefined, false);
    }
    /**
     * Execute this function to execute after operation reset functions.
     * @param {After} mode After operation mode. Default is 'hard_reset'.
     * @param { boolean } usingUsbOtg For 'hard_reset' to specify if using USB-OTG
     */ async after(mode = "hard_reset", usingUsbOtg) {
        switch(mode){
            case "hard_reset":
                if (this.resetConstructors.hardReset) {
                    this.info("Hard resetting via RTS pin...");
                    const hardReset = this.resetConstructors.hardReset(this.transport, usingUsbOtg);
                    await hardReset.reset();
                }
                break;
            case "soft_reset":
                this.info("Soft resetting...");
                await this.softReset(false);
                break;
            case "no_reset_stub":
                this.info("Staying in flasher stub.");
                break;
            default:
                this.info("Staying in bootloader.");
                if (this.IS_STUB) this.softReset(true);
                break;
        }
    }
}




var $1l09q = parcelRequire("1l09q");




/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in
 * compliance with the License. You may obtain a copy of
 * the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in
 * writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
 * OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing
 * permissions and limitations under the License.
 */ 'use strict';
var $55a31c8eb06014ca$export$24d5ae9391ffe6e0;
(function(SerialPolyfillProtocol) {
    SerialPolyfillProtocol[SerialPolyfillProtocol["UsbCdcAcm"] = 0] = "UsbCdcAcm";
})($55a31c8eb06014ca$export$24d5ae9391ffe6e0 || ($55a31c8eb06014ca$export$24d5ae9391ffe6e0 = {}));
const $55a31c8eb06014ca$var$kSetLineCoding = 0x20;
const $55a31c8eb06014ca$var$kSetControlLineState = 0x22;
const $55a31c8eb06014ca$var$kSendBreak = 0x23;
const $55a31c8eb06014ca$var$kDefaultBufferSize = 255;
const $55a31c8eb06014ca$var$kDefaultDataBits = 8;
const $55a31c8eb06014ca$var$kDefaultParity = 'none';
const $55a31c8eb06014ca$var$kDefaultStopBits = 1;
const $55a31c8eb06014ca$var$kAcceptableDataBits = [
    16,
    8,
    7,
    6,
    5
];
const $55a31c8eb06014ca$var$kAcceptableStopBits = [
    1,
    2
];
const $55a31c8eb06014ca$var$kAcceptableParity = [
    'none',
    'even',
    'odd'
];
const $55a31c8eb06014ca$var$kParityIndexMapping = [
    'none',
    'odd',
    'even'
];
const $55a31c8eb06014ca$var$kStopBitsIndexMapping = [
    1,
    1.5,
    2
];
const $55a31c8eb06014ca$var$kDefaultPolyfillOptions = {
    protocol: $55a31c8eb06014ca$export$24d5ae9391ffe6e0.UsbCdcAcm,
    usbControlInterfaceClass: 2,
    usbTransferInterfaceClass: 10
};
/**
 * Utility function to get the interface implementing a desired class.
 * @param {USBDevice} device The USB device.
 * @param {number} classCode The desired interface class.
 * @return {USBInterface} The first interface found that implements the desired
 * class.
 * @throws TypeError if no interface is found.
 */ function $55a31c8eb06014ca$var$findInterface(device, classCode) {
    const configuration = device.configurations[0];
    for (const iface of configuration.interfaces){
        const alternate = iface.alternates[0];
        if (alternate.interfaceClass === classCode) return iface;
    }
    throw new TypeError(`Unable to find interface with class ${classCode}.`);
}
/**
 * Utility function to get an endpoint with a particular direction.
 * @param {USBInterface} iface The interface to search.
 * @param {USBDirection} direction The desired transfer direction.
 * @return {USBEndpoint} The first endpoint with the desired transfer direction.
 * @throws TypeError if no endpoint is found.
 */ function $55a31c8eb06014ca$var$findEndpoint(iface, direction) {
    const alternate = iface.alternates[0];
    for (const endpoint of alternate.endpoints){
        if (endpoint.direction == direction) return endpoint;
    }
    throw new TypeError(`Interface ${iface.interfaceNumber} does not have an ` + `${direction} endpoint.`);
}
/**
 * Implementation of the underlying source API[1] which reads data from a USB
 * endpoint. This can be used to construct a ReadableStream.
 *
 * [1]: https://streams.spec.whatwg.org/#underlying-source-api
 */ class $55a31c8eb06014ca$var$UsbEndpointUnderlyingSource {
    /**
     * Constructs a new UnderlyingSource that will pull data from the specified
     * endpoint on the given USB device.
     *
     * @param {USBDevice} device
     * @param {USBEndpoint} endpoint
     * @param {function} onError function to be called on error
     */ constructor(device, endpoint, onError){
        this.type = 'bytes';
        this.device_ = device;
        this.endpoint_ = endpoint;
        this.onError_ = onError;
    }
    /**
     * Reads a chunk of data from the device.
     *
     * @param {ReadableByteStreamController} controller
     */ pull(controller) {
        (async ()=>{
            var _a;
            let chunkSize;
            if (controller.desiredSize) {
                const d = controller.desiredSize / this.endpoint_.packetSize;
                chunkSize = Math.ceil(d) * this.endpoint_.packetSize;
            } else chunkSize = this.endpoint_.packetSize;
            try {
                const result = await this.device_.transferIn(this.endpoint_.endpointNumber, chunkSize);
                if (result.status != 'ok') {
                    controller.error(`USB error: ${result.status}`);
                    this.onError_();
                }
                if ((_a = result.data) === null || _a === void 0 ? void 0 : _a.buffer) {
                    const chunk = new Uint8Array(result.data.buffer, result.data.byteOffset, result.data.byteLength);
                    controller.enqueue(chunk);
                }
            } catch (error) {
                controller.error(error.toString());
                this.onError_();
            }
        })();
    }
}
/**
 * Implementation of the underlying sink API[2] which writes data to a USB
 * endpoint. This can be used to construct a WritableStream.
 *
 * [2]: https://streams.spec.whatwg.org/#underlying-sink-api
 */ class $55a31c8eb06014ca$var$UsbEndpointUnderlyingSink {
    /**
     * Constructs a new UnderlyingSink that will write data to the specified
     * endpoint on the given USB device.
     *
     * @param {USBDevice} device
     * @param {USBEndpoint} endpoint
     * @param {function} onError function to be called on error
     */ constructor(device, endpoint, onError){
        this.device_ = device;
        this.endpoint_ = endpoint;
        this.onError_ = onError;
    }
    /**
     * Writes a chunk to the device.
     *
     * @param {Uint8Array} chunk
     * @param {WritableStreamDefaultController} controller
     */ async write(chunk, controller) {
        try {
            const result = await this.device_.transferOut(this.endpoint_.endpointNumber, chunk);
            if (result.status != 'ok') {
                controller.error(result.status);
                this.onError_();
            }
        } catch (error) {
            controller.error(error.toString());
            this.onError_();
        }
    }
}
class $55a31c8eb06014ca$export$237d90817cb05a2f {
    /**
     * constructor taking a WebUSB device that creates a SerialPort instance.
     * @param {USBDevice} device A device acquired from the WebUSB API
     * @param {SerialPolyfillOptions} polyfillOptions Optional options to
     * configure the polyfill.
     */ constructor(device, polyfillOptions){
        this.polyfillOptions_ = Object.assign(Object.assign({}, $55a31c8eb06014ca$var$kDefaultPolyfillOptions), polyfillOptions);
        this.outputSignals_ = {
            dataTerminalReady: false,
            requestToSend: false,
            break: false
        };
        this.device_ = device;
        this.controlInterface_ = $55a31c8eb06014ca$var$findInterface(this.device_, this.polyfillOptions_.usbControlInterfaceClass);
        this.transferInterface_ = $55a31c8eb06014ca$var$findInterface(this.device_, this.polyfillOptions_.usbTransferInterfaceClass);
        this.inEndpoint_ = $55a31c8eb06014ca$var$findEndpoint(this.transferInterface_, 'in');
        this.outEndpoint_ = $55a31c8eb06014ca$var$findEndpoint(this.transferInterface_, 'out');
    }
    /**
     * Getter for the readable attribute. Constructs a new ReadableStream as
     * necessary.
     * @return {ReadableStream} the current readable stream
     */ get readable() {
        var _a;
        if (!this.readable_ && this.device_.opened) this.readable_ = new ReadableStream(new $55a31c8eb06014ca$var$UsbEndpointUnderlyingSource(this.device_, this.inEndpoint_, ()=>{
            this.readable_ = null;
        }), {
            highWaterMark: (_a = this.serialOptions_.bufferSize) !== null && _a !== void 0 ? _a : $55a31c8eb06014ca$var$kDefaultBufferSize
        });
        return this.readable_;
    }
    /**
     * Getter for the writable attribute. Constructs a new WritableStream as
     * necessary.
     * @return {WritableStream} the current writable stream
     */ get writable() {
        var _a;
        if (!this.writable_ && this.device_.opened) this.writable_ = new WritableStream(new $55a31c8eb06014ca$var$UsbEndpointUnderlyingSink(this.device_, this.outEndpoint_, ()=>{
            this.writable_ = null;
        }), new ByteLengthQueuingStrategy({
            highWaterMark: (_a = this.serialOptions_.bufferSize) !== null && _a !== void 0 ? _a : $55a31c8eb06014ca$var$kDefaultBufferSize
        }));
        return this.writable_;
    }
    /**
     * a function that opens the device and claims all interfaces needed to
     * control and communicate to and from the serial device
     * @param {SerialOptions} options Object containing serial options
     * @return {Promise<void>} A promise that will resolve when device is ready
     * for communication
     */ async open(options) {
        this.serialOptions_ = options;
        this.validateOptions();
        try {
            await this.device_.open();
            if (this.device_.configuration === null) await this.device_.selectConfiguration(1);
            await this.device_.claimInterface(this.controlInterface_.interfaceNumber);
            if (this.controlInterface_ !== this.transferInterface_) await this.device_.claimInterface(this.transferInterface_.interfaceNumber);
            await this.setLineCoding();
            await this.setSignals({
                dataTerminalReady: true
            });
        } catch (error) {
            if (this.device_.opened) await this.device_.close();
            throw new Error('Error setting up device: ' + error.toString());
        }
    }
    /**
     * Closes the port.
     *
     * @return {Promise<void>} A promise that will resolve when the port is
     * closed.
     */ async close() {
        const promises = [];
        if (this.readable_) promises.push(this.readable_.cancel());
        if (this.writable_) promises.push(this.writable_.abort());
        await Promise.all(promises);
        this.readable_ = null;
        this.writable_ = null;
        if (this.device_.opened) {
            await this.setSignals({
                dataTerminalReady: false,
                requestToSend: false
            });
            await this.device_.close();
        }
    }
    /**
     * Forgets the port.
     *
     * @return {Promise<void>} A promise that will resolve when the port is
     * forgotten.
     */ async forget() {
        return this.device_.forget();
    }
    /**
     * A function that returns properties of the device.
     * @return {SerialPortInfo} Device properties.
     */ getInfo() {
        return {
            usbVendorId: this.device_.vendorId,
            usbProductId: this.device_.productId
        };
    }
    /**
     * A function used to change the serial settings of the device
     * @param {object} options the object which carries serial settings data
     * @return {Promise<void>} A promise that will resolve when the options are
     * set
     */ reconfigure(options) {
        this.serialOptions_ = Object.assign(Object.assign({}, this.serialOptions_), options);
        this.validateOptions();
        return this.setLineCoding();
    }
    /**
     * Sets control signal state for the port.
     * @param {SerialOutputSignals} signals The signals to enable or disable.
     * @return {Promise<void>} a promise that is resolved when the signal state
     * has been changed.
     */ async setSignals(signals) {
        this.outputSignals_ = Object.assign(Object.assign({}, this.outputSignals_), signals);
        if (signals.dataTerminalReady !== undefined || signals.requestToSend !== undefined) {
            // The Set_Control_Line_State command expects a bitmap containing the
            // values of all output signals that should be enabled or disabled.
            //
            // Ref: USB CDC specification version 1.1 §6.2.14.
            const value = (this.outputSignals_.dataTerminalReady ? 1 : 0) | (this.outputSignals_.requestToSend ? 2 : 0);
            await this.device_.controlTransferOut({
                'requestType': 'class',
                'recipient': 'interface',
                'request': $55a31c8eb06014ca$var$kSetControlLineState,
                'value': value,
                'index': this.controlInterface_.interfaceNumber
            });
        }
        if (signals.break !== undefined) {
            // The SendBreak command expects to be given a duration for how long the
            // break signal should be asserted. Passing 0xFFFF enables the signal
            // until 0x0000 is send.
            //
            // Ref: USB CDC specification version 1.1 §6.2.15.
            const value = this.outputSignals_.break ? 0xFFFF : 0x0000;
            await this.device_.controlTransferOut({
                'requestType': 'class',
                'recipient': 'interface',
                'request': $55a31c8eb06014ca$var$kSendBreak,
                'value': value,
                'index': this.controlInterface_.interfaceNumber
            });
        }
    }
    /**
     * Checks the serial options for validity and throws an error if it is
     * not valid
     */ validateOptions() {
        if (!this.isValidBaudRate(this.serialOptions_.baudRate)) throw new RangeError('invalid Baud Rate ' + this.serialOptions_.baudRate);
        if (!this.isValidDataBits(this.serialOptions_.dataBits)) throw new RangeError('invalid dataBits ' + this.serialOptions_.dataBits);
        if (!this.isValidStopBits(this.serialOptions_.stopBits)) throw new RangeError('invalid stopBits ' + this.serialOptions_.stopBits);
        if (!this.isValidParity(this.serialOptions_.parity)) throw new RangeError('invalid parity ' + this.serialOptions_.parity);
    }
    /**
     * Checks the baud rate for validity
     * @param {number} baudRate the baud rate to check
     * @return {boolean} A boolean that reflects whether the baud rate is valid
     */ isValidBaudRate(baudRate) {
        return baudRate % 1 === 0;
    }
    /**
     * Checks the data bits for validity
     * @param {number} dataBits the data bits to check
     * @return {boolean} A boolean that reflects whether the data bits setting is
     * valid
     */ isValidDataBits(dataBits) {
        if (typeof dataBits === 'undefined') return true;
        return $55a31c8eb06014ca$var$kAcceptableDataBits.includes(dataBits);
    }
    /**
     * Checks the stop bits for validity
     * @param {number} stopBits the stop bits to check
     * @return {boolean} A boolean that reflects whether the stop bits setting is
     * valid
     */ isValidStopBits(stopBits) {
        if (typeof stopBits === 'undefined') return true;
        return $55a31c8eb06014ca$var$kAcceptableStopBits.includes(stopBits);
    }
    /**
     * Checks the parity for validity
     * @param {string} parity the parity to check
     * @return {boolean} A boolean that reflects whether the parity is valid
     */ isValidParity(parity) {
        if (typeof parity === 'undefined') return true;
        return $55a31c8eb06014ca$var$kAcceptableParity.includes(parity);
    }
    /**
     * sends the options alog the control interface to set them on the device
     * @return {Promise} a promise that will resolve when the options are set
     */ async setLineCoding() {
        var _a, _b, _c;
        // Ref: USB CDC specification version 1.1 §6.2.12.
        const buffer = new ArrayBuffer(7);
        const view = new DataView(buffer);
        view.setUint32(0, this.serialOptions_.baudRate, true);
        view.setUint8(4, $55a31c8eb06014ca$var$kStopBitsIndexMapping.indexOf((_a = this.serialOptions_.stopBits) !== null && _a !== void 0 ? _a : $55a31c8eb06014ca$var$kDefaultStopBits));
        view.setUint8(5, $55a31c8eb06014ca$var$kParityIndexMapping.indexOf((_b = this.serialOptions_.parity) !== null && _b !== void 0 ? _b : $55a31c8eb06014ca$var$kDefaultParity));
        view.setUint8(6, (_c = this.serialOptions_.dataBits) !== null && _c !== void 0 ? _c : $55a31c8eb06014ca$var$kDefaultDataBits);
        const result = await this.device_.controlTransferOut({
            'requestType': 'class',
            'recipient': 'interface',
            'request': $55a31c8eb06014ca$var$kSetLineCoding,
            'value': 0x00,
            'index': this.controlInterface_.interfaceNumber
        }, buffer);
        if (result.status != 'ok') throw new DOMException('NetworkError', 'Failed to set line coding.');
    }
}
/** implementation of the global navigator.serial object */ class $55a31c8eb06014ca$var$Serial {
    /**
     * Requests permission to access a new port.
     *
     * @param {SerialPortRequestOptions} options
     * @param {SerialPolyfillOptions} polyfillOptions
     * @return {Promise<SerialPort>}
     */ async requestPort(options, polyfillOptions) {
        polyfillOptions = Object.assign(Object.assign({}, $55a31c8eb06014ca$var$kDefaultPolyfillOptions), polyfillOptions);
        const usbFilters = [];
        if (options && options.filters) for (const filter of options.filters){
            const usbFilter = {
                classCode: polyfillOptions.usbControlInterfaceClass
            };
            if (filter.usbVendorId !== undefined) usbFilter.vendorId = filter.usbVendorId;
            if (filter.usbProductId !== undefined) usbFilter.productId = filter.usbProductId;
            usbFilters.push(usbFilter);
        }
        if (usbFilters.length === 0) usbFilters.push({
            classCode: polyfillOptions.usbControlInterfaceClass
        });
        const device = await navigator.usb.requestDevice({
            'filters': usbFilters
        });
        const port = new $55a31c8eb06014ca$export$237d90817cb05a2f(device, polyfillOptions);
        return port;
    }
    /**
     * Get the set of currently available ports.
     *
     * @param {SerialPolyfillOptions} polyfillOptions Polyfill configuration that
     * should be applied to these ports.
     * @return {Promise<SerialPort[]>} a promise that is resolved with a list of
     * ports.
     */ async getPorts(polyfillOptions) {
        polyfillOptions = Object.assign(Object.assign({}, $55a31c8eb06014ca$var$kDefaultPolyfillOptions), polyfillOptions);
        const devices = await navigator.usb.getDevices();
        const ports = [];
        devices.forEach((device)=>{
            try {
                const port = new $55a31c8eb06014ca$export$237d90817cb05a2f(device, polyfillOptions);
                ports.push(port);
            } catch (e) {
            // Skip unrecognized port.
            }
        });
        return ports;
    }
}
const $55a31c8eb06014ca$export$6c2c9a00e27c07e8 = new $55a31c8eb06014ca$var$Serial();


/**
 * Copyright (c) 2014-2024 The xterm.js authors. All rights reserved.
 * @license MIT
 *
 * Copyright (c) 2012-2013, Christopher Jeffrey (MIT License)
 * @license MIT
 *
 * Originally forked from (with the author's permission):
 *   Fabrice Bellard's javascript vt100 for jslinux:
 *   http://bellard.org/jslinux/
 *   Copyright (c) 2011 Fabrice Bellard
 */ /*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/ var $5c2a9584e51cbabf$var$zs = Object.defineProperty;
var $5c2a9584e51cbabf$var$Rl = Object.getOwnPropertyDescriptor;
var $5c2a9584e51cbabf$var$Ll = (s, t1)=>{
    for(var e in t1)$5c2a9584e51cbabf$var$zs(s, e, {
        get: t1[e],
        enumerable: !0
    });
};
var $5c2a9584e51cbabf$var$M = (s, t1, e, i)=>{
    for(var r = i > 1 ? void 0 : i ? $5c2a9584e51cbabf$var$Rl(t1, e) : t1, n = s.length - 1, o; n >= 0; n--)(o = s[n]) && (r = (i ? o(t1, e, r) : o(r)) || r);
    return i && r && $5c2a9584e51cbabf$var$zs(t1, e, r), r;
}, $5c2a9584e51cbabf$var$S = (s, t1)=>(e, i)=>t1(e, i, s);
var $5c2a9584e51cbabf$var$Gs = "Terminal input", $5c2a9584e51cbabf$var$mi = {
    get: ()=>$5c2a9584e51cbabf$var$Gs,
    set: (s)=>$5c2a9584e51cbabf$var$Gs = s
}, $5c2a9584e51cbabf$var$$s = "Too much output to announce, navigate to rows manually to read", $5c2a9584e51cbabf$var$_i = {
    get: ()=>$5c2a9584e51cbabf$var$$s,
    set: (s)=>$5c2a9584e51cbabf$var$$s = s
};
function $5c2a9584e51cbabf$var$Al(s) {
    return s.replace(/\r?\n/g, "\r");
}
function $5c2a9584e51cbabf$var$kl(s, t1) {
    return t1 ? "\x1B[200~" + s + "\x1B[201~" : s;
}
function $5c2a9584e51cbabf$var$Vs(s, t1) {
    s.clipboardData && s.clipboardData.setData("text/plain", t1.selectionText), s.preventDefault();
}
function $5c2a9584e51cbabf$var$qs(s, t1, e, i) {
    if (s.stopPropagation(), s.clipboardData) {
        let r = s.clipboardData.getData("text/plain");
        $5c2a9584e51cbabf$var$Cn(r, t1, e, i);
    }
}
function $5c2a9584e51cbabf$var$Cn(s, t1, e, i) {
    s = $5c2a9584e51cbabf$var$Al(s), s = $5c2a9584e51cbabf$var$kl(s, e.decPrivateModes.bracketedPasteMode && i.rawOptions.ignoreBracketedPasteMode !== !0), e.triggerDataEvent(s, !0), t1.value = "";
}
function $5c2a9584e51cbabf$var$Mn(s, t1, e) {
    let i = e.getBoundingClientRect(), r = s.clientX - i.left - 10, n = s.clientY - i.top - 10;
    t1.style.width = "20px", t1.style.height = "20px", t1.style.left = `${r}px`, t1.style.top = `${n}px`, t1.style.zIndex = "1000", t1.focus();
}
function $5c2a9584e51cbabf$var$Pn(s, t1, e, i, r) {
    $5c2a9584e51cbabf$var$Mn(s, t1, e), r && i.rightClickSelect(s), t1.value = i.selectionText, t1.select();
}
function $5c2a9584e51cbabf$var$Ce(s) {
    return s > 65535 ? (s -= 65536, String.fromCharCode((s >> 10) + 55296) + String.fromCharCode(s % 1024 + 56320)) : String.fromCharCode(s);
}
function $5c2a9584e51cbabf$var$It(s, t1 = 0, e = s.length) {
    let i = "";
    for(let r = t1; r < e; ++r){
        let n = s[r];
        n > 65535 ? (n -= 65536, i += String.fromCharCode((n >> 10) + 55296) + String.fromCharCode(n % 1024 + 56320)) : i += String.fromCharCode(n);
    }
    return i;
}
var $5c2a9584e51cbabf$var$er = class {
    constructor(){
        this._interim = 0;
    }
    clear() {
        this._interim = 0;
    }
    decode(t1, e) {
        let i = t1.length;
        if (!i) return 0;
        let r = 0, n = 0;
        if (this._interim) {
            let o = t1.charCodeAt(n++);
            56320 <= o && o <= 57343 ? e[r++] = (this._interim - 55296) * 1024 + o - 56320 + 65536 : (e[r++] = this._interim, e[r++] = o), this._interim = 0;
        }
        for(let o = n; o < i; ++o){
            let l = t1.charCodeAt(o);
            if (55296 <= l && l <= 56319) {
                if (++o >= i) return this._interim = l, r;
                let a = t1.charCodeAt(o);
                56320 <= a && a <= 57343 ? e[r++] = (l - 55296) * 1024 + a - 56320 + 65536 : (e[r++] = l, e[r++] = a);
                continue;
            }
            l !== 65279 && (e[r++] = l);
        }
        return r;
    }
}, $5c2a9584e51cbabf$var$tr = class {
    constructor(){
        this.interim = new Uint8Array(3);
    }
    clear() {
        this.interim.fill(0);
    }
    decode(t1, e) {
        let i = t1.length;
        if (!i) return 0;
        let r = 0, n, o, l, a, u = 0, h = 0;
        if (this.interim[0]) {
            let _ = !1, p = this.interim[0];
            p &= (p & 224) === 192 ? 31 : (p & 240) === 224 ? 15 : 7;
            let m = 0, f;
            for(; (f = this.interim[++m] & 63) && m < 4;)p <<= 6, p |= f;
            let A = (this.interim[0] & 224) === 192 ? 2 : (this.interim[0] & 240) === 224 ? 3 : 4, R = A - m;
            for(; h < R;){
                if (h >= i) return 0;
                if (f = t1[h++], (f & 192) !== 128) {
                    h--, _ = !0;
                    break;
                } else this.interim[m++] = f, p <<= 6, p |= f & 63;
            }
            _ || (A === 2 ? p < 128 ? h-- : e[r++] = p : A === 3 ? p < 2048 || p >= 55296 && p <= 57343 || p === 65279 || (e[r++] = p) : p < 65536 || p > 1114111 || (e[r++] = p)), this.interim.fill(0);
        }
        let c = i - 4, d = h;
        for(; d < i;){
            for(; d < c && !((n = t1[d]) & 128) && !((o = t1[d + 1]) & 128) && !((l = t1[d + 2]) & 128) && !((a = t1[d + 3]) & 128);)e[r++] = n, e[r++] = o, e[r++] = l, e[r++] = a, d += 4;
            if (n = t1[d++], n < 128) e[r++] = n;
            else if ((n & 224) === 192) {
                if (d >= i) return this.interim[0] = n, r;
                if (o = t1[d++], (o & 192) !== 128) {
                    d--;
                    continue;
                }
                if (u = (n & 31) << 6 | o & 63, u < 128) {
                    d--;
                    continue;
                }
                e[r++] = u;
            } else if ((n & 240) === 224) {
                if (d >= i) return this.interim[0] = n, r;
                if (o = t1[d++], (o & 192) !== 128) {
                    d--;
                    continue;
                }
                if (d >= i) return this.interim[0] = n, this.interim[1] = o, r;
                if (l = t1[d++], (l & 192) !== 128) {
                    d--;
                    continue;
                }
                if (u = (n & 15) << 12 | (o & 63) << 6 | l & 63, u < 2048 || u >= 55296 && u <= 57343 || u === 65279) continue;
                e[r++] = u;
            } else if ((n & 248) === 240) {
                if (d >= i) return this.interim[0] = n, r;
                if (o = t1[d++], (o & 192) !== 128) {
                    d--;
                    continue;
                }
                if (d >= i) return this.interim[0] = n, this.interim[1] = o, r;
                if (l = t1[d++], (l & 192) !== 128) {
                    d--;
                    continue;
                }
                if (d >= i) return this.interim[0] = n, this.interim[1] = o, this.interim[2] = l, r;
                if (a = t1[d++], (a & 192) !== 128) {
                    d--;
                    continue;
                }
                if (u = (n & 7) << 18 | (o & 63) << 12 | (l & 63) << 6 | a & 63, u < 65536 || u > 1114111) continue;
                e[r++] = u;
            }
        }
        return r;
    }
};
var $5c2a9584e51cbabf$var$ir = "";
var $5c2a9584e51cbabf$var$we = " ";
var $5c2a9584e51cbabf$var$De = class s {
    constructor(){
        this.fg = 0;
        this.bg = 0;
        this.extended = new $5c2a9584e51cbabf$var$rt;
    }
    static toColorRGB(t1) {
        return [
            t1 >>> 16 & 255,
            t1 >>> 8 & 255,
            t1 & 255
        ];
    }
    static fromColorRGB(t1) {
        return (t1[0] & 255) << 16 | (t1[1] & 255) << 8 | t1[2] & 255;
    }
    clone() {
        let t1 = new s;
        return t1.fg = this.fg, t1.bg = this.bg, t1.extended = this.extended.clone(), t1;
    }
    isInverse() {
        return this.fg & 67108864;
    }
    isBold() {
        return this.fg & 134217728;
    }
    isUnderline() {
        return this.hasExtendedAttrs() && this.extended.underlineStyle !== 0 ? 1 : this.fg & 268435456;
    }
    isBlink() {
        return this.fg & 536870912;
    }
    isInvisible() {
        return this.fg & 1073741824;
    }
    isItalic() {
        return this.bg & 67108864;
    }
    isDim() {
        return this.bg & 134217728;
    }
    isStrikethrough() {
        return this.fg & 2147483648;
    }
    isProtected() {
        return this.bg & 536870912;
    }
    isOverline() {
        return this.bg & 1073741824;
    }
    getFgColorMode() {
        return this.fg & 50331648;
    }
    getBgColorMode() {
        return this.bg & 50331648;
    }
    isFgRGB() {
        return (this.fg & 50331648) === 50331648;
    }
    isBgRGB() {
        return (this.bg & 50331648) === 50331648;
    }
    isFgPalette() {
        return (this.fg & 50331648) === 16777216 || (this.fg & 50331648) === 33554432;
    }
    isBgPalette() {
        return (this.bg & 50331648) === 16777216 || (this.bg & 50331648) === 33554432;
    }
    isFgDefault() {
        return (this.fg & 50331648) === 0;
    }
    isBgDefault() {
        return (this.bg & 50331648) === 0;
    }
    isAttributeDefault() {
        return this.fg === 0 && this.bg === 0;
    }
    getFgColor() {
        switch(this.fg & 50331648){
            case 16777216:
            case 33554432:
                return this.fg & 255;
            case 50331648:
                return this.fg & 16777215;
            default:
                return -1;
        }
    }
    getBgColor() {
        switch(this.bg & 50331648){
            case 16777216:
            case 33554432:
                return this.bg & 255;
            case 50331648:
                return this.bg & 16777215;
            default:
                return -1;
        }
    }
    hasExtendedAttrs() {
        return this.bg & 268435456;
    }
    updateExtended() {
        this.extended.isEmpty() ? this.bg &= -268435457 : this.bg |= 268435456;
    }
    getUnderlineColor() {
        if (this.bg & 268435456 && ~this.extended.underlineColor) switch(this.extended.underlineColor & 50331648){
            case 16777216:
            case 33554432:
                return this.extended.underlineColor & 255;
            case 50331648:
                return this.extended.underlineColor & 16777215;
            default:
                return this.getFgColor();
        }
        return this.getFgColor();
    }
    getUnderlineColorMode() {
        return this.bg & 268435456 && ~this.extended.underlineColor ? this.extended.underlineColor & 50331648 : this.getFgColorMode();
    }
    isUnderlineColorRGB() {
        return this.bg & 268435456 && ~this.extended.underlineColor ? (this.extended.underlineColor & 50331648) === 50331648 : this.isFgRGB();
    }
    isUnderlineColorPalette() {
        return this.bg & 268435456 && ~this.extended.underlineColor ? (this.extended.underlineColor & 50331648) === 16777216 || (this.extended.underlineColor & 50331648) === 33554432 : this.isFgPalette();
    }
    isUnderlineColorDefault() {
        return this.bg & 268435456 && ~this.extended.underlineColor ? (this.extended.underlineColor & 50331648) === 0 : this.isFgDefault();
    }
    getUnderlineStyle() {
        return this.fg & 268435456 ? this.bg & 268435456 ? this.extended.underlineStyle : 1 : 0;
    }
    getUnderlineVariantOffset() {
        return this.extended.underlineVariantOffset;
    }
}, $5c2a9584e51cbabf$var$rt = class s {
    constructor(t1 = 0, e = 0){
        this._ext = 0;
        this._urlId = 0;
        this._ext = t1, this._urlId = e;
    }
    get ext() {
        return this._urlId ? this._ext & -469762049 | this.underlineStyle << 26 : this._ext;
    }
    set ext(t1) {
        this._ext = t1;
    }
    get underlineStyle() {
        return this._urlId ? 5 : (this._ext & 469762048) >> 26;
    }
    set underlineStyle(t1) {
        this._ext &= -469762049, this._ext |= t1 << 26 & 469762048;
    }
    get underlineColor() {
        return this._ext & 67108863;
    }
    set underlineColor(t1) {
        this._ext &= -67108864, this._ext |= t1 & 67108863;
    }
    get urlId() {
        return this._urlId;
    }
    set urlId(t1) {
        this._urlId = t1;
    }
    get underlineVariantOffset() {
        let t1 = (this._ext & 3758096384) >> 29;
        return t1 < 0 ? t1 ^ 4294967288 : t1;
    }
    set underlineVariantOffset(t1) {
        this._ext &= 536870911, this._ext |= t1 << 29 & 3758096384;
    }
    clone() {
        return new s(this._ext, this._urlId);
    }
    isEmpty() {
        return this.underlineStyle === 0 && this._urlId === 0;
    }
};
var $5c2a9584e51cbabf$var$q = class s extends $5c2a9584e51cbabf$var$De {
    constructor(){
        super(...arguments);
        this.content = 0;
        this.fg = 0;
        this.bg = 0;
        this.extended = new $5c2a9584e51cbabf$var$rt;
        this.combinedData = "";
    }
    static fromCharData(e) {
        let i = new s;
        return i.setFromCharData(e), i;
    }
    isCombined() {
        return this.content & 2097152;
    }
    getWidth() {
        return this.content >> 22;
    }
    getChars() {
        return this.content & 2097152 ? this.combinedData : this.content & 2097151 ? $5c2a9584e51cbabf$var$Ce(this.content & 2097151) : "";
    }
    getCode() {
        return this.isCombined() ? this.combinedData.charCodeAt(this.combinedData.length - 1) : this.content & 2097151;
    }
    setFromCharData(e) {
        this.fg = e[0], this.bg = 0;
        let i = !1;
        if (e[1].length > 2) i = !0;
        else if (e[1].length === 2) {
            let r = e[1].charCodeAt(0);
            if (55296 <= r && r <= 56319) {
                let n = e[1].charCodeAt(1);
                56320 <= n && n <= 57343 ? this.content = (r - 55296) * 1024 + n - 56320 + 65536 | e[2] << 22 : i = !0;
            } else i = !0;
        } else this.content = e[1].charCodeAt(0) | e[2] << 22;
        i && (this.combinedData = e[1], this.content = 2097152 | e[2] << 22);
    }
    getAsCharData() {
        return [
            this.fg,
            this.getChars(),
            this.getWidth(),
            this.getCode()
        ];
    }
};
var $5c2a9584e51cbabf$var$js = "di$target", $5c2a9584e51cbabf$var$Hn = "di$dependencies", $5c2a9584e51cbabf$var$Fn = new Map;
function $5c2a9584e51cbabf$var$Xs(s) {
    return s[$5c2a9584e51cbabf$var$Hn] || [];
}
function $5c2a9584e51cbabf$var$ie(s) {
    if ($5c2a9584e51cbabf$var$Fn.has(s)) return $5c2a9584e51cbabf$var$Fn.get(s);
    let t1 = function(e, i, r) {
        if (arguments.length !== 3) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
        $5c2a9584e51cbabf$var$Pl(t1, e, r);
    };
    return t1._id = s, $5c2a9584e51cbabf$var$Fn.set(s, t1), t1;
}
function $5c2a9584e51cbabf$var$Pl(s, t1, e) {
    t1[$5c2a9584e51cbabf$var$js] === t1 ? t1[$5c2a9584e51cbabf$var$Hn].push({
        id: s,
        index: e
    }) : (t1[$5c2a9584e51cbabf$var$Hn] = [
        {
            id: s,
            index: e
        }
    ], t1[$5c2a9584e51cbabf$var$js] = t1);
}
var $5c2a9584e51cbabf$var$F = $5c2a9584e51cbabf$var$ie("BufferService"), $5c2a9584e51cbabf$var$rr = $5c2a9584e51cbabf$var$ie("CoreMouseService"), $5c2a9584e51cbabf$var$ge = $5c2a9584e51cbabf$var$ie("CoreService"), $5c2a9584e51cbabf$var$Zs = $5c2a9584e51cbabf$var$ie("CharsetService"), $5c2a9584e51cbabf$var$xt = $5c2a9584e51cbabf$var$ie("InstantiationService");
var $5c2a9584e51cbabf$var$nr = $5c2a9584e51cbabf$var$ie("LogService"), $5c2a9584e51cbabf$var$H = $5c2a9584e51cbabf$var$ie("OptionsService"), $5c2a9584e51cbabf$var$sr = $5c2a9584e51cbabf$var$ie("OscLinkService"), $5c2a9584e51cbabf$var$Js = $5c2a9584e51cbabf$var$ie("UnicodeService"), $5c2a9584e51cbabf$var$Be = $5c2a9584e51cbabf$var$ie("DecorationService");
var $5c2a9584e51cbabf$var$wt = class {
    constructor(t1, e, i){
        this._bufferService = t1;
        this._optionsService = e;
        this._oscLinkService = i;
    }
    provideLinks(t1, e) {
        let i = this._bufferService.buffer.lines.get(t1 - 1);
        if (!i) {
            e(void 0);
            return;
        }
        let r = [], n = this._optionsService.rawOptions.linkHandler, o = new $5c2a9584e51cbabf$var$q, l = i.getTrimmedLength(), a = -1, u = -1, h = !1;
        for(let c = 0; c < l; c++)if (!(u === -1 && !i.hasContent(c))) {
            if (i.loadCell(c, o), o.hasExtendedAttrs() && o.extended.urlId) {
                if (u === -1) {
                    u = c, a = o.extended.urlId;
                    continue;
                } else h = o.extended.urlId !== a;
            } else u !== -1 && (h = !0);
            if (h || u !== -1 && c === l - 1) {
                let d = this._oscLinkService.getLinkData(a)?.uri;
                if (d) {
                    let _ = {
                        start: {
                            x: u + 1,
                            y: t1
                        },
                        end: {
                            x: c + (!h && c === l - 1 ? 1 : 0),
                            y: t1
                        }
                    }, p = !1;
                    if (!n?.allowNonHttpProtocols) try {
                        let m = new URL(d);
                        [
                            "http:",
                            "https:"
                        ].includes(m.protocol) || (p = !0);
                    } catch  {
                        p = !0;
                    }
                    p || r.push({
                        text: d,
                        range: _,
                        activate: (m, f)=>n ? n.activate(m, f, _) : $5c2a9584e51cbabf$var$Ol(m, f),
                        hover: (m, f)=>n?.hover?.(m, f, _),
                        leave: (m, f)=>n?.leave?.(m, f, _)
                    });
                }
                h = !1, o.hasExtendedAttrs() && o.extended.urlId ? (u = c, a = o.extended.urlId) : (u = -1, a = -1);
            }
        }
        e(r);
    }
};
$5c2a9584e51cbabf$var$wt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$sr)
], $5c2a9584e51cbabf$var$wt);
function $5c2a9584e51cbabf$var$Ol(s, t1) {
    if (confirm(`Do you want to navigate to ${t1}?

WARNING: This link could potentially be dangerous`)) {
        let i = window.open();
        if (i) {
            try {
                i.opener = null;
            } catch  {}
            i.location.href = t1;
        } else console.warn("Opening link blocked as opener could not be cleared");
    }
}
var $5c2a9584e51cbabf$var$nt = $5c2a9584e51cbabf$var$ie("CharSizeService"), $5c2a9584e51cbabf$var$ae = $5c2a9584e51cbabf$var$ie("CoreBrowserService"), $5c2a9584e51cbabf$var$Dt = $5c2a9584e51cbabf$var$ie("MouseService"), $5c2a9584e51cbabf$var$ce = $5c2a9584e51cbabf$var$ie("RenderService"), $5c2a9584e51cbabf$var$Qs = $5c2a9584e51cbabf$var$ie("SelectionService"), $5c2a9584e51cbabf$var$or = $5c2a9584e51cbabf$var$ie("CharacterJoinerService"), $5c2a9584e51cbabf$var$Re = $5c2a9584e51cbabf$var$ie("ThemeService"), $5c2a9584e51cbabf$var$lr = $5c2a9584e51cbabf$var$ie("LinkProviderService");
var $5c2a9584e51cbabf$var$Wn = class {
    constructor(){
        this.listeners = [], this.unexpectedErrorHandler = function(t1) {
            setTimeout(()=>{
                throw t1.stack ? $5c2a9584e51cbabf$var$ar.isErrorNoTelemetry(t1) ? new $5c2a9584e51cbabf$var$ar(t1.message + `

` + t1.stack) : new Error(t1.message + `

` + t1.stack) : t1;
            }, 0);
        };
    }
    addListener(t1) {
        return this.listeners.push(t1), ()=>{
            this._removeListener(t1);
        };
    }
    emit(t1) {
        this.listeners.forEach((e)=>{
            e(t1);
        });
    }
    _removeListener(t1) {
        this.listeners.splice(this.listeners.indexOf(t1), 1);
    }
    setUnexpectedErrorHandler(t1) {
        this.unexpectedErrorHandler = t1;
    }
    getUnexpectedErrorHandler() {
        return this.unexpectedErrorHandler;
    }
    onUnexpectedError(t1) {
        this.unexpectedErrorHandler(t1), this.emit(t1);
    }
    onUnexpectedExternalError(t1) {
        this.unexpectedErrorHandler(t1);
    }
}, $5c2a9584e51cbabf$var$Bl = new $5c2a9584e51cbabf$var$Wn;
function $5c2a9584e51cbabf$var$Lt(s) {
    $5c2a9584e51cbabf$var$Nl(s) || $5c2a9584e51cbabf$var$Bl.onUnexpectedError(s);
}
var $5c2a9584e51cbabf$var$Un = "Canceled";
function $5c2a9584e51cbabf$var$Nl(s) {
    return s instanceof $5c2a9584e51cbabf$var$bi ? !0 : s instanceof Error && s.name === $5c2a9584e51cbabf$var$Un && s.message === $5c2a9584e51cbabf$var$Un;
}
var $5c2a9584e51cbabf$var$bi = class extends Error {
    constructor(){
        super($5c2a9584e51cbabf$var$Un), this.name = this.message;
    }
};
function $5c2a9584e51cbabf$var$eo(s) {
    return s ? new Error(`Illegal argument: ${s}`) : new Error("Illegal argument");
}
var $5c2a9584e51cbabf$var$ar = class s extends Error {
    constructor(t1){
        super(t1), this.name = "CodeExpectedError";
    }
    static fromError(t1) {
        if (t1 instanceof s) return t1;
        let e = new s;
        return e.message = t1.message, e.stack = t1.stack, e;
    }
    static isErrorNoTelemetry(t1) {
        return t1.name === "CodeExpectedError";
    }
}, $5c2a9584e51cbabf$var$Rt = class s extends Error {
    constructor(t1){
        super(t1 || "An unexpected bug occurred."), Object.setPrototypeOf(this, s.prototype);
    }
};
function $5c2a9584e51cbabf$var$Fl(s, t1, e = 0, i = s.length) {
    let r = e, n = i;
    for(; r < n;){
        let o = Math.floor((r + n) / 2);
        t1(s[o]) ? r = o + 1 : n = o;
    }
    return r - 1;
}
var $5c2a9584e51cbabf$var$cr = class cr {
    constructor(t1){
        this._array = t1;
        this._findLastMonotonousLastIdx = 0;
    }
    findLastMonotonous(t1) {
        if (cr.assertInvariants) {
            if (this._prevFindLastPredicate) {
                for (let i of this._array)if (this._prevFindLastPredicate(i) && !t1(i)) throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
            }
            this._prevFindLastPredicate = t1;
        }
        let e = $5c2a9584e51cbabf$var$Fl(this._array, t1, this._findLastMonotonousLastIdx);
        return this._findLastMonotonousLastIdx = e + 1, e === -1 ? void 0 : this._array[e];
    }
};
$5c2a9584e51cbabf$var$cr.assertInvariants = !1;
var $5c2a9584e51cbabf$var$to = $5c2a9584e51cbabf$var$cr;
function $5c2a9584e51cbabf$var$Se(s, t1 = 0) {
    return s[s.length - (1 + t1)];
}
var $5c2a9584e51cbabf$var$ro;
((l)=>{
    function s(a) {
        return a < 0;
    }
    l.isLessThan = s;
    function t1(a) {
        return a <= 0;
    }
    l.isLessThanOrEqual = t1;
    function e(a) {
        return a > 0;
    }
    l.isGreaterThan = e;
    function i(a) {
        return a === 0;
    }
    l.isNeitherLessOrGreaterThan = i, l.greaterThan = 1, l.lessThan = -1, l.neitherLessOrGreaterThan = 0;
})($5c2a9584e51cbabf$var$ro ||= {});
function $5c2a9584e51cbabf$var$no(s, t1) {
    return (e, i)=>t1(s(e), s(i));
}
var $5c2a9584e51cbabf$var$so = (s, t1)=>s - t1;
var $5c2a9584e51cbabf$var$At = class At {
    constructor(t1){
        this.iterate = t1;
    }
    forEach(t1) {
        this.iterate((e)=>(t1(e), !0));
    }
    toArray() {
        let t1 = [];
        return this.iterate((e)=>(t1.push(e), !0)), t1;
    }
    filter(t1) {
        return new At((e)=>this.iterate((i)=>t1(i) ? e(i) : !0));
    }
    map(t1) {
        return new At((e)=>this.iterate((i)=>e(t1(i))));
    }
    some(t1) {
        let e = !1;
        return this.iterate((i)=>(e = t1(i), !e)), e;
    }
    findFirst(t1) {
        let e;
        return this.iterate((i)=>t1(i) ? (e = i, !1) : !0), e;
    }
    findLast(t1) {
        let e;
        return this.iterate((i)=>(t1(i) && (e = i), !0)), e;
    }
    findLastMaxBy(t1) {
        let e, i = !0;
        return this.iterate((r)=>((i || $5c2a9584e51cbabf$var$ro.isGreaterThan(t1(r, e))) && (i = !1, e = r), !0)), e;
    }
};
$5c2a9584e51cbabf$var$At.empty = new $5c2a9584e51cbabf$var$At((t1)=>{});
var $5c2a9584e51cbabf$var$io = $5c2a9584e51cbabf$var$At;
function $5c2a9584e51cbabf$var$co(s, t1) {
    let e = Object.create(null);
    for (let i of s){
        let r = t1(i), n = e[r];
        n || (n = e[r] = []), n.push(i);
    }
    return e;
}
var $5c2a9584e51cbabf$var$lo, $5c2a9584e51cbabf$var$ao, $5c2a9584e51cbabf$var$oo = class {
    constructor(t1, e){
        this.toKey = e;
        this._map = new Map;
        this[$5c2a9584e51cbabf$var$lo] = "SetWithKey";
        for (let i of t1)this.add(i);
    }
    get size() {
        return this._map.size;
    }
    add(t1) {
        let e = this.toKey(t1);
        return this._map.set(e, t1), this;
    }
    delete(t1) {
        return this._map.delete(this.toKey(t1));
    }
    has(t1) {
        return this._map.has(this.toKey(t1));
    }
    *entries() {
        for (let t1 of this._map.values())yield [
            t1,
            t1
        ];
    }
    keys() {
        return this.values();
    }
    *values() {
        for (let t1 of this._map.values())yield t1;
    }
    clear() {
        this._map.clear();
    }
    forEach(t1, e) {
        this._map.forEach((i)=>t1.call(e, i, i, this));
    }
    [($5c2a9584e51cbabf$var$ao = Symbol.iterator, $5c2a9584e51cbabf$var$lo = Symbol.toStringTag, $5c2a9584e51cbabf$var$ao)]() {
        return this.values();
    }
};
var $5c2a9584e51cbabf$var$ur = class {
    constructor(){
        this.map = new Map;
    }
    add(t1, e) {
        let i = this.map.get(t1);
        i || (i = new Set, this.map.set(t1, i)), i.add(e);
    }
    delete(t1, e) {
        let i = this.map.get(t1);
        i && (i.delete(e), i.size === 0 && this.map.delete(t1));
    }
    forEach(t1, e) {
        let i = this.map.get(t1);
        i && i.forEach(e);
    }
    get(t1) {
        let e = this.map.get(t1);
        return e || new Set;
    }
};
function $5c2a9584e51cbabf$var$Kn(s, t1) {
    let e = this, i = !1, r;
    return function() {
        if (i) return r;
        if (i = !0, t1) try {
            r = s.apply(e, arguments);
        } finally{
            t1();
        }
        else r = s.apply(e, arguments);
        return r;
    };
}
var $5c2a9584e51cbabf$var$zn;
((O)=>{
    function s(I) {
        return I && typeof I == "object" && typeof I[Symbol.iterator] == "function";
    }
    O.is = s;
    let t1 = Object.freeze([]);
    function e() {
        return t1;
    }
    O.empty = e;
    function* i(I) {
        yield I;
    }
    O.single = i;
    function r(I) {
        return s(I) ? I : i(I);
    }
    O.wrap = r;
    function n(I) {
        return I || t1;
    }
    O.from = n;
    function* o(I) {
        for(let k = I.length - 1; k >= 0; k--)yield I[k];
    }
    O.reverse = o;
    function l(I) {
        return !I || I[Symbol.iterator]().next().done === !0;
    }
    O.isEmpty = l;
    function a(I) {
        return I[Symbol.iterator]().next().value;
    }
    O.first = a;
    function u(I, k) {
        let P = 0;
        for (let oe of I)if (k(oe, P++)) return !0;
        return !1;
    }
    O.some = u;
    function h(I, k) {
        for (let P of I)if (k(P)) return P;
    }
    O.find = h;
    function* c(I, k) {
        for (let P of I)k(P) && (yield P);
    }
    O.filter = c;
    function* d(I, k) {
        let P = 0;
        for (let oe of I)yield k(oe, P++);
    }
    O.map = d;
    function* _(I, k) {
        let P = 0;
        for (let oe of I)yield* k(oe, P++);
    }
    O.flatMap = _;
    function* p(...I) {
        for (let k of I)yield* k;
    }
    O.concat = p;
    function m(I, k, P) {
        let oe = P;
        for (let Me of I)oe = k(oe, Me);
        return oe;
    }
    O.reduce = m;
    function* f(I, k, P = I.length) {
        for(k < 0 && (k += I.length), P < 0 ? P += I.length : P > I.length && (P = I.length); k < P; k++)yield I[k];
    }
    O.slice = f;
    function A(I, k = Number.POSITIVE_INFINITY) {
        let P = [];
        if (k === 0) return [
            P,
            I
        ];
        let oe = I[Symbol.iterator]();
        for(let Me = 0; Me < k; Me++){
            let Pe = oe.next();
            if (Pe.done) return [
                P,
                O.empty()
            ];
            P.push(Pe.value);
        }
        return [
            P,
            {
                [Symbol.iterator] () {
                    return oe;
                }
            }
        ];
    }
    O.consume = A;
    async function R(I) {
        let k = [];
        for await (let P of I)k.push(P);
        return Promise.resolve(k);
    }
    O.asyncToArray = R;
})($5c2a9584e51cbabf$var$zn ||= {});
var $5c2a9584e51cbabf$var$Wl = !1, $5c2a9584e51cbabf$var$dt = null, $5c2a9584e51cbabf$var$hr = class hr {
    constructor(){
        this.livingDisposables = new Map;
    }
    getDisposableData(t1) {
        let e = this.livingDisposables.get(t1);
        return e || (e = {
            parent: null,
            source: null,
            isSingleton: !1,
            value: t1,
            idx: hr.idx++
        }, this.livingDisposables.set(t1, e)), e;
    }
    trackDisposable(t1) {
        let e = this.getDisposableData(t1);
        e.source || (e.source = new Error().stack);
    }
    setParent(t1, e) {
        let i = this.getDisposableData(t1);
        i.parent = e;
    }
    markAsDisposed(t1) {
        this.livingDisposables.delete(t1);
    }
    markAsSingleton(t1) {
        this.getDisposableData(t1).isSingleton = !0;
    }
    getRootParent(t1, e) {
        let i = e.get(t1);
        if (i) return i;
        let r = t1.parent ? this.getRootParent(this.getDisposableData(t1.parent), e) : t1;
        return e.set(t1, r), r;
    }
    getTrackedDisposables() {
        let t1 = new Map;
        return [
            ...this.livingDisposables.entries()
        ].filter(([, i])=>i.source !== null && !this.getRootParent(i, t1).isSingleton).flatMap(([i])=>i);
    }
    computeLeakingDisposables(t1 = 10, e) {
        let i;
        if (e) i = e;
        else {
            let a = new Map, u = [
                ...this.livingDisposables.values()
            ].filter((c)=>c.source !== null && !this.getRootParent(c, a).isSingleton);
            if (u.length === 0) return;
            let h = new Set(u.map((c)=>c.value));
            if (i = u.filter((c)=>!(c.parent && h.has(c.parent))), i.length === 0) throw new Error("There are cyclic diposable chains!");
        }
        if (!i) return;
        function r(a) {
            function u(c, d) {
                for(; c.length > 0 && d.some((_)=>typeof _ == "string" ? _ === c[0] : c[0].match(_));)c.shift();
            }
            let h = a.source.split(`
`).map((c)=>c.trim().replace("at ", "")).filter((c)=>c !== "");
            return u(h, [
                "Error",
                /^trackDisposable \(.*\)$/,
                /^DisposableTracker.trackDisposable \(.*\)$/
            ]), h.reverse();
        }
        let n = new $5c2a9584e51cbabf$var$ur;
        for (let a of i){
            let u = r(a);
            for(let h = 0; h <= u.length; h++)n.add(u.slice(0, h).join(`
`), a);
        }
        i.sort($5c2a9584e51cbabf$var$no((a)=>a.idx, $5c2a9584e51cbabf$var$so));
        let o = "", l = 0;
        for (let a of i.slice(0, t1)){
            l++;
            let u = r(a), h = [];
            for(let c = 0; c < u.length; c++){
                let d = u[c];
                d = `(shared with ${n.get(u.slice(0, c + 1).join(`
`)).size}/${i.length} leaks) at ${d}`;
                let p = n.get(u.slice(0, c).join(`
`)), m = $5c2a9584e51cbabf$var$co([
                    ...p
                ].map((f)=>r(f)[c]), (f)=>f);
                delete m[u[c]];
                for (let [f, A] of Object.entries(m))h.unshift(`    - stacktraces of ${A.length} other leaks continue with ${f}`);
                h.unshift(d);
            }
            o += `


==================== Leaking disposable ${l}/${i.length}: ${a.value.constructor.name} ====================
${h.join(`
`)}
============================================================

`;
        }
        return i.length > t1 && (o += `


... and ${i.length - t1} more leaking disposables

`), {
            leaks: i,
            details: o
        };
    }
};
$5c2a9584e51cbabf$var$hr.idx = 0;
var $5c2a9584e51cbabf$var$uo = $5c2a9584e51cbabf$var$hr;
function $5c2a9584e51cbabf$var$Ul(s) {
    $5c2a9584e51cbabf$var$dt = s;
}
if ($5c2a9584e51cbabf$var$Wl) {
    let s = "__is_disposable_tracked__";
    $5c2a9584e51cbabf$var$Ul(new class {
        trackDisposable(t1) {
            let e = new Error("Potentially leaked disposable").stack;
            setTimeout(()=>{
                t1[s] || console.log(e);
            }, 3e3);
        }
        setParent(t1, e) {
            if (t1 && t1 !== $5c2a9584e51cbabf$var$D.None) try {
                t1[s] = !0;
            } catch  {}
        }
        markAsDisposed(t1) {
            if (t1 && t1 !== $5c2a9584e51cbabf$var$D.None) try {
                t1[s] = !0;
            } catch  {}
        }
        markAsSingleton(t1) {}
    });
}
function $5c2a9584e51cbabf$var$fr(s) {
    return $5c2a9584e51cbabf$var$dt?.trackDisposable(s), s;
}
function $5c2a9584e51cbabf$var$pr(s) {
    $5c2a9584e51cbabf$var$dt?.markAsDisposed(s);
}
function $5c2a9584e51cbabf$var$vi(s, t1) {
    $5c2a9584e51cbabf$var$dt?.setParent(s, t1);
}
function $5c2a9584e51cbabf$var$Kl(s, t1) {
    if ($5c2a9584e51cbabf$var$dt) for (let e of s)$5c2a9584e51cbabf$var$dt.setParent(e, t1);
}
function $5c2a9584e51cbabf$var$Gn(s) {
    return $5c2a9584e51cbabf$var$dt?.markAsSingleton(s), s;
}
function $5c2a9584e51cbabf$var$Ne(s) {
    if ($5c2a9584e51cbabf$var$zn.is(s)) {
        let t1 = [];
        for (let e of s)if (e) try {
            e.dispose();
        } catch (i) {
            t1.push(i);
        }
        if (t1.length === 1) throw t1[0];
        if (t1.length > 1) throw new AggregateError(t1, "Encountered errors while disposing of store");
        return Array.isArray(s) ? [] : s;
    } else if (s) return s.dispose(), s;
}
function $5c2a9584e51cbabf$var$ho(...s) {
    let t1 = $5c2a9584e51cbabf$var$C(()=>$5c2a9584e51cbabf$var$Ne(s));
    return $5c2a9584e51cbabf$var$Kl(s, t1), t1;
}
function $5c2a9584e51cbabf$var$C(s) {
    let t1 = $5c2a9584e51cbabf$var$fr({
        dispose: $5c2a9584e51cbabf$var$Kn(()=>{
            $5c2a9584e51cbabf$var$pr(t1), s();
        })
    });
    return t1;
}
var $5c2a9584e51cbabf$var$dr = class dr {
    constructor(){
        this._toDispose = new Set;
        this._isDisposed = !1;
        $5c2a9584e51cbabf$var$fr(this);
    }
    dispose() {
        this._isDisposed || ($5c2a9584e51cbabf$var$pr(this), this._isDisposed = !0, this.clear());
    }
    get isDisposed() {
        return this._isDisposed;
    }
    clear() {
        if (this._toDispose.size !== 0) try {
            $5c2a9584e51cbabf$var$Ne(this._toDispose);
        } finally{
            this._toDispose.clear();
        }
    }
    add(t1) {
        if (!t1) return t1;
        if (t1 === this) throw new Error("Cannot register a disposable on itself!");
        return $5c2a9584e51cbabf$var$vi(t1, this), this._isDisposed ? dr.DISABLE_DISPOSED_WARNING || console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack) : this._toDispose.add(t1), t1;
    }
    delete(t1) {
        if (t1) {
            if (t1 === this) throw new Error("Cannot dispose a disposable on itself!");
            this._toDispose.delete(t1), t1.dispose();
        }
    }
    deleteAndLeak(t1) {
        t1 && this._toDispose.has(t1) && (this._toDispose.delete(t1), $5c2a9584e51cbabf$var$vi(t1, null));
    }
};
$5c2a9584e51cbabf$var$dr.DISABLE_DISPOSED_WARNING = !1;
var $5c2a9584e51cbabf$var$Ee = $5c2a9584e51cbabf$var$dr, $5c2a9584e51cbabf$var$D = class {
    constructor(){
        this._store = new $5c2a9584e51cbabf$var$Ee;
        $5c2a9584e51cbabf$var$fr(this), $5c2a9584e51cbabf$var$vi(this._store, this);
    }
    dispose() {
        $5c2a9584e51cbabf$var$pr(this), this._store.dispose();
    }
    _register(t1) {
        if (t1 === this) throw new Error("Cannot register a disposable on itself!");
        return this._store.add(t1);
    }
};
$5c2a9584e51cbabf$var$D.None = Object.freeze({
    dispose () {}
});
var $5c2a9584e51cbabf$var$ye = class {
    constructor(){
        this._isDisposed = !1;
        $5c2a9584e51cbabf$var$fr(this);
    }
    get value() {
        return this._isDisposed ? void 0 : this._value;
    }
    set value(t1) {
        this._isDisposed || t1 === this._value || (this._value?.dispose(), t1 && $5c2a9584e51cbabf$var$vi(t1, this), this._value = t1);
    }
    clear() {
        this.value = void 0;
    }
    dispose() {
        this._isDisposed = !0, $5c2a9584e51cbabf$var$pr(this), this._value?.dispose(), this._value = void 0;
    }
    clearAndLeak() {
        let t1 = this._value;
        return this._value = void 0, t1 && $5c2a9584e51cbabf$var$vi(t1, null), t1;
    }
};
var $5c2a9584e51cbabf$var$fe = typeof window == "object" ? window : globalThis;
var $5c2a9584e51cbabf$var$kt = class kt {
    constructor(t1){
        this.element = t1, this.next = kt.Undefined, this.prev = kt.Undefined;
    }
};
$5c2a9584e51cbabf$var$kt.Undefined = new $5c2a9584e51cbabf$var$kt(void 0);
var $5c2a9584e51cbabf$var$G = $5c2a9584e51cbabf$var$kt, $5c2a9584e51cbabf$var$Ct = class {
    constructor(){
        this._first = $5c2a9584e51cbabf$var$G.Undefined;
        this._last = $5c2a9584e51cbabf$var$G.Undefined;
        this._size = 0;
    }
    get size() {
        return this._size;
    }
    isEmpty() {
        return this._first === $5c2a9584e51cbabf$var$G.Undefined;
    }
    clear() {
        let t1 = this._first;
        for(; t1 !== $5c2a9584e51cbabf$var$G.Undefined;){
            let e = t1.next;
            t1.prev = $5c2a9584e51cbabf$var$G.Undefined, t1.next = $5c2a9584e51cbabf$var$G.Undefined, t1 = e;
        }
        this._first = $5c2a9584e51cbabf$var$G.Undefined, this._last = $5c2a9584e51cbabf$var$G.Undefined, this._size = 0;
    }
    unshift(t1) {
        return this._insert(t1, !1);
    }
    push(t1) {
        return this._insert(t1, !0);
    }
    _insert(t1, e) {
        let i = new $5c2a9584e51cbabf$var$G(t1);
        if (this._first === $5c2a9584e51cbabf$var$G.Undefined) this._first = i, this._last = i;
        else if (e) {
            let n = this._last;
            this._last = i, i.prev = n, n.next = i;
        } else {
            let n = this._first;
            this._first = i, i.next = n, n.prev = i;
        }
        this._size += 1;
        let r = !1;
        return ()=>{
            r || (r = !0, this._remove(i));
        };
    }
    shift() {
        if (this._first !== $5c2a9584e51cbabf$var$G.Undefined) {
            let t1 = this._first.element;
            return this._remove(this._first), t1;
        }
    }
    pop() {
        if (this._last !== $5c2a9584e51cbabf$var$G.Undefined) {
            let t1 = this._last.element;
            return this._remove(this._last), t1;
        }
    }
    _remove(t1) {
        if (t1.prev !== $5c2a9584e51cbabf$var$G.Undefined && t1.next !== $5c2a9584e51cbabf$var$G.Undefined) {
            let e = t1.prev;
            e.next = t1.next, t1.next.prev = e;
        } else t1.prev === $5c2a9584e51cbabf$var$G.Undefined && t1.next === $5c2a9584e51cbabf$var$G.Undefined ? (this._first = $5c2a9584e51cbabf$var$G.Undefined, this._last = $5c2a9584e51cbabf$var$G.Undefined) : t1.next === $5c2a9584e51cbabf$var$G.Undefined ? (this._last = this._last.prev, this._last.next = $5c2a9584e51cbabf$var$G.Undefined) : t1.prev === $5c2a9584e51cbabf$var$G.Undefined && (this._first = this._first.next, this._first.prev = $5c2a9584e51cbabf$var$G.Undefined);
        this._size -= 1;
    }
    *[Symbol.iterator]() {
        let t1 = this._first;
        for(; t1 !== $5c2a9584e51cbabf$var$G.Undefined;)yield t1.element, t1 = t1.next;
    }
};
var $5c2a9584e51cbabf$var$zl = globalThis.performance && typeof globalThis.performance.now == "function", $5c2a9584e51cbabf$var$mr = class s {
    static create(t1) {
        return new s(t1);
    }
    constructor(t1){
        this._now = $5c2a9584e51cbabf$var$zl && t1 === !1 ? Date.now : globalThis.performance.now.bind(globalThis.performance), this._startTime = this._now(), this._stopTime = -1;
    }
    stop() {
        this._stopTime = this._now();
    }
    reset() {
        this._startTime = this._now(), this._stopTime = -1;
    }
    elapsed() {
        return this._stopTime !== -1 ? this._stopTime - this._startTime : this._now() - this._startTime;
    }
};
var $5c2a9584e51cbabf$var$Gl = !1, $5c2a9584e51cbabf$var$fo = !1, $5c2a9584e51cbabf$var$$l = !1, $5c2a9584e51cbabf$var$$;
((Qe)=>{
    Qe.None = ()=>$5c2a9584e51cbabf$var$D.None;
    function t1(y) {
        if ($5c2a9584e51cbabf$var$$l) {
            let { onDidAddListener: T } = y, g = $5c2a9584e51cbabf$var$gi.create(), w = 0;
            y.onDidAddListener = ()=>{
                ++w === 2 && (console.warn("snapshotted emitter LIKELY used public and SHOULD HAVE BEEN created with DisposableStore. snapshotted here"), g.print()), T?.();
            };
        }
    }
    function e(y, T) {
        return d(y, ()=>{}, 0, void 0, !0, void 0, T);
    }
    Qe.defer = e;
    function i(y) {
        return (T, g = null, w)=>{
            let E = !1, x;
            return x = y((N)=>{
                if (!E) return x ? x.dispose() : E = !0, T.call(g, N);
            }, null, w), E && x.dispose(), x;
        };
    }
    Qe.once = i;
    function r(y, T, g) {
        return h((w, E = null, x)=>y((N)=>w.call(E, T(N)), null, x), g);
    }
    Qe.map = r;
    function n(y, T, g) {
        return h((w, E = null, x)=>y((N)=>{
                T(N), w.call(E, N);
            }, null, x), g);
    }
    Qe.forEach = n;
    function o(y, T, g) {
        return h((w, E = null, x)=>y((N)=>T(N) && w.call(E, N), null, x), g);
    }
    Qe.filter = o;
    function l(y) {
        return y;
    }
    Qe.signal = l;
    function a(...y) {
        return (T, g = null, w)=>{
            let E = $5c2a9584e51cbabf$var$ho(...y.map((x)=>x((N)=>T.call(g, N))));
            return c(E, w);
        };
    }
    Qe.any = a;
    function u(y, T, g, w) {
        let E = g;
        return r(y, (x)=>(E = T(E, x), E), w);
    }
    Qe.reduce = u;
    function h(y, T) {
        let g, w = {
            onWillAddFirstListener () {
                g = y(E.fire, E);
            },
            onDidRemoveLastListener () {
                g?.dispose();
            }
        };
        T || t1(w);
        let E = new $5c2a9584e51cbabf$var$v(w);
        return T?.add(E), E.event;
    }
    function c(y, T) {
        return T instanceof Array ? T.push(y) : T && T.add(y), y;
    }
    function d(y, T, g = 100, w = !1, E = !1, x, N) {
        let Z, te, Oe, ze = 0, le, et = {
            leakWarningThreshold: x,
            onWillAddFirstListener () {
                Z = y((ht)=>{
                    ze++, te = T(te, ht), w && !Oe && (me.fire(te), te = void 0), le = ()=>{
                        let fi = te;
                        te = void 0, Oe = void 0, (!w || ze > 1) && me.fire(fi), ze = 0;
                    }, typeof g == "number" ? (clearTimeout(Oe), Oe = setTimeout(le, g)) : Oe === void 0 && (Oe = 0, queueMicrotask(le));
                });
            },
            onWillRemoveListener () {
                E && ze > 0 && le?.();
            },
            onDidRemoveLastListener () {
                le = void 0, Z.dispose();
            }
        };
        N || t1(et);
        let me = new $5c2a9584e51cbabf$var$v(et);
        return N?.add(me), me.event;
    }
    Qe.debounce = d;
    function _(y, T = 0, g) {
        return Qe.debounce(y, (w, E)=>w ? (w.push(E), w) : [
                E
            ], T, void 0, !0, void 0, g);
    }
    Qe.accumulate = _;
    function p(y, T = (w, E)=>w === E, g) {
        let w = !0, E;
        return o(y, (x)=>{
            let N = w || !T(x, E);
            return w = !1, E = x, N;
        }, g);
    }
    Qe.latch = p;
    function m(y, T, g) {
        return [
            Qe.filter(y, T, g),
            Qe.filter(y, (w)=>!T(w), g)
        ];
    }
    Qe.split = m;
    function f(y, T = !1, g = [], w) {
        let E = g.slice(), x = y((te)=>{
            E ? E.push(te) : Z.fire(te);
        });
        w && w.add(x);
        let N = ()=>{
            E?.forEach((te)=>Z.fire(te)), E = null;
        }, Z = new $5c2a9584e51cbabf$var$v({
            onWillAddFirstListener () {
                x || (x = y((te)=>Z.fire(te)), w && w.add(x));
            },
            onDidAddFirstListener () {
                E && (T ? setTimeout(N) : N());
            },
            onDidRemoveLastListener () {
                x && x.dispose(), x = null;
            }
        });
        return w && w.add(Z), Z.event;
    }
    Qe.buffer = f;
    function A(y, T) {
        return (w, E, x)=>{
            let N = T(new O);
            return y(function(Z) {
                let te = N.evaluate(Z);
                te !== R && w.call(E, te);
            }, void 0, x);
        };
    }
    Qe.chain = A;
    let R = Symbol("HaltChainable");
    class O {
        constructor(){
            this.steps = [];
        }
        map(T) {
            return this.steps.push(T), this;
        }
        forEach(T) {
            return this.steps.push((g)=>(T(g), g)), this;
        }
        filter(T) {
            return this.steps.push((g)=>T(g) ? g : R), this;
        }
        reduce(T, g) {
            let w = g;
            return this.steps.push((E)=>(w = T(w, E), w)), this;
        }
        latch(T = (g, w)=>g === w) {
            let g = !0, w;
            return this.steps.push((E)=>{
                let x = g || !T(E, w);
                return g = !1, w = E, x ? E : R;
            }), this;
        }
        evaluate(T) {
            for (let g of this.steps)if (T = g(T), T === R) break;
            return T;
        }
    }
    function I(y, T, g = (w)=>w) {
        let w = (...Z)=>N.fire(g(...Z)), E = ()=>y.on(T, w), x = ()=>y.removeListener(T, w), N = new $5c2a9584e51cbabf$var$v({
            onWillAddFirstListener: E,
            onDidRemoveLastListener: x
        });
        return N.event;
    }
    Qe.fromNodeEventEmitter = I;
    function k(y, T, g = (w)=>w) {
        let w = (...Z)=>N.fire(g(...Z)), E = ()=>y.addEventListener(T, w), x = ()=>y.removeEventListener(T, w), N = new $5c2a9584e51cbabf$var$v({
            onWillAddFirstListener: E,
            onDidRemoveLastListener: x
        });
        return N.event;
    }
    Qe.fromDOMEventEmitter = k;
    function P(y) {
        return new Promise((T)=>i(y)(T));
    }
    Qe.toPromise = P;
    function oe(y) {
        let T = new $5c2a9584e51cbabf$var$v;
        return y.then((g)=>{
            T.fire(g);
        }, ()=>{
            T.fire(void 0);
        }).finally(()=>{
            T.dispose();
        }), T.event;
    }
    Qe.fromPromise = oe;
    function Me(y, T) {
        return y((g)=>T.fire(g));
    }
    Qe.forward = Me;
    function Pe(y, T, g) {
        return T(g), y((w)=>T(w));
    }
    Qe.runAndSubscribe = Pe;
    class Ke {
        constructor(T, g){
            this._observable = T;
            this._counter = 0;
            this._hasChanged = !1;
            let w = {
                onWillAddFirstListener: ()=>{
                    T.addObserver(this);
                },
                onDidRemoveLastListener: ()=>{
                    T.removeObserver(this);
                }
            };
            g || t1(w), this.emitter = new $5c2a9584e51cbabf$var$v(w), g && g.add(this.emitter);
        }
        beginUpdate(T) {
            this._counter++;
        }
        handlePossibleChange(T) {}
        handleChange(T, g) {
            this._hasChanged = !0;
        }
        endUpdate(T) {
            this._counter--, this._counter === 0 && (this._observable.reportChanges(), this._hasChanged && (this._hasChanged = !1, this.emitter.fire(this._observable.get())));
        }
    }
    function di(y, T) {
        return new Ke(y, T).emitter.event;
    }
    Qe.fromObservable = di;
    function V(y) {
        return (T, g, w)=>{
            let E = 0, x = !1, N = {
                beginUpdate () {
                    E++;
                },
                endUpdate () {
                    E--, E === 0 && (y.reportChanges(), x && (x = !1, T.call(g)));
                },
                handlePossibleChange () {},
                handleChange () {
                    x = !0;
                }
            };
            y.addObserver(N), y.reportChanges();
            let Z = {
                dispose () {
                    y.removeObserver(N);
                }
            };
            return w instanceof $5c2a9584e51cbabf$var$Ee ? w.add(Z) : Array.isArray(w) && w.push(Z), Z;
        };
    }
    Qe.fromObservableLight = V;
})($5c2a9584e51cbabf$var$$ ||= {});
var $5c2a9584e51cbabf$var$Mt = class Mt {
    constructor(t1){
        this.listenerCount = 0;
        this.invocationCount = 0;
        this.elapsedOverall = 0;
        this.durations = [];
        this.name = `${t1}_${Mt._idPool++}`, Mt.all.add(this);
    }
    start(t1) {
        this._stopWatch = new $5c2a9584e51cbabf$var$mr, this.listenerCount = t1;
    }
    stop() {
        if (this._stopWatch) {
            let t1 = this._stopWatch.elapsed();
            this.durations.push(t1), this.elapsedOverall += t1, this.invocationCount += 1, this._stopWatch = void 0;
        }
    }
};
$5c2a9584e51cbabf$var$Mt.all = new Set, $5c2a9584e51cbabf$var$Mt._idPool = 0;
var $5c2a9584e51cbabf$var$$n = $5c2a9584e51cbabf$var$Mt, $5c2a9584e51cbabf$var$po = -1;
var $5c2a9584e51cbabf$var$br = class br {
    constructor(t1, e, i = (br._idPool++).toString(16).padStart(3, "0")){
        this._errorHandler = t1;
        this.threshold = e;
        this.name = i;
        this._warnCountdown = 0;
    }
    dispose() {
        this._stacks?.clear();
    }
    check(t1, e) {
        let i = this.threshold;
        if (i <= 0 || e < i) return;
        this._stacks || (this._stacks = new Map);
        let r = this._stacks.get(t1.value) || 0;
        if (this._stacks.set(t1.value, r + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
            this._warnCountdown = i * .5;
            let [n, o] = this.getMostFrequentStack(), l = `[${this.name}] potential listener LEAK detected, having ${e} listeners already. MOST frequent listener (${o}):`;
            console.warn(l), console.warn(n);
            let a = new $5c2a9584e51cbabf$var$qn(l, n);
            this._errorHandler(a);
        }
        return ()=>{
            let n = this._stacks.get(t1.value) || 0;
            this._stacks.set(t1.value, n - 1);
        };
    }
    getMostFrequentStack() {
        if (!this._stacks) return;
        let t1, e = 0;
        for (let [i, r] of this._stacks)(!t1 || e < r) && (t1 = [
            i,
            r
        ], e = r);
        return t1;
    }
};
$5c2a9584e51cbabf$var$br._idPool = 1;
var $5c2a9584e51cbabf$var$Vn = $5c2a9584e51cbabf$var$br, $5c2a9584e51cbabf$var$gi = class s {
    constructor(t1){
        this.value = t1;
    }
    static create() {
        let t1 = new Error;
        return new s(t1.stack ?? "");
    }
    print() {
        console.warn(this.value.split(`
`).slice(2).join(`
`));
    }
}, $5c2a9584e51cbabf$var$qn = class extends Error {
    constructor(t1, e){
        super(t1), this.name = "ListenerLeakError", this.stack = e;
    }
}, $5c2a9584e51cbabf$var$Yn = class extends Error {
    constructor(t1, e){
        super(t1), this.name = "ListenerRefusalError", this.stack = e;
    }
}, $5c2a9584e51cbabf$var$Vl = 0, $5c2a9584e51cbabf$var$Pt = class {
    constructor(t1){
        this.value = t1;
        this.id = $5c2a9584e51cbabf$var$Vl++;
    }
}, $5c2a9584e51cbabf$var$ql = 2, $5c2a9584e51cbabf$var$Yl = (s, t1)=>{
    if (s instanceof $5c2a9584e51cbabf$var$Pt) t1(s);
    else for(let e = 0; e < s.length; e++){
        let i = s[e];
        i && t1(i);
    }
}, $5c2a9584e51cbabf$var$_r;
if ($5c2a9584e51cbabf$var$Gl) {
    let s = [];
    setInterval(()=>{
        s.length !== 0 && (console.warn("[LEAKING LISTENERS] GC'ed these listeners that were NOT yet disposed:"), console.warn(s.join(`
`)), s.length = 0);
    }, 3e3), $5c2a9584e51cbabf$var$_r = new FinalizationRegistry((t1)=>{
        typeof t1 == "string" && s.push(t1);
    });
}
var $5c2a9584e51cbabf$var$v = class {
    constructor(t1){
        this._size = 0;
        this._options = t1, this._leakageMon = $5c2a9584e51cbabf$var$po > 0 || this._options?.leakWarningThreshold ? new $5c2a9584e51cbabf$var$Vn(t1?.onListenerError ?? $5c2a9584e51cbabf$var$Lt, this._options?.leakWarningThreshold ?? $5c2a9584e51cbabf$var$po) : void 0, this._perfMon = this._options?._profName ? new $5c2a9584e51cbabf$var$$n(this._options._profName) : void 0, this._deliveryQueue = this._options?.deliveryQueue;
    }
    dispose() {
        if (!this._disposed) {
            if (this._disposed = !0, this._deliveryQueue?.current === this && this._deliveryQueue.reset(), this._listeners) {
                if ($5c2a9584e51cbabf$var$fo) {
                    let t1 = this._listeners;
                    queueMicrotask(()=>{
                        $5c2a9584e51cbabf$var$Yl(t1, (e)=>e.stack?.print());
                    });
                }
                this._listeners = void 0, this._size = 0;
            }
            this._options?.onDidRemoveLastListener?.(), this._leakageMon?.dispose();
        }
    }
    get event() {
        return this._event ??= (t1, e, i)=>{
            if (this._leakageMon && this._size > this._leakageMon.threshold ** 2) {
                let a = `[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far (${this._size} vs ${this._leakageMon.threshold})`;
                console.warn(a);
                let u = this._leakageMon.getMostFrequentStack() ?? [
                    "UNKNOWN stack",
                    -1
                ], h = new $5c2a9584e51cbabf$var$Yn(`${a}. HINT: Stack shows most frequent listener (${u[1]}-times)`, u[0]);
                return (this._options?.onListenerError || $5c2a9584e51cbabf$var$Lt)(h), $5c2a9584e51cbabf$var$D.None;
            }
            if (this._disposed) return $5c2a9584e51cbabf$var$D.None;
            e && (t1 = t1.bind(e));
            let r = new $5c2a9584e51cbabf$var$Pt(t1), n, o;
            this._leakageMon && this._size >= Math.ceil(this._leakageMon.threshold * .2) && (r.stack = $5c2a9584e51cbabf$var$gi.create(), n = this._leakageMon.check(r.stack, this._size + 1)), $5c2a9584e51cbabf$var$fo && (r.stack = o ?? $5c2a9584e51cbabf$var$gi.create()), this._listeners ? this._listeners instanceof $5c2a9584e51cbabf$var$Pt ? (this._deliveryQueue ??= new $5c2a9584e51cbabf$var$jn, this._listeners = [
                this._listeners,
                r
            ]) : this._listeners.push(r) : (this._options?.onWillAddFirstListener?.(this), this._listeners = r, this._options?.onDidAddFirstListener?.(this)), this._size++;
            let l = $5c2a9584e51cbabf$var$C(()=>{
                $5c2a9584e51cbabf$var$_r?.unregister(l), n?.(), this._removeListener(r);
            });
            if (i instanceof $5c2a9584e51cbabf$var$Ee ? i.add(l) : Array.isArray(i) && i.push(l), $5c2a9584e51cbabf$var$_r) {
                let a = new Error().stack.split(`
`).slice(2, 3).join(`
`).trim(), u = /(file:|vscode-file:\/\/vscode-app)?(\/[^:]*:\d+:\d+)/.exec(a);
                $5c2a9584e51cbabf$var$_r.register(l, u?.[2] ?? a, l);
            }
            return l;
        }, this._event;
    }
    _removeListener(t1) {
        if (this._options?.onWillRemoveListener?.(this), !this._listeners) return;
        if (this._size === 1) {
            this._listeners = void 0, this._options?.onDidRemoveLastListener?.(this), this._size = 0;
            return;
        }
        let e = this._listeners, i = e.indexOf(t1);
        if (i === -1) throw console.log("disposed?", this._disposed), console.log("size?", this._size), console.log("arr?", JSON.stringify(this._listeners)), new Error("Attempted to dispose unknown listener");
        this._size--, e[i] = void 0;
        let r = this._deliveryQueue.current === this;
        if (this._size * $5c2a9584e51cbabf$var$ql <= e.length) {
            let n = 0;
            for(let o = 0; o < e.length; o++)e[o] ? e[n++] = e[o] : r && (this._deliveryQueue.end--, n < this._deliveryQueue.i && this._deliveryQueue.i--);
            e.length = n;
        }
    }
    _deliver(t1, e) {
        if (!t1) return;
        let i = this._options?.onListenerError || $5c2a9584e51cbabf$var$Lt;
        if (!i) {
            t1.value(e);
            return;
        }
        try {
            t1.value(e);
        } catch (r) {
            i(r);
        }
    }
    _deliverQueue(t1) {
        let e = t1.current._listeners;
        for(; t1.i < t1.end;)this._deliver(e[t1.i++], t1.value);
        t1.reset();
    }
    fire(t1) {
        if (this._deliveryQueue?.current && (this._deliverQueue(this._deliveryQueue), this._perfMon?.stop()), this._perfMon?.start(this._size), this._listeners) {
            if (this._listeners instanceof $5c2a9584e51cbabf$var$Pt) this._deliver(this._listeners, t1);
            else {
                let e = this._deliveryQueue;
                e.enqueue(this, t1, this._listeners.length), this._deliverQueue(e);
            }
        }
        this._perfMon?.stop();
    }
    hasListeners() {
        return this._size > 0;
    }
};
var $5c2a9584e51cbabf$var$jn = class {
    constructor(){
        this.i = -1;
        this.end = 0;
    }
    enqueue(t1, e, i) {
        this.i = 0, this.end = i, this.current = t1, this.value = e;
    }
    reset() {
        this.i = this.end, this.current = void 0, this.value = void 0;
    }
};
var $5c2a9584e51cbabf$var$gr = class gr {
    constructor(){
        this.mapWindowIdToZoomLevel = new Map;
        this._onDidChangeZoomLevel = new $5c2a9584e51cbabf$var$v;
        this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
        this.mapWindowIdToZoomFactor = new Map;
        this._onDidChangeFullscreen = new $5c2a9584e51cbabf$var$v;
        this.onDidChangeFullscreen = this._onDidChangeFullscreen.event;
        this.mapWindowIdToFullScreen = new Map;
    }
    getZoomLevel(t1) {
        return this.mapWindowIdToZoomLevel.get(this.getWindowId(t1)) ?? 0;
    }
    setZoomLevel(t1, e) {
        if (this.getZoomLevel(e) === t1) return;
        let i = this.getWindowId(e);
        this.mapWindowIdToZoomLevel.set(i, t1), this._onDidChangeZoomLevel.fire(i);
    }
    getZoomFactor(t1) {
        return this.mapWindowIdToZoomFactor.get(this.getWindowId(t1)) ?? 1;
    }
    setZoomFactor(t1, e) {
        this.mapWindowIdToZoomFactor.set(this.getWindowId(e), t1);
    }
    setFullscreen(t1, e) {
        if (this.isFullscreen(e) === t1) return;
        let i = this.getWindowId(e);
        this.mapWindowIdToFullScreen.set(i, t1), this._onDidChangeFullscreen.fire(i);
    }
    isFullscreen(t1) {
        return !!this.mapWindowIdToFullScreen.get(this.getWindowId(t1));
    }
    getWindowId(t1) {
        return t1.vscodeWindowId;
    }
};
$5c2a9584e51cbabf$var$gr.INSTANCE = new $5c2a9584e51cbabf$var$gr;
var $5c2a9584e51cbabf$var$Si = $5c2a9584e51cbabf$var$gr;
function $5c2a9584e51cbabf$var$Xl(s, t1, e) {
    typeof t1 == "string" && (t1 = s.matchMedia(t1)), t1.addEventListener("change", e);
}
var $5c2a9584e51cbabf$var$Eu = $5c2a9584e51cbabf$var$Si.INSTANCE.onDidChangeZoomLevel;
function $5c2a9584e51cbabf$var$mo(s) {
    return $5c2a9584e51cbabf$var$Si.INSTANCE.getZoomFactor(s);
}
var $5c2a9584e51cbabf$var$Tu = $5c2a9584e51cbabf$var$Si.INSTANCE.onDidChangeFullscreen, $5c2a9584e51cbabf$var$Ot = typeof navigator == "object" ? navigator.userAgent : "", $5c2a9584e51cbabf$var$Ei = $5c2a9584e51cbabf$var$Ot.indexOf("Firefox") >= 0, $5c2a9584e51cbabf$var$Bt = $5c2a9584e51cbabf$var$Ot.indexOf("AppleWebKit") >= 0, $5c2a9584e51cbabf$var$Ti = $5c2a9584e51cbabf$var$Ot.indexOf("Chrome") >= 0, $5c2a9584e51cbabf$var$Sr = !$5c2a9584e51cbabf$var$Ti && $5c2a9584e51cbabf$var$Ot.indexOf("Safari") >= 0;
var $5c2a9584e51cbabf$var$Iu = $5c2a9584e51cbabf$var$Ot.indexOf("Electron/") >= 0, $5c2a9584e51cbabf$var$yu = $5c2a9584e51cbabf$var$Ot.indexOf("Android") >= 0, $5c2a9584e51cbabf$var$vr = !1;
if (typeof $5c2a9584e51cbabf$var$fe.matchMedia == "function") {
    let s = $5c2a9584e51cbabf$var$fe.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)"), t1 = $5c2a9584e51cbabf$var$fe.matchMedia("(display-mode: fullscreen)");
    $5c2a9584e51cbabf$var$vr = s.matches, $5c2a9584e51cbabf$var$Xl($5c2a9584e51cbabf$var$fe, s, ({ matches: e })=>{
        $5c2a9584e51cbabf$var$vr && t1.matches || ($5c2a9584e51cbabf$var$vr = e);
    });
}
function $5c2a9584e51cbabf$var$_o() {
    return $5c2a9584e51cbabf$var$vr;
}
var $5c2a9584e51cbabf$var$Nt = "en", $5c2a9584e51cbabf$var$yr = !1, $5c2a9584e51cbabf$var$xr = !1, $5c2a9584e51cbabf$var$Ii = !1, $5c2a9584e51cbabf$var$Zl = !1, $5c2a9584e51cbabf$var$vo = !1, $5c2a9584e51cbabf$var$go = !1, $5c2a9584e51cbabf$var$Jl = !1, $5c2a9584e51cbabf$var$Ql = !1, $5c2a9584e51cbabf$var$ea = !1, $5c2a9584e51cbabf$var$ta = !1, $5c2a9584e51cbabf$var$Tr, $5c2a9584e51cbabf$var$Ir = $5c2a9584e51cbabf$var$Nt, $5c2a9584e51cbabf$var$bo = $5c2a9584e51cbabf$var$Nt, $5c2a9584e51cbabf$var$ia, $5c2a9584e51cbabf$var$$e, $5c2a9584e51cbabf$var$Ve = globalThis, $5c2a9584e51cbabf$var$xe;
typeof $5c2a9584e51cbabf$var$Ve.vscode < "u" && typeof $5c2a9584e51cbabf$var$Ve.vscode.process < "u" && ($5c2a9584e51cbabf$var$xe = $5c2a9584e51cbabf$var$Ve.vscode.process);
var $5c2a9584e51cbabf$var$So = typeof $5c2a9584e51cbabf$var$xe?.versions?.electron == "string", $5c2a9584e51cbabf$var$ra = $5c2a9584e51cbabf$var$So && $5c2a9584e51cbabf$var$xe?.type === "renderer";
if (typeof $5c2a9584e51cbabf$var$xe == "object") {
    $5c2a9584e51cbabf$var$yr = $5c2a9584e51cbabf$var$xe.platform === "win32", $5c2a9584e51cbabf$var$xr = $5c2a9584e51cbabf$var$xe.platform === "darwin", $5c2a9584e51cbabf$var$Ii = $5c2a9584e51cbabf$var$xe.platform === "linux", $5c2a9584e51cbabf$var$Zl = $5c2a9584e51cbabf$var$Ii && !!$5c2a9584e51cbabf$var$xe.env.SNAP && !!$5c2a9584e51cbabf$var$xe.env.SNAP_REVISION, $5c2a9584e51cbabf$var$Jl = $5c2a9584e51cbabf$var$So, $5c2a9584e51cbabf$var$ea = !!$5c2a9584e51cbabf$var$xe.env.CI || !!$5c2a9584e51cbabf$var$xe.env.BUILD_ARTIFACTSTAGINGDIRECTORY, $5c2a9584e51cbabf$var$Tr = $5c2a9584e51cbabf$var$Nt, $5c2a9584e51cbabf$var$Ir = $5c2a9584e51cbabf$var$Nt;
    let s = $5c2a9584e51cbabf$var$xe.env.VSCODE_NLS_CONFIG;
    if (s) try {
        let t1 = JSON.parse(s);
        $5c2a9584e51cbabf$var$Tr = t1.userLocale, $5c2a9584e51cbabf$var$bo = t1.osLocale, $5c2a9584e51cbabf$var$Ir = t1.resolvedLanguage || $5c2a9584e51cbabf$var$Nt, $5c2a9584e51cbabf$var$ia = t1.languagePack?.translationsConfigFile;
    } catch  {}
    $5c2a9584e51cbabf$var$vo = !0;
} else typeof navigator == "object" && !$5c2a9584e51cbabf$var$ra ? ($5c2a9584e51cbabf$var$$e = navigator.userAgent, $5c2a9584e51cbabf$var$yr = $5c2a9584e51cbabf$var$$e.indexOf("Windows") >= 0, $5c2a9584e51cbabf$var$xr = $5c2a9584e51cbabf$var$$e.indexOf("Macintosh") >= 0, $5c2a9584e51cbabf$var$Ql = ($5c2a9584e51cbabf$var$$e.indexOf("Macintosh") >= 0 || $5c2a9584e51cbabf$var$$e.indexOf("iPad") >= 0 || $5c2a9584e51cbabf$var$$e.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0, $5c2a9584e51cbabf$var$Ii = $5c2a9584e51cbabf$var$$e.indexOf("Linux") >= 0, $5c2a9584e51cbabf$var$ta = $5c2a9584e51cbabf$var$$e?.indexOf("Mobi") >= 0, $5c2a9584e51cbabf$var$go = !0, $5c2a9584e51cbabf$var$Ir = globalThis._VSCODE_NLS_LANGUAGE || $5c2a9584e51cbabf$var$Nt, $5c2a9584e51cbabf$var$Tr = navigator.language.toLowerCase(), $5c2a9584e51cbabf$var$bo = $5c2a9584e51cbabf$var$Tr) : console.error("Unable to resolve platform.");
var $5c2a9584e51cbabf$var$Xn = 0;
$5c2a9584e51cbabf$var$xr ? $5c2a9584e51cbabf$var$Xn = 1 : $5c2a9584e51cbabf$var$yr ? $5c2a9584e51cbabf$var$Xn = 3 : $5c2a9584e51cbabf$var$Ii && ($5c2a9584e51cbabf$var$Xn = 2);
var $5c2a9584e51cbabf$var$wr = $5c2a9584e51cbabf$var$yr, $5c2a9584e51cbabf$var$Te = $5c2a9584e51cbabf$var$xr, $5c2a9584e51cbabf$var$Zn = $5c2a9584e51cbabf$var$Ii;
var $5c2a9584e51cbabf$var$Dr = $5c2a9584e51cbabf$var$vo;
var $5c2a9584e51cbabf$var$na = $5c2a9584e51cbabf$var$go && typeof $5c2a9584e51cbabf$var$Ve.importScripts == "function", $5c2a9584e51cbabf$var$xu = $5c2a9584e51cbabf$var$na ? $5c2a9584e51cbabf$var$Ve.origin : void 0;
var $5c2a9584e51cbabf$var$Fe = $5c2a9584e51cbabf$var$$e, $5c2a9584e51cbabf$var$st = $5c2a9584e51cbabf$var$Ir, $5c2a9584e51cbabf$var$sa;
((i)=>{
    function s() {
        return $5c2a9584e51cbabf$var$st;
    }
    i.value = s;
    function t1() {
        return $5c2a9584e51cbabf$var$st.length === 2 ? $5c2a9584e51cbabf$var$st === "en" : $5c2a9584e51cbabf$var$st.length >= 3 ? $5c2a9584e51cbabf$var$st[0] === "e" && $5c2a9584e51cbabf$var$st[1] === "n" && $5c2a9584e51cbabf$var$st[2] === "-" : !1;
    }
    i.isDefaultVariant = t1;
    function e() {
        return $5c2a9584e51cbabf$var$st === "en";
    }
    i.isDefault = e;
})($5c2a9584e51cbabf$var$sa ||= {});
var $5c2a9584e51cbabf$var$oa = typeof $5c2a9584e51cbabf$var$Ve.postMessage == "function" && !$5c2a9584e51cbabf$var$Ve.importScripts, $5c2a9584e51cbabf$var$Eo = (()=>{
    if ($5c2a9584e51cbabf$var$oa) {
        let s = [];
        $5c2a9584e51cbabf$var$Ve.addEventListener("message", (e)=>{
            if (e.data && e.data.vscodeScheduleAsyncWork) for(let i = 0, r = s.length; i < r; i++){
                let n = s[i];
                if (n.id === e.data.vscodeScheduleAsyncWork) {
                    s.splice(i, 1), n.callback();
                    return;
                }
            }
        });
        let t1 = 0;
        return (e)=>{
            let i = ++t1;
            s.push({
                id: i,
                callback: e
            }), $5c2a9584e51cbabf$var$Ve.postMessage({
                vscodeScheduleAsyncWork: i
            }, "*");
        };
    }
    return (s)=>setTimeout(s);
})();
var $5c2a9584e51cbabf$var$la = !!($5c2a9584e51cbabf$var$Fe && $5c2a9584e51cbabf$var$Fe.indexOf("Chrome") >= 0), $5c2a9584e51cbabf$var$wu = !!($5c2a9584e51cbabf$var$Fe && $5c2a9584e51cbabf$var$Fe.indexOf("Firefox") >= 0), $5c2a9584e51cbabf$var$Du = !!(!$5c2a9584e51cbabf$var$la && $5c2a9584e51cbabf$var$Fe && $5c2a9584e51cbabf$var$Fe.indexOf("Safari") >= 0), $5c2a9584e51cbabf$var$Ru = !!($5c2a9584e51cbabf$var$Fe && $5c2a9584e51cbabf$var$Fe.indexOf("Edg/") >= 0), $5c2a9584e51cbabf$var$Lu = !!($5c2a9584e51cbabf$var$Fe && $5c2a9584e51cbabf$var$Fe.indexOf("Android") >= 0);
var $5c2a9584e51cbabf$var$ot = typeof navigator == "object" ? navigator : {}, $5c2a9584e51cbabf$var$aa = {
    clipboard: {
        writeText: $5c2a9584e51cbabf$var$Dr || document.queryCommandSupported && document.queryCommandSupported("copy") || !!($5c2a9584e51cbabf$var$ot && $5c2a9584e51cbabf$var$ot.clipboard && $5c2a9584e51cbabf$var$ot.clipboard.writeText),
        readText: $5c2a9584e51cbabf$var$Dr || !!($5c2a9584e51cbabf$var$ot && $5c2a9584e51cbabf$var$ot.clipboard && $5c2a9584e51cbabf$var$ot.clipboard.readText)
    },
    keyboard: $5c2a9584e51cbabf$var$Dr || $5c2a9584e51cbabf$var$_o() ? 0 : $5c2a9584e51cbabf$var$ot.keyboard || $5c2a9584e51cbabf$var$Sr ? 1 : 2,
    touch: "ontouchstart" in $5c2a9584e51cbabf$var$fe || $5c2a9584e51cbabf$var$ot.maxTouchPoints > 0,
    pointerEvents: $5c2a9584e51cbabf$var$fe.PointerEvent && ("ontouchstart" in $5c2a9584e51cbabf$var$fe || navigator.maxTouchPoints > 0)
};
var $5c2a9584e51cbabf$var$yi = class {
    constructor(){
        this._keyCodeToStr = [], this._strToKeyCode = Object.create(null);
    }
    define(t1, e) {
        this._keyCodeToStr[t1] = e, this._strToKeyCode[e.toLowerCase()] = t1;
    }
    keyCodeToStr(t1) {
        return this._keyCodeToStr[t1];
    }
    strToKeyCode(t1) {
        return this._strToKeyCode[t1.toLowerCase()] || 0;
    }
}, $5c2a9584e51cbabf$var$Jn = new $5c2a9584e51cbabf$var$yi, $5c2a9584e51cbabf$var$To = new $5c2a9584e51cbabf$var$yi, $5c2a9584e51cbabf$var$Io = new $5c2a9584e51cbabf$var$yi, $5c2a9584e51cbabf$var$yo = new Array(230);
var $5c2a9584e51cbabf$var$Qn;
((o)=>{
    function s(l) {
        return $5c2a9584e51cbabf$var$Jn.keyCodeToStr(l);
    }
    o.toString = s;
    function t1(l) {
        return $5c2a9584e51cbabf$var$Jn.strToKeyCode(l);
    }
    o.fromString = t1;
    function e(l) {
        return $5c2a9584e51cbabf$var$To.keyCodeToStr(l);
    }
    o.toUserSettingsUS = e;
    function i(l) {
        return $5c2a9584e51cbabf$var$Io.keyCodeToStr(l);
    }
    o.toUserSettingsGeneral = i;
    function r(l) {
        return $5c2a9584e51cbabf$var$To.strToKeyCode(l) || $5c2a9584e51cbabf$var$Io.strToKeyCode(l);
    }
    o.fromUserSettings = r;
    function n(l) {
        if (l >= 98 && l <= 113) return null;
        switch(l){
            case 16:
                return "Up";
            case 18:
                return "Down";
            case 15:
                return "Left";
            case 17:
                return "Right";
        }
        return $5c2a9584e51cbabf$var$Jn.keyCodeToStr(l);
    }
    o.toElectronAccelerator = n;
})($5c2a9584e51cbabf$var$Qn ||= {});
var $5c2a9584e51cbabf$var$Rr = class s {
    constructor(t1, e, i, r, n){
        this.ctrlKey = t1;
        this.shiftKey = e;
        this.altKey = i;
        this.metaKey = r;
        this.keyCode = n;
    }
    equals(t1) {
        return t1 instanceof s && this.ctrlKey === t1.ctrlKey && this.shiftKey === t1.shiftKey && this.altKey === t1.altKey && this.metaKey === t1.metaKey && this.keyCode === t1.keyCode;
    }
    getHashCode() {
        let t1 = this.ctrlKey ? "1" : "0", e = this.shiftKey ? "1" : "0", i = this.altKey ? "1" : "0", r = this.metaKey ? "1" : "0";
        return `K${t1}${e}${i}${r}${this.keyCode}`;
    }
    isModifierKey() {
        return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
    }
    toKeybinding() {
        return new $5c2a9584e51cbabf$var$es([
            this
        ]);
    }
    isDuplicateModifierCase() {
        return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
    }
};
var $5c2a9584e51cbabf$var$es = class {
    constructor(t1){
        if (t1.length === 0) throw $5c2a9584e51cbabf$var$eo("chords");
        this.chords = t1;
    }
    getHashCode() {
        let t1 = "";
        for(let e = 0, i = this.chords.length; e < i; e++)e !== 0 && (t1 += ";"), t1 += this.chords[e].getHashCode();
        return t1;
    }
    equals(t1) {
        if (t1 === null || this.chords.length !== t1.chords.length) return !1;
        for(let e = 0; e < this.chords.length; e++)if (!this.chords[e].equals(t1.chords[e])) return !1;
        return !0;
    }
};
function $5c2a9584e51cbabf$var$ca(s) {
    if (s.charCode) {
        let e = String.fromCharCode(s.charCode).toUpperCase();
        return $5c2a9584e51cbabf$var$Qn.fromString(e);
    }
    let t1 = s.keyCode;
    if (t1 === 3) return 7;
    if ($5c2a9584e51cbabf$var$Ei) switch(t1){
        case 59:
            return 85;
        case 60:
            if ($5c2a9584e51cbabf$var$Zn) return 97;
            break;
        case 61:
            return 86;
        case 107:
            return 109;
        case 109:
            return 111;
        case 173:
            return 88;
        case 224:
            if ($5c2a9584e51cbabf$var$Te) return 57;
            break;
    }
    else if ($5c2a9584e51cbabf$var$Bt) {
        if ($5c2a9584e51cbabf$var$Te && t1 === 93) return 57;
        if (!$5c2a9584e51cbabf$var$Te && t1 === 92) return 57;
    }
    return $5c2a9584e51cbabf$var$yo[t1] || 0;
}
var $5c2a9584e51cbabf$var$ua = $5c2a9584e51cbabf$var$Te ? 256 : 2048, $5c2a9584e51cbabf$var$ha = 512, $5c2a9584e51cbabf$var$da = 1024, $5c2a9584e51cbabf$var$fa = $5c2a9584e51cbabf$var$Te ? 2048 : 256;
var $5c2a9584e51cbabf$var$ft = class {
    constructor(t1){
        this._standardKeyboardEventBrand = !0;
        let e = t1;
        this.browserEvent = e, this.target = e.target, this.ctrlKey = e.ctrlKey, this.shiftKey = e.shiftKey, this.altKey = e.altKey, this.metaKey = e.metaKey, this.altGraphKey = e.getModifierState?.("AltGraph"), this.keyCode = $5c2a9584e51cbabf$var$ca(e), this.code = e.code, this.ctrlKey = this.ctrlKey || this.keyCode === 5, this.altKey = this.altKey || this.keyCode === 6, this.shiftKey = this.shiftKey || this.keyCode === 4, this.metaKey = this.metaKey || this.keyCode === 57, this._asKeybinding = this._computeKeybinding(), this._asKeyCodeChord = this._computeKeyCodeChord();
    }
    preventDefault() {
        this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
    }
    stopPropagation() {
        this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
    }
    toKeyCodeChord() {
        return this._asKeyCodeChord;
    }
    equals(t1) {
        return this._asKeybinding === t1;
    }
    _computeKeybinding() {
        let t1 = 0;
        this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (t1 = this.keyCode);
        let e = 0;
        return this.ctrlKey && (e |= $5c2a9584e51cbabf$var$ua), this.altKey && (e |= $5c2a9584e51cbabf$var$ha), this.shiftKey && (e |= $5c2a9584e51cbabf$var$da), this.metaKey && (e |= $5c2a9584e51cbabf$var$fa), e |= t1, e;
    }
    _computeKeyCodeChord() {
        let t1 = 0;
        return this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (t1 = this.keyCode), new $5c2a9584e51cbabf$var$Rr(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, t1);
    }
};
var $5c2a9584e51cbabf$var$wo = new WeakMap;
function $5c2a9584e51cbabf$var$pa(s) {
    if (!s.parent || s.parent === s) return null;
    try {
        let t1 = s.location, e = s.parent.location;
        if (t1.origin !== "null" && e.origin !== "null" && t1.origin !== e.origin) return null;
    } catch  {
        return null;
    }
    return s.parent;
}
var $5c2a9584e51cbabf$var$Lr = class {
    static getSameOriginWindowChain(t1) {
        let e = $5c2a9584e51cbabf$var$wo.get(t1);
        if (!e) {
            e = [], $5c2a9584e51cbabf$var$wo.set(t1, e);
            let i = t1, r;
            do r = $5c2a9584e51cbabf$var$pa(i), r ? e.push({
                window: new WeakRef(i),
                iframeElement: i.frameElement || null
            }) : e.push({
                window: new WeakRef(i),
                iframeElement: null
            }), i = r;
            while (i);
        }
        return e.slice(0);
    }
    static getPositionOfChildWindowRelativeToAncestorWindow(t1, e) {
        if (!e || t1 === e) return {
            top: 0,
            left: 0
        };
        let i = 0, r = 0, n = this.getSameOriginWindowChain(t1);
        for (let o of n){
            let l = o.window.deref();
            if (i += l?.scrollY ?? 0, r += l?.scrollX ?? 0, l === e || !o.iframeElement) break;
            let a = o.iframeElement.getBoundingClientRect();
            i += a.top, r += a.left;
        }
        return {
            top: i,
            left: r
        };
    }
};
var $5c2a9584e51cbabf$var$qe = class {
    constructor(t1, e){
        this.timestamp = Date.now(), this.browserEvent = e, this.leftButton = e.button === 0, this.middleButton = e.button === 1, this.rightButton = e.button === 2, this.buttons = e.buttons, this.target = e.target, this.detail = e.detail || 1, e.type === "dblclick" && (this.detail = 2), this.ctrlKey = e.ctrlKey, this.shiftKey = e.shiftKey, this.altKey = e.altKey, this.metaKey = e.metaKey, typeof e.pageX == "number" ? (this.posx = e.pageX, this.posy = e.pageY) : (this.posx = e.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft, this.posy = e.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop);
        let i = $5c2a9584e51cbabf$var$Lr.getPositionOfChildWindowRelativeToAncestorWindow(t1, e.view);
        this.posx -= i.left, this.posy -= i.top;
    }
    preventDefault() {
        this.browserEvent.preventDefault();
    }
    stopPropagation() {
        this.browserEvent.stopPropagation();
    }
};
var $5c2a9584e51cbabf$var$xi = class {
    constructor(t1, e = 0, i = 0){
        this.browserEvent = t1 || null, this.target = t1 ? t1.target || t1.targetNode || t1.srcElement : null, this.deltaY = i, this.deltaX = e;
        let r = !1;
        if ($5c2a9584e51cbabf$var$Ti) {
            let n = navigator.userAgent.match(/Chrome\/(\d+)/);
            r = (n ? parseInt(n[1]) : 123) <= 122;
        }
        if (t1) {
            let n = t1, o = t1, l = t1.view?.devicePixelRatio || 1;
            if (typeof n.wheelDeltaY < "u") r ? this.deltaY = n.wheelDeltaY / (120 * l) : this.deltaY = n.wheelDeltaY / 120;
            else if (typeof o.VERTICAL_AXIS < "u" && o.axis === o.VERTICAL_AXIS) this.deltaY = -o.detail / 3;
            else if (t1.type === "wheel") {
                let a = t1;
                a.deltaMode === a.DOM_DELTA_LINE ? $5c2a9584e51cbabf$var$Ei && !$5c2a9584e51cbabf$var$Te ? this.deltaY = -t1.deltaY / 3 : this.deltaY = -t1.deltaY : this.deltaY = -t1.deltaY / 40;
            }
            if (typeof n.wheelDeltaX < "u") $5c2a9584e51cbabf$var$Sr && $5c2a9584e51cbabf$var$wr ? this.deltaX = -(n.wheelDeltaX / 120) : r ? this.deltaX = n.wheelDeltaX / (120 * l) : this.deltaX = n.wheelDeltaX / 120;
            else if (typeof o.HORIZONTAL_AXIS < "u" && o.axis === o.HORIZONTAL_AXIS) this.deltaX = -t1.detail / 3;
            else if (t1.type === "wheel") {
                let a = t1;
                a.deltaMode === a.DOM_DELTA_LINE ? $5c2a9584e51cbabf$var$Ei && !$5c2a9584e51cbabf$var$Te ? this.deltaX = -t1.deltaX / 3 : this.deltaX = -t1.deltaX : this.deltaX = -t1.deltaX / 40;
            }
            this.deltaY === 0 && this.deltaX === 0 && t1.wheelDelta && (r ? this.deltaY = t1.wheelDelta / (120 * l) : this.deltaY = t1.wheelDelta / 120);
        }
    }
    preventDefault() {
        this.browserEvent?.preventDefault();
    }
    stopPropagation() {
        this.browserEvent?.stopPropagation();
    }
};
var $5c2a9584e51cbabf$var$Do = Object.freeze(function(s, t1) {
    let e = setTimeout(s.bind(t1), 0);
    return {
        dispose () {
            clearTimeout(e);
        }
    };
}), $5c2a9584e51cbabf$var$ma;
((i)=>{
    function s(r) {
        return r === i.None || r === i.Cancelled || r instanceof $5c2a9584e51cbabf$var$ts ? !0 : !r || typeof r != "object" ? !1 : typeof r.isCancellationRequested == "boolean" && typeof r.onCancellationRequested == "function";
    }
    i.isCancellationToken = s, i.None = Object.freeze({
        isCancellationRequested: !1,
        onCancellationRequested: $5c2a9584e51cbabf$var$$.None
    }), i.Cancelled = Object.freeze({
        isCancellationRequested: !0,
        onCancellationRequested: $5c2a9584e51cbabf$var$Do
    });
})($5c2a9584e51cbabf$var$ma ||= {});
var $5c2a9584e51cbabf$var$ts = class {
    constructor(){
        this._isCancelled = !1;
        this._emitter = null;
    }
    cancel() {
        this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
    }
    get isCancellationRequested() {
        return this._isCancelled;
    }
    get onCancellationRequested() {
        return this._isCancelled ? $5c2a9584e51cbabf$var$Do : (this._emitter || (this._emitter = new $5c2a9584e51cbabf$var$v), this._emitter.event);
    }
    dispose() {
        this._emitter && (this._emitter.dispose(), this._emitter = null);
    }
};
var $5c2a9584e51cbabf$var$_a = Symbol("MicrotaskDelay");
var $5c2a9584e51cbabf$var$Ye = class {
    constructor(t1, e){
        this._isDisposed = !1;
        this._token = -1, typeof t1 == "function" && typeof e == "number" && this.setIfNotSet(t1, e);
    }
    dispose() {
        this.cancel(), this._isDisposed = !0;
    }
    cancel() {
        this._token !== -1 && (clearTimeout(this._token), this._token = -1);
    }
    cancelAndSet(t1, e) {
        if (this._isDisposed) throw new $5c2a9584e51cbabf$var$Rt("Calling 'cancelAndSet' on a disposed TimeoutTimer");
        this.cancel(), this._token = setTimeout(()=>{
            this._token = -1, t1();
        }, e);
    }
    setIfNotSet(t1, e) {
        if (this._isDisposed) throw new $5c2a9584e51cbabf$var$Rt("Calling 'setIfNotSet' on a disposed TimeoutTimer");
        this._token === -1 && (this._token = setTimeout(()=>{
            this._token = -1, t1();
        }, e));
    }
}, $5c2a9584e51cbabf$var$kr = class {
    constructor(){
        this.disposable = void 0;
        this.isDisposed = !1;
    }
    cancel() {
        this.disposable?.dispose(), this.disposable = void 0;
    }
    cancelAndSet(t1, e, i = globalThis) {
        if (this.isDisposed) throw new $5c2a9584e51cbabf$var$Rt("Calling 'cancelAndSet' on a disposed IntervalTimer");
        this.cancel();
        let r = i.setInterval(()=>{
            t1();
        }, e);
        this.disposable = $5c2a9584e51cbabf$var$C(()=>{
            i.clearInterval(r), this.disposable = void 0;
        });
    }
    dispose() {
        this.cancel(), this.isDisposed = !0;
    }
};
var $5c2a9584e51cbabf$var$ba, $5c2a9584e51cbabf$var$Ar;
(function() {
    typeof globalThis.requestIdleCallback != "function" || typeof globalThis.cancelIdleCallback != "function" ? $5c2a9584e51cbabf$var$Ar = (s, t1)=>{
        $5c2a9584e51cbabf$var$Eo(()=>{
            if (e) return;
            let i = Date.now() + 15;
            t1(Object.freeze({
                didTimeout: !0,
                timeRemaining () {
                    return Math.max(0, i - Date.now());
                }
            }));
        });
        let e = !1;
        return {
            dispose () {
                e || (e = !0);
            }
        };
    } : $5c2a9584e51cbabf$var$Ar = (s, t1, e)=>{
        let i = s.requestIdleCallback(t1, typeof e == "number" ? {
            timeout: e
        } : void 0), r = !1;
        return {
            dispose () {
                r || (r = !0, s.cancelIdleCallback(i));
            }
        };
    }, $5c2a9584e51cbabf$var$ba = (s)=>$5c2a9584e51cbabf$var$Ar(globalThis, s);
})();
var $5c2a9584e51cbabf$var$va;
((e)=>{
    async function s(i) {
        let r, n = await Promise.all(i.map((o)=>o.then((l)=>l, (l)=>{
                r || (r = l);
            })));
        if (typeof r < "u") throw r;
        return n;
    }
    e.settled = s;
    function t1(i) {
        return new Promise(async (r, n)=>{
            try {
                await i(r, n);
            } catch (o) {
                n(o);
            }
        });
    }
    e.withAsyncBody = t1;
})($5c2a9584e51cbabf$var$va ||= {});
var $5c2a9584e51cbabf$var$_e = class _e {
    static fromArray(t1) {
        return new _e((e)=>{
            e.emitMany(t1);
        });
    }
    static fromPromise(t1) {
        return new _e(async (e)=>{
            e.emitMany(await t1);
        });
    }
    static fromPromises(t1) {
        return new _e(async (e)=>{
            await Promise.all(t1.map(async (i)=>e.emitOne(await i)));
        });
    }
    static merge(t1) {
        return new _e(async (e)=>{
            await Promise.all(t1.map(async (i)=>{
                for await (let r of i)e.emitOne(r);
            }));
        });
    }
    constructor(t1, e){
        this._state = 0, this._results = [], this._error = null, this._onReturn = e, this._onStateChanged = new $5c2a9584e51cbabf$var$v, queueMicrotask(async ()=>{
            let i = {
                emitOne: (r)=>this.emitOne(r),
                emitMany: (r)=>this.emitMany(r),
                reject: (r)=>this.reject(r)
            };
            try {
                await Promise.resolve(t1(i)), this.resolve();
            } catch (r) {
                this.reject(r);
            } finally{
                i.emitOne = void 0, i.emitMany = void 0, i.reject = void 0;
            }
        });
    }
    [Symbol.asyncIterator]() {
        let t1 = 0;
        return {
            next: async ()=>{
                do {
                    if (this._state === 2) throw this._error;
                    if (t1 < this._results.length) return {
                        done: !1,
                        value: this._results[t1++]
                    };
                    if (this._state === 1) return {
                        done: !0,
                        value: void 0
                    };
                    await $5c2a9584e51cbabf$var$$.toPromise(this._onStateChanged.event);
                }while (!0);
            },
            return: async ()=>(this._onReturn?.(), {
                    done: !0,
                    value: void 0
                })
        };
    }
    static map(t1, e) {
        return new _e(async (i)=>{
            for await (let r of t1)i.emitOne(e(r));
        });
    }
    map(t1) {
        return _e.map(this, t1);
    }
    static filter(t1, e) {
        return new _e(async (i)=>{
            for await (let r of t1)e(r) && i.emitOne(r);
        });
    }
    filter(t1) {
        return _e.filter(this, t1);
    }
    static coalesce(t1) {
        return _e.filter(t1, (e)=>!!e);
    }
    coalesce() {
        return _e.coalesce(this);
    }
    static async toPromise(t1) {
        let e = [];
        for await (let i of t1)e.push(i);
        return e;
    }
    toPromise() {
        return _e.toPromise(this);
    }
    emitOne(t1) {
        this._state === 0 && (this._results.push(t1), this._onStateChanged.fire());
    }
    emitMany(t1) {
        this._state === 0 && (this._results = this._results.concat(t1), this._onStateChanged.fire());
    }
    resolve() {
        this._state === 0 && (this._state = 1, this._onStateChanged.fire());
    }
    reject(t1) {
        this._state === 0 && (this._state = 2, this._error = t1, this._onStateChanged.fire());
    }
};
$5c2a9584e51cbabf$var$_e.EMPTY = $5c2a9584e51cbabf$var$_e.fromArray([]);
var $5c2a9584e51cbabf$var$Ro = $5c2a9584e51cbabf$var$_e;
function $5c2a9584e51cbabf$var$Lo(s) {
    return 55296 <= s && s <= 56319;
}
function $5c2a9584e51cbabf$var$is(s) {
    return 56320 <= s && s <= 57343;
}
function $5c2a9584e51cbabf$var$Ao(s, t1) {
    return (s - 55296 << 10) + (t1 - 56320) + 65536;
}
function $5c2a9584e51cbabf$var$Mo(s) {
    return $5c2a9584e51cbabf$var$ns(s, 0);
}
function $5c2a9584e51cbabf$var$ns(s, t1) {
    switch(typeof s){
        case "object":
            return s === null ? $5c2a9584e51cbabf$var$je(349, t1) : Array.isArray(s) ? $5c2a9584e51cbabf$var$Ea(s, t1) : $5c2a9584e51cbabf$var$Ta(s, t1);
        case "string":
            return $5c2a9584e51cbabf$var$Po(s, t1);
        case "boolean":
            return $5c2a9584e51cbabf$var$Sa(s, t1);
        case "number":
            return $5c2a9584e51cbabf$var$je(s, t1);
        case "undefined":
            return $5c2a9584e51cbabf$var$je(937, t1);
        default:
            return $5c2a9584e51cbabf$var$je(617, t1);
    }
}
function $5c2a9584e51cbabf$var$je(s, t1) {
    return (t1 << 5) - t1 + s | 0;
}
function $5c2a9584e51cbabf$var$Sa(s, t1) {
    return $5c2a9584e51cbabf$var$je(s ? 433 : 863, t1);
}
function $5c2a9584e51cbabf$var$Po(s, t1) {
    t1 = $5c2a9584e51cbabf$var$je(149417, t1);
    for(let e = 0, i = s.length; e < i; e++)t1 = $5c2a9584e51cbabf$var$je(s.charCodeAt(e), t1);
    return t1;
}
function $5c2a9584e51cbabf$var$Ea(s, t1) {
    return t1 = $5c2a9584e51cbabf$var$je(104579, t1), s.reduce((e, i)=>$5c2a9584e51cbabf$var$ns(i, e), t1);
}
function $5c2a9584e51cbabf$var$Ta(s, t1) {
    return t1 = $5c2a9584e51cbabf$var$je(181387, t1), Object.keys(s).sort().reduce((e, i)=>(e = $5c2a9584e51cbabf$var$Po(i, e), $5c2a9584e51cbabf$var$ns(s[i], e)), t1);
}
function $5c2a9584e51cbabf$var$rs(s, t1, e = 32) {
    let i = e - t1, r = ~((1 << i) - 1);
    return (s << t1 | (r & s) >>> i) >>> 0;
}
function $5c2a9584e51cbabf$var$ko(s, t1 = 0, e = s.byteLength, i = 0) {
    for(let r = 0; r < e; r++)s[t1 + r] = i;
}
function $5c2a9584e51cbabf$var$Ia(s, t1, e = "0") {
    for(; s.length < t1;)s = e + s;
    return s;
}
function $5c2a9584e51cbabf$var$wi(s, t1 = 32) {
    return s instanceof ArrayBuffer ? Array.from(new Uint8Array(s)).map((e)=>e.toString(16).padStart(2, "0")).join("") : $5c2a9584e51cbabf$var$Ia((s >>> 0).toString(16), t1 / 4);
}
var $5c2a9584e51cbabf$var$Cr = class Cr {
    constructor(){
        this._h0 = 1732584193;
        this._h1 = 4023233417;
        this._h2 = 2562383102;
        this._h3 = 271733878;
        this._h4 = 3285377520;
        this._buff = new Uint8Array(67), this._buffDV = new DataView(this._buff.buffer), this._buffLen = 0, this._totalLen = 0, this._leftoverHighSurrogate = 0, this._finished = !1;
    }
    update(t1) {
        let e = t1.length;
        if (e === 0) return;
        let i = this._buff, r = this._buffLen, n = this._leftoverHighSurrogate, o, l;
        for(n !== 0 ? (o = n, l = -1, n = 0) : (o = t1.charCodeAt(0), l = 0);;){
            let a = o;
            if ($5c2a9584e51cbabf$var$Lo(o)) {
                if (l + 1 < e) {
                    let u = t1.charCodeAt(l + 1);
                    $5c2a9584e51cbabf$var$is(u) ? (l++, a = $5c2a9584e51cbabf$var$Ao(o, u)) : a = 65533;
                } else {
                    n = o;
                    break;
                }
            } else $5c2a9584e51cbabf$var$is(o) && (a = 65533);
            if (r = this._push(i, r, a), l++, l < e) o = t1.charCodeAt(l);
            else break;
        }
        this._buffLen = r, this._leftoverHighSurrogate = n;
    }
    _push(t1, e, i) {
        return i < 128 ? t1[e++] = i : i < 2048 ? (t1[e++] = 192 | (i & 1984) >>> 6, t1[e++] = 128 | (i & 63) >>> 0) : i < 65536 ? (t1[e++] = 224 | (i & 61440) >>> 12, t1[e++] = 128 | (i & 4032) >>> 6, t1[e++] = 128 | (i & 63) >>> 0) : (t1[e++] = 240 | (i & 1835008) >>> 18, t1[e++] = 128 | (i & 258048) >>> 12, t1[e++] = 128 | (i & 4032) >>> 6, t1[e++] = 128 | (i & 63) >>> 0), e >= 64 && (this._step(), e -= 64, this._totalLen += 64, t1[0] = t1[64], t1[1] = t1[65], t1[2] = t1[66]), e;
    }
    digest() {
        return this._finished || (this._finished = !0, this._leftoverHighSurrogate && (this._leftoverHighSurrogate = 0, this._buffLen = this._push(this._buff, this._buffLen, 65533)), this._totalLen += this._buffLen, this._wrapUp()), $5c2a9584e51cbabf$var$wi(this._h0) + $5c2a9584e51cbabf$var$wi(this._h1) + $5c2a9584e51cbabf$var$wi(this._h2) + $5c2a9584e51cbabf$var$wi(this._h3) + $5c2a9584e51cbabf$var$wi(this._h4);
    }
    _wrapUp() {
        this._buff[this._buffLen++] = 128, $5c2a9584e51cbabf$var$ko(this._buff, this._buffLen), this._buffLen > 56 && (this._step(), $5c2a9584e51cbabf$var$ko(this._buff));
        let t1 = 8 * this._totalLen;
        this._buffDV.setUint32(56, Math.floor(t1 / 4294967296), !1), this._buffDV.setUint32(60, t1 % 4294967296, !1), this._step();
    }
    _step() {
        let t1 = Cr._bigBlock32, e = this._buffDV;
        for(let c = 0; c < 64; c += 4)t1.setUint32(c, e.getUint32(c, !1), !1);
        for(let c = 64; c < 320; c += 4)t1.setUint32(c, $5c2a9584e51cbabf$var$rs(t1.getUint32(c - 12, !1) ^ t1.getUint32(c - 32, !1) ^ t1.getUint32(c - 56, !1) ^ t1.getUint32(c - 64, !1), 1), !1);
        let i = this._h0, r = this._h1, n = this._h2, o = this._h3, l = this._h4, a, u, h;
        for(let c = 0; c < 80; c++)c < 20 ? (a = r & n | ~r & o, u = 1518500249) : c < 40 ? (a = r ^ n ^ o, u = 1859775393) : c < 60 ? (a = r & n | r & o | n & o, u = 2400959708) : (a = r ^ n ^ o, u = 3395469782), h = $5c2a9584e51cbabf$var$rs(i, 5) + a + l + u + t1.getUint32(c * 4, !1) & 4294967295, l = o, o = n, n = $5c2a9584e51cbabf$var$rs(r, 30), r = i, i = h;
        this._h0 = this._h0 + i & 4294967295, this._h1 = this._h1 + r & 4294967295, this._h2 = this._h2 + n & 4294967295, this._h3 = this._h3 + o & 4294967295, this._h4 = this._h4 + l & 4294967295;
    }
};
$5c2a9584e51cbabf$var$Cr._bigBlock32 = new DataView(new ArrayBuffer(320));
var $5c2a9584e51cbabf$var$Co = $5c2a9584e51cbabf$var$Cr;
var { registerWindow: $5c2a9584e51cbabf$var$Bh, getWindow: $5c2a9584e51cbabf$var$be, getDocument: $5c2a9584e51cbabf$var$Nh, getWindows: $5c2a9584e51cbabf$var$Fh, getWindowsCount: $5c2a9584e51cbabf$var$Hh, getWindowId: $5c2a9584e51cbabf$var$Oo, getWindowById: $5c2a9584e51cbabf$var$Wh, hasWindow: $5c2a9584e51cbabf$var$Uh, onDidRegisterWindow: $5c2a9584e51cbabf$var$No, onWillUnregisterWindow: $5c2a9584e51cbabf$var$Kh, onDidUnregisterWindow: $5c2a9584e51cbabf$var$zh } = function() {
    let s = new Map;
    $5c2a9584e51cbabf$var$fe;
    let t1 = {
        window: $5c2a9584e51cbabf$var$fe,
        disposables: new $5c2a9584e51cbabf$var$Ee
    };
    s.set($5c2a9584e51cbabf$var$fe.vscodeWindowId, t1);
    let e = new $5c2a9584e51cbabf$var$v, i = new $5c2a9584e51cbabf$var$v, r = new $5c2a9584e51cbabf$var$v;
    function n(o, l) {
        return (typeof o == "number" ? s.get(o) : void 0) ?? (l ? t1 : void 0);
    }
    return {
        onDidRegisterWindow: e.event,
        onWillUnregisterWindow: r.event,
        onDidUnregisterWindow: i.event,
        registerWindow (o) {
            if (s.has(o.vscodeWindowId)) return $5c2a9584e51cbabf$var$D.None;
            let l = new $5c2a9584e51cbabf$var$Ee, a = {
                window: o,
                disposables: l.add(new $5c2a9584e51cbabf$var$Ee)
            };
            return s.set(o.vscodeWindowId, a), l.add($5c2a9584e51cbabf$var$C(()=>{
                s.delete(o.vscodeWindowId), i.fire(o);
            })), l.add($5c2a9584e51cbabf$var$L(o, $5c2a9584e51cbabf$var$Y.BEFORE_UNLOAD, ()=>{
                r.fire(o);
            })), e.fire(a), l;
        },
        getWindows () {
            return s.values();
        },
        getWindowsCount () {
            return s.size;
        },
        getWindowId (o) {
            return o.vscodeWindowId;
        },
        hasWindow (o) {
            return s.has(o);
        },
        getWindowById: n,
        getWindow (o) {
            let l = o;
            if (l?.ownerDocument?.defaultView) return l.ownerDocument.defaultView.window;
            let a = o;
            return a?.view ? a.view.window : $5c2a9584e51cbabf$var$fe;
        },
        getDocument (o) {
            return $5c2a9584e51cbabf$var$be(o).document;
        }
    };
}();
var $5c2a9584e51cbabf$var$ss = class {
    constructor(t1, e, i, r){
        this._node = t1, this._type = e, this._handler = i, this._options = r || !1, this._node.addEventListener(this._type, this._handler, this._options);
    }
    dispose() {
        this._handler && (this._node.removeEventListener(this._type, this._handler, this._options), this._node = null, this._handler = null);
    }
};
function $5c2a9584e51cbabf$var$L(s, t1, e, i) {
    return new $5c2a9584e51cbabf$var$ss(s, t1, e, i);
}
function $5c2a9584e51cbabf$var$ya(s, t1) {
    return function(e) {
        return t1(new $5c2a9584e51cbabf$var$qe(s, e));
    };
}
function $5c2a9584e51cbabf$var$xa(s) {
    return function(t1) {
        return s(new $5c2a9584e51cbabf$var$ft(t1));
    };
}
var $5c2a9584e51cbabf$var$os = function(t1, e, i, r) {
    let n = i;
    return e === "click" || e === "mousedown" || e === "contextmenu" ? n = $5c2a9584e51cbabf$var$ya($5c2a9584e51cbabf$var$be(t1), i) : (e === "keydown" || e === "keypress" || e === "keyup") && (n = $5c2a9584e51cbabf$var$xa(i)), $5c2a9584e51cbabf$var$L(t1, e, n, r);
};
var $5c2a9584e51cbabf$var$wa, $5c2a9584e51cbabf$var$mt;
var $5c2a9584e51cbabf$var$Mr = class extends $5c2a9584e51cbabf$var$kr {
    constructor(t1){
        super(), this.defaultTarget = t1 && $5c2a9584e51cbabf$var$be(t1);
    }
    cancelAndSet(t1, e, i) {
        return super.cancelAndSet(t1, e, i ?? this.defaultTarget);
    }
}, $5c2a9584e51cbabf$var$Di = class {
    constructor(t1, e = 0){
        this._runner = t1, this.priority = e, this._canceled = !1;
    }
    dispose() {
        this._canceled = !0;
    }
    execute() {
        if (!this._canceled) try {
            this._runner();
        } catch (t1) {
            $5c2a9584e51cbabf$var$Lt(t1);
        }
    }
    static sort(t1, e) {
        return e.priority - t1.priority;
    }
};
(function() {
    let s = new Map, t1 = new Map, e = new Map, i = new Map, r = (n)=>{
        e.set(n, !1);
        let o = s.get(n) ?? [];
        for(t1.set(n, o), s.set(n, []), i.set(n, !0); o.length > 0;)o.sort($5c2a9584e51cbabf$var$Di.sort), o.shift().execute();
        i.set(n, !1);
    };
    $5c2a9584e51cbabf$var$mt = (n, o, l = 0)=>{
        let a = $5c2a9584e51cbabf$var$Oo(n), u = new $5c2a9584e51cbabf$var$Di(o, l), h = s.get(a);
        return h || (h = [], s.set(a, h)), h.push(u), e.get(a) || (e.set(a, !0), n.requestAnimationFrame(()=>r(a))), u;
    }, $5c2a9584e51cbabf$var$wa = (n, o, l)=>{
        let a = $5c2a9584e51cbabf$var$Oo(n);
        if (i.get(a)) {
            let u = new $5c2a9584e51cbabf$var$Di(o, l), h = t1.get(a);
            return h || (h = [], t1.set(a, h)), h.push(u), u;
        } else return $5c2a9584e51cbabf$var$mt(n, o, l);
    };
})();
var $5c2a9584e51cbabf$var$pt = class pt {
    constructor(t1, e){
        this.width = t1;
        this.height = e;
    }
    with(t1 = this.width, e = this.height) {
        return t1 !== this.width || e !== this.height ? new pt(t1, e) : this;
    }
    static is(t1) {
        return typeof t1 == "object" && typeof t1.height == "number" && typeof t1.width == "number";
    }
    static lift(t1) {
        return t1 instanceof pt ? t1 : new pt(t1.width, t1.height);
    }
    static equals(t1, e) {
        return t1 === e ? !0 : !t1 || !e ? !1 : t1.width === e.width && t1.height === e.height;
    }
};
$5c2a9584e51cbabf$var$pt.None = new $5c2a9584e51cbabf$var$pt(0, 0);
var $5c2a9584e51cbabf$var$Bo = $5c2a9584e51cbabf$var$pt;
function $5c2a9584e51cbabf$var$Fo(s) {
    let t1 = s.getBoundingClientRect(), e = $5c2a9584e51cbabf$var$be(s);
    return {
        left: t1.left + e.scrollX,
        top: t1.top + e.scrollY,
        width: t1.width,
        height: t1.height
    };
}
var $5c2a9584e51cbabf$var$Gh = new class {
    constructor(){
        this.mutationObservers = new Map;
    }
    observe(s, t1, e) {
        let i = this.mutationObservers.get(s);
        i || (i = new Map, this.mutationObservers.set(s, i));
        let r = $5c2a9584e51cbabf$var$Mo(e), n = i.get(r);
        if (n) n.users += 1;
        else {
            let o = new $5c2a9584e51cbabf$var$v, l = new MutationObserver((u)=>o.fire(u));
            l.observe(s, e);
            let a = n = {
                users: 1,
                observer: l,
                onDidMutate: o.event
            };
            t1.add($5c2a9584e51cbabf$var$C(()=>{
                a.users -= 1, a.users === 0 && (o.dispose(), l.disconnect(), i?.delete(r), i?.size === 0 && this.mutationObservers.delete(s));
            })), i.set(r, n);
        }
        return n.onDidMutate;
    }
};
var $5c2a9584e51cbabf$var$Y = {
    CLICK: "click",
    AUXCLICK: "auxclick",
    DBLCLICK: "dblclick",
    MOUSE_UP: "mouseup",
    MOUSE_DOWN: "mousedown",
    MOUSE_OVER: "mouseover",
    MOUSE_MOVE: "mousemove",
    MOUSE_OUT: "mouseout",
    MOUSE_ENTER: "mouseenter",
    MOUSE_LEAVE: "mouseleave",
    MOUSE_WHEEL: "wheel",
    POINTER_UP: "pointerup",
    POINTER_DOWN: "pointerdown",
    POINTER_MOVE: "pointermove",
    POINTER_LEAVE: "pointerleave",
    CONTEXT_MENU: "contextmenu",
    WHEEL: "wheel",
    KEY_DOWN: "keydown",
    KEY_PRESS: "keypress",
    KEY_UP: "keyup",
    LOAD: "load",
    BEFORE_UNLOAD: "beforeunload",
    UNLOAD: "unload",
    PAGE_SHOW: "pageshow",
    PAGE_HIDE: "pagehide",
    PASTE: "paste",
    ABORT: "abort",
    ERROR: "error",
    RESIZE: "resize",
    SCROLL: "scroll",
    FULLSCREEN_CHANGE: "fullscreenchange",
    WK_FULLSCREEN_CHANGE: "webkitfullscreenchange",
    SELECT: "select",
    CHANGE: "change",
    SUBMIT: "submit",
    RESET: "reset",
    FOCUS: "focus",
    FOCUS_IN: "focusin",
    FOCUS_OUT: "focusout",
    BLUR: "blur",
    INPUT: "input",
    STORAGE: "storage",
    DRAG_START: "dragstart",
    DRAG: "drag",
    DRAG_ENTER: "dragenter",
    DRAG_LEAVE: "dragleave",
    DRAG_OVER: "dragover",
    DROP: "drop",
    DRAG_END: "dragend",
    ANIMATION_START: $5c2a9584e51cbabf$var$Bt ? "webkitAnimationStart" : "animationstart",
    ANIMATION_END: $5c2a9584e51cbabf$var$Bt ? "webkitAnimationEnd" : "animationend",
    ANIMATION_ITERATION: $5c2a9584e51cbabf$var$Bt ? "webkitAnimationIteration" : "animationiteration"
};
var $5c2a9584e51cbabf$var$Da = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
function $5c2a9584e51cbabf$var$Ho(s, t1, e, ...i) {
    let r = $5c2a9584e51cbabf$var$Da.exec(t1);
    if (!r) throw new Error("Bad use of emmet");
    let n = r[1] || "div", o;
    return s !== "http://www.w3.org/1999/xhtml" ? o = document.createElementNS(s, n) : o = document.createElement(n), r[3] && (o.id = r[3]), r[4] && (o.className = r[4].replace(/\./g, " ").trim()), e && Object.entries(e).forEach(([l, a])=>{
        typeof a > "u" || (/^on\w+$/.test(l) ? o[l] = a : l === "selected" ? a && o.setAttribute(l, "true") : o.setAttribute(l, a));
    }), o.append(...i), o;
}
function $5c2a9584e51cbabf$var$Ra(s, t1, ...e) {
    return $5c2a9584e51cbabf$var$Ho("http://www.w3.org/1999/xhtml", s, t1, ...e);
}
$5c2a9584e51cbabf$var$Ra.SVG = function(s, t1, ...e) {
    return $5c2a9584e51cbabf$var$Ho("http://www.w3.org/2000/svg", s, t1, ...e);
};
var $5c2a9584e51cbabf$var$ls = class {
    constructor(t1){
        this.domNode = t1;
        this._maxWidth = "";
        this._width = "";
        this._height = "";
        this._top = "";
        this._left = "";
        this._bottom = "";
        this._right = "";
        this._paddingTop = "";
        this._paddingLeft = "";
        this._paddingBottom = "";
        this._paddingRight = "";
        this._fontFamily = "";
        this._fontWeight = "";
        this._fontSize = "";
        this._fontStyle = "";
        this._fontFeatureSettings = "";
        this._fontVariationSettings = "";
        this._textDecoration = "";
        this._lineHeight = "";
        this._letterSpacing = "";
        this._className = "";
        this._display = "";
        this._position = "";
        this._visibility = "";
        this._color = "";
        this._backgroundColor = "";
        this._layerHint = !1;
        this._contain = "none";
        this._boxShadow = "";
    }
    setMaxWidth(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._maxWidth !== e && (this._maxWidth = e, this.domNode.style.maxWidth = this._maxWidth);
    }
    setWidth(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._width !== e && (this._width = e, this.domNode.style.width = this._width);
    }
    setHeight(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._height !== e && (this._height = e, this.domNode.style.height = this._height);
    }
    setTop(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._top !== e && (this._top = e, this.domNode.style.top = this._top);
    }
    setLeft(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._left !== e && (this._left = e, this.domNode.style.left = this._left);
    }
    setBottom(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._bottom !== e && (this._bottom = e, this.domNode.style.bottom = this._bottom);
    }
    setRight(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._right !== e && (this._right = e, this.domNode.style.right = this._right);
    }
    setPaddingTop(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._paddingTop !== e && (this._paddingTop = e, this.domNode.style.paddingTop = this._paddingTop);
    }
    setPaddingLeft(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._paddingLeft !== e && (this._paddingLeft = e, this.domNode.style.paddingLeft = this._paddingLeft);
    }
    setPaddingBottom(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._paddingBottom !== e && (this._paddingBottom = e, this.domNode.style.paddingBottom = this._paddingBottom);
    }
    setPaddingRight(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._paddingRight !== e && (this._paddingRight = e, this.domNode.style.paddingRight = this._paddingRight);
    }
    setFontFamily(t1) {
        this._fontFamily !== t1 && (this._fontFamily = t1, this.domNode.style.fontFamily = this._fontFamily);
    }
    setFontWeight(t1) {
        this._fontWeight !== t1 && (this._fontWeight = t1, this.domNode.style.fontWeight = this._fontWeight);
    }
    setFontSize(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._fontSize !== e && (this._fontSize = e, this.domNode.style.fontSize = this._fontSize);
    }
    setFontStyle(t1) {
        this._fontStyle !== t1 && (this._fontStyle = t1, this.domNode.style.fontStyle = this._fontStyle);
    }
    setFontFeatureSettings(t1) {
        this._fontFeatureSettings !== t1 && (this._fontFeatureSettings = t1, this.domNode.style.fontFeatureSettings = this._fontFeatureSettings);
    }
    setFontVariationSettings(t1) {
        this._fontVariationSettings !== t1 && (this._fontVariationSettings = t1, this.domNode.style.fontVariationSettings = this._fontVariationSettings);
    }
    setTextDecoration(t1) {
        this._textDecoration !== t1 && (this._textDecoration = t1, this.domNode.style.textDecoration = this._textDecoration);
    }
    setLineHeight(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._lineHeight !== e && (this._lineHeight = e, this.domNode.style.lineHeight = this._lineHeight);
    }
    setLetterSpacing(t1) {
        let e = $5c2a9584e51cbabf$var$Ie(t1);
        this._letterSpacing !== e && (this._letterSpacing = e, this.domNode.style.letterSpacing = this._letterSpacing);
    }
    setClassName(t1) {
        this._className !== t1 && (this._className = t1, this.domNode.className = this._className);
    }
    toggleClassName(t1, e) {
        this.domNode.classList.toggle(t1, e), this._className = this.domNode.className;
    }
    setDisplay(t1) {
        this._display !== t1 && (this._display = t1, this.domNode.style.display = this._display);
    }
    setPosition(t1) {
        this._position !== t1 && (this._position = t1, this.domNode.style.position = this._position);
    }
    setVisibility(t1) {
        this._visibility !== t1 && (this._visibility = t1, this.domNode.style.visibility = this._visibility);
    }
    setColor(t1) {
        this._color !== t1 && (this._color = t1, this.domNode.style.color = this._color);
    }
    setBackgroundColor(t1) {
        this._backgroundColor !== t1 && (this._backgroundColor = t1, this.domNode.style.backgroundColor = this._backgroundColor);
    }
    setLayerHinting(t1) {
        this._layerHint !== t1 && (this._layerHint = t1, this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "");
    }
    setBoxShadow(t1) {
        this._boxShadow !== t1 && (this._boxShadow = t1, this.domNode.style.boxShadow = t1);
    }
    setContain(t1) {
        this._contain !== t1 && (this._contain = t1, this.domNode.style.contain = this._contain);
    }
    setAttribute(t1, e) {
        this.domNode.setAttribute(t1, e);
    }
    removeAttribute(t1) {
        this.domNode.removeAttribute(t1);
    }
    appendChild(t1) {
        this.domNode.appendChild(t1.domNode);
    }
    removeChild(t1) {
        this.domNode.removeChild(t1.domNode);
    }
};
function $5c2a9584e51cbabf$var$Ie(s) {
    return typeof s == "number" ? `${s}px` : s;
}
function $5c2a9584e51cbabf$var$_t(s) {
    return new $5c2a9584e51cbabf$var$ls(s);
}
var $5c2a9584e51cbabf$var$Wt = class {
    constructor(){
        this._hooks = new $5c2a9584e51cbabf$var$Ee;
        this._pointerMoveCallback = null;
        this._onStopCallback = null;
    }
    dispose() {
        this.stopMonitoring(!1), this._hooks.dispose();
    }
    stopMonitoring(t1, e) {
        if (!this.isMonitoring()) return;
        this._hooks.clear(), this._pointerMoveCallback = null;
        let i = this._onStopCallback;
        this._onStopCallback = null, t1 && i && i(e);
    }
    isMonitoring() {
        return !!this._pointerMoveCallback;
    }
    startMonitoring(t1, e, i, r, n) {
        this.isMonitoring() && this.stopMonitoring(!1), this._pointerMoveCallback = r, this._onStopCallback = n;
        let o = t1;
        try {
            t1.setPointerCapture(e), this._hooks.add($5c2a9584e51cbabf$var$C(()=>{
                try {
                    t1.releasePointerCapture(e);
                } catch  {}
            }));
        } catch  {
            o = $5c2a9584e51cbabf$var$be(t1);
        }
        this._hooks.add($5c2a9584e51cbabf$var$L(o, $5c2a9584e51cbabf$var$Y.POINTER_MOVE, (l)=>{
            if (l.buttons !== i) {
                this.stopMonitoring(!0);
                return;
            }
            l.preventDefault(), this._pointerMoveCallback(l);
        })), this._hooks.add($5c2a9584e51cbabf$var$L(o, $5c2a9584e51cbabf$var$Y.POINTER_UP, (l)=>this.stopMonitoring(!0)));
    }
};
function $5c2a9584e51cbabf$var$Wo(s, t1, e) {
    let i = null, r = null;
    if (typeof e.value == "function" ? (i = "value", r = e.value, r.length !== 0 && console.warn("Memoize should only be used in functions with zero parameters")) : typeof e.get == "function" && (i = "get", r = e.get), !r) throw new Error("not supported");
    let n = `$memoize$${t1}`;
    e[i] = function(...o) {
        return this.hasOwnProperty(n) || Object.defineProperty(this, n, {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: r.apply(this, o)
        }), this[n];
    };
}
var $5c2a9584e51cbabf$var$He;
((n)=>(n.Tap = "-xterm-gesturetap", n.Change = "-xterm-gesturechange", n.Start = "-xterm-gesturestart", n.End = "-xterm-gesturesend", n.Contextmenu = "-xterm-gesturecontextmenu"))($5c2a9584e51cbabf$var$He ||= {});
var $5c2a9584e51cbabf$var$Q = class Q extends $5c2a9584e51cbabf$var$D {
    constructor(){
        super();
        this.dispatched = !1;
        this.targets = new $5c2a9584e51cbabf$var$Ct;
        this.ignoreTargets = new $5c2a9584e51cbabf$var$Ct;
        this.activeTouches = {}, this.handle = null, this._lastSetTapCountTime = 0, this._register($5c2a9584e51cbabf$var$$.runAndSubscribe($5c2a9584e51cbabf$var$No, ({ window: e, disposables: i })=>{
            i.add($5c2a9584e51cbabf$var$L(e.document, "touchstart", (r)=>this.onTouchStart(r), {
                passive: !1
            })), i.add($5c2a9584e51cbabf$var$L(e.document, "touchend", (r)=>this.onTouchEnd(e, r))), i.add($5c2a9584e51cbabf$var$L(e.document, "touchmove", (r)=>this.onTouchMove(r), {
                passive: !1
            }));
        }, {
            window: $5c2a9584e51cbabf$var$fe,
            disposables: this._store
        }));
    }
    static addTarget(e) {
        if (!Q.isTouchDevice()) return $5c2a9584e51cbabf$var$D.None;
        Q.INSTANCE || (Q.INSTANCE = $5c2a9584e51cbabf$var$Gn(new Q));
        let i = Q.INSTANCE.targets.push(e);
        return $5c2a9584e51cbabf$var$C(i);
    }
    static ignoreTarget(e) {
        if (!Q.isTouchDevice()) return $5c2a9584e51cbabf$var$D.None;
        Q.INSTANCE || (Q.INSTANCE = $5c2a9584e51cbabf$var$Gn(new Q));
        let i = Q.INSTANCE.ignoreTargets.push(e);
        return $5c2a9584e51cbabf$var$C(i);
    }
    static isTouchDevice() {
        return "ontouchstart" in $5c2a9584e51cbabf$var$fe || navigator.maxTouchPoints > 0;
    }
    dispose() {
        this.handle && (this.handle.dispose(), this.handle = null), super.dispose();
    }
    onTouchStart(e) {
        let i = Date.now();
        this.handle && (this.handle.dispose(), this.handle = null);
        for(let r = 0, n = e.targetTouches.length; r < n; r++){
            let o = e.targetTouches.item(r);
            this.activeTouches[o.identifier] = {
                id: o.identifier,
                initialTarget: o.target,
                initialTimeStamp: i,
                initialPageX: o.pageX,
                initialPageY: o.pageY,
                rollingTimestamps: [
                    i
                ],
                rollingPageX: [
                    o.pageX
                ],
                rollingPageY: [
                    o.pageY
                ]
            };
            let l = this.newGestureEvent($5c2a9584e51cbabf$var$He.Start, o.target);
            l.pageX = o.pageX, l.pageY = o.pageY, this.dispatchEvent(l);
        }
        this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
    }
    onTouchEnd(e, i) {
        let r = Date.now(), n = Object.keys(this.activeTouches).length;
        for(let o = 0, l = i.changedTouches.length; o < l; o++){
            let a = i.changedTouches.item(o);
            if (!this.activeTouches.hasOwnProperty(String(a.identifier))) {
                console.warn("move of an UNKNOWN touch", a);
                continue;
            }
            let u = this.activeTouches[a.identifier], h = Date.now() - u.initialTimeStamp;
            if (h < Q.HOLD_DELAY && Math.abs(u.initialPageX - $5c2a9584e51cbabf$var$Se(u.rollingPageX)) < 30 && Math.abs(u.initialPageY - $5c2a9584e51cbabf$var$Se(u.rollingPageY)) < 30) {
                let c = this.newGestureEvent($5c2a9584e51cbabf$var$He.Tap, u.initialTarget);
                c.pageX = $5c2a9584e51cbabf$var$Se(u.rollingPageX), c.pageY = $5c2a9584e51cbabf$var$Se(u.rollingPageY), this.dispatchEvent(c);
            } else if (h >= Q.HOLD_DELAY && Math.abs(u.initialPageX - $5c2a9584e51cbabf$var$Se(u.rollingPageX)) < 30 && Math.abs(u.initialPageY - $5c2a9584e51cbabf$var$Se(u.rollingPageY)) < 30) {
                let c = this.newGestureEvent($5c2a9584e51cbabf$var$He.Contextmenu, u.initialTarget);
                c.pageX = $5c2a9584e51cbabf$var$Se(u.rollingPageX), c.pageY = $5c2a9584e51cbabf$var$Se(u.rollingPageY), this.dispatchEvent(c);
            } else if (n === 1) {
                let c = $5c2a9584e51cbabf$var$Se(u.rollingPageX), d = $5c2a9584e51cbabf$var$Se(u.rollingPageY), _ = $5c2a9584e51cbabf$var$Se(u.rollingTimestamps) - u.rollingTimestamps[0], p = c - u.rollingPageX[0], m = d - u.rollingPageY[0], f = [
                    ...this.targets
                ].filter((A)=>u.initialTarget instanceof Node && A.contains(u.initialTarget));
                this.inertia(e, f, r, Math.abs(p) / _, p > 0 ? 1 : -1, c, Math.abs(m) / _, m > 0 ? 1 : -1, d);
            }
            this.dispatchEvent(this.newGestureEvent($5c2a9584e51cbabf$var$He.End, u.initialTarget)), delete this.activeTouches[a.identifier];
        }
        this.dispatched && (i.preventDefault(), i.stopPropagation(), this.dispatched = !1);
    }
    newGestureEvent(e, i) {
        let r = document.createEvent("CustomEvent");
        return r.initEvent(e, !1, !0), r.initialTarget = i, r.tapCount = 0, r;
    }
    dispatchEvent(e) {
        if (e.type === $5c2a9584e51cbabf$var$He.Tap) {
            let i = new Date().getTime(), r = 0;
            i - this._lastSetTapCountTime > Q.CLEAR_TAP_COUNT_TIME ? r = 1 : r = 2, this._lastSetTapCountTime = i, e.tapCount = r;
        } else (e.type === $5c2a9584e51cbabf$var$He.Change || e.type === $5c2a9584e51cbabf$var$He.Contextmenu) && (this._lastSetTapCountTime = 0);
        if (e.initialTarget instanceof Node) {
            for (let r of this.ignoreTargets)if (r.contains(e.initialTarget)) return;
            let i = [];
            for (let r of this.targets)if (r.contains(e.initialTarget)) {
                let n = 0, o = e.initialTarget;
                for(; o && o !== r;)n++, o = o.parentElement;
                i.push([
                    n,
                    r
                ]);
            }
            i.sort((r, n)=>r[0] - n[0]);
            for (let [r, n] of i)n.dispatchEvent(e), this.dispatched = !0;
        }
    }
    inertia(e, i, r, n, o, l, a, u, h) {
        this.handle = $5c2a9584e51cbabf$var$mt(e, ()=>{
            let c = Date.now(), d = c - r, _ = 0, p = 0, m = !0;
            n += Q.SCROLL_FRICTION * d, a += Q.SCROLL_FRICTION * d, n > 0 && (m = !1, _ = o * n * d), a > 0 && (m = !1, p = u * a * d);
            let f = this.newGestureEvent($5c2a9584e51cbabf$var$He.Change);
            f.translationX = _, f.translationY = p, i.forEach((A)=>A.dispatchEvent(f)), m || this.inertia(e, i, c, n, o, l + _, a, u, h + p);
        });
    }
    onTouchMove(e) {
        let i = Date.now();
        for(let r = 0, n = e.changedTouches.length; r < n; r++){
            let o = e.changedTouches.item(r);
            if (!this.activeTouches.hasOwnProperty(String(o.identifier))) {
                console.warn("end of an UNKNOWN touch", o);
                continue;
            }
            let l = this.activeTouches[o.identifier], a = this.newGestureEvent($5c2a9584e51cbabf$var$He.Change, l.initialTarget);
            a.translationX = o.pageX - $5c2a9584e51cbabf$var$Se(l.rollingPageX), a.translationY = o.pageY - $5c2a9584e51cbabf$var$Se(l.rollingPageY), a.pageX = o.pageX, a.pageY = o.pageY, this.dispatchEvent(a), l.rollingPageX.length > 3 && (l.rollingPageX.shift(), l.rollingPageY.shift(), l.rollingTimestamps.shift()), l.rollingPageX.push(o.pageX), l.rollingPageY.push(o.pageY), l.rollingTimestamps.push(i);
        }
        this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
    }
};
$5c2a9584e51cbabf$var$Q.SCROLL_FRICTION = -0.005, $5c2a9584e51cbabf$var$Q.HOLD_DELAY = 700, $5c2a9584e51cbabf$var$Q.CLEAR_TAP_COUNT_TIME = 400, $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$Wo
], $5c2a9584e51cbabf$var$Q, "isTouchDevice", 1);
var $5c2a9584e51cbabf$var$Pr = $5c2a9584e51cbabf$var$Q;
var $5c2a9584e51cbabf$var$lt = class extends $5c2a9584e51cbabf$var$D {
    onclick(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.CLICK, (i)=>e(new $5c2a9584e51cbabf$var$qe($5c2a9584e51cbabf$var$be(t1), i))));
    }
    onmousedown(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.MOUSE_DOWN, (i)=>e(new $5c2a9584e51cbabf$var$qe($5c2a9584e51cbabf$var$be(t1), i))));
    }
    onmouseover(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.MOUSE_OVER, (i)=>e(new $5c2a9584e51cbabf$var$qe($5c2a9584e51cbabf$var$be(t1), i))));
    }
    onmouseleave(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.MOUSE_LEAVE, (i)=>e(new $5c2a9584e51cbabf$var$qe($5c2a9584e51cbabf$var$be(t1), i))));
    }
    onkeydown(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.KEY_DOWN, (i)=>e(new $5c2a9584e51cbabf$var$ft(i))));
    }
    onkeyup(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.KEY_UP, (i)=>e(new $5c2a9584e51cbabf$var$ft(i))));
    }
    oninput(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.INPUT, e));
    }
    onblur(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.BLUR, e));
    }
    onfocus(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.FOCUS, e));
    }
    onchange(t1, e) {
        this._register($5c2a9584e51cbabf$var$L(t1, $5c2a9584e51cbabf$var$Y.CHANGE, e));
    }
    ignoreGesture(t1) {
        return $5c2a9584e51cbabf$var$Pr.ignoreTarget(t1);
    }
};
var $5c2a9584e51cbabf$var$Uo = 11, $5c2a9584e51cbabf$var$Or = class extends $5c2a9584e51cbabf$var$lt {
    constructor(t1){
        super(), this._onActivate = t1.onActivate, this.bgDomNode = document.createElement("div"), this.bgDomNode.className = "arrow-background", this.bgDomNode.style.position = "absolute", this.bgDomNode.style.width = t1.bgWidth + "px", this.bgDomNode.style.height = t1.bgHeight + "px", typeof t1.top < "u" && (this.bgDomNode.style.top = "0px"), typeof t1.left < "u" && (this.bgDomNode.style.left = "0px"), typeof t1.bottom < "u" && (this.bgDomNode.style.bottom = "0px"), typeof t1.right < "u" && (this.bgDomNode.style.right = "0px"), this.domNode = document.createElement("div"), this.domNode.className = t1.className, this.domNode.style.position = "absolute", this.domNode.style.width = $5c2a9584e51cbabf$var$Uo + "px", this.domNode.style.height = $5c2a9584e51cbabf$var$Uo + "px", typeof t1.top < "u" && (this.domNode.style.top = t1.top + "px"), typeof t1.left < "u" && (this.domNode.style.left = t1.left + "px"), typeof t1.bottom < "u" && (this.domNode.style.bottom = t1.bottom + "px"), typeof t1.right < "u" && (this.domNode.style.right = t1.right + "px"), this._pointerMoveMonitor = this._register(new $5c2a9584e51cbabf$var$Wt), this._register($5c2a9584e51cbabf$var$os(this.bgDomNode, $5c2a9584e51cbabf$var$Y.POINTER_DOWN, (e)=>this._arrowPointerDown(e))), this._register($5c2a9584e51cbabf$var$os(this.domNode, $5c2a9584e51cbabf$var$Y.POINTER_DOWN, (e)=>this._arrowPointerDown(e))), this._pointerdownRepeatTimer = this._register(new $5c2a9584e51cbabf$var$Mr), this._pointerdownScheduleRepeatTimer = this._register(new $5c2a9584e51cbabf$var$Ye);
    }
    _arrowPointerDown(t1) {
        if (!t1.target || !(t1.target instanceof Element)) return;
        let e = ()=>{
            this._pointerdownRepeatTimer.cancelAndSet(()=>this._onActivate(), 1e3 / 24, $5c2a9584e51cbabf$var$be(t1));
        };
        this._onActivate(), this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancelAndSet(e, 200), this._pointerMoveMonitor.startMonitoring(t1.target, t1.pointerId, t1.buttons, (i)=>{}, ()=>{
            this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancel();
        }), t1.preventDefault();
    }
};
var $5c2a9584e51cbabf$var$cs = class s {
    constructor(t1, e, i, r, n, o, l){
        this._forceIntegerValues = t1;
        this._scrollStateBrand = void 0;
        this._forceIntegerValues && (e = e | 0, i = i | 0, r = r | 0, n = n | 0, o = o | 0, l = l | 0), this.rawScrollLeft = r, this.rawScrollTop = l, e < 0 && (e = 0), r + e > i && (r = i - e), r < 0 && (r = 0), n < 0 && (n = 0), l + n > o && (l = o - n), l < 0 && (l = 0), this.width = e, this.scrollWidth = i, this.scrollLeft = r, this.height = n, this.scrollHeight = o, this.scrollTop = l;
    }
    equals(t1) {
        return this.rawScrollLeft === t1.rawScrollLeft && this.rawScrollTop === t1.rawScrollTop && this.width === t1.width && this.scrollWidth === t1.scrollWidth && this.scrollLeft === t1.scrollLeft && this.height === t1.height && this.scrollHeight === t1.scrollHeight && this.scrollTop === t1.scrollTop;
    }
    withScrollDimensions(t1, e) {
        return new s(this._forceIntegerValues, typeof t1.width < "u" ? t1.width : this.width, typeof t1.scrollWidth < "u" ? t1.scrollWidth : this.scrollWidth, e ? this.rawScrollLeft : this.scrollLeft, typeof t1.height < "u" ? t1.height : this.height, typeof t1.scrollHeight < "u" ? t1.scrollHeight : this.scrollHeight, e ? this.rawScrollTop : this.scrollTop);
    }
    withScrollPosition(t1) {
        return new s(this._forceIntegerValues, this.width, this.scrollWidth, typeof t1.scrollLeft < "u" ? t1.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, typeof t1.scrollTop < "u" ? t1.scrollTop : this.rawScrollTop);
    }
    createScrollEvent(t1, e) {
        let i = this.width !== t1.width, r = this.scrollWidth !== t1.scrollWidth, n = this.scrollLeft !== t1.scrollLeft, o = this.height !== t1.height, l = this.scrollHeight !== t1.scrollHeight, a = this.scrollTop !== t1.scrollTop;
        return {
            inSmoothScrolling: e,
            oldWidth: t1.width,
            oldScrollWidth: t1.scrollWidth,
            oldScrollLeft: t1.scrollLeft,
            width: this.width,
            scrollWidth: this.scrollWidth,
            scrollLeft: this.scrollLeft,
            oldHeight: t1.height,
            oldScrollHeight: t1.scrollHeight,
            oldScrollTop: t1.scrollTop,
            height: this.height,
            scrollHeight: this.scrollHeight,
            scrollTop: this.scrollTop,
            widthChanged: i,
            scrollWidthChanged: r,
            scrollLeftChanged: n,
            heightChanged: o,
            scrollHeightChanged: l,
            scrollTopChanged: a
        };
    }
}, $5c2a9584e51cbabf$var$Ri = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._scrollableBrand = void 0;
        this._onScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this.onScroll = this._onScroll.event;
        this._smoothScrollDuration = e.smoothScrollDuration, this._scheduleAtNextAnimationFrame = e.scheduleAtNextAnimationFrame, this._state = new $5c2a9584e51cbabf$var$cs(e.forceIntegerValues, 0, 0, 0, 0, 0, 0), this._smoothScrolling = null;
    }
    dispose() {
        this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), super.dispose();
    }
    setSmoothScrollDuration(e) {
        this._smoothScrollDuration = e;
    }
    validateScrollPosition(e) {
        return this._state.withScrollPosition(e);
    }
    getScrollDimensions() {
        return this._state;
    }
    setScrollDimensions(e, i) {
        let r = this._state.withScrollDimensions(e, i);
        this._setState(r, !!this._smoothScrolling), this._smoothScrolling?.acceptScrollDimensions(this._state);
    }
    getFutureScrollPosition() {
        return this._smoothScrolling ? this._smoothScrolling.to : this._state;
    }
    getCurrentScrollPosition() {
        return this._state;
    }
    setScrollPositionNow(e) {
        let i = this._state.withScrollPosition(e);
        this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(i, !1);
    }
    setScrollPositionSmooth(e, i) {
        if (this._smoothScrollDuration === 0) return this.setScrollPositionNow(e);
        if (this._smoothScrolling) {
            e = {
                scrollLeft: typeof e.scrollLeft > "u" ? this._smoothScrolling.to.scrollLeft : e.scrollLeft,
                scrollTop: typeof e.scrollTop > "u" ? this._smoothScrolling.to.scrollTop : e.scrollTop
            };
            let r = this._state.withScrollPosition(e);
            if (this._smoothScrolling.to.scrollLeft === r.scrollLeft && this._smoothScrolling.to.scrollTop === r.scrollTop) return;
            let n;
            i ? n = new $5c2a9584e51cbabf$var$Nr(this._smoothScrolling.from, r, this._smoothScrolling.startTime, this._smoothScrolling.duration) : n = this._smoothScrolling.combine(this._state, r, this._smoothScrollDuration), this._smoothScrolling.dispose(), this._smoothScrolling = n;
        } else {
            let r = this._state.withScrollPosition(e);
            this._smoothScrolling = $5c2a9584e51cbabf$var$Nr.start(this._state, r, this._smoothScrollDuration);
        }
        this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(()=>{
            this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
        });
    }
    hasPendingScrollAnimation() {
        return !!this._smoothScrolling;
    }
    _performSmoothScrolling() {
        if (!this._smoothScrolling) return;
        let e = this._smoothScrolling.tick(), i = this._state.withScrollPosition(e);
        if (this._setState(i, !0), !!this._smoothScrolling) {
            if (e.isDone) {
                this._smoothScrolling.dispose(), this._smoothScrolling = null;
                return;
            }
            this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(()=>{
                this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
            });
        }
    }
    _setState(e, i) {
        let r = this._state;
        r.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(r, i)));
    }
}, $5c2a9584e51cbabf$var$Br = class {
    constructor(t1, e, i){
        this.scrollLeft = t1, this.scrollTop = e, this.isDone = i;
    }
};
function $5c2a9584e51cbabf$var$as(s, t1) {
    let e = t1 - s;
    return function(i) {
        return s + e * $5c2a9584e51cbabf$var$ka(i);
    };
}
function $5c2a9584e51cbabf$var$La(s, t1, e) {
    return function(i) {
        return i < e ? s(i / e) : t1((i - e) / (1 - e));
    };
}
var $5c2a9584e51cbabf$var$Nr = class s {
    constructor(t1, e, i, r){
        this.from = t1, this.to = e, this.duration = r, this.startTime = i, this.animationFrameDisposable = null, this._initAnimations();
    }
    _initAnimations() {
        this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
    }
    _initAnimation(t1, e, i) {
        if (Math.abs(t1 - e) > 2.5 * i) {
            let n, o;
            return t1 < e ? (n = t1 + .75 * i, o = e - .75 * i) : (n = t1 - .75 * i, o = e + .75 * i), $5c2a9584e51cbabf$var$La($5c2a9584e51cbabf$var$as(t1, n), $5c2a9584e51cbabf$var$as(o, e), .33);
        }
        return $5c2a9584e51cbabf$var$as(t1, e);
    }
    dispose() {
        this.animationFrameDisposable !== null && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
    }
    acceptScrollDimensions(t1) {
        this.to = t1.withScrollPosition(this.to), this._initAnimations();
    }
    tick() {
        return this._tick(Date.now());
    }
    _tick(t1) {
        let e = (t1 - this.startTime) / this.duration;
        if (e < 1) {
            let i = this.scrollLeft(e), r = this.scrollTop(e);
            return new $5c2a9584e51cbabf$var$Br(i, r, !1);
        }
        return new $5c2a9584e51cbabf$var$Br(this.to.scrollLeft, this.to.scrollTop, !0);
    }
    combine(t1, e, i) {
        return s.start(t1, e, i);
    }
    static start(t1, e, i) {
        i = i + 10;
        let r = Date.now() - 10;
        return new s(t1, e, r, i);
    }
};
function $5c2a9584e51cbabf$var$Aa(s) {
    return Math.pow(s, 3);
}
function $5c2a9584e51cbabf$var$ka(s) {
    return 1 - $5c2a9584e51cbabf$var$Aa(1 - s);
}
var $5c2a9584e51cbabf$var$Fr = class extends $5c2a9584e51cbabf$var$D {
    constructor(t1, e, i){
        super(), this._visibility = t1, this._visibleClassName = e, this._invisibleClassName = i, this._domNode = null, this._isVisible = !1, this._isNeeded = !1, this._rawShouldBeVisible = !1, this._shouldBeVisible = !1, this._revealTimer = this._register(new $5c2a9584e51cbabf$var$Ye);
    }
    setVisibility(t1) {
        this._visibility !== t1 && (this._visibility = t1, this._updateShouldBeVisible());
    }
    setShouldBeVisible(t1) {
        this._rawShouldBeVisible = t1, this._updateShouldBeVisible();
    }
    _applyVisibilitySetting() {
        return this._visibility === 2 ? !1 : this._visibility === 3 ? !0 : this._rawShouldBeVisible;
    }
    _updateShouldBeVisible() {
        let t1 = this._applyVisibilitySetting();
        this._shouldBeVisible !== t1 && (this._shouldBeVisible = t1, this.ensureVisibility());
    }
    setIsNeeded(t1) {
        this._isNeeded !== t1 && (this._isNeeded = t1, this.ensureVisibility());
    }
    setDomNode(t1) {
        this._domNode = t1, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
    }
    ensureVisibility() {
        if (!this._isNeeded) {
            this._hide(!1);
            return;
        }
        this._shouldBeVisible ? this._reveal() : this._hide(!0);
    }
    _reveal() {
        this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet(()=>{
            this._domNode?.setClassName(this._visibleClassName);
        }, 0));
    }
    _hide(t1) {
        this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, this._domNode?.setClassName(this._invisibleClassName + (t1 ? " fade" : "")));
    }
};
var $5c2a9584e51cbabf$var$Ca = 140, $5c2a9584e51cbabf$var$Ut = class extends $5c2a9584e51cbabf$var$lt {
    constructor(t1){
        super(), this._lazyRender = t1.lazyRender, this._host = t1.host, this._scrollable = t1.scrollable, this._scrollByPage = t1.scrollByPage, this._scrollbarState = t1.scrollbarState, this._visibilityController = this._register(new $5c2a9584e51cbabf$var$Fr(t1.visibility, "visible scrollbar " + t1.extraScrollbarClassName, "invisible scrollbar " + t1.extraScrollbarClassName)), this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._pointerMoveMonitor = this._register(new $5c2a9584e51cbabf$var$Wt), this._shouldRender = !0, this.domNode = $5c2a9584e51cbabf$var$_t(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this._visibilityController.setDomNode(this.domNode), this.domNode.setPosition("absolute"), this._register($5c2a9584e51cbabf$var$L(this.domNode.domNode, $5c2a9584e51cbabf$var$Y.POINTER_DOWN, (e)=>this._domNodePointerDown(e)));
    }
    _createArrow(t1) {
        let e = this._register(new $5c2a9584e51cbabf$var$Or(t1));
        this.domNode.domNode.appendChild(e.bgDomNode), this.domNode.domNode.appendChild(e.domNode);
    }
    _createSlider(t1, e, i, r) {
        this.slider = $5c2a9584e51cbabf$var$_t(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(t1), this.slider.setLeft(e), typeof i == "number" && this.slider.setWidth(i), typeof r == "number" && this.slider.setHeight(r), this.slider.setLayerHinting(!0), this.slider.setContain("strict"), this.domNode.domNode.appendChild(this.slider.domNode), this._register($5c2a9584e51cbabf$var$L(this.slider.domNode, $5c2a9584e51cbabf$var$Y.POINTER_DOWN, (n)=>{
            n.button === 0 && (n.preventDefault(), this._sliderPointerDown(n));
        })), this.onclick(this.slider.domNode, (n)=>{
            n.leftButton && n.stopPropagation();
        });
    }
    _onElementSize(t1) {
        return this._scrollbarState.setVisibleSize(t1) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
    _onElementScrollSize(t1) {
        return this._scrollbarState.setScrollSize(t1) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
    _onElementScrollPosition(t1) {
        return this._scrollbarState.setScrollPosition(t1) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
    beginReveal() {
        this._visibilityController.setShouldBeVisible(!0);
    }
    beginHide() {
        this._visibilityController.setShouldBeVisible(!1);
    }
    render() {
        this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
    }
    _domNodePointerDown(t1) {
        t1.target === this.domNode.domNode && this._onPointerDown(t1);
    }
    delegatePointerDown(t1) {
        let e = this.domNode.domNode.getClientRects()[0].top, i = e + this._scrollbarState.getSliderPosition(), r = e + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(), n = this._sliderPointerPosition(t1);
        i <= n && n <= r ? t1.button === 0 && (t1.preventDefault(), this._sliderPointerDown(t1)) : this._onPointerDown(t1);
    }
    _onPointerDown(t1) {
        let e, i;
        if (t1.target === this.domNode.domNode && typeof t1.offsetX == "number" && typeof t1.offsetY == "number") e = t1.offsetX, i = t1.offsetY;
        else {
            let n = $5c2a9584e51cbabf$var$Fo(this.domNode.domNode);
            e = t1.pageX - n.left, i = t1.pageY - n.top;
        }
        let r = this._pointerDownRelativePosition(e, i);
        this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(r) : this._scrollbarState.getDesiredScrollPositionFromOffset(r)), t1.button === 0 && (t1.preventDefault(), this._sliderPointerDown(t1));
    }
    _sliderPointerDown(t1) {
        if (!t1.target || !(t1.target instanceof Element)) return;
        let e = this._sliderPointerPosition(t1), i = this._sliderOrthogonalPointerPosition(t1), r = this._scrollbarState.clone();
        this.slider.toggleClassName("active", !0), this._pointerMoveMonitor.startMonitoring(t1.target, t1.pointerId, t1.buttons, (n)=>{
            let o = this._sliderOrthogonalPointerPosition(n), l = Math.abs(o - i);
            if ($5c2a9584e51cbabf$var$wr && l > $5c2a9584e51cbabf$var$Ca) {
                this._setDesiredScrollPositionNow(r.getScrollPosition());
                return;
            }
            let u = this._sliderPointerPosition(n) - e;
            this._setDesiredScrollPositionNow(r.getDesiredScrollPositionFromDelta(u));
        }, ()=>{
            this.slider.toggleClassName("active", !1), this._host.onDragEnd();
        }), this._host.onDragStart();
    }
    _setDesiredScrollPositionNow(t1) {
        let e = {};
        this.writeScrollPosition(e, t1), this._scrollable.setScrollPositionNow(e);
    }
    updateScrollbarSize(t1) {
        this._updateScrollbarSize(t1), this._scrollbarState.setScrollbarSize(t1), this._shouldRender = !0, this._lazyRender || this.render();
    }
    isNeeded() {
        return this._scrollbarState.isNeeded();
    }
};
var $5c2a9584e51cbabf$var$Kt = class s {
    constructor(t1, e, i, r, n, o){
        this._scrollbarSize = Math.round(e), this._oppositeScrollbarSize = Math.round(i), this._arrowSize = Math.round(t1), this._visibleSize = r, this._scrollSize = n, this._scrollPosition = o, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
    }
    clone() {
        return new s(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    }
    setVisibleSize(t1) {
        let e = Math.round(t1);
        return this._visibleSize !== e ? (this._visibleSize = e, this._refreshComputedValues(), !0) : !1;
    }
    setScrollSize(t1) {
        let e = Math.round(t1);
        return this._scrollSize !== e ? (this._scrollSize = e, this._refreshComputedValues(), !0) : !1;
    }
    setScrollPosition(t1) {
        let e = Math.round(t1);
        return this._scrollPosition !== e ? (this._scrollPosition = e, this._refreshComputedValues(), !0) : !1;
    }
    setScrollbarSize(t1) {
        this._scrollbarSize = Math.round(t1);
    }
    setOppositeScrollbarSize(t1) {
        this._oppositeScrollbarSize = Math.round(t1);
    }
    static _computeValues(t1, e, i, r, n) {
        let o = Math.max(0, i - t1), l = Math.max(0, o - 2 * e), a = r > 0 && r > i;
        if (!a) return {
            computedAvailableSize: Math.round(o),
            computedIsNeeded: a,
            computedSliderSize: Math.round(l),
            computedSliderRatio: 0,
            computedSliderPosition: 0
        };
        let u = Math.round(Math.max(20, Math.floor(i * l / r))), h = (l - u) / (r - i), c = n * h;
        return {
            computedAvailableSize: Math.round(o),
            computedIsNeeded: a,
            computedSliderSize: Math.round(u),
            computedSliderRatio: h,
            computedSliderPosition: Math.round(c)
        };
    }
    _refreshComputedValues() {
        let t1 = s._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
        this._computedAvailableSize = t1.computedAvailableSize, this._computedIsNeeded = t1.computedIsNeeded, this._computedSliderSize = t1.computedSliderSize, this._computedSliderRatio = t1.computedSliderRatio, this._computedSliderPosition = t1.computedSliderPosition;
    }
    getArrowSize() {
        return this._arrowSize;
    }
    getScrollPosition() {
        return this._scrollPosition;
    }
    getRectangleLargeSize() {
        return this._computedAvailableSize;
    }
    getRectangleSmallSize() {
        return this._scrollbarSize;
    }
    isNeeded() {
        return this._computedIsNeeded;
    }
    getSliderSize() {
        return this._computedSliderSize;
    }
    getSliderPosition() {
        return this._computedSliderPosition;
    }
    getDesiredScrollPositionFromOffset(t1) {
        if (!this._computedIsNeeded) return 0;
        let e = t1 - this._arrowSize - this._computedSliderSize / 2;
        return Math.round(e / this._computedSliderRatio);
    }
    getDesiredScrollPositionFromOffsetPaged(t1) {
        if (!this._computedIsNeeded) return 0;
        let e = t1 - this._arrowSize, i = this._scrollPosition;
        return e < this._computedSliderPosition ? i -= this._visibleSize : i += this._visibleSize, i;
    }
    getDesiredScrollPositionFromDelta(t1) {
        if (!this._computedIsNeeded) return 0;
        let e = this._computedSliderPosition + t1;
        return Math.round(e / this._computedSliderRatio);
    }
};
var $5c2a9584e51cbabf$var$Wr = class extends $5c2a9584e51cbabf$var$Ut {
    constructor(t1, e, i){
        let r = t1.getScrollDimensions(), n = t1.getCurrentScrollPosition();
        if (super({
            lazyRender: e.lazyRender,
            host: i,
            scrollbarState: new $5c2a9584e51cbabf$var$Kt(e.horizontalHasArrows ? e.arrowSize : 0, e.horizontal === 2 ? 0 : e.horizontalScrollbarSize, e.vertical === 2 ? 0 : e.verticalScrollbarSize, r.width, r.scrollWidth, n.scrollLeft),
            visibility: e.horizontal,
            extraScrollbarClassName: "horizontal",
            scrollable: t1,
            scrollByPage: e.scrollByPage
        }), e.horizontalHasArrows) throw new Error("horizontalHasArrows is not supported in xterm.js");
        this._createSlider(Math.floor((e.horizontalScrollbarSize - e.horizontalSliderSize) / 2), 0, void 0, e.horizontalSliderSize);
    }
    _updateSlider(t1, e) {
        this.slider.setWidth(t1), this.slider.setLeft(e);
    }
    _renderDomNode(t1, e) {
        this.domNode.setWidth(t1), this.domNode.setHeight(e), this.domNode.setLeft(0), this.domNode.setBottom(0);
    }
    onDidScroll(t1) {
        return this._shouldRender = this._onElementScrollSize(t1.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(t1.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(t1.width) || this._shouldRender, this._shouldRender;
    }
    _pointerDownRelativePosition(t1, e) {
        return t1;
    }
    _sliderPointerPosition(t1) {
        return t1.pageX;
    }
    _sliderOrthogonalPointerPosition(t1) {
        return t1.pageY;
    }
    _updateScrollbarSize(t1) {
        this.slider.setHeight(t1);
    }
    writeScrollPosition(t1, e) {
        t1.scrollLeft = e;
    }
    updateOptions(t1) {
        this.updateScrollbarSize(t1.horizontal === 2 ? 0 : t1.horizontalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(t1.vertical === 2 ? 0 : t1.verticalScrollbarSize), this._visibilityController.setVisibility(t1.horizontal), this._scrollByPage = t1.scrollByPage;
    }
};
var $5c2a9584e51cbabf$var$Ur = class extends $5c2a9584e51cbabf$var$Ut {
    constructor(t1, e, i){
        let r = t1.getScrollDimensions(), n = t1.getCurrentScrollPosition();
        if (super({
            lazyRender: e.lazyRender,
            host: i,
            scrollbarState: new $5c2a9584e51cbabf$var$Kt(e.verticalHasArrows ? e.arrowSize : 0, e.vertical === 2 ? 0 : e.verticalScrollbarSize, 0, r.height, r.scrollHeight, n.scrollTop),
            visibility: e.vertical,
            extraScrollbarClassName: "vertical",
            scrollable: t1,
            scrollByPage: e.scrollByPage
        }), e.verticalHasArrows) throw new Error("horizontalHasArrows is not supported in xterm.js");
        this._createSlider(0, Math.floor((e.verticalScrollbarSize - e.verticalSliderSize) / 2), e.verticalSliderSize, void 0);
    }
    _updateSlider(t1, e) {
        this.slider.setHeight(t1), this.slider.setTop(e);
    }
    _renderDomNode(t1, e) {
        this.domNode.setWidth(e), this.domNode.setHeight(t1), this.domNode.setRight(0), this.domNode.setTop(0);
    }
    onDidScroll(t1) {
        return this._shouldRender = this._onElementScrollSize(t1.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(t1.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(t1.height) || this._shouldRender, this._shouldRender;
    }
    _pointerDownRelativePosition(t1, e) {
        return e;
    }
    _sliderPointerPosition(t1) {
        return t1.pageY;
    }
    _sliderOrthogonalPointerPosition(t1) {
        return t1.pageX;
    }
    _updateScrollbarSize(t1) {
        this.slider.setWidth(t1);
    }
    writeScrollPosition(t1, e) {
        t1.scrollTop = e;
    }
    updateOptions(t1) {
        this.updateScrollbarSize(t1.vertical === 2 ? 0 : t1.verticalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(0), this._visibilityController.setVisibility(t1.vertical), this._scrollByPage = t1.scrollByPage;
    }
};
var $5c2a9584e51cbabf$var$Ma = 500, $5c2a9584e51cbabf$var$Ko = 50, $5c2a9584e51cbabf$var$zo = !0, $5c2a9584e51cbabf$var$us = class {
    constructor(t1, e, i){
        this.timestamp = t1, this.deltaX = e, this.deltaY = i, this.score = 0;
    }
}, $5c2a9584e51cbabf$var$zr = class zr {
    constructor(){
        this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
    }
    isPhysicalMouseWheel() {
        if (this._front === -1 && this._rear === -1) return !1;
        let t1 = 1, e = 0, i = 1, r = this._rear;
        do {
            let n = r === this._front ? t1 : Math.pow(2, -i);
            if (t1 -= n, e += this._memory[r].score * n, r === this._front) break;
            r = (this._capacity + r - 1) % this._capacity, i++;
        }while (!0);
        return e <= .5;
    }
    acceptStandardWheelEvent(t1) {
        if ($5c2a9584e51cbabf$var$Ti) {
            let e = $5c2a9584e51cbabf$var$be(t1.browserEvent), i = $5c2a9584e51cbabf$var$mo(e);
            this.accept(Date.now(), t1.deltaX * i, t1.deltaY * i);
        } else this.accept(Date.now(), t1.deltaX, t1.deltaY);
    }
    accept(t1, e, i) {
        let r = null, n = new $5c2a9584e51cbabf$var$us(t1, e, i);
        this._front === -1 && this._rear === -1 ? (this._memory[0] = n, this._front = 0, this._rear = 0) : (r = this._memory[this._rear], this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = n), n.score = this._computeScore(n, r);
    }
    _computeScore(t1, e) {
        if (Math.abs(t1.deltaX) > 0 && Math.abs(t1.deltaY) > 0) return 1;
        let i = .5;
        if ((!this._isAlmostInt(t1.deltaX) || !this._isAlmostInt(t1.deltaY)) && (i += .25), e) {
            let r = Math.abs(t1.deltaX), n = Math.abs(t1.deltaY), o = Math.abs(e.deltaX), l = Math.abs(e.deltaY), a = Math.max(Math.min(r, o), 1), u = Math.max(Math.min(n, l), 1), h = Math.max(r, o), c = Math.max(n, l);
            h % a === 0 && c % u === 0 && (i -= .5);
        }
        return Math.min(Math.max(i, 0), 1);
    }
    _isAlmostInt(t1) {
        return Math.abs(Math.round(t1) - t1) < .01;
    }
};
$5c2a9584e51cbabf$var$zr.INSTANCE = new $5c2a9584e51cbabf$var$zr;
var $5c2a9584e51cbabf$var$hs = $5c2a9584e51cbabf$var$zr, $5c2a9584e51cbabf$var$ds = class extends $5c2a9584e51cbabf$var$lt {
    constructor(e, i, r){
        super();
        this._onScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this.onScroll = this._onScroll.event;
        this._onWillScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this.onWillScroll = this._onWillScroll.event;
        this._options = $5c2a9584e51cbabf$var$Pa(i), this._scrollable = r, this._register(this._scrollable.onScroll((o)=>{
            this._onWillScroll.fire(o), this._onDidScroll(o), this._onScroll.fire(o);
        }));
        let n = {
            onMouseWheel: (o)=>this._onMouseWheel(o),
            onDragStart: ()=>this._onDragStart(),
            onDragEnd: ()=>this._onDragEnd()
        };
        this._verticalScrollbar = this._register(new $5c2a9584e51cbabf$var$Ur(this._scrollable, this._options, n)), this._horizontalScrollbar = this._register(new $5c2a9584e51cbabf$var$Wr(this._scrollable, this._options, n)), this._domNode = document.createElement("div"), this._domNode.className = "xterm-scrollable-element " + this._options.className, this._domNode.setAttribute("role", "presentation"), this._domNode.style.position = "relative", this._domNode.appendChild(e), this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode), this._domNode.appendChild(this._verticalScrollbar.domNode.domNode), this._options.useShadows ? (this._leftShadowDomNode = $5c2a9584e51cbabf$var$_t(document.createElement("div")), this._leftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._leftShadowDomNode.domNode), this._topShadowDomNode = $5c2a9584e51cbabf$var$_t(document.createElement("div")), this._topShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topShadowDomNode.domNode), this._topLeftShadowDomNode = $5c2a9584e51cbabf$var$_t(document.createElement("div")), this._topLeftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topLeftShadowDomNode.domNode)) : (this._leftShadowDomNode = null, this._topShadowDomNode = null, this._topLeftShadowDomNode = null), this._listenOnDomNode = this._options.listenOnDomNode || this._domNode, this._mouseWheelToDispose = [], this._setListeningToMouseWheel(this._options.handleMouseWheel), this.onmouseover(this._listenOnDomNode, (o)=>this._onMouseOver(o)), this.onmouseleave(this._listenOnDomNode, (o)=>this._onMouseLeave(o)), this._hideTimeout = this._register(new $5c2a9584e51cbabf$var$Ye), this._isDragging = !1, this._mouseIsOver = !1, this._shouldRender = !0, this._revealOnScroll = !0;
    }
    get options() {
        return this._options;
    }
    dispose() {
        this._mouseWheelToDispose = $5c2a9584e51cbabf$var$Ne(this._mouseWheelToDispose), super.dispose();
    }
    getDomNode() {
        return this._domNode;
    }
    getOverviewRulerLayoutInfo() {
        return {
            parent: this._domNode,
            insertBefore: this._verticalScrollbar.domNode.domNode
        };
    }
    delegateVerticalScrollbarPointerDown(e) {
        this._verticalScrollbar.delegatePointerDown(e);
    }
    getScrollDimensions() {
        return this._scrollable.getScrollDimensions();
    }
    setScrollDimensions(e) {
        this._scrollable.setScrollDimensions(e, !1);
    }
    updateClassName(e) {
        this._options.className = e, $5c2a9584e51cbabf$var$Te && (this._options.className += " mac"), this._domNode.className = "xterm-scrollable-element " + this._options.className;
    }
    updateOptions(e) {
        typeof e.handleMouseWheel < "u" && (this._options.handleMouseWheel = e.handleMouseWheel, this._setListeningToMouseWheel(this._options.handleMouseWheel)), typeof e.mouseWheelScrollSensitivity < "u" && (this._options.mouseWheelScrollSensitivity = e.mouseWheelScrollSensitivity), typeof e.fastScrollSensitivity < "u" && (this._options.fastScrollSensitivity = e.fastScrollSensitivity), typeof e.scrollPredominantAxis < "u" && (this._options.scrollPredominantAxis = e.scrollPredominantAxis), typeof e.horizontal < "u" && (this._options.horizontal = e.horizontal), typeof e.vertical < "u" && (this._options.vertical = e.vertical), typeof e.horizontalScrollbarSize < "u" && (this._options.horizontalScrollbarSize = e.horizontalScrollbarSize), typeof e.verticalScrollbarSize < "u" && (this._options.verticalScrollbarSize = e.verticalScrollbarSize), typeof e.scrollByPage < "u" && (this._options.scrollByPage = e.scrollByPage), this._horizontalScrollbar.updateOptions(this._options), this._verticalScrollbar.updateOptions(this._options), this._options.lazyRender || this._render();
    }
    setRevealOnScroll(e) {
        this._revealOnScroll = e;
    }
    delegateScrollFromMouseWheelEvent(e) {
        this._onMouseWheel(new $5c2a9584e51cbabf$var$xi(e));
    }
    _setListeningToMouseWheel(e) {
        if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = $5c2a9584e51cbabf$var$Ne(this._mouseWheelToDispose), e)) {
            let r = (n)=>{
                this._onMouseWheel(new $5c2a9584e51cbabf$var$xi(n));
            };
            this._mouseWheelToDispose.push($5c2a9584e51cbabf$var$L(this._listenOnDomNode, $5c2a9584e51cbabf$var$Y.MOUSE_WHEEL, r, {
                passive: !1
            }));
        }
    }
    _onMouseWheel(e) {
        if (e.browserEvent?.defaultPrevented) return;
        let i = $5c2a9584e51cbabf$var$hs.INSTANCE;
        $5c2a9584e51cbabf$var$zo && i.acceptStandardWheelEvent(e);
        let r = !1;
        if (e.deltaY || e.deltaX) {
            let o = e.deltaY * this._options.mouseWheelScrollSensitivity, l = e.deltaX * this._options.mouseWheelScrollSensitivity;
            this._options.scrollPredominantAxis && (this._options.scrollYToX && l + o === 0 ? l = o = 0 : Math.abs(o) >= Math.abs(l) ? l = 0 : o = 0), this._options.flipAxes && ([o, l] = [
                l,
                o
            ]);
            let a = !$5c2a9584e51cbabf$var$Te && e.browserEvent && e.browserEvent.shiftKey;
            (this._options.scrollYToX || a) && !l && (l = o, o = 0), e.browserEvent && e.browserEvent.altKey && (l = l * this._options.fastScrollSensitivity, o = o * this._options.fastScrollSensitivity);
            let u = this._scrollable.getFutureScrollPosition(), h = {};
            if (o) {
                let c = $5c2a9584e51cbabf$var$Ko * o, d = u.scrollTop - (c < 0 ? Math.floor(c) : Math.ceil(c));
                this._verticalScrollbar.writeScrollPosition(h, d);
            }
            if (l) {
                let c = $5c2a9584e51cbabf$var$Ko * l, d = u.scrollLeft - (c < 0 ? Math.floor(c) : Math.ceil(c));
                this._horizontalScrollbar.writeScrollPosition(h, d);
            }
            h = this._scrollable.validateScrollPosition(h), (u.scrollLeft !== h.scrollLeft || u.scrollTop !== h.scrollTop) && ($5c2a9584e51cbabf$var$zo && this._options.mouseWheelSmoothScroll && i.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(h) : this._scrollable.setScrollPositionNow(h), r = !0);
        }
        let n = r;
        !n && this._options.alwaysConsumeMouseWheel && (n = !0), !n && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded()) && (n = !0), n && (e.preventDefault(), e.stopPropagation());
    }
    _onDidScroll(e) {
        this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
    }
    renderNow() {
        if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");
        this._render();
    }
    _render() {
        if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
            let e = this._scrollable.getCurrentScrollPosition(), i = e.scrollTop > 0, r = e.scrollLeft > 0, n = r ? " left" : "", o = i ? " top" : "", l = r || i ? " top-left-corner" : "";
            this._leftShadowDomNode.setClassName(`shadow${n}`), this._topShadowDomNode.setClassName(`shadow${o}`), this._topLeftShadowDomNode.setClassName(`shadow${l}${o}${n}`);
        }
    }
    _onDragStart() {
        this._isDragging = !0, this._reveal();
    }
    _onDragEnd() {
        this._isDragging = !1, this._hide();
    }
    _onMouseLeave(e) {
        this._mouseIsOver = !1, this._hide();
    }
    _onMouseOver(e) {
        this._mouseIsOver = !0, this._reveal();
    }
    _reveal() {
        this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
    }
    _hide() {
        !this._mouseIsOver && !this._isDragging && (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
    }
    _scheduleHide() {
        !this._mouseIsOver && !this._isDragging && this._hideTimeout.cancelAndSet(()=>this._hide(), $5c2a9584e51cbabf$var$Ma);
    }
};
var $5c2a9584e51cbabf$var$Kr = class extends $5c2a9584e51cbabf$var$ds {
    constructor(t1, e, i){
        super(t1, e, i);
    }
    setScrollPosition(t1) {
        t1.reuseAnimation ? this._scrollable.setScrollPositionSmooth(t1, t1.reuseAnimation) : this._scrollable.setScrollPositionNow(t1);
    }
    getScrollPosition() {
        return this._scrollable.getCurrentScrollPosition();
    }
};
function $5c2a9584e51cbabf$var$Pa(s) {
    let t1 = {
        lazyRender: typeof s.lazyRender < "u" ? s.lazyRender : !1,
        className: typeof s.className < "u" ? s.className : "",
        useShadows: typeof s.useShadows < "u" ? s.useShadows : !0,
        handleMouseWheel: typeof s.handleMouseWheel < "u" ? s.handleMouseWheel : !0,
        flipAxes: typeof s.flipAxes < "u" ? s.flipAxes : !1,
        consumeMouseWheelIfScrollbarIsNeeded: typeof s.consumeMouseWheelIfScrollbarIsNeeded < "u" ? s.consumeMouseWheelIfScrollbarIsNeeded : !1,
        alwaysConsumeMouseWheel: typeof s.alwaysConsumeMouseWheel < "u" ? s.alwaysConsumeMouseWheel : !1,
        scrollYToX: typeof s.scrollYToX < "u" ? s.scrollYToX : !1,
        mouseWheelScrollSensitivity: typeof s.mouseWheelScrollSensitivity < "u" ? s.mouseWheelScrollSensitivity : 1,
        fastScrollSensitivity: typeof s.fastScrollSensitivity < "u" ? s.fastScrollSensitivity : 5,
        scrollPredominantAxis: typeof s.scrollPredominantAxis < "u" ? s.scrollPredominantAxis : !0,
        mouseWheelSmoothScroll: typeof s.mouseWheelSmoothScroll < "u" ? s.mouseWheelSmoothScroll : !0,
        arrowSize: typeof s.arrowSize < "u" ? s.arrowSize : 11,
        listenOnDomNode: typeof s.listenOnDomNode < "u" ? s.listenOnDomNode : null,
        horizontal: typeof s.horizontal < "u" ? s.horizontal : 1,
        horizontalScrollbarSize: typeof s.horizontalScrollbarSize < "u" ? s.horizontalScrollbarSize : 10,
        horizontalSliderSize: typeof s.horizontalSliderSize < "u" ? s.horizontalSliderSize : 0,
        horizontalHasArrows: typeof s.horizontalHasArrows < "u" ? s.horizontalHasArrows : !1,
        vertical: typeof s.vertical < "u" ? s.vertical : 1,
        verticalScrollbarSize: typeof s.verticalScrollbarSize < "u" ? s.verticalScrollbarSize : 10,
        verticalHasArrows: typeof s.verticalHasArrows < "u" ? s.verticalHasArrows : !1,
        verticalSliderSize: typeof s.verticalSliderSize < "u" ? s.verticalSliderSize : 0,
        scrollByPage: typeof s.scrollByPage < "u" ? s.scrollByPage : !1
    };
    return t1.horizontalSliderSize = typeof s.horizontalSliderSize < "u" ? s.horizontalSliderSize : t1.horizontalScrollbarSize, t1.verticalSliderSize = typeof s.verticalSliderSize < "u" ? s.verticalSliderSize : t1.verticalScrollbarSize, $5c2a9584e51cbabf$var$Te && (t1.className += " mac"), t1;
}
var $5c2a9584e51cbabf$var$zt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u){
        super();
        this._bufferService = r;
        this._optionsService = a;
        this._renderService = u;
        this._onRequestScrollLines = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestScrollLines = this._onRequestScrollLines.event;
        this._isSyncing = !1;
        this._isHandlingScroll = !1;
        this._suppressOnScrollHandler = !1;
        let h = this._register(new $5c2a9584e51cbabf$var$Ri({
            forceIntegerValues: !1,
            smoothScrollDuration: this._optionsService.rawOptions.smoothScrollDuration,
            scheduleAtNextAnimationFrame: (c)=>$5c2a9584e51cbabf$var$mt(n.window, c)
        }));
        this._register(this._optionsService.onSpecificOptionChange("smoothScrollDuration", ()=>{
            h.setSmoothScrollDuration(this._optionsService.rawOptions.smoothScrollDuration);
        })), this._scrollableElement = this._register(new $5c2a9584e51cbabf$var$Kr(i, {
            vertical: 1,
            horizontal: 2,
            useShadows: !1,
            mouseWheelSmoothScroll: !0,
            ...this._getChangeOptions()
        }, h)), this._register(this._optionsService.onMultipleOptionChange([
            "scrollSensitivity",
            "fastScrollSensitivity",
            "overviewRuler"
        ], ()=>this._scrollableElement.updateOptions(this._getChangeOptions()))), this._register(o.onProtocolChange((c)=>{
            this._scrollableElement.updateOptions({
                handleMouseWheel: !(c & 16)
            });
        })), this._scrollableElement.setScrollDimensions({
            height: 0,
            scrollHeight: 0
        }), this._register($5c2a9584e51cbabf$var$$.runAndSubscribe(l.onChangeColors, ()=>{
            this._scrollableElement.getDomNode().style.backgroundColor = l.colors.background.css;
        })), e.appendChild(this._scrollableElement.getDomNode()), this._register($5c2a9584e51cbabf$var$C(()=>this._scrollableElement.getDomNode().remove())), this._styleElement = n.mainDocument.createElement("style"), i.appendChild(this._styleElement), this._register($5c2a9584e51cbabf$var$C(()=>this._styleElement.remove())), this._register($5c2a9584e51cbabf$var$$.runAndSubscribe(l.onChangeColors, ()=>{
            this._styleElement.textContent = [
                ".xterm .xterm-scrollable-element > .scrollbar > .slider {",
                `  background: ${l.colors.scrollbarSliderBackground.css};`,
                "}",
                ".xterm .xterm-scrollable-element > .scrollbar > .slider:hover {",
                `  background: ${l.colors.scrollbarSliderHoverBackground.css};`,
                "}",
                ".xterm .xterm-scrollable-element > .scrollbar > .slider.active {",
                `  background: ${l.colors.scrollbarSliderActiveBackground.css};`,
                "}"
            ].join(`
`);
        })), this._register(this._bufferService.onResize(()=>this.queueSync())), this._register(this._bufferService.buffers.onBufferActivate(()=>{
            this._latestYDisp = void 0, this.queueSync();
        })), this._register(this._bufferService.onScroll(()=>this._sync())), this._register(this._scrollableElement.onScroll((c)=>this._handleScroll(c)));
    }
    scrollLines(e) {
        let i = this._scrollableElement.getScrollPosition();
        this._scrollableElement.setScrollPosition({
            reuseAnimation: !0,
            scrollTop: i.scrollTop + e * this._renderService.dimensions.css.cell.height
        });
    }
    scrollToLine(e, i) {
        i && (this._latestYDisp = e), this._scrollableElement.setScrollPosition({
            reuseAnimation: !i,
            scrollTop: e * this._renderService.dimensions.css.cell.height
        });
    }
    _getChangeOptions() {
        return {
            mouseWheelScrollSensitivity: this._optionsService.rawOptions.scrollSensitivity,
            fastScrollSensitivity: this._optionsService.rawOptions.fastScrollSensitivity,
            verticalScrollbarSize: this._optionsService.rawOptions.overviewRuler?.width || 14
        };
    }
    queueSync(e) {
        e !== void 0 && (this._latestYDisp = e), this._queuedAnimationFrame === void 0 && (this._queuedAnimationFrame = this._renderService.addRefreshCallback(()=>{
            this._queuedAnimationFrame = void 0, this._sync(this._latestYDisp);
        }));
    }
    _sync(e = this._bufferService.buffer.ydisp) {
        !this._renderService || this._isSyncing || (this._isSyncing = !0, this._suppressOnScrollHandler = !0, this._scrollableElement.setScrollDimensions({
            height: this._renderService.dimensions.css.canvas.height,
            scrollHeight: this._renderService.dimensions.css.cell.height * this._bufferService.buffer.lines.length
        }), this._suppressOnScrollHandler = !1, e !== this._latestYDisp && this._scrollableElement.setScrollPosition({
            scrollTop: e * this._renderService.dimensions.css.cell.height
        }), this._isSyncing = !1);
    }
    _handleScroll(e) {
        if (!this._renderService || this._isHandlingScroll || this._suppressOnScrollHandler) return;
        this._isHandlingScroll = !0;
        let i = Math.round(e.scrollTop / this._renderService.dimensions.css.cell.height), r = i - this._bufferService.buffer.ydisp;
        r !== 0 && (this._latestYDisp = i, this._onRequestScrollLines.fire(r)), this._isHandlingScroll = !1;
    }
};
$5c2a9584e51cbabf$var$zt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$rr),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$Re),
    $5c2a9584e51cbabf$var$S(6, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(7, $5c2a9584e51cbabf$var$ce)
], $5c2a9584e51cbabf$var$zt);
var $5c2a9584e51cbabf$var$Gt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o){
        super();
        this._screenElement = e;
        this._bufferService = i;
        this._coreBrowserService = r;
        this._decorationService = n;
        this._renderService = o;
        this._decorationElements = new Map;
        this._altBufferIsActive = !1;
        this._dimensionsChanged = !1;
        this._container = document.createElement("div"), this._container.classList.add("xterm-decoration-container"), this._screenElement.appendChild(this._container), this._register(this._renderService.onRenderedViewportChange(()=>this._doRefreshDecorations())), this._register(this._renderService.onDimensionsChange(()=>{
            this._dimensionsChanged = !0, this._queueRefresh();
        })), this._register(this._coreBrowserService.onDprChange(()=>this._queueRefresh())), this._register(this._bufferService.buffers.onBufferActivate(()=>{
            this._altBufferIsActive = this._bufferService.buffer === this._bufferService.buffers.alt;
        })), this._register(this._decorationService.onDecorationRegistered(()=>this._queueRefresh())), this._register(this._decorationService.onDecorationRemoved((l)=>this._removeDecoration(l))), this._register($5c2a9584e51cbabf$var$C(()=>{
            this._container.remove(), this._decorationElements.clear();
        }));
    }
    _queueRefresh() {
        this._animationFrame === void 0 && (this._animationFrame = this._renderService.addRefreshCallback(()=>{
            this._doRefreshDecorations(), this._animationFrame = void 0;
        }));
    }
    _doRefreshDecorations() {
        for (let e of this._decorationService.decorations)this._renderDecoration(e);
        this._dimensionsChanged = !1;
    }
    _renderDecoration(e) {
        this._refreshStyle(e), this._dimensionsChanged && this._refreshXPosition(e);
    }
    _createElement(e) {
        let i = this._coreBrowserService.mainDocument.createElement("div");
        i.classList.add("xterm-decoration"), i.classList.toggle("xterm-decoration-top-layer", e?.options?.layer === "top"), i.style.width = `${Math.round((e.options.width || 1) * this._renderService.dimensions.css.cell.width)}px`, i.style.height = `${(e.options.height || 1) * this._renderService.dimensions.css.cell.height}px`, i.style.top = `${(e.marker.line - this._bufferService.buffers.active.ydisp) * this._renderService.dimensions.css.cell.height}px`, i.style.lineHeight = `${this._renderService.dimensions.css.cell.height}px`;
        let r = e.options.x ?? 0;
        return r && r > this._bufferService.cols && (i.style.display = "none"), this._refreshXPosition(e, i), i;
    }
    _refreshStyle(e) {
        let i = e.marker.line - this._bufferService.buffers.active.ydisp;
        if (i < 0 || i >= this._bufferService.rows) e.element && (e.element.style.display = "none", e.onRenderEmitter.fire(e.element));
        else {
            let r = this._decorationElements.get(e);
            r || (r = this._createElement(e), e.element = r, this._decorationElements.set(e, r), this._container.appendChild(r), e.onDispose(()=>{
                this._decorationElements.delete(e), r.remove();
            })), r.style.display = this._altBufferIsActive ? "none" : "block", this._altBufferIsActive || (r.style.width = `${Math.round((e.options.width || 1) * this._renderService.dimensions.css.cell.width)}px`, r.style.height = `${(e.options.height || 1) * this._renderService.dimensions.css.cell.height}px`, r.style.top = `${i * this._renderService.dimensions.css.cell.height}px`, r.style.lineHeight = `${this._renderService.dimensions.css.cell.height}px`), e.onRenderEmitter.fire(r);
        }
    }
    _refreshXPosition(e, i = e.element) {
        if (!i) return;
        let r = e.options.x ?? 0;
        (e.options.anchor || "left") === "right" ? i.style.right = r ? `${r * this._renderService.dimensions.css.cell.width}px` : "" : i.style.left = r ? `${r * this._renderService.dimensions.css.cell.width}px` : "";
    }
    _removeDecoration(e) {
        this._decorationElements.get(e)?.remove(), this._decorationElements.delete(e), e.dispose();
    }
};
$5c2a9584e51cbabf$var$Gt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$Be),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ce)
], $5c2a9584e51cbabf$var$Gt);
var $5c2a9584e51cbabf$var$Gr = class {
    constructor(){
        this._zones = [];
        this._zonePool = [];
        this._zonePoolIndex = 0;
        this._linePadding = {
            full: 0,
            left: 0,
            center: 0,
            right: 0
        };
    }
    get zones() {
        return this._zonePool.length = Math.min(this._zonePool.length, this._zones.length), this._zones;
    }
    clear() {
        this._zones.length = 0, this._zonePoolIndex = 0;
    }
    addDecoration(t1) {
        if (t1.options.overviewRulerOptions) {
            for (let e of this._zones)if (e.color === t1.options.overviewRulerOptions.color && e.position === t1.options.overviewRulerOptions.position) {
                if (this._lineIntersectsZone(e, t1.marker.line)) return;
                if (this._lineAdjacentToZone(e, t1.marker.line, t1.options.overviewRulerOptions.position)) {
                    this._addLineToZone(e, t1.marker.line);
                    return;
                }
            }
            if (this._zonePoolIndex < this._zonePool.length) {
                this._zonePool[this._zonePoolIndex].color = t1.options.overviewRulerOptions.color, this._zonePool[this._zonePoolIndex].position = t1.options.overviewRulerOptions.position, this._zonePool[this._zonePoolIndex].startBufferLine = t1.marker.line, this._zonePool[this._zonePoolIndex].endBufferLine = t1.marker.line, this._zones.push(this._zonePool[this._zonePoolIndex++]);
                return;
            }
            this._zones.push({
                color: t1.options.overviewRulerOptions.color,
                position: t1.options.overviewRulerOptions.position,
                startBufferLine: t1.marker.line,
                endBufferLine: t1.marker.line
            }), this._zonePool.push(this._zones[this._zones.length - 1]), this._zonePoolIndex++;
        }
    }
    setPadding(t1) {
        this._linePadding = t1;
    }
    _lineIntersectsZone(t1, e) {
        return e >= t1.startBufferLine && e <= t1.endBufferLine;
    }
    _lineAdjacentToZone(t1, e, i) {
        return e >= t1.startBufferLine - this._linePadding[i || "full"] && e <= t1.endBufferLine + this._linePadding[i || "full"];
    }
    _addLineToZone(t1, e) {
        t1.startBufferLine = Math.min(t1.startBufferLine, e), t1.endBufferLine = Math.max(t1.endBufferLine, e);
    }
};
var $5c2a9584e51cbabf$var$We = {
    full: 0,
    left: 0,
    center: 0,
    right: 0
}, $5c2a9584e51cbabf$var$at = {
    full: 0,
    left: 0,
    center: 0,
    right: 0
}, $5c2a9584e51cbabf$var$Li = {
    full: 0,
    left: 0,
    center: 0,
    right: 0
}, $5c2a9584e51cbabf$var$bt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u){
        super();
        this._viewportElement = e;
        this._screenElement = i;
        this._bufferService = r;
        this._decorationService = n;
        this._renderService = o;
        this._optionsService = l;
        this._themeService = a;
        this._coreBrowserService = u;
        this._colorZoneStore = new $5c2a9584e51cbabf$var$Gr;
        this._shouldUpdateDimensions = !0;
        this._shouldUpdateAnchor = !0;
        this._lastKnownBufferLength = 0;
        this._canvas = this._coreBrowserService.mainDocument.createElement("canvas"), this._canvas.classList.add("xterm-decoration-overview-ruler"), this._refreshCanvasDimensions(), this._viewportElement.parentElement?.insertBefore(this._canvas, this._viewportElement), this._register($5c2a9584e51cbabf$var$C(()=>this._canvas?.remove()));
        let h = this._canvas.getContext("2d");
        if (h) this._ctx = h;
        else throw new Error("Ctx cannot be null");
        this._register(this._decorationService.onDecorationRegistered(()=>this._queueRefresh(void 0, !0))), this._register(this._decorationService.onDecorationRemoved(()=>this._queueRefresh(void 0, !0))), this._register(this._renderService.onRenderedViewportChange(()=>this._queueRefresh())), this._register(this._bufferService.buffers.onBufferActivate(()=>{
            this._canvas.style.display = this._bufferService.buffer === this._bufferService.buffers.alt ? "none" : "block";
        })), this._register(this._bufferService.onScroll(()=>{
            this._lastKnownBufferLength !== this._bufferService.buffers.normal.lines.length && (this._refreshDrawHeightConstants(), this._refreshColorZonePadding());
        })), this._register(this._renderService.onRender(()=>{
            (!this._containerHeight || this._containerHeight !== this._screenElement.clientHeight) && (this._queueRefresh(!0), this._containerHeight = this._screenElement.clientHeight);
        })), this._register(this._coreBrowserService.onDprChange(()=>this._queueRefresh(!0))), this._register(this._optionsService.onSpecificOptionChange("overviewRuler", ()=>this._queueRefresh(!0))), this._register(this._themeService.onChangeColors(()=>this._queueRefresh())), this._queueRefresh(!0);
    }
    get _width() {
        return this._optionsService.options.overviewRuler?.width || 0;
    }
    _refreshDrawConstants() {
        let e = Math.floor((this._canvas.width - 1) / 3), i = Math.ceil((this._canvas.width - 1) / 3);
        $5c2a9584e51cbabf$var$at.full = this._canvas.width, $5c2a9584e51cbabf$var$at.left = e, $5c2a9584e51cbabf$var$at.center = i, $5c2a9584e51cbabf$var$at.right = e, this._refreshDrawHeightConstants(), $5c2a9584e51cbabf$var$Li.full = 1, $5c2a9584e51cbabf$var$Li.left = 1, $5c2a9584e51cbabf$var$Li.center = 1 + $5c2a9584e51cbabf$var$at.left, $5c2a9584e51cbabf$var$Li.right = 1 + $5c2a9584e51cbabf$var$at.left + $5c2a9584e51cbabf$var$at.center;
    }
    _refreshDrawHeightConstants() {
        $5c2a9584e51cbabf$var$We.full = Math.round(2 * this._coreBrowserService.dpr);
        let e = this._canvas.height / this._bufferService.buffer.lines.length, i = Math.round(Math.max(Math.min(e, 12), 6) * this._coreBrowserService.dpr);
        $5c2a9584e51cbabf$var$We.left = i, $5c2a9584e51cbabf$var$We.center = i, $5c2a9584e51cbabf$var$We.right = i;
    }
    _refreshColorZonePadding() {
        this._colorZoneStore.setPadding({
            full: Math.floor(this._bufferService.buffers.active.lines.length / (this._canvas.height - 1) * $5c2a9584e51cbabf$var$We.full),
            left: Math.floor(this._bufferService.buffers.active.lines.length / (this._canvas.height - 1) * $5c2a9584e51cbabf$var$We.left),
            center: Math.floor(this._bufferService.buffers.active.lines.length / (this._canvas.height - 1) * $5c2a9584e51cbabf$var$We.center),
            right: Math.floor(this._bufferService.buffers.active.lines.length / (this._canvas.height - 1) * $5c2a9584e51cbabf$var$We.right)
        }), this._lastKnownBufferLength = this._bufferService.buffers.normal.lines.length;
    }
    _refreshCanvasDimensions() {
        this._canvas.style.width = `${this._width}px`, this._canvas.width = Math.round(this._width * this._coreBrowserService.dpr), this._canvas.style.height = `${this._screenElement.clientHeight}px`, this._canvas.height = Math.round(this._screenElement.clientHeight * this._coreBrowserService.dpr), this._refreshDrawConstants(), this._refreshColorZonePadding();
    }
    _refreshDecorations() {
        this._shouldUpdateDimensions && this._refreshCanvasDimensions(), this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height), this._colorZoneStore.clear();
        for (let i of this._decorationService.decorations)this._colorZoneStore.addDecoration(i);
        this._ctx.lineWidth = 1, this._renderRulerOutline();
        let e = this._colorZoneStore.zones;
        for (let i of e)i.position !== "full" && this._renderColorZone(i);
        for (let i of e)i.position === "full" && this._renderColorZone(i);
        this._shouldUpdateDimensions = !1, this._shouldUpdateAnchor = !1;
    }
    _renderRulerOutline() {
        this._ctx.fillStyle = this._themeService.colors.overviewRulerBorder.css, this._ctx.fillRect(0, 0, 1, this._canvas.height), this._optionsService.rawOptions.overviewRuler.showTopBorder && this._ctx.fillRect(1, 0, this._canvas.width - 1, 1), this._optionsService.rawOptions.overviewRuler.showBottomBorder && this._ctx.fillRect(1, this._canvas.height - 1, this._canvas.width - 1, this._canvas.height);
    }
    _renderColorZone(e) {
        this._ctx.fillStyle = e.color, this._ctx.fillRect($5c2a9584e51cbabf$var$Li[e.position || "full"], Math.round((this._canvas.height - 1) * (e.startBufferLine / this._bufferService.buffers.active.lines.length) - $5c2a9584e51cbabf$var$We[e.position || "full"] / 2), $5c2a9584e51cbabf$var$at[e.position || "full"], Math.round((this._canvas.height - 1) * ((e.endBufferLine - e.startBufferLine) / this._bufferService.buffers.active.lines.length) + $5c2a9584e51cbabf$var$We[e.position || "full"]));
    }
    _queueRefresh(e, i) {
        this._shouldUpdateDimensions = e || this._shouldUpdateDimensions, this._shouldUpdateAnchor = i || this._shouldUpdateAnchor, this._animationFrame === void 0 && (this._animationFrame = this._coreBrowserService.window.requestAnimationFrame(()=>{
            this._refreshDecorations(), this._animationFrame = void 0;
        }));
    }
};
$5c2a9584e51cbabf$var$bt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$Be),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ce),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(6, $5c2a9584e51cbabf$var$Re),
    $5c2a9584e51cbabf$var$S(7, $5c2a9584e51cbabf$var$ae)
], $5c2a9584e51cbabf$var$bt);
var $5c2a9584e51cbabf$var$b;
((E)=>(E.NUL = "\0", E.SOH = "", E.STX = "", E.ETX = "", E.EOT = "", E.ENQ = "", E.ACK = "", E.BEL = "\x07", E.BS = "\b", E.HT = "	", E.LF = `
`, E.VT = "\v", E.FF = "\f", E.CR = "\r", E.SO = "", E.SI = "", E.DLE = "", E.DC1 = "", E.DC2 = "", E.DC3 = "", E.DC4 = "", E.NAK = "", E.SYN = "", E.ETB = "", E.CAN = "", E.EM = "", E.SUB = "", E.ESC = "\x1B", E.FS = "", E.GS = "", E.RS = "", E.US = "", E.SP = " ", E.DEL = "\x7F"))($5c2a9584e51cbabf$var$b ||= {});
var $5c2a9584e51cbabf$var$Ai;
((g)=>(g.PAD = "\x80", g.HOP = "\x81", g.BPH = "\x82", g.NBH = "\x83", g.IND = "\x84", g.NEL = "\x85", g.SSA = "\x86", g.ESA = "\x87", g.HTS = "\x88", g.HTJ = "\x89", g.VTS = "\x8A", g.PLD = "\x8B", g.PLU = "\x8C", g.RI = "\x8D", g.SS2 = "\x8E", g.SS3 = "\x8F", g.DCS = "\x90", g.PU1 = "\x91", g.PU2 = "\x92", g.STS = "\x93", g.CCH = "\x94", g.MW = "\x95", g.SPA = "\x96", g.EPA = "\x97", g.SOS = "\x98", g.SGCI = "\x99", g.SCI = "\x9A", g.CSI = "\x9B", g.ST = "\x9C", g.OSC = "\x9D", g.PM = "\x9E", g.APC = "\x9F"))($5c2a9584e51cbabf$var$Ai ||= {});
var $5c2a9584e51cbabf$var$fs;
((t1)=>t1.ST = `${$5c2a9584e51cbabf$var$b.ESC}\\`)($5c2a9584e51cbabf$var$fs ||= {});
var $5c2a9584e51cbabf$var$$t = class {
    constructor(t1, e, i, r, n, o){
        this._textarea = t1;
        this._compositionView = e;
        this._bufferService = i;
        this._optionsService = r;
        this._coreService = n;
        this._renderService = o;
        this._isComposing = !1, this._isSendingComposition = !1, this._compositionPosition = {
            start: 0,
            end: 0
        }, this._dataAlreadySent = "";
    }
    get isComposing() {
        return this._isComposing;
    }
    compositionstart() {
        this._isComposing = !0, this._compositionPosition.start = this._textarea.value.length, this._compositionView.textContent = "", this._dataAlreadySent = "", this._compositionView.classList.add("active");
    }
    compositionupdate(t1) {
        this._compositionView.textContent = t1.data, this.updateCompositionElements(), setTimeout(()=>{
            this._compositionPosition.end = this._textarea.value.length;
        }, 0);
    }
    compositionend() {
        this._finalizeComposition(!0);
    }
    keydown(t1) {
        if (this._isComposing || this._isSendingComposition) {
            if (t1.keyCode === 20 || t1.keyCode === 229 || t1.keyCode === 16 || t1.keyCode === 17 || t1.keyCode === 18) return !1;
            this._finalizeComposition(!1);
        }
        return t1.keyCode === 229 ? (this._handleAnyTextareaChanges(), !1) : !0;
    }
    _finalizeComposition(t1) {
        if (this._compositionView.classList.remove("active"), this._isComposing = !1, t1) {
            let e = {
                start: this._compositionPosition.start,
                end: this._compositionPosition.end
            };
            this._isSendingComposition = !0, setTimeout(()=>{
                if (this._isSendingComposition) {
                    this._isSendingComposition = !1;
                    let i;
                    e.start += this._dataAlreadySent.length, this._isComposing ? i = this._textarea.value.substring(e.start, this._compositionPosition.start) : i = this._textarea.value.substring(e.start), i.length > 0 && this._coreService.triggerDataEvent(i, !0);
                }
            }, 0);
        } else {
            this._isSendingComposition = !1;
            let e = this._textarea.value.substring(this._compositionPosition.start, this._compositionPosition.end);
            this._coreService.triggerDataEvent(e, !0);
        }
    }
    _handleAnyTextareaChanges() {
        let t1 = this._textarea.value;
        setTimeout(()=>{
            if (!this._isComposing) {
                let e = this._textarea.value, i = e.replace(t1, "");
                this._dataAlreadySent = i, e.length > t1.length ? this._coreService.triggerDataEvent(i, !0) : e.length < t1.length ? this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.DEL}`, !0) : e.length === t1.length && e !== t1 && this._coreService.triggerDataEvent(e, !0);
            }
        }, 0);
    }
    updateCompositionElements(t1) {
        if (this._isComposing) {
            if (this._bufferService.buffer.isCursorInViewport) {
                let e = Math.min(this._bufferService.buffer.x, this._bufferService.cols - 1), i = this._renderService.dimensions.css.cell.height, r = this._bufferService.buffer.y * this._renderService.dimensions.css.cell.height, n = e * this._renderService.dimensions.css.cell.width;
                this._compositionView.style.left = n + "px", this._compositionView.style.top = r + "px", this._compositionView.style.height = i + "px", this._compositionView.style.lineHeight = i + "px", this._compositionView.style.fontFamily = this._optionsService.rawOptions.fontFamily, this._compositionView.style.fontSize = this._optionsService.rawOptions.fontSize + "px";
                let o = this._compositionView.getBoundingClientRect();
                this._textarea.style.left = n + "px", this._textarea.style.top = r + "px", this._textarea.style.width = Math.max(o.width, 1) + "px", this._textarea.style.height = Math.max(o.height, 1) + "px", this._textarea.style.lineHeight = o.height + "px";
            }
            t1 || setTimeout(()=>this.updateCompositionElements(!0), 0);
        }
    }
};
$5c2a9584e51cbabf$var$$t = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$ce)
], $5c2a9584e51cbabf$var$$t);
var $5c2a9584e51cbabf$var$ue = 0, $5c2a9584e51cbabf$var$he = 0, $5c2a9584e51cbabf$var$de = 0, $5c2a9584e51cbabf$var$J = 0, $5c2a9584e51cbabf$var$ps = {
    css: "#00000000",
    rgba: 0
}, $5c2a9584e51cbabf$var$j;
((i)=>{
    function s(r, n, o, l) {
        return l !== void 0 ? `#${$5c2a9584e51cbabf$var$vt(r)}${$5c2a9584e51cbabf$var$vt(n)}${$5c2a9584e51cbabf$var$vt(o)}${$5c2a9584e51cbabf$var$vt(l)}` : `#${$5c2a9584e51cbabf$var$vt(r)}${$5c2a9584e51cbabf$var$vt(n)}${$5c2a9584e51cbabf$var$vt(o)}`;
    }
    i.toCss = s;
    function t1(r, n, o, l = 255) {
        return (r << 24 | n << 16 | o << 8 | l) >>> 0;
    }
    i.toRgba = t1;
    function e(r, n, o, l) {
        return {
            css: i.toCss(r, n, o, l),
            rgba: i.toRgba(r, n, o, l)
        };
    }
    i.toColor = e;
})($5c2a9584e51cbabf$var$j ||= {});
var $5c2a9584e51cbabf$var$U;
((l)=>{
    function s(a, u) {
        if ($5c2a9584e51cbabf$var$J = (u.rgba & 255) / 255, $5c2a9584e51cbabf$var$J === 1) return {
            css: u.css,
            rgba: u.rgba
        };
        let h = u.rgba >> 24 & 255, c = u.rgba >> 16 & 255, d = u.rgba >> 8 & 255, _ = a.rgba >> 24 & 255, p = a.rgba >> 16 & 255, m = a.rgba >> 8 & 255;
        $5c2a9584e51cbabf$var$ue = _ + Math.round((h - _) * $5c2a9584e51cbabf$var$J), $5c2a9584e51cbabf$var$he = p + Math.round((c - p) * $5c2a9584e51cbabf$var$J), $5c2a9584e51cbabf$var$de = m + Math.round((d - m) * $5c2a9584e51cbabf$var$J);
        let f = $5c2a9584e51cbabf$var$j.toCss($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de), A = $5c2a9584e51cbabf$var$j.toRgba($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de);
        return {
            css: f,
            rgba: A
        };
    }
    l.blend = s;
    function t1(a) {
        return (a.rgba & 255) === 255;
    }
    l.isOpaque = t1;
    function e(a, u, h) {
        let c = $5c2a9584e51cbabf$var$$r.ensureContrastRatio(a.rgba, u.rgba, h);
        if (c) return $5c2a9584e51cbabf$var$j.toColor(c >> 24 & 255, c >> 16 & 255, c >> 8 & 255);
    }
    l.ensureContrastRatio = e;
    function i(a) {
        let u = (a.rgba | 255) >>> 0;
        return [$5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de] = $5c2a9584e51cbabf$var$$r.toChannels(u), {
            css: $5c2a9584e51cbabf$var$j.toCss($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de),
            rgba: u
        };
    }
    l.opaque = i;
    function r(a, u) {
        return $5c2a9584e51cbabf$var$J = Math.round(u * 255), [$5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de] = $5c2a9584e51cbabf$var$$r.toChannels(a.rgba), {
            css: $5c2a9584e51cbabf$var$j.toCss($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J),
            rgba: $5c2a9584e51cbabf$var$j.toRgba($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J)
        };
    }
    l.opacity = r;
    function n(a, u) {
        return $5c2a9584e51cbabf$var$J = a.rgba & 255, r(a, $5c2a9584e51cbabf$var$J * u / 255);
    }
    l.multiplyOpacity = n;
    function o(a) {
        return [
            a.rgba >> 24 & 255,
            a.rgba >> 16 & 255,
            a.rgba >> 8 & 255
        ];
    }
    l.toColorRGB = o;
})($5c2a9584e51cbabf$var$U ||= {});
var $5c2a9584e51cbabf$var$z;
((i)=>{
    let s, t1;
    try {
        let r = document.createElement("canvas");
        r.width = 1, r.height = 1;
        let n = r.getContext("2d", {
            willReadFrequently: !0
        });
        n && (s = n, s.globalCompositeOperation = "copy", t1 = s.createLinearGradient(0, 0, 1, 1));
    } catch  {}
    function e(r) {
        if (r.match(/#[\da-f]{3,8}/i)) switch(r.length){
            case 4:
                return $5c2a9584e51cbabf$var$ue = parseInt(r.slice(1, 2).repeat(2), 16), $5c2a9584e51cbabf$var$he = parseInt(r.slice(2, 3).repeat(2), 16), $5c2a9584e51cbabf$var$de = parseInt(r.slice(3, 4).repeat(2), 16), $5c2a9584e51cbabf$var$j.toColor($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de);
            case 5:
                return $5c2a9584e51cbabf$var$ue = parseInt(r.slice(1, 2).repeat(2), 16), $5c2a9584e51cbabf$var$he = parseInt(r.slice(2, 3).repeat(2), 16), $5c2a9584e51cbabf$var$de = parseInt(r.slice(3, 4).repeat(2), 16), $5c2a9584e51cbabf$var$J = parseInt(r.slice(4, 5).repeat(2), 16), $5c2a9584e51cbabf$var$j.toColor($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J);
            case 7:
                return {
                    css: r,
                    rgba: (parseInt(r.slice(1), 16) << 8 | 255) >>> 0
                };
            case 9:
                return {
                    css: r,
                    rgba: parseInt(r.slice(1), 16) >>> 0
                };
        }
        let n = r.match(/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(,\s*(0|1|\d?\.(\d+))\s*)?\)/);
        if (n) return $5c2a9584e51cbabf$var$ue = parseInt(n[1]), $5c2a9584e51cbabf$var$he = parseInt(n[2]), $5c2a9584e51cbabf$var$de = parseInt(n[3]), $5c2a9584e51cbabf$var$J = Math.round((n[5] === void 0 ? 1 : parseFloat(n[5])) * 255), $5c2a9584e51cbabf$var$j.toColor($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J);
        if (!s || !t1) throw new Error("css.toColor: Unsupported css format");
        if (s.fillStyle = t1, s.fillStyle = r, typeof s.fillStyle != "string") throw new Error("css.toColor: Unsupported css format");
        if (s.fillRect(0, 0, 1, 1), [$5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J] = s.getImageData(0, 0, 1, 1).data, $5c2a9584e51cbabf$var$J !== 255) throw new Error("css.toColor: Unsupported css format");
        return {
            rgba: $5c2a9584e51cbabf$var$j.toRgba($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de, $5c2a9584e51cbabf$var$J),
            css: r
        };
    }
    i.toColor = e;
})($5c2a9584e51cbabf$var$z ||= {});
var $5c2a9584e51cbabf$var$ve;
((e)=>{
    function s(i) {
        return t1(i >> 16 & 255, i >> 8 & 255, i & 255);
    }
    e.relativeLuminance = s;
    function t1(i, r, n) {
        let o = i / 255, l = r / 255, a = n / 255, u = o <= .03928 ? o / 12.92 : Math.pow((o + .055) / 1.055, 2.4), h = l <= .03928 ? l / 12.92 : Math.pow((l + .055) / 1.055, 2.4), c = a <= .03928 ? a / 12.92 : Math.pow((a + .055) / 1.055, 2.4);
        return u * .2126 + h * .7152 + c * .0722;
    }
    e.relativeLuminance2 = t1;
})($5c2a9584e51cbabf$var$ve ||= {});
var $5c2a9584e51cbabf$var$$r;
((n)=>{
    function s(o, l) {
        if ($5c2a9584e51cbabf$var$J = (l & 255) / 255, $5c2a9584e51cbabf$var$J === 1) return l;
        let a = l >> 24 & 255, u = l >> 16 & 255, h = l >> 8 & 255, c = o >> 24 & 255, d = o >> 16 & 255, _ = o >> 8 & 255;
        return $5c2a9584e51cbabf$var$ue = c + Math.round((a - c) * $5c2a9584e51cbabf$var$J), $5c2a9584e51cbabf$var$he = d + Math.round((u - d) * $5c2a9584e51cbabf$var$J), $5c2a9584e51cbabf$var$de = _ + Math.round((h - _) * $5c2a9584e51cbabf$var$J), $5c2a9584e51cbabf$var$j.toRgba($5c2a9584e51cbabf$var$ue, $5c2a9584e51cbabf$var$he, $5c2a9584e51cbabf$var$de);
    }
    n.blend = s;
    function t1(o, l, a) {
        let u = $5c2a9584e51cbabf$var$ve.relativeLuminance(o >> 8), h = $5c2a9584e51cbabf$var$ve.relativeLuminance(l >> 8);
        if ($5c2a9584e51cbabf$var$Xe(u, h) < a) {
            if (h < u) {
                let p = e(o, l, a), m = $5c2a9584e51cbabf$var$Xe(u, $5c2a9584e51cbabf$var$ve.relativeLuminance(p >> 8));
                if (m < a) {
                    let f = i(o, l, a), A = $5c2a9584e51cbabf$var$Xe(u, $5c2a9584e51cbabf$var$ve.relativeLuminance(f >> 8));
                    return m > A ? p : f;
                }
                return p;
            }
            let d = i(o, l, a), _ = $5c2a9584e51cbabf$var$Xe(u, $5c2a9584e51cbabf$var$ve.relativeLuminance(d >> 8));
            if (_ < a) {
                let p = e(o, l, a), m = $5c2a9584e51cbabf$var$Xe(u, $5c2a9584e51cbabf$var$ve.relativeLuminance(p >> 8));
                return _ > m ? d : p;
            }
            return d;
        }
    }
    n.ensureContrastRatio = t1;
    function e(o, l, a) {
        let u = o >> 24 & 255, h = o >> 16 & 255, c = o >> 8 & 255, d = l >> 24 & 255, _ = l >> 16 & 255, p = l >> 8 & 255, m = $5c2a9584e51cbabf$var$Xe($5c2a9584e51cbabf$var$ve.relativeLuminance2(d, _, p), $5c2a9584e51cbabf$var$ve.relativeLuminance2(u, h, c));
        for(; m < a && (d > 0 || _ > 0 || p > 0);)d -= Math.max(0, Math.ceil(d * .1)), _ -= Math.max(0, Math.ceil(_ * .1)), p -= Math.max(0, Math.ceil(p * .1)), m = $5c2a9584e51cbabf$var$Xe($5c2a9584e51cbabf$var$ve.relativeLuminance2(d, _, p), $5c2a9584e51cbabf$var$ve.relativeLuminance2(u, h, c));
        return (d << 24 | _ << 16 | p << 8 | 255) >>> 0;
    }
    n.reduceLuminance = e;
    function i(o, l, a) {
        let u = o >> 24 & 255, h = o >> 16 & 255, c = o >> 8 & 255, d = l >> 24 & 255, _ = l >> 16 & 255, p = l >> 8 & 255, m = $5c2a9584e51cbabf$var$Xe($5c2a9584e51cbabf$var$ve.relativeLuminance2(d, _, p), $5c2a9584e51cbabf$var$ve.relativeLuminance2(u, h, c));
        for(; m < a && (d < 255 || _ < 255 || p < 255);)d = Math.min(255, d + Math.ceil((255 - d) * .1)), _ = Math.min(255, _ + Math.ceil((255 - _) * .1)), p = Math.min(255, p + Math.ceil((255 - p) * .1)), m = $5c2a9584e51cbabf$var$Xe($5c2a9584e51cbabf$var$ve.relativeLuminance2(d, _, p), $5c2a9584e51cbabf$var$ve.relativeLuminance2(u, h, c));
        return (d << 24 | _ << 16 | p << 8 | 255) >>> 0;
    }
    n.increaseLuminance = i;
    function r(o) {
        return [
            o >> 24 & 255,
            o >> 16 & 255,
            o >> 8 & 255,
            o & 255
        ];
    }
    n.toChannels = r;
})($5c2a9584e51cbabf$var$$r ||= {});
function $5c2a9584e51cbabf$var$vt(s) {
    let t1 = s.toString(16);
    return t1.length < 2 ? "0" + t1 : t1;
}
function $5c2a9584e51cbabf$var$Xe(s, t1) {
    return s < t1 ? (t1 + .05) / (s + .05) : (s + .05) / (t1 + .05);
}
var $5c2a9584e51cbabf$var$Vr = class extends $5c2a9584e51cbabf$var$De {
    constructor(e, i, r){
        super();
        this.content = 0;
        this.combinedData = "";
        this.fg = e.fg, this.bg = e.bg, this.combinedData = i, this._width = r;
    }
    isCombined() {
        return 2097152;
    }
    getWidth() {
        return this._width;
    }
    getChars() {
        return this.combinedData;
    }
    getCode() {
        return 2097151;
    }
    setFromCharData(e) {
        throw new Error("not implemented");
    }
    getAsCharData() {
        return [
            this.fg,
            this.getChars(),
            this.getWidth(),
            this.getCode()
        ];
    }
}, $5c2a9584e51cbabf$var$ct = class {
    constructor(t1){
        this._bufferService = t1;
        this._characterJoiners = [];
        this._nextCharacterJoinerId = 0;
        this._workCell = new $5c2a9584e51cbabf$var$q;
    }
    register(t1) {
        let e = {
            id: this._nextCharacterJoinerId++,
            handler: t1
        };
        return this._characterJoiners.push(e), e.id;
    }
    deregister(t1) {
        for(let e = 0; e < this._characterJoiners.length; e++)if (this._characterJoiners[e].id === t1) return this._characterJoiners.splice(e, 1), !0;
        return !1;
    }
    getJoinedCharacters(t1) {
        if (this._characterJoiners.length === 0) return [];
        let e = this._bufferService.buffer.lines.get(t1);
        if (!e || e.length === 0) return [];
        let i = [], r = e.translateToString(!0), n = 0, o = 0, l = 0, a = e.getFg(0), u = e.getBg(0);
        for(let h = 0; h < e.getTrimmedLength(); h++)if (e.loadCell(h, this._workCell), this._workCell.getWidth() !== 0) {
            if (this._workCell.fg !== a || this._workCell.bg !== u) {
                if (h - n > 1) {
                    let c = this._getJoinedRanges(r, l, o, e, n);
                    for(let d = 0; d < c.length; d++)i.push(c[d]);
                }
                n = h, l = o, a = this._workCell.fg, u = this._workCell.bg;
            }
            o += this._workCell.getChars().length || $5c2a9584e51cbabf$var$we.length;
        }
        if (this._bufferService.cols - n > 1) {
            let h = this._getJoinedRanges(r, l, o, e, n);
            for(let c = 0; c < h.length; c++)i.push(h[c]);
        }
        return i;
    }
    _getJoinedRanges(t1, e, i, r, n) {
        let o = t1.substring(e, i), l = [];
        try {
            l = this._characterJoiners[0].handler(o);
        } catch (a) {
            console.error(a);
        }
        for(let a = 1; a < this._characterJoiners.length; a++)try {
            let u = this._characterJoiners[a].handler(o);
            for(let h = 0; h < u.length; h++)$5c2a9584e51cbabf$var$ct._mergeRanges(l, u[h]);
        } catch (u) {
            console.error(u);
        }
        return this._stringRangesToCellRanges(l, r, n), l;
    }
    _stringRangesToCellRanges(t1, e, i) {
        let r = 0, n = !1, o = 0, l = t1[r];
        if (l) {
            for(let a = i; a < this._bufferService.cols; a++){
                let u = e.getWidth(a), h = e.getString(a).length || $5c2a9584e51cbabf$var$we.length;
                if (u !== 0) {
                    if (!n && l[0] <= o && (l[0] = a, n = !0), l[1] <= o) {
                        if (l[1] = a, l = t1[++r], !l) break;
                        l[0] <= o ? (l[0] = a, n = !0) : n = !1;
                    }
                    o += h;
                }
            }
            l && (l[1] = this._bufferService.cols);
        }
    }
    static _mergeRanges(t1, e) {
        let i = !1;
        for(let r = 0; r < t1.length; r++){
            let n = t1[r];
            if (i) {
                if (e[1] <= n[0]) return t1[r - 1][1] = e[1], t1;
                if (e[1] <= n[1]) return t1[r - 1][1] = Math.max(e[1], n[1]), t1.splice(r, 1), t1;
                t1.splice(r, 1), r--;
            } else {
                if (e[1] <= n[0]) return t1.splice(r, 0, e), t1;
                if (e[1] <= n[1]) return n[0] = Math.min(e[0], n[0]), t1;
                e[0] < n[1] && (n[0] = Math.min(e[0], n[0]), i = !0);
                continue;
            }
        }
        return i ? t1[t1.length - 1][1] = e[1] : t1.push(e), t1;
    }
};
$5c2a9584e51cbabf$var$ct = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F)
], $5c2a9584e51cbabf$var$ct);
function $5c2a9584e51cbabf$var$Oa(s) {
    return 57508 <= s && s <= 57558;
}
function $5c2a9584e51cbabf$var$Ba(s) {
    return 9472 <= s && s <= 9631;
}
function $5c2a9584e51cbabf$var$$o(s) {
    return $5c2a9584e51cbabf$var$Oa(s) || $5c2a9584e51cbabf$var$Ba(s);
}
function $5c2a9584e51cbabf$var$Vo() {
    return {
        css: {
            canvas: $5c2a9584e51cbabf$var$qr(),
            cell: $5c2a9584e51cbabf$var$qr()
        },
        device: {
            canvas: $5c2a9584e51cbabf$var$qr(),
            cell: $5c2a9584e51cbabf$var$qr(),
            char: {
                width: 0,
                height: 0,
                left: 0,
                top: 0
            }
        }
    };
}
function $5c2a9584e51cbabf$var$qr() {
    return {
        width: 0,
        height: 0
    };
}
var $5c2a9584e51cbabf$var$Vt = class {
    constructor(t1, e, i, r, n, o, l){
        this._document = t1;
        this._characterJoinerService = e;
        this._optionsService = i;
        this._coreBrowserService = r;
        this._coreService = n;
        this._decorationService = o;
        this._themeService = l;
        this._workCell = new $5c2a9584e51cbabf$var$q;
        this._columnSelectMode = !1;
        this.defaultSpacing = 0;
    }
    handleSelectionChanged(t1, e, i) {
        this._selectionStart = t1, this._selectionEnd = e, this._columnSelectMode = i;
    }
    createRow(t1, e, i, r, n, o, l, a, u, h, c) {
        let d = [], _ = this._characterJoinerService.getJoinedCharacters(e), p = this._themeService.colors, m = t1.getNoBgTrimmedLength();
        i && m < o + 1 && (m = o + 1);
        let f, A = 0, R = "", O = 0, I = 0, k = 0, P = 0, oe = !1, Me = 0, Pe = !1, Ke = 0, di = 0, V = [], Qe = h !== -1 && c !== -1;
        for(let y = 0; y < m; y++){
            t1.loadCell(y, this._workCell);
            let T = this._workCell.getWidth();
            if (T === 0) continue;
            let g = !1, w = y >= di, E = y, x = this._workCell;
            if (_.length > 0 && y === _[0][0] && w) {
                let W = _.shift(), An = this._isCellInSelection(W[0], e);
                for(O = W[0] + 1; O < W[1]; O++)w &&= An === this._isCellInSelection(O, e);
                w &&= !i || o < W[0] || o >= W[1], w ? (g = !0, x = new $5c2a9584e51cbabf$var$Vr(this._workCell, t1.translateToString(!0, W[0], W[1]), W[1] - W[0]), E = W[1] - 1, T = x.getWidth()) : di = W[1];
            }
            let N = this._isCellInSelection(y, e), Z = i && y === o, te = Qe && y >= h && y <= c, Oe = !1;
            this._decorationService.forEachDecorationAtCell(y, e, void 0, (W)=>{
                Oe = !0;
            });
            let ze = x.getChars() || $5c2a9584e51cbabf$var$we;
            if (ze === " " && (x.isUnderline() || x.isOverline()) && (ze = "\xA0"), Ke = T * a - u.get(ze, x.isBold(), x.isItalic()), !f) f = this._document.createElement("span");
            else if (A && (N && Pe || !N && !Pe && x.bg === I) && (N && Pe && p.selectionForeground || x.fg === k) && x.extended.ext === P && te === oe && Ke === Me && !Z && !g && !Oe && w) {
                x.isInvisible() ? R += $5c2a9584e51cbabf$var$we : R += ze, A++;
                continue;
            } else A && (f.textContent = R), f = this._document.createElement("span"), A = 0, R = "";
            if (I = x.bg, k = x.fg, P = x.extended.ext, oe = te, Me = Ke, Pe = N, g && o >= y && o <= E && (o = y), !this._coreService.isCursorHidden && Z && this._coreService.isCursorInitialized) {
                if (V.push("xterm-cursor"), this._coreBrowserService.isFocused) l && V.push("xterm-cursor-blink"), V.push(r === "bar" ? "xterm-cursor-bar" : r === "underline" ? "xterm-cursor-underline" : "xterm-cursor-block");
                else if (n) switch(n){
                    case "outline":
                        V.push("xterm-cursor-outline");
                        break;
                    case "block":
                        V.push("xterm-cursor-block");
                        break;
                    case "bar":
                        V.push("xterm-cursor-bar");
                        break;
                    case "underline":
                        V.push("xterm-cursor-underline");
                        break;
                    default:
                        break;
                }
            }
            if (x.isBold() && V.push("xterm-bold"), x.isItalic() && V.push("xterm-italic"), x.isDim() && V.push("xterm-dim"), x.isInvisible() ? R = $5c2a9584e51cbabf$var$we : R = x.getChars() || $5c2a9584e51cbabf$var$we, x.isUnderline() && (V.push(`xterm-underline-${x.extended.underlineStyle}`), R === " " && (R = "\xA0"), !x.isUnderlineColorDefault())) {
                if (x.isUnderlineColorRGB()) f.style.textDecorationColor = `rgb(${$5c2a9584e51cbabf$var$De.toColorRGB(x.getUnderlineColor()).join(",")})`;
                else {
                    let W = x.getUnderlineColor();
                    this._optionsService.rawOptions.drawBoldTextInBrightColors && x.isBold() && W < 8 && (W += 8), f.style.textDecorationColor = p.ansi[W].css;
                }
            }
            x.isOverline() && (V.push("xterm-overline"), R === " " && (R = "\xA0")), x.isStrikethrough() && V.push("xterm-strikethrough"), te && (f.style.textDecoration = "underline");
            let le = x.getFgColor(), et = x.getFgColorMode(), me = x.getBgColor(), ht = x.getBgColorMode(), fi = !!x.isInverse();
            if (fi) {
                let W = le;
                le = me, me = W;
                let An = et;
                et = ht, ht = An;
            }
            let tt, Qi, pi = !1;
            this._decorationService.forEachDecorationAtCell(y, e, void 0, (W)=>{
                W.options.layer !== "top" && pi || (W.backgroundColorRGB && (ht = 50331648, me = W.backgroundColorRGB.rgba >> 8 & 16777215, tt = W.backgroundColorRGB), W.foregroundColorRGB && (et = 50331648, le = W.foregroundColorRGB.rgba >> 8 & 16777215, Qi = W.foregroundColorRGB), pi = W.options.layer === "top");
            }), !pi && N && (tt = this._coreBrowserService.isFocused ? p.selectionBackgroundOpaque : p.selectionInactiveBackgroundOpaque, me = tt.rgba >> 8 & 16777215, ht = 50331648, pi = !0, p.selectionForeground && (et = 50331648, le = p.selectionForeground.rgba >> 8 & 16777215, Qi = p.selectionForeground)), pi && V.push("xterm-decoration-top");
            let it;
            switch(ht){
                case 16777216:
                case 33554432:
                    it = p.ansi[me], V.push(`xterm-bg-${me}`);
                    break;
                case 50331648:
                    it = $5c2a9584e51cbabf$var$j.toColor(me >> 16, me >> 8 & 255, me & 255), this._addStyle(f, `background-color:#${$5c2a9584e51cbabf$var$qo((me >>> 0).toString(16), "0", 6)}`);
                    break;
                case 0:
                default:
                    fi ? (it = p.foreground, V.push(`xterm-bg-${257}`)) : it = p.background;
            }
            switch(tt || x.isDim() && (tt = $5c2a9584e51cbabf$var$U.multiplyOpacity(it, .5)), et){
                case 16777216:
                case 33554432:
                    x.isBold() && le < 8 && this._optionsService.rawOptions.drawBoldTextInBrightColors && (le += 8), this._applyMinimumContrast(f, it, p.ansi[le], x, tt, void 0) || V.push(`xterm-fg-${le}`);
                    break;
                case 50331648:
                    let W = $5c2a9584e51cbabf$var$j.toColor(le >> 16 & 255, le >> 8 & 255, le & 255);
                    this._applyMinimumContrast(f, it, W, x, tt, Qi) || this._addStyle(f, `color:#${$5c2a9584e51cbabf$var$qo(le.toString(16), "0", 6)}`);
                    break;
                case 0:
                default:
                    this._applyMinimumContrast(f, it, p.foreground, x, tt, Qi) || fi && V.push(`xterm-fg-${257}`);
            }
            V.length && (f.className = V.join(" "), V.length = 0), !Z && !g && !Oe && w ? A++ : f.textContent = R, Ke !== this.defaultSpacing && (f.style.letterSpacing = `${Ke}px`), d.push(f), y = E;
        }
        return f && A && (f.textContent = R), d;
    }
    _applyMinimumContrast(t1, e, i, r, n, o) {
        if (this._optionsService.rawOptions.minimumContrastRatio === 1 || $5c2a9584e51cbabf$var$$o(r.getCode())) return !1;
        let l = this._getContrastCache(r), a;
        if (!n && !o && (a = l.getColor(e.rgba, i.rgba)), a === void 0) {
            let u = this._optionsService.rawOptions.minimumContrastRatio / (r.isDim() ? 2 : 1);
            a = $5c2a9584e51cbabf$var$U.ensureContrastRatio(n || e, o || i, u), l.setColor((n || e).rgba, (o || i).rgba, a ?? null);
        }
        return a ? (this._addStyle(t1, `color:${a.css}`), !0) : !1;
    }
    _getContrastCache(t1) {
        return t1.isDim() ? this._themeService.colors.halfContrastCache : this._themeService.colors.contrastCache;
    }
    _addStyle(t1, e) {
        t1.setAttribute("style", `${t1.getAttribute("style") || ""}${e};`);
    }
    _isCellInSelection(t1, e) {
        let i = this._selectionStart, r = this._selectionEnd;
        return !i || !r ? !1 : this._columnSelectMode ? i[0] <= r[0] ? t1 >= i[0] && e >= i[1] && t1 < r[0] && e <= r[1] : t1 < i[0] && e >= i[1] && t1 >= r[0] && e <= r[1] : e > i[1] && e < r[1] || i[1] === r[1] && e === i[1] && t1 >= i[0] && t1 < r[0] || i[1] < r[1] && e === r[1] && t1 < r[0] || i[1] < r[1] && e === i[1] && t1 >= i[0];
    }
};
$5c2a9584e51cbabf$var$Vt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$or),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$Be),
    $5c2a9584e51cbabf$var$S(6, $5c2a9584e51cbabf$var$Re)
], $5c2a9584e51cbabf$var$Vt);
function $5c2a9584e51cbabf$var$qo(s, t1, e) {
    for(; s.length < e;)s = t1 + s;
    return s;
}
var $5c2a9584e51cbabf$var$Yr = class {
    constructor(t1, e){
        this._flat = new Float32Array(256);
        this._font = "";
        this._fontSize = 0;
        this._weight = "normal";
        this._weightBold = "bold";
        this._measureElements = [];
        this._container = t1.createElement("div"), this._container.classList.add("xterm-width-cache-measure-container"), this._container.setAttribute("aria-hidden", "true"), this._container.style.whiteSpace = "pre", this._container.style.fontKerning = "none";
        let i = t1.createElement("span");
        i.classList.add("xterm-char-measure-element");
        let r = t1.createElement("span");
        r.classList.add("xterm-char-measure-element"), r.style.fontWeight = "bold";
        let n = t1.createElement("span");
        n.classList.add("xterm-char-measure-element"), n.style.fontStyle = "italic";
        let o = t1.createElement("span");
        o.classList.add("xterm-char-measure-element"), o.style.fontWeight = "bold", o.style.fontStyle = "italic", this._measureElements = [
            i,
            r,
            n,
            o
        ], this._container.appendChild(i), this._container.appendChild(r), this._container.appendChild(n), this._container.appendChild(o), e.appendChild(this._container), this.clear();
    }
    dispose() {
        this._container.remove(), this._measureElements.length = 0, this._holey = void 0;
    }
    clear() {
        this._flat.fill(-9999), this._holey = new Map;
    }
    setFont(t1, e, i, r) {
        t1 === this._font && e === this._fontSize && i === this._weight && r === this._weightBold || (this._font = t1, this._fontSize = e, this._weight = i, this._weightBold = r, this._container.style.fontFamily = this._font, this._container.style.fontSize = `${this._fontSize}px`, this._measureElements[0].style.fontWeight = `${i}`, this._measureElements[1].style.fontWeight = `${r}`, this._measureElements[2].style.fontWeight = `${i}`, this._measureElements[3].style.fontWeight = `${r}`, this.clear());
    }
    get(t1, e, i) {
        let r = 0;
        if (!e && !i && t1.length === 1 && (r = t1.charCodeAt(0)) < 256) {
            if (this._flat[r] !== -9999) return this._flat[r];
            let l = this._measure(t1, 0);
            return l > 0 && (this._flat[r] = l), l;
        }
        let n = t1;
        e && (n += "B"), i && (n += "I");
        let o = this._holey.get(n);
        if (o === void 0) {
            let l = 0;
            e && (l |= 1), i && (l |= 2), o = this._measure(t1, l), o > 0 && this._holey.set(n, o);
        }
        return o;
    }
    _measure(t1, e) {
        let i = this._measureElements[e];
        return i.textContent = t1.repeat(32), i.offsetWidth / 32;
    }
};
var $5c2a9584e51cbabf$var$ms = class {
    constructor(){
        this.clear();
    }
    clear() {
        this.hasSelection = !1, this.columnSelectMode = !1, this.viewportStartRow = 0, this.viewportEndRow = 0, this.viewportCappedStartRow = 0, this.viewportCappedEndRow = 0, this.startCol = 0, this.endCol = 0, this.selectionStart = void 0, this.selectionEnd = void 0;
    }
    update(t1, e, i, r = !1) {
        if (this.selectionStart = e, this.selectionEnd = i, !e || !i || e[0] === i[0] && e[1] === i[1]) {
            this.clear();
            return;
        }
        let n = t1.buffers.active.ydisp, o = e[1] - n, l = i[1] - n, a = Math.max(o, 0), u = Math.min(l, t1.rows - 1);
        if (a >= t1.rows || u < 0) {
            this.clear();
            return;
        }
        this.hasSelection = !0, this.columnSelectMode = r, this.viewportStartRow = o, this.viewportEndRow = l, this.viewportCappedStartRow = a, this.viewportCappedEndRow = u, this.startCol = e[0], this.endCol = i[0];
    }
    isCellSelected(t1, e, i) {
        return this.hasSelection ? (i -= t1.buffer.active.viewportY, this.columnSelectMode ? this.startCol <= this.endCol ? e >= this.startCol && i >= this.viewportCappedStartRow && e < this.endCol && i <= this.viewportCappedEndRow : e < this.startCol && i >= this.viewportCappedStartRow && e >= this.endCol && i <= this.viewportCappedEndRow : i > this.viewportStartRow && i < this.viewportEndRow || this.viewportStartRow === this.viewportEndRow && i === this.viewportStartRow && e >= this.startCol && e < this.endCol || this.viewportStartRow < this.viewportEndRow && i === this.viewportEndRow && e < this.endCol || this.viewportStartRow < this.viewportEndRow && i === this.viewportStartRow && e >= this.startCol) : !1;
    }
};
function $5c2a9584e51cbabf$var$Yo() {
    return new $5c2a9584e51cbabf$var$ms;
}
var $5c2a9584e51cbabf$var$_s = "xterm-dom-renderer-owner-", $5c2a9584e51cbabf$var$Le = "xterm-rows", $5c2a9584e51cbabf$var$jr = "xterm-fg-", $5c2a9584e51cbabf$var$jo = "xterm-bg-", $5c2a9584e51cbabf$var$ki = "xterm-focus", $5c2a9584e51cbabf$var$Xr = "xterm-selection", $5c2a9584e51cbabf$var$Na = 1, $5c2a9584e51cbabf$var$Yt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u, h, c, d, _, p, m){
        super();
        this._terminal = e;
        this._document = i;
        this._element = r;
        this._screenElement = n;
        this._viewportElement = o;
        this._helperContainer = l;
        this._linkifier2 = a;
        this._charSizeService = h;
        this._optionsService = c;
        this._bufferService = d;
        this._coreService = _;
        this._coreBrowserService = p;
        this._themeService = m;
        this._terminalClass = $5c2a9584e51cbabf$var$Na++;
        this._rowElements = [];
        this._selectionRenderModel = $5c2a9584e51cbabf$var$Yo();
        this.onRequestRedraw = this._register(new $5c2a9584e51cbabf$var$v).event;
        this._rowContainer = this._document.createElement("div"), this._rowContainer.classList.add($5c2a9584e51cbabf$var$Le), this._rowContainer.style.lineHeight = "normal", this._rowContainer.setAttribute("aria-hidden", "true"), this._refreshRowElements(this._bufferService.cols, this._bufferService.rows), this._selectionContainer = this._document.createElement("div"), this._selectionContainer.classList.add($5c2a9584e51cbabf$var$Xr), this._selectionContainer.setAttribute("aria-hidden", "true"), this.dimensions = $5c2a9584e51cbabf$var$Vo(), this._updateDimensions(), this._register(this._optionsService.onOptionChange(()=>this._handleOptionsChanged())), this._register(this._themeService.onChangeColors((f)=>this._injectCss(f))), this._injectCss(this._themeService.colors), this._rowFactory = u.createInstance($5c2a9584e51cbabf$var$Vt, document), this._element.classList.add($5c2a9584e51cbabf$var$_s + this._terminalClass), this._screenElement.appendChild(this._rowContainer), this._screenElement.appendChild(this._selectionContainer), this._register(this._linkifier2.onShowLinkUnderline((f)=>this._handleLinkHover(f))), this._register(this._linkifier2.onHideLinkUnderline((f)=>this._handleLinkLeave(f))), this._register($5c2a9584e51cbabf$var$C(()=>{
            this._element.classList.remove($5c2a9584e51cbabf$var$_s + this._terminalClass), this._rowContainer.remove(), this._selectionContainer.remove(), this._widthCache.dispose(), this._themeStyleElement.remove(), this._dimensionsStyleElement.remove();
        })), this._widthCache = new $5c2a9584e51cbabf$var$Yr(this._document, this._helperContainer), this._widthCache.setFont(this._optionsService.rawOptions.fontFamily, this._optionsService.rawOptions.fontSize, this._optionsService.rawOptions.fontWeight, this._optionsService.rawOptions.fontWeightBold), this._setDefaultSpacing();
    }
    _updateDimensions() {
        let e = this._coreBrowserService.dpr;
        this.dimensions.device.char.width = this._charSizeService.width * e, this.dimensions.device.char.height = Math.ceil(this._charSizeService.height * e), this.dimensions.device.cell.width = this.dimensions.device.char.width + Math.round(this._optionsService.rawOptions.letterSpacing), this.dimensions.device.cell.height = Math.floor(this.dimensions.device.char.height * this._optionsService.rawOptions.lineHeight), this.dimensions.device.char.left = 0, this.dimensions.device.char.top = 0, this.dimensions.device.canvas.width = this.dimensions.device.cell.width * this._bufferService.cols, this.dimensions.device.canvas.height = this.dimensions.device.cell.height * this._bufferService.rows, this.dimensions.css.canvas.width = Math.round(this.dimensions.device.canvas.width / e), this.dimensions.css.canvas.height = Math.round(this.dimensions.device.canvas.height / e), this.dimensions.css.cell.width = this.dimensions.css.canvas.width / this._bufferService.cols, this.dimensions.css.cell.height = this.dimensions.css.canvas.height / this._bufferService.rows;
        for (let r of this._rowElements)r.style.width = `${this.dimensions.css.canvas.width}px`, r.style.height = `${this.dimensions.css.cell.height}px`, r.style.lineHeight = `${this.dimensions.css.cell.height}px`, r.style.overflow = "hidden";
        this._dimensionsStyleElement || (this._dimensionsStyleElement = this._document.createElement("style"), this._screenElement.appendChild(this._dimensionsStyleElement));
        let i = `${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} span { display: inline-block; height: 100%; vertical-align: top;}`;
        this._dimensionsStyleElement.textContent = i, this._selectionContainer.style.height = this._viewportElement.style.height, this._screenElement.style.width = `${this.dimensions.css.canvas.width}px`, this._screenElement.style.height = `${this.dimensions.css.canvas.height}px`;
    }
    _injectCss(e) {
        this._themeStyleElement || (this._themeStyleElement = this._document.createElement("style"), this._screenElement.appendChild(this._themeStyleElement));
        let i = `${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} { pointer-events: none; color: ${e.foreground.css}; font-family: ${this._optionsService.rawOptions.fontFamily}; font-size: ${this._optionsService.rawOptions.fontSize}px; font-kerning: none; white-space: pre}`;
        i += `${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-dim { color: ${$5c2a9584e51cbabf$var$U.multiplyOpacity(e.foreground, .5).css};}`, i += `${this._terminalSelector} span:not(.xterm-bold) { font-weight: ${this._optionsService.rawOptions.fontWeight};}${this._terminalSelector} span.xterm-bold { font-weight: ${this._optionsService.rawOptions.fontWeightBold};}${this._terminalSelector} span.xterm-italic { font-style: italic;}`;
        let r = `blink_underline_${this._terminalClass}`, n = `blink_bar_${this._terminalClass}`, o = `blink_block_${this._terminalClass}`;
        i += `@keyframes ${r} { 50% {  border-bottom-style: hidden; }}`, i += `@keyframes ${n} { 50% {  box-shadow: none; }}`, i += `@keyframes ${o} { 0% {  background-color: ${e.cursor.css};  color: ${e.cursorAccent.css}; } 50% {  background-color: inherit;  color: ${e.cursor.css}; }}`, i += `${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le}.${$5c2a9584e51cbabf$var$ki} .xterm-cursor.xterm-cursor-blink.xterm-cursor-underline { animation: ${r} 1s step-end infinite;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le}.${$5c2a9584e51cbabf$var$ki} .xterm-cursor.xterm-cursor-blink.xterm-cursor-bar { animation: ${n} 1s step-end infinite;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le}.${$5c2a9584e51cbabf$var$ki} .xterm-cursor.xterm-cursor-blink.xterm-cursor-block { animation: ${o} 1s step-end infinite;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-cursor.xterm-cursor-block { background-color: ${e.cursor.css}; color: ${e.cursorAccent.css};}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-cursor.xterm-cursor-block:not(.xterm-cursor-blink) { background-color: ${e.cursor.css} !important; color: ${e.cursorAccent.css} !important;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-cursor.xterm-cursor-outline { outline: 1px solid ${e.cursor.css}; outline-offset: -1px;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-cursor.xterm-cursor-bar { box-shadow: ${this._optionsService.rawOptions.cursorWidth}px 0 0 ${e.cursor.css} inset;}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Le} .xterm-cursor.xterm-cursor-underline { border-bottom: 1px ${e.cursor.css}; border-bottom-style: solid; height: calc(100% - 1px);}`, i += `${this._terminalSelector} .${$5c2a9584e51cbabf$var$Xr} { position: absolute; top: 0; left: 0; z-index: 1; pointer-events: none;}${this._terminalSelector}.focus .${$5c2a9584e51cbabf$var$Xr} div { position: absolute; background-color: ${e.selectionBackgroundOpaque.css};}${this._terminalSelector} .${$5c2a9584e51cbabf$var$Xr} div { position: absolute; background-color: ${e.selectionInactiveBackgroundOpaque.css};}`;
        for (let [l, a] of e.ansi.entries())i += `${this._terminalSelector} .${$5c2a9584e51cbabf$var$jr}${l} { color: ${a.css}; }${this._terminalSelector} .${$5c2a9584e51cbabf$var$jr}${l}.xterm-dim { color: ${$5c2a9584e51cbabf$var$U.multiplyOpacity(a, .5).css}; }${this._terminalSelector} .${$5c2a9584e51cbabf$var$jo}${l} { background-color: ${a.css}; }`;
        i += `${this._terminalSelector} .${$5c2a9584e51cbabf$var$jr}${257} { color: ${$5c2a9584e51cbabf$var$U.opaque(e.background).css}; }${this._terminalSelector} .${$5c2a9584e51cbabf$var$jr}${257}.xterm-dim { color: ${$5c2a9584e51cbabf$var$U.multiplyOpacity($5c2a9584e51cbabf$var$U.opaque(e.background), .5).css}; }${this._terminalSelector} .${$5c2a9584e51cbabf$var$jo}${257} { background-color: ${e.foreground.css}; }`, this._themeStyleElement.textContent = i;
    }
    _setDefaultSpacing() {
        let e = this.dimensions.css.cell.width - this._widthCache.get("W", !1, !1);
        this._rowContainer.style.letterSpacing = `${e}px`, this._rowFactory.defaultSpacing = e;
    }
    handleDevicePixelRatioChange() {
        this._updateDimensions(), this._widthCache.clear(), this._setDefaultSpacing();
    }
    _refreshRowElements(e, i) {
        for(let r = this._rowElements.length; r <= i; r++){
            let n = this._document.createElement("div");
            this._rowContainer.appendChild(n), this._rowElements.push(n);
        }
        for(; this._rowElements.length > i;)this._rowContainer.removeChild(this._rowElements.pop());
    }
    handleResize(e, i) {
        this._refreshRowElements(e, i), this._updateDimensions(), this.handleSelectionChanged(this._selectionRenderModel.selectionStart, this._selectionRenderModel.selectionEnd, this._selectionRenderModel.columnSelectMode);
    }
    handleCharSizeChanged() {
        this._updateDimensions(), this._widthCache.clear(), this._setDefaultSpacing();
    }
    handleBlur() {
        this._rowContainer.classList.remove($5c2a9584e51cbabf$var$ki), this.renderRows(0, this._bufferService.rows - 1);
    }
    handleFocus() {
        this._rowContainer.classList.add($5c2a9584e51cbabf$var$ki), this.renderRows(this._bufferService.buffer.y, this._bufferService.buffer.y);
    }
    handleSelectionChanged(e, i, r) {
        if (this._selectionContainer.replaceChildren(), this._rowFactory.handleSelectionChanged(e, i, r), this.renderRows(0, this._bufferService.rows - 1), !e || !i || (this._selectionRenderModel.update(this._terminal, e, i, r), !this._selectionRenderModel.hasSelection)) return;
        let n = this._selectionRenderModel.viewportStartRow, o = this._selectionRenderModel.viewportEndRow, l = this._selectionRenderModel.viewportCappedStartRow, a = this._selectionRenderModel.viewportCappedEndRow, u = this._document.createDocumentFragment();
        if (r) {
            let h = e[0] > i[0];
            u.appendChild(this._createSelectionElement(l, h ? i[0] : e[0], h ? e[0] : i[0], a - l + 1));
        } else {
            let h = n === l ? e[0] : 0, c = l === o ? i[0] : this._bufferService.cols;
            u.appendChild(this._createSelectionElement(l, h, c));
            let d = a - l - 1;
            if (u.appendChild(this._createSelectionElement(l + 1, 0, this._bufferService.cols, d)), l !== a) {
                let _ = o === a ? i[0] : this._bufferService.cols;
                u.appendChild(this._createSelectionElement(a, 0, _));
            }
        }
        this._selectionContainer.appendChild(u);
    }
    _createSelectionElement(e, i, r, n = 1) {
        let o = this._document.createElement("div"), l = i * this.dimensions.css.cell.width, a = this.dimensions.css.cell.width * (r - i);
        return l + a > this.dimensions.css.canvas.width && (a = this.dimensions.css.canvas.width - l), o.style.height = `${n * this.dimensions.css.cell.height}px`, o.style.top = `${e * this.dimensions.css.cell.height}px`, o.style.left = `${l}px`, o.style.width = `${a}px`, o;
    }
    handleCursorMove() {}
    _handleOptionsChanged() {
        this._updateDimensions(), this._injectCss(this._themeService.colors), this._widthCache.setFont(this._optionsService.rawOptions.fontFamily, this._optionsService.rawOptions.fontSize, this._optionsService.rawOptions.fontWeight, this._optionsService.rawOptions.fontWeightBold), this._setDefaultSpacing();
    }
    clear() {
        for (let e of this._rowElements)e.replaceChildren();
    }
    renderRows(e, i) {
        let r = this._bufferService.buffer, n = r.ybase + r.y, o = Math.min(r.x, this._bufferService.cols - 1), l = this._coreService.decPrivateModes.cursorBlink ?? this._optionsService.rawOptions.cursorBlink, a = this._coreService.decPrivateModes.cursorStyle ?? this._optionsService.rawOptions.cursorStyle, u = this._optionsService.rawOptions.cursorInactiveStyle;
        for(let h = e; h <= i; h++){
            let c = h + r.ydisp, d = this._rowElements[h], _ = r.lines.get(c);
            if (!d || !_) break;
            d.replaceChildren(...this._rowFactory.createRow(_, c, c === n, a, u, o, l, this.dimensions.css.cell.width, this._widthCache, -1, -1));
        }
    }
    get _terminalSelector() {
        return `.${$5c2a9584e51cbabf$var$_s}${this._terminalClass}`;
    }
    _handleLinkHover(e) {
        this._setCellUnderline(e.x1, e.x2, e.y1, e.y2, e.cols, !0);
    }
    _handleLinkLeave(e) {
        this._setCellUnderline(e.x1, e.x2, e.y1, e.y2, e.cols, !1);
    }
    _setCellUnderline(e, i, r, n, o, l) {
        r < 0 && (e = 0), n < 0 && (i = 0);
        let a = this._bufferService.rows - 1;
        r = Math.max(Math.min(r, a), 0), n = Math.max(Math.min(n, a), 0), o = Math.min(o, this._bufferService.cols);
        let u = this._bufferService.buffer, h = u.ybase + u.y, c = Math.min(u.x, o - 1), d = this._optionsService.rawOptions.cursorBlink, _ = this._optionsService.rawOptions.cursorStyle, p = this._optionsService.rawOptions.cursorInactiveStyle;
        for(let m = r; m <= n; ++m){
            let f = m + u.ydisp, A = this._rowElements[m], R = u.lines.get(f);
            if (!A || !R) break;
            A.replaceChildren(...this._rowFactory.createRow(R, f, f === h, _, p, c, d, this.dimensions.css.cell.width, this._widthCache, l ? m === r ? e : 0 : -1, l ? (m === n ? i : o) - 1 : -1));
        }
    }
};
$5c2a9584e51cbabf$var$Yt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(7, $5c2a9584e51cbabf$var$xt),
    $5c2a9584e51cbabf$var$S(8, $5c2a9584e51cbabf$var$nt),
    $5c2a9584e51cbabf$var$S(9, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(10, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(11, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(12, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(13, $5c2a9584e51cbabf$var$Re)
], $5c2a9584e51cbabf$var$Yt);
var $5c2a9584e51cbabf$var$jt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r){
        super();
        this._optionsService = r;
        this.width = 0;
        this.height = 0;
        this._onCharSizeChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onCharSizeChange = this._onCharSizeChange.event;
        try {
            this._measureStrategy = this._register(new $5c2a9584e51cbabf$var$vs(this._optionsService));
        } catch  {
            this._measureStrategy = this._register(new $5c2a9584e51cbabf$var$bs(e, i, this._optionsService));
        }
        this._register(this._optionsService.onMultipleOptionChange([
            "fontFamily",
            "fontSize"
        ], ()=>this.measure()));
    }
    get hasValidSize() {
        return this.width > 0 && this.height > 0;
    }
    measure() {
        let e = this._measureStrategy.measure();
        (e.width !== this.width || e.height !== this.height) && (this.width = e.width, this.height = e.height, this._onCharSizeChange.fire());
    }
};
$5c2a9584e51cbabf$var$jt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$jt);
var $5c2a9584e51cbabf$var$Zr = class extends $5c2a9584e51cbabf$var$D {
    constructor(){
        super(...arguments);
        this._result = {
            width: 0,
            height: 0
        };
    }
    _validateAndSet(e, i) {
        e !== void 0 && e > 0 && i !== void 0 && i > 0 && (this._result.width = e, this._result.height = i);
    }
}, $5c2a9584e51cbabf$var$bs = class extends $5c2a9584e51cbabf$var$Zr {
    constructor(e, i, r){
        super();
        this._document = e;
        this._parentElement = i;
        this._optionsService = r;
        this._measureElement = this._document.createElement("span"), this._measureElement.classList.add("xterm-char-measure-element"), this._measureElement.textContent = "W".repeat(32), this._measureElement.setAttribute("aria-hidden", "true"), this._measureElement.style.whiteSpace = "pre", this._measureElement.style.fontKerning = "none", this._parentElement.appendChild(this._measureElement);
    }
    measure() {
        return this._measureElement.style.fontFamily = this._optionsService.rawOptions.fontFamily, this._measureElement.style.fontSize = `${this._optionsService.rawOptions.fontSize}px`, this._validateAndSet(Number(this._measureElement.offsetWidth) / 32, Number(this._measureElement.offsetHeight)), this._result;
    }
}, $5c2a9584e51cbabf$var$vs = class extends $5c2a9584e51cbabf$var$Zr {
    constructor(e){
        super();
        this._optionsService = e;
        this._canvas = new OffscreenCanvas(100, 100), this._ctx = this._canvas.getContext("2d");
        let i = this._ctx.measureText("W");
        if (!("width" in i && "fontBoundingBoxAscent" in i && "fontBoundingBoxDescent" in i)) throw new Error("Required font metrics not supported");
    }
    measure() {
        this._ctx.font = `${this._optionsService.rawOptions.fontSize}px ${this._optionsService.rawOptions.fontFamily}`;
        let e = this._ctx.measureText("W");
        return this._validateAndSet(e.width, e.fontBoundingBoxAscent + e.fontBoundingBoxDescent), this._result;
    }
};
var $5c2a9584e51cbabf$var$Jr = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r){
        super();
        this._textarea = e;
        this._window = i;
        this.mainDocument = r;
        this._isFocused = !1;
        this._cachedIsFocused = void 0;
        this._screenDprMonitor = this._register(new $5c2a9584e51cbabf$var$gs(this._window));
        this._onDprChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDprChange = this._onDprChange.event;
        this._onWindowChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onWindowChange = this._onWindowChange.event;
        this._register(this.onWindowChange((n)=>this._screenDprMonitor.setWindow(n))), this._register($5c2a9584e51cbabf$var$$.forward(this._screenDprMonitor.onDprChange, this._onDprChange)), this._register($5c2a9584e51cbabf$var$L(this._textarea, "focus", ()=>this._isFocused = !0)), this._register($5c2a9584e51cbabf$var$L(this._textarea, "blur", ()=>this._isFocused = !1));
    }
    get window() {
        return this._window;
    }
    set window(e) {
        this._window !== e && (this._window = e, this._onWindowChange.fire(this._window));
    }
    get dpr() {
        return this.window.devicePixelRatio;
    }
    get isFocused() {
        return this._cachedIsFocused === void 0 && (this._cachedIsFocused = this._isFocused && this._textarea.ownerDocument.hasFocus(), queueMicrotask(()=>this._cachedIsFocused = void 0)), this._cachedIsFocused;
    }
}, $5c2a9584e51cbabf$var$gs = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._parentWindow = e;
        this._windowResizeListener = this._register(new $5c2a9584e51cbabf$var$ye);
        this._onDprChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDprChange = this._onDprChange.event;
        this._outerListener = ()=>this._setDprAndFireIfDiffers(), this._currentDevicePixelRatio = this._parentWindow.devicePixelRatio, this._updateDpr(), this._setWindowResizeListener(), this._register($5c2a9584e51cbabf$var$C(()=>this.clearListener()));
    }
    setWindow(e) {
        this._parentWindow = e, this._setWindowResizeListener(), this._setDprAndFireIfDiffers();
    }
    _setWindowResizeListener() {
        this._windowResizeListener.value = $5c2a9584e51cbabf$var$L(this._parentWindow, "resize", ()=>this._setDprAndFireIfDiffers());
    }
    _setDprAndFireIfDiffers() {
        this._parentWindow.devicePixelRatio !== this._currentDevicePixelRatio && this._onDprChange.fire(this._parentWindow.devicePixelRatio), this._updateDpr();
    }
    _updateDpr() {
        this._outerListener && (this._resolutionMediaMatchList?.removeListener(this._outerListener), this._currentDevicePixelRatio = this._parentWindow.devicePixelRatio, this._resolutionMediaMatchList = this._parentWindow.matchMedia(`screen and (resolution: ${this._parentWindow.devicePixelRatio}dppx)`), this._resolutionMediaMatchList.addListener(this._outerListener));
    }
    clearListener() {
        !this._resolutionMediaMatchList || !this._outerListener || (this._resolutionMediaMatchList.removeListener(this._outerListener), this._resolutionMediaMatchList = void 0, this._outerListener = void 0);
    }
};
var $5c2a9584e51cbabf$var$Qr = class extends $5c2a9584e51cbabf$var$D {
    constructor(){
        super();
        this.linkProviders = [];
        this._register($5c2a9584e51cbabf$var$C(()=>this.linkProviders.length = 0));
    }
    registerLinkProvider(e) {
        return this.linkProviders.push(e), {
            dispose: ()=>{
                let i = this.linkProviders.indexOf(e);
                i !== -1 && this.linkProviders.splice(i, 1);
            }
        };
    }
};
function $5c2a9584e51cbabf$var$Ci(s, t1, e) {
    let i = e.getBoundingClientRect(), r = s.getComputedStyle(e), n = parseInt(r.getPropertyValue("padding-left")), o = parseInt(r.getPropertyValue("padding-top"));
    return [
        t1.clientX - i.left - n,
        t1.clientY - i.top - o
    ];
}
function $5c2a9584e51cbabf$var$Xo(s, t1, e, i, r, n, o, l, a) {
    if (!n) return;
    let u = $5c2a9584e51cbabf$var$Ci(s, t1, e);
    if (u) return u[0] = Math.ceil((u[0] + (a ? o / 2 : 0)) / o), u[1] = Math.ceil(u[1] / l), u[0] = Math.min(Math.max(u[0], 1), i + (a ? 1 : 0)), u[1] = Math.min(Math.max(u[1], 1), r), u;
}
var $5c2a9584e51cbabf$var$Xt = class {
    constructor(t1, e){
        this._renderService = t1;
        this._charSizeService = e;
    }
    getCoords(t1, e, i, r, n) {
        return $5c2a9584e51cbabf$var$Xo(window, t1, e, i, r, this._charSizeService.hasValidSize, this._renderService.dimensions.css.cell.width, this._renderService.dimensions.css.cell.height, n);
    }
    getMouseReportCoords(t1, e) {
        let i = $5c2a9584e51cbabf$var$Ci(window, t1, e);
        if (this._charSizeService.hasValidSize) return i[0] = Math.min(Math.max(i[0], 0), this._renderService.dimensions.css.canvas.width - 1), i[1] = Math.min(Math.max(i[1], 0), this._renderService.dimensions.css.canvas.height - 1), {
            col: Math.floor(i[0] / this._renderService.dimensions.css.cell.width),
            row: Math.floor(i[1] / this._renderService.dimensions.css.cell.height),
            x: Math.floor(i[0]),
            y: Math.floor(i[1])
        };
    }
};
$5c2a9584e51cbabf$var$Xt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$ce),
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$nt)
], $5c2a9584e51cbabf$var$Xt);
var $5c2a9584e51cbabf$var$en = class {
    constructor(t1, e){
        this._renderCallback = t1;
        this._coreBrowserService = e;
        this._refreshCallbacks = [];
    }
    dispose() {
        this._animationFrame && (this._coreBrowserService.window.cancelAnimationFrame(this._animationFrame), this._animationFrame = void 0);
    }
    addRefreshCallback(t1) {
        return this._refreshCallbacks.push(t1), this._animationFrame || (this._animationFrame = this._coreBrowserService.window.requestAnimationFrame(()=>this._innerRefresh())), this._animationFrame;
    }
    refresh(t1, e, i) {
        this._rowCount = i, t1 = t1 !== void 0 ? t1 : 0, e = e !== void 0 ? e : this._rowCount - 1, this._rowStart = this._rowStart !== void 0 ? Math.min(this._rowStart, t1) : t1, this._rowEnd = this._rowEnd !== void 0 ? Math.max(this._rowEnd, e) : e, !this._animationFrame && (this._animationFrame = this._coreBrowserService.window.requestAnimationFrame(()=>this._innerRefresh()));
    }
    _innerRefresh() {
        if (this._animationFrame = void 0, this._rowStart === void 0 || this._rowEnd === void 0 || this._rowCount === void 0) {
            this._runRefreshCallbacks();
            return;
        }
        let t1 = Math.max(this._rowStart, 0), e = Math.min(this._rowEnd, this._rowCount - 1);
        this._rowStart = void 0, this._rowEnd = void 0, this._renderCallback(t1, e), this._runRefreshCallbacks();
    }
    _runRefreshCallbacks() {
        for (let t1 of this._refreshCallbacks)t1(0);
        this._refreshCallbacks = [];
    }
};
var $5c2a9584e51cbabf$var$tn = {};
$5c2a9584e51cbabf$var$Ll($5c2a9584e51cbabf$var$tn, {
    getSafariVersion: ()=>$5c2a9584e51cbabf$var$Ha,
    isChromeOS: ()=>$5c2a9584e51cbabf$var$Ts,
    isFirefox: ()=>$5c2a9584e51cbabf$var$Ss,
    isIpad: ()=>$5c2a9584e51cbabf$var$Wa,
    isIphone: ()=>$5c2a9584e51cbabf$var$Ua,
    isLegacyEdge: ()=>$5c2a9584e51cbabf$var$Fa,
    isLinux: ()=>$5c2a9584e51cbabf$var$Bi,
    isMac: ()=>$5c2a9584e51cbabf$var$Zt,
    isNode: ()=>$5c2a9584e51cbabf$var$Mi,
    isSafari: ()=>$5c2a9584e51cbabf$var$Zo,
    isWindows: ()=>$5c2a9584e51cbabf$var$Es
});
var $5c2a9584e51cbabf$var$Mi = false, $5c2a9584e51cbabf$var$Pi = $5c2a9584e51cbabf$var$Mi ? "node" : navigator.userAgent, $5c2a9584e51cbabf$var$Oi = $5c2a9584e51cbabf$var$Mi ? "node" : navigator.platform, $5c2a9584e51cbabf$var$Ss = $5c2a9584e51cbabf$var$Pi.includes("Firefox"), $5c2a9584e51cbabf$var$Fa = $5c2a9584e51cbabf$var$Pi.includes("Edge"), $5c2a9584e51cbabf$var$Zo = /^((?!chrome|android).)*safari/i.test($5c2a9584e51cbabf$var$Pi);
function $5c2a9584e51cbabf$var$Ha() {
    if (!$5c2a9584e51cbabf$var$Zo) return 0;
    let s = $5c2a9584e51cbabf$var$Pi.match(/Version\/(\d+)/);
    return s === null || s.length < 2 ? 0 : parseInt(s[1]);
}
var $5c2a9584e51cbabf$var$Zt = [
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K"
].includes($5c2a9584e51cbabf$var$Oi), $5c2a9584e51cbabf$var$Wa = $5c2a9584e51cbabf$var$Oi === "iPad", $5c2a9584e51cbabf$var$Ua = $5c2a9584e51cbabf$var$Oi === "iPhone", $5c2a9584e51cbabf$var$Es = [
    "Windows",
    "Win16",
    "Win32",
    "WinCE"
].includes($5c2a9584e51cbabf$var$Oi), $5c2a9584e51cbabf$var$Bi = $5c2a9584e51cbabf$var$Oi.indexOf("Linux") >= 0, $5c2a9584e51cbabf$var$Ts = /\bCrOS\b/.test($5c2a9584e51cbabf$var$Pi);
var $5c2a9584e51cbabf$var$rn = class {
    constructor(){
        this._tasks = [];
        this._i = 0;
    }
    enqueue(t1) {
        this._tasks.push(t1), this._start();
    }
    flush() {
        for(; this._i < this._tasks.length;)this._tasks[this._i]() || this._i++;
        this.clear();
    }
    clear() {
        this._idleCallback && (this._cancelCallback(this._idleCallback), this._idleCallback = void 0), this._i = 0, this._tasks.length = 0;
    }
    _start() {
        this._idleCallback || (this._idleCallback = this._requestCallback(this._process.bind(this)));
    }
    _process(t1) {
        this._idleCallback = void 0;
        let e = 0, i = 0, r = t1.timeRemaining(), n = 0;
        for(; this._i < this._tasks.length;){
            if (e = performance.now(), this._tasks[this._i]() || this._i++, e = Math.max(1, performance.now() - e), i = Math.max(e, i), n = t1.timeRemaining(), i * 1.5 > n) {
                r - e < -20 && console.warn(`task queue exceeded allotted deadline by ${Math.abs(Math.round(r - e))}ms`), this._start();
                return;
            }
            r = n;
        }
        this.clear();
    }
}, $5c2a9584e51cbabf$var$Is = class extends $5c2a9584e51cbabf$var$rn {
    _requestCallback(t1) {
        return setTimeout(()=>t1(this._createDeadline(16)));
    }
    _cancelCallback(t1) {
        clearTimeout(t1);
    }
    _createDeadline(t1) {
        let e = performance.now() + t1;
        return {
            timeRemaining: ()=>Math.max(0, e - performance.now())
        };
    }
}, $5c2a9584e51cbabf$var$ys = class extends $5c2a9584e51cbabf$var$rn {
    _requestCallback(t1) {
        return requestIdleCallback(t1);
    }
    _cancelCallback(t1) {
        cancelIdleCallback(t1);
    }
}, $5c2a9584e51cbabf$var$Jt = !$5c2a9584e51cbabf$var$Mi && "requestIdleCallback" in window ? $5c2a9584e51cbabf$var$ys : $5c2a9584e51cbabf$var$Is, $5c2a9584e51cbabf$var$nn = class {
    constructor(){
        this._queue = new $5c2a9584e51cbabf$var$Jt;
    }
    set(t1) {
        this._queue.clear(), this._queue.enqueue(t1);
    }
    flush() {
        this._queue.flush();
    }
};
var $5c2a9584e51cbabf$var$Qt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u, h){
        super();
        this._rowCount = e;
        this._optionsService = r;
        this._charSizeService = n;
        this._coreService = o;
        this._coreBrowserService = u;
        this._renderer = this._register(new $5c2a9584e51cbabf$var$ye);
        this._pausedResizeTask = new $5c2a9584e51cbabf$var$nn;
        this._observerDisposable = this._register(new $5c2a9584e51cbabf$var$ye);
        this._isPaused = !1;
        this._needsFullRefresh = !1;
        this._isNextRenderRedrawOnly = !0;
        this._needsSelectionRefresh = !1;
        this._canvasWidth = 0;
        this._canvasHeight = 0;
        this._selectionState = {
            start: void 0,
            end: void 0,
            columnSelectMode: !1
        };
        this._onDimensionsChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDimensionsChange = this._onDimensionsChange.event;
        this._onRenderedViewportChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRenderedViewportChange = this._onRenderedViewportChange.event;
        this._onRender = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRender = this._onRender.event;
        this._onRefreshRequest = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRefreshRequest = this._onRefreshRequest.event;
        this._renderDebouncer = new $5c2a9584e51cbabf$var$en((c, d)=>this._renderRows(c, d), this._coreBrowserService), this._register(this._renderDebouncer), this._syncOutputHandler = new $5c2a9584e51cbabf$var$xs(this._coreBrowserService, this._coreService, ()=>this._fullRefresh()), this._register($5c2a9584e51cbabf$var$C(()=>this._syncOutputHandler.dispose())), this._register(this._coreBrowserService.onDprChange(()=>this.handleDevicePixelRatioChange())), this._register(a.onResize(()=>this._fullRefresh())), this._register(a.buffers.onBufferActivate(()=>this._renderer.value?.clear())), this._register(this._optionsService.onOptionChange(()=>this._handleOptionsChanged())), this._register(this._charSizeService.onCharSizeChange(()=>this.handleCharSizeChanged())), this._register(l.onDecorationRegistered(()=>this._fullRefresh())), this._register(l.onDecorationRemoved(()=>this._fullRefresh())), this._register(this._optionsService.onMultipleOptionChange([
            "customGlyphs",
            "drawBoldTextInBrightColors",
            "letterSpacing",
            "lineHeight",
            "fontFamily",
            "fontSize",
            "fontWeight",
            "fontWeightBold",
            "minimumContrastRatio",
            "rescaleOverlappingGlyphs"
        ], ()=>{
            this.clear(), this.handleResize(a.cols, a.rows), this._fullRefresh();
        })), this._register(this._optionsService.onMultipleOptionChange([
            "cursorBlink",
            "cursorStyle"
        ], ()=>this.refreshRows(a.buffer.y, a.buffer.y, !0))), this._register(h.onChangeColors(()=>this._fullRefresh())), this._registerIntersectionObserver(this._coreBrowserService.window, i), this._register(this._coreBrowserService.onWindowChange((c)=>this._registerIntersectionObserver(c, i)));
    }
    get dimensions() {
        return this._renderer.value.dimensions;
    }
    _registerIntersectionObserver(e, i) {
        if ("IntersectionObserver" in e) {
            let r = new e.IntersectionObserver((n)=>this._handleIntersectionChange(n[n.length - 1]), {
                threshold: 0
            });
            r.observe(i), this._observerDisposable.value = $5c2a9584e51cbabf$var$C(()=>r.disconnect());
        }
    }
    _handleIntersectionChange(e) {
        this._isPaused = e.isIntersecting === void 0 ? e.intersectionRatio === 0 : !e.isIntersecting, !this._isPaused && !this._charSizeService.hasValidSize && this._charSizeService.measure(), !this._isPaused && this._needsFullRefresh && (this._pausedResizeTask.flush(), this.refreshRows(0, this._rowCount - 1), this._needsFullRefresh = !1);
    }
    refreshRows(e, i, r = !1) {
        if (this._isPaused) {
            this._needsFullRefresh = !0;
            return;
        }
        if (this._coreService.decPrivateModes.synchronizedOutput) {
            this._syncOutputHandler.bufferRows(e, i);
            return;
        }
        let n = this._syncOutputHandler.flush();
        n && (e = Math.min(e, n.start), i = Math.max(i, n.end)), r || (this._isNextRenderRedrawOnly = !1), this._renderDebouncer.refresh(e, i, this._rowCount);
    }
    _renderRows(e, i) {
        if (this._renderer.value) {
            if (this._coreService.decPrivateModes.synchronizedOutput) {
                this._syncOutputHandler.bufferRows(e, i);
                return;
            }
            e = Math.min(e, this._rowCount - 1), i = Math.min(i, this._rowCount - 1), this._renderer.value.renderRows(e, i), this._needsSelectionRefresh && (this._renderer.value.handleSelectionChanged(this._selectionState.start, this._selectionState.end, this._selectionState.columnSelectMode), this._needsSelectionRefresh = !1), this._isNextRenderRedrawOnly || this._onRenderedViewportChange.fire({
                start: e,
                end: i
            }), this._onRender.fire({
                start: e,
                end: i
            }), this._isNextRenderRedrawOnly = !0;
        }
    }
    resize(e, i) {
        this._rowCount = i, this._fireOnCanvasResize();
    }
    _handleOptionsChanged() {
        this._renderer.value && (this.refreshRows(0, this._rowCount - 1), this._fireOnCanvasResize());
    }
    _fireOnCanvasResize() {
        this._renderer.value && (this._renderer.value.dimensions.css.canvas.width === this._canvasWidth && this._renderer.value.dimensions.css.canvas.height === this._canvasHeight || this._onDimensionsChange.fire(this._renderer.value.dimensions));
    }
    hasRenderer() {
        return !!this._renderer.value;
    }
    setRenderer(e) {
        this._renderer.value = e, this._renderer.value && (this._renderer.value.onRequestRedraw((i)=>this.refreshRows(i.start, i.end, !0)), this._needsSelectionRefresh = !0, this._fullRefresh());
    }
    addRefreshCallback(e) {
        return this._renderDebouncer.addRefreshCallback(e);
    }
    _fullRefresh() {
        this._isPaused ? this._needsFullRefresh = !0 : this.refreshRows(0, this._rowCount - 1);
    }
    clearTextureAtlas() {
        this._renderer.value && (this._renderer.value.clearTextureAtlas?.(), this._fullRefresh());
    }
    handleDevicePixelRatioChange() {
        this._charSizeService.measure(), this._renderer.value && (this._renderer.value.handleDevicePixelRatioChange(), this.refreshRows(0, this._rowCount - 1));
    }
    handleResize(e, i) {
        this._renderer.value && (this._isPaused ? this._pausedResizeTask.set(()=>this._renderer.value?.handleResize(e, i)) : this._renderer.value.handleResize(e, i), this._fullRefresh());
    }
    handleCharSizeChanged() {
        this._renderer.value?.handleCharSizeChanged();
    }
    handleBlur() {
        this._renderer.value?.handleBlur();
    }
    handleFocus() {
        this._renderer.value?.handleFocus();
    }
    handleSelectionChanged(e, i, r) {
        this._selectionState.start = e, this._selectionState.end = i, this._selectionState.columnSelectMode = r, this._renderer.value?.handleSelectionChanged(e, i, r);
    }
    handleCursorMove() {
        this._renderer.value?.handleCursorMove();
    }
    clear() {
        this._renderer.value?.clear();
    }
};
$5c2a9584e51cbabf$var$Qt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$nt),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$Be),
    $5c2a9584e51cbabf$var$S(6, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(7, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(8, $5c2a9584e51cbabf$var$Re)
], $5c2a9584e51cbabf$var$Qt);
var $5c2a9584e51cbabf$var$xs = class {
    constructor(t1, e, i){
        this._coreBrowserService = t1;
        this._coreService = e;
        this._onTimeout = i;
        this._start = 0;
        this._end = 0;
        this._isBuffering = !1;
    }
    bufferRows(t1, e) {
        this._isBuffering ? (this._start = Math.min(this._start, t1), this._end = Math.max(this._end, e)) : (this._start = t1, this._end = e, this._isBuffering = !0), this._timeout === void 0 && (this._timeout = this._coreBrowserService.window.setTimeout(()=>{
            this._timeout = void 0, this._coreService.decPrivateModes.synchronizedOutput = !1, this._onTimeout();
        }, 1e3));
    }
    flush() {
        if (this._timeout !== void 0 && (this._coreBrowserService.window.clearTimeout(this._timeout), this._timeout = void 0), !this._isBuffering) return;
        let t1 = {
            start: this._start,
            end: this._end
        };
        return this._isBuffering = !1, t1;
    }
    dispose() {
        this._timeout !== void 0 && (this._coreBrowserService.window.clearTimeout(this._timeout), this._timeout = void 0);
    }
};
function $5c2a9584e51cbabf$var$Jo(s, t1, e, i) {
    let r = e.buffer.x, n = e.buffer.y;
    if (!e.buffer.hasScrollback) return $5c2a9584e51cbabf$var$Ga(r, n, s, t1, e, i) + $5c2a9584e51cbabf$var$sn(n, t1, e, i) + $5c2a9584e51cbabf$var$$a(r, n, s, t1, e, i);
    let o;
    if (n === t1) return o = r > s ? "D" : "C", $5c2a9584e51cbabf$var$Fi(Math.abs(r - s), $5c2a9584e51cbabf$var$Ni(o, i));
    o = n > t1 ? "D" : "C";
    let l = Math.abs(n - t1), a = $5c2a9584e51cbabf$var$za(n > t1 ? s : r, e) + (l - 1) * e.cols + 1 + $5c2a9584e51cbabf$var$Ka(n > t1 ? r : s, e);
    return $5c2a9584e51cbabf$var$Fi(a, $5c2a9584e51cbabf$var$Ni(o, i));
}
function $5c2a9584e51cbabf$var$Ka(s, t1) {
    return s - 1;
}
function $5c2a9584e51cbabf$var$za(s, t1) {
    return t1.cols - s;
}
function $5c2a9584e51cbabf$var$Ga(s, t1, e, i, r, n) {
    return $5c2a9584e51cbabf$var$sn(t1, i, r, n).length === 0 ? "" : $5c2a9584e51cbabf$var$Fi($5c2a9584e51cbabf$var$el(s, t1, s, t1 - $5c2a9584e51cbabf$var$gt(t1, r), !1, r).length, $5c2a9584e51cbabf$var$Ni("D", n));
}
function $5c2a9584e51cbabf$var$sn(s, t1, e, i) {
    let r = s - $5c2a9584e51cbabf$var$gt(s, e), n = t1 - $5c2a9584e51cbabf$var$gt(t1, e), o = Math.abs(r - n) - $5c2a9584e51cbabf$var$Va(s, t1, e);
    return $5c2a9584e51cbabf$var$Fi(o, $5c2a9584e51cbabf$var$Ni($5c2a9584e51cbabf$var$Qo(s, t1), i));
}
function $5c2a9584e51cbabf$var$$a(s, t1, e, i, r, n) {
    let o;
    $5c2a9584e51cbabf$var$sn(t1, i, r, n).length > 0 ? o = i - $5c2a9584e51cbabf$var$gt(i, r) : o = t1;
    let l = i, a = $5c2a9584e51cbabf$var$qa(s, t1, e, i, r, n);
    return $5c2a9584e51cbabf$var$Fi($5c2a9584e51cbabf$var$el(s, o, e, l, a === "C", r).length, $5c2a9584e51cbabf$var$Ni(a, n));
}
function $5c2a9584e51cbabf$var$Va(s, t1, e) {
    let i = 0, r = s - $5c2a9584e51cbabf$var$gt(s, e), n = t1 - $5c2a9584e51cbabf$var$gt(t1, e);
    for(let o = 0; o < Math.abs(r - n); o++){
        let l = $5c2a9584e51cbabf$var$Qo(s, t1) === "A" ? -1 : 1;
        e.buffer.lines.get(r + l * o)?.isWrapped && i++;
    }
    return i;
}
function $5c2a9584e51cbabf$var$gt(s, t1) {
    let e = 0, i = t1.buffer.lines.get(s), r = i?.isWrapped;
    for(; r && s >= 0 && s < t1.rows;)e++, i = t1.buffer.lines.get(--s), r = i?.isWrapped;
    return e;
}
function $5c2a9584e51cbabf$var$qa(s, t1, e, i, r, n) {
    let o;
    return $5c2a9584e51cbabf$var$sn(e, i, r, n).length > 0 ? o = i - $5c2a9584e51cbabf$var$gt(i, r) : o = t1, s < e && o <= i || s >= e && o < i ? "C" : "D";
}
function $5c2a9584e51cbabf$var$Qo(s, t1) {
    return s > t1 ? "A" : "B";
}
function $5c2a9584e51cbabf$var$el(s, t1, e, i, r, n) {
    let o = s, l = t1, a = "";
    for(; (o !== e || l !== i) && l >= 0 && l < n.buffer.lines.length;)o += r ? 1 : -1, r && o > n.cols - 1 ? (a += n.buffer.translateBufferLineToString(l, !1, s, o), o = 0, s = 0, l++) : !r && o < 0 && (a += n.buffer.translateBufferLineToString(l, !1, 0, s + 1), o = n.cols - 1, s = o, l--);
    return a + n.buffer.translateBufferLineToString(l, !1, s, o);
}
function $5c2a9584e51cbabf$var$Ni(s, t1) {
    let e = t1 ? "O" : "[";
    return $5c2a9584e51cbabf$var$b.ESC + e + s;
}
function $5c2a9584e51cbabf$var$Fi(s, t1) {
    s = Math.floor(s);
    let e = "";
    for(let i = 0; i < s; i++)e += t1;
    return e;
}
var $5c2a9584e51cbabf$var$on = class {
    constructor(t1){
        this._bufferService = t1;
        this.isSelectAllActive = !1;
        this.selectionStartLength = 0;
    }
    clearSelection() {
        this.selectionStart = void 0, this.selectionEnd = void 0, this.isSelectAllActive = !1, this.selectionStartLength = 0;
    }
    get finalSelectionStart() {
        return this.isSelectAllActive ? [
            0,
            0
        ] : !this.selectionEnd || !this.selectionStart ? this.selectionStart : this.areSelectionValuesReversed() ? this.selectionEnd : this.selectionStart;
    }
    get finalSelectionEnd() {
        if (this.isSelectAllActive) return [
            this._bufferService.cols,
            this._bufferService.buffer.ybase + this._bufferService.rows - 1
        ];
        if (this.selectionStart) {
            if (!this.selectionEnd || this.areSelectionValuesReversed()) {
                let t1 = this.selectionStart[0] + this.selectionStartLength;
                return t1 > this._bufferService.cols ? t1 % this._bufferService.cols === 0 ? [
                    this._bufferService.cols,
                    this.selectionStart[1] + Math.floor(t1 / this._bufferService.cols) - 1
                ] : [
                    t1 % this._bufferService.cols,
                    this.selectionStart[1] + Math.floor(t1 / this._bufferService.cols)
                ] : [
                    t1,
                    this.selectionStart[1]
                ];
            }
            if (this.selectionStartLength && this.selectionEnd[1] === this.selectionStart[1]) {
                let t1 = this.selectionStart[0] + this.selectionStartLength;
                return t1 > this._bufferService.cols ? [
                    t1 % this._bufferService.cols,
                    this.selectionStart[1] + Math.floor(t1 / this._bufferService.cols)
                ] : [
                    Math.max(t1, this.selectionEnd[0]),
                    this.selectionEnd[1]
                ];
            }
            return this.selectionEnd;
        }
    }
    areSelectionValuesReversed() {
        let t1 = this.selectionStart, e = this.selectionEnd;
        return !t1 || !e ? !1 : t1[1] > e[1] || t1[1] === e[1] && t1[0] > e[0];
    }
    handleTrim(t1) {
        return this.selectionStart && (this.selectionStart[1] -= t1), this.selectionEnd && (this.selectionEnd[1] -= t1), this.selectionEnd && this.selectionEnd[1] < 0 ? (this.clearSelection(), !0) : (this.selectionStart && this.selectionStart[1] < 0 && (this.selectionStart[1] = 0), !1);
    }
};
function $5c2a9584e51cbabf$var$ws(s, t1) {
    if (s.start.y > s.end.y) throw new Error(`Buffer range end (${s.end.x}, ${s.end.y}) cannot be before start (${s.start.x}, ${s.start.y})`);
    return t1 * (s.end.y - s.start.y) + (s.end.x - s.start.x + 1);
}
var $5c2a9584e51cbabf$var$Ds = 50, $5c2a9584e51cbabf$var$Ya = 15, $5c2a9584e51cbabf$var$ja = 50, $5c2a9584e51cbabf$var$Xa = 500, $5c2a9584e51cbabf$var$Za = "\xA0", $5c2a9584e51cbabf$var$Ja = new RegExp($5c2a9584e51cbabf$var$Za, "g");
var $5c2a9584e51cbabf$var$ei = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u, h){
        super();
        this._element = e;
        this._screenElement = i;
        this._linkifier = r;
        this._bufferService = n;
        this._coreService = o;
        this._mouseService = l;
        this._optionsService = a;
        this._renderService = u;
        this._coreBrowserService = h;
        this._dragScrollAmount = 0;
        this._enabled = !0;
        this._workCell = new $5c2a9584e51cbabf$var$q;
        this._mouseDownTimeStamp = 0;
        this._oldHasSelection = !1;
        this._oldSelectionStart = void 0;
        this._oldSelectionEnd = void 0;
        this._onLinuxMouseSelection = this._register(new $5c2a9584e51cbabf$var$v);
        this.onLinuxMouseSelection = this._onLinuxMouseSelection.event;
        this._onRedrawRequest = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestRedraw = this._onRedrawRequest.event;
        this._onSelectionChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onSelectionChange = this._onSelectionChange.event;
        this._onRequestScrollLines = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestScrollLines = this._onRequestScrollLines.event;
        this._mouseMoveListener = (c)=>this._handleMouseMove(c), this._mouseUpListener = (c)=>this._handleMouseUp(c), this._coreService.onUserInput(()=>{
            this.hasSelection && this.clearSelection();
        }), this._trimListener = this._bufferService.buffer.lines.onTrim((c)=>this._handleTrim(c)), this._register(this._bufferService.buffers.onBufferActivate((c)=>this._handleBufferActivate(c))), this.enable(), this._model = new $5c2a9584e51cbabf$var$on(this._bufferService), this._activeSelectionMode = 0, this._register($5c2a9584e51cbabf$var$C(()=>{
            this._removeMouseDownListeners();
        })), this._register(this._bufferService.onResize((c)=>{
            c.rowsChanged && this.clearSelection();
        }));
    }
    reset() {
        this.clearSelection();
    }
    disable() {
        this.clearSelection(), this._enabled = !1;
    }
    enable() {
        this._enabled = !0;
    }
    get selectionStart() {
        return this._model.finalSelectionStart;
    }
    get selectionEnd() {
        return this._model.finalSelectionEnd;
    }
    get hasSelection() {
        let e = this._model.finalSelectionStart, i = this._model.finalSelectionEnd;
        return !e || !i ? !1 : e[0] !== i[0] || e[1] !== i[1];
    }
    get selectionText() {
        let e = this._model.finalSelectionStart, i = this._model.finalSelectionEnd;
        if (!e || !i) return "";
        let r = this._bufferService.buffer, n = [];
        if (this._activeSelectionMode === 3) {
            if (e[0] === i[0]) return "";
            let l = e[0] < i[0] ? e[0] : i[0], a = e[0] < i[0] ? i[0] : e[0];
            for(let u = e[1]; u <= i[1]; u++){
                let h = r.translateBufferLineToString(u, !0, l, a);
                n.push(h);
            }
        } else {
            let l = e[1] === i[1] ? i[0] : void 0;
            n.push(r.translateBufferLineToString(e[1], !0, e[0], l));
            for(let a = e[1] + 1; a <= i[1] - 1; a++){
                let u = r.lines.get(a), h = r.translateBufferLineToString(a, !0);
                u?.isWrapped ? n[n.length - 1] += h : n.push(h);
            }
            if (e[1] !== i[1]) {
                let a = r.lines.get(i[1]), u = r.translateBufferLineToString(i[1], !0, 0, i[0]);
                a && a.isWrapped ? n[n.length - 1] += u : n.push(u);
            }
        }
        return n.map((l)=>l.replace($5c2a9584e51cbabf$var$Ja, " ")).join($5c2a9584e51cbabf$var$Es ? `\r
` : `
`);
    }
    clearSelection() {
        this._model.clearSelection(), this._removeMouseDownListeners(), this.refresh(), this._onSelectionChange.fire();
    }
    refresh(e) {
        this._refreshAnimationFrame || (this._refreshAnimationFrame = this._coreBrowserService.window.requestAnimationFrame(()=>this._refresh())), $5c2a9584e51cbabf$var$Bi && e && this.selectionText.length && this._onLinuxMouseSelection.fire(this.selectionText);
    }
    _refresh() {
        this._refreshAnimationFrame = void 0, this._onRedrawRequest.fire({
            start: this._model.finalSelectionStart,
            end: this._model.finalSelectionEnd,
            columnSelectMode: this._activeSelectionMode === 3
        });
    }
    _isClickInSelection(e) {
        let i = this._getMouseBufferCoords(e), r = this._model.finalSelectionStart, n = this._model.finalSelectionEnd;
        return !r || !n || !i ? !1 : this._areCoordsInSelection(i, r, n);
    }
    isCellInSelection(e, i) {
        let r = this._model.finalSelectionStart, n = this._model.finalSelectionEnd;
        return !r || !n ? !1 : this._areCoordsInSelection([
            e,
            i
        ], r, n);
    }
    _areCoordsInSelection(e, i, r) {
        return e[1] > i[1] && e[1] < r[1] || i[1] === r[1] && e[1] === i[1] && e[0] >= i[0] && e[0] < r[0] || i[1] < r[1] && e[1] === r[1] && e[0] < r[0] || i[1] < r[1] && e[1] === i[1] && e[0] >= i[0];
    }
    _selectWordAtCursor(e, i) {
        let r = this._linkifier.currentLink?.link?.range;
        if (r) return this._model.selectionStart = [
            r.start.x - 1,
            r.start.y - 1
        ], this._model.selectionStartLength = $5c2a9584e51cbabf$var$ws(r, this._bufferService.cols), this._model.selectionEnd = void 0, !0;
        let n = this._getMouseBufferCoords(e);
        return n ? (this._selectWordAt(n, i), this._model.selectionEnd = void 0, !0) : !1;
    }
    selectAll() {
        this._model.isSelectAllActive = !0, this.refresh(), this._onSelectionChange.fire();
    }
    selectLines(e, i) {
        this._model.clearSelection(), e = Math.max(e, 0), i = Math.min(i, this._bufferService.buffer.lines.length - 1), this._model.selectionStart = [
            0,
            e
        ], this._model.selectionEnd = [
            this._bufferService.cols,
            i
        ], this.refresh(), this._onSelectionChange.fire();
    }
    _handleTrim(e) {
        this._model.handleTrim(e) && this.refresh();
    }
    _getMouseBufferCoords(e) {
        let i = this._mouseService.getCoords(e, this._screenElement, this._bufferService.cols, this._bufferService.rows, !0);
        if (i) return i[0]--, i[1]--, i[1] += this._bufferService.buffer.ydisp, i;
    }
    _getMouseEventScrollAmount(e) {
        let i = $5c2a9584e51cbabf$var$Ci(this._coreBrowserService.window, e, this._screenElement)[1], r = this._renderService.dimensions.css.canvas.height;
        return i >= 0 && i <= r ? 0 : (i > r && (i -= r), i = Math.min(Math.max(i, -$5c2a9584e51cbabf$var$Ds), $5c2a9584e51cbabf$var$Ds), i /= $5c2a9584e51cbabf$var$Ds, i / Math.abs(i) + Math.round(i * ($5c2a9584e51cbabf$var$Ya - 1)));
    }
    shouldForceSelection(e) {
        return $5c2a9584e51cbabf$var$Zt ? e.altKey && this._optionsService.rawOptions.macOptionClickForcesSelection : e.shiftKey;
    }
    handleMouseDown(e) {
        if (this._mouseDownTimeStamp = e.timeStamp, !(e.button === 2 && this.hasSelection) && e.button === 0) {
            if (!this._enabled) {
                if (!this.shouldForceSelection(e)) return;
                e.stopPropagation();
            }
            e.preventDefault(), this._dragScrollAmount = 0, this._enabled && e.shiftKey ? this._handleIncrementalClick(e) : e.detail === 1 ? this._handleSingleClick(e) : e.detail === 2 ? this._handleDoubleClick(e) : e.detail === 3 && this._handleTripleClick(e), this._addMouseDownListeners(), this.refresh(!0);
        }
    }
    _addMouseDownListeners() {
        this._screenElement.ownerDocument && (this._screenElement.ownerDocument.addEventListener("mousemove", this._mouseMoveListener), this._screenElement.ownerDocument.addEventListener("mouseup", this._mouseUpListener)), this._dragScrollIntervalTimer = this._coreBrowserService.window.setInterval(()=>this._dragScroll(), $5c2a9584e51cbabf$var$ja);
    }
    _removeMouseDownListeners() {
        this._screenElement.ownerDocument && (this._screenElement.ownerDocument.removeEventListener("mousemove", this._mouseMoveListener), this._screenElement.ownerDocument.removeEventListener("mouseup", this._mouseUpListener)), this._coreBrowserService.window.clearInterval(this._dragScrollIntervalTimer), this._dragScrollIntervalTimer = void 0;
    }
    _handleIncrementalClick(e) {
        this._model.selectionStart && (this._model.selectionEnd = this._getMouseBufferCoords(e));
    }
    _handleSingleClick(e) {
        if (this._model.selectionStartLength = 0, this._model.isSelectAllActive = !1, this._activeSelectionMode = this.shouldColumnSelect(e) ? 3 : 0, this._model.selectionStart = this._getMouseBufferCoords(e), !this._model.selectionStart) return;
        this._model.selectionEnd = void 0;
        let i = this._bufferService.buffer.lines.get(this._model.selectionStart[1]);
        i && i.length !== this._model.selectionStart[0] && i.hasWidth(this._model.selectionStart[0]) === 0 && this._model.selectionStart[0]++;
    }
    _handleDoubleClick(e) {
        this._selectWordAtCursor(e, !0) && (this._activeSelectionMode = 1);
    }
    _handleTripleClick(e) {
        let i = this._getMouseBufferCoords(e);
        i && (this._activeSelectionMode = 2, this._selectLineAt(i[1]));
    }
    shouldColumnSelect(e) {
        return e.altKey && !($5c2a9584e51cbabf$var$Zt && this._optionsService.rawOptions.macOptionClickForcesSelection);
    }
    _handleMouseMove(e) {
        if (e.stopImmediatePropagation(), !this._model.selectionStart) return;
        let i = this._model.selectionEnd ? [
            this._model.selectionEnd[0],
            this._model.selectionEnd[1]
        ] : null;
        if (this._model.selectionEnd = this._getMouseBufferCoords(e), !this._model.selectionEnd) {
            this.refresh(!0);
            return;
        }
        this._activeSelectionMode === 2 ? this._model.selectionEnd[1] < this._model.selectionStart[1] ? this._model.selectionEnd[0] = 0 : this._model.selectionEnd[0] = this._bufferService.cols : this._activeSelectionMode === 1 && this._selectToWordAt(this._model.selectionEnd), this._dragScrollAmount = this._getMouseEventScrollAmount(e), this._activeSelectionMode !== 3 && (this._dragScrollAmount > 0 ? this._model.selectionEnd[0] = this._bufferService.cols : this._dragScrollAmount < 0 && (this._model.selectionEnd[0] = 0));
        let r = this._bufferService.buffer;
        if (this._model.selectionEnd[1] < r.lines.length) {
            let n = r.lines.get(this._model.selectionEnd[1]);
            n && n.hasWidth(this._model.selectionEnd[0]) === 0 && this._model.selectionEnd[0] < this._bufferService.cols && this._model.selectionEnd[0]++;
        }
        (!i || i[0] !== this._model.selectionEnd[0] || i[1] !== this._model.selectionEnd[1]) && this.refresh(!0);
    }
    _dragScroll() {
        if (!(!this._model.selectionEnd || !this._model.selectionStart) && this._dragScrollAmount) {
            this._onRequestScrollLines.fire({
                amount: this._dragScrollAmount,
                suppressScrollEvent: !1
            });
            let e = this._bufferService.buffer;
            this._dragScrollAmount > 0 ? (this._activeSelectionMode !== 3 && (this._model.selectionEnd[0] = this._bufferService.cols), this._model.selectionEnd[1] = Math.min(e.ydisp + this._bufferService.rows, e.lines.length - 1)) : (this._activeSelectionMode !== 3 && (this._model.selectionEnd[0] = 0), this._model.selectionEnd[1] = e.ydisp), this.refresh();
        }
    }
    _handleMouseUp(e) {
        let i = e.timeStamp - this._mouseDownTimeStamp;
        if (this._removeMouseDownListeners(), this.selectionText.length <= 1 && i < $5c2a9584e51cbabf$var$Xa && e.altKey && this._optionsService.rawOptions.altClickMovesCursor) {
            if (this._bufferService.buffer.ybase === this._bufferService.buffer.ydisp) {
                let r = this._mouseService.getCoords(e, this._element, this._bufferService.cols, this._bufferService.rows, !1);
                if (r && r[0] !== void 0 && r[1] !== void 0) {
                    let n = $5c2a9584e51cbabf$var$Jo(r[0] - 1, r[1] - 1, this._bufferService, this._coreService.decPrivateModes.applicationCursorKeys);
                    this._coreService.triggerDataEvent(n, !0);
                }
            }
        } else this._fireEventIfSelectionChanged();
    }
    _fireEventIfSelectionChanged() {
        let e = this._model.finalSelectionStart, i = this._model.finalSelectionEnd, r = !!e && !!i && (e[0] !== i[0] || e[1] !== i[1]);
        if (!r) {
            this._oldHasSelection && this._fireOnSelectionChange(e, i, r);
            return;
        }
        !e || !i || (!this._oldSelectionStart || !this._oldSelectionEnd || e[0] !== this._oldSelectionStart[0] || e[1] !== this._oldSelectionStart[1] || i[0] !== this._oldSelectionEnd[0] || i[1] !== this._oldSelectionEnd[1]) && this._fireOnSelectionChange(e, i, r);
    }
    _fireOnSelectionChange(e, i, r) {
        this._oldSelectionStart = e, this._oldSelectionEnd = i, this._oldHasSelection = r, this._onSelectionChange.fire();
    }
    _handleBufferActivate(e) {
        this.clearSelection(), this._trimListener.dispose(), this._trimListener = e.activeBuffer.lines.onTrim((i)=>this._handleTrim(i));
    }
    _convertViewportColToCharacterIndex(e, i) {
        let r = i;
        for(let n = 0; i >= n; n++){
            let o = e.loadCell(n, this._workCell).getChars().length;
            this._workCell.getWidth() === 0 ? r-- : o > 1 && i !== n && (r += o - 1);
        }
        return r;
    }
    setSelection(e, i, r) {
        this._model.clearSelection(), this._removeMouseDownListeners(), this._model.selectionStart = [
            e,
            i
        ], this._model.selectionStartLength = r, this.refresh(), this._fireEventIfSelectionChanged();
    }
    rightClickSelect(e) {
        this._isClickInSelection(e) || (this._selectWordAtCursor(e, !1) && this.refresh(!0), this._fireEventIfSelectionChanged());
    }
    _getWordAt(e, i, r = !0, n = !0) {
        if (e[0] >= this._bufferService.cols) return;
        let o = this._bufferService.buffer, l = o.lines.get(e[1]);
        if (!l) return;
        let a = o.translateBufferLineToString(e[1], !1), u = this._convertViewportColToCharacterIndex(l, e[0]), h = u, c = e[0] - u, d = 0, _ = 0, p = 0, m = 0;
        if (a.charAt(u) === " ") {
            for(; u > 0 && a.charAt(u - 1) === " ";)u--;
            for(; h < a.length && a.charAt(h + 1) === " ";)h++;
        } else {
            let R = e[0], O = e[0];
            l.getWidth(R) === 0 && (d++, R--), l.getWidth(O) === 2 && (_++, O++);
            let I = l.getString(O).length;
            for(I > 1 && (m += I - 1, h += I - 1); R > 0 && u > 0 && !this._isCharWordSeparator(l.loadCell(R - 1, this._workCell));){
                l.loadCell(R - 1, this._workCell);
                let k = this._workCell.getChars().length;
                this._workCell.getWidth() === 0 ? (d++, R--) : k > 1 && (p += k - 1, u -= k - 1), u--, R--;
            }
            for(; O < l.length && h + 1 < a.length && !this._isCharWordSeparator(l.loadCell(O + 1, this._workCell));){
                l.loadCell(O + 1, this._workCell);
                let k = this._workCell.getChars().length;
                this._workCell.getWidth() === 2 ? (_++, O++) : k > 1 && (m += k - 1, h += k - 1), h++, O++;
            }
        }
        h++;
        let f = u + c - d + p, A = Math.min(this._bufferService.cols, h - u + d + _ - p - m);
        if (!(!i && a.slice(u, h).trim() === "")) {
            if (r && f === 0 && l.getCodePoint(0) !== 32) {
                let R = o.lines.get(e[1] - 1);
                if (R && l.isWrapped && R.getCodePoint(this._bufferService.cols - 1) !== 32) {
                    let O = this._getWordAt([
                        this._bufferService.cols - 1,
                        e[1] - 1
                    ], !1, !0, !1);
                    if (O) {
                        let I = this._bufferService.cols - O.start;
                        f -= I, A += I;
                    }
                }
            }
            if (n && f + A === this._bufferService.cols && l.getCodePoint(this._bufferService.cols - 1) !== 32) {
                let R = o.lines.get(e[1] + 1);
                if (R?.isWrapped && R.getCodePoint(0) !== 32) {
                    let O = this._getWordAt([
                        0,
                        e[1] + 1
                    ], !1, !1, !0);
                    O && (A += O.length);
                }
            }
            return {
                start: f,
                length: A
            };
        }
    }
    _selectWordAt(e, i) {
        let r = this._getWordAt(e, i);
        if (r) {
            for(; r.start < 0;)r.start += this._bufferService.cols, e[1]--;
            this._model.selectionStart = [
                r.start,
                e[1]
            ], this._model.selectionStartLength = r.length;
        }
    }
    _selectToWordAt(e) {
        let i = this._getWordAt(e, !0);
        if (i) {
            let r = e[1];
            for(; i.start < 0;)i.start += this._bufferService.cols, r--;
            if (!this._model.areSelectionValuesReversed()) for(; i.start + i.length > this._bufferService.cols;)i.length -= this._bufferService.cols, r++;
            this._model.selectionEnd = [
                this._model.areSelectionValuesReversed() ? i.start : i.start + i.length,
                r
            ];
        }
    }
    _isCharWordSeparator(e) {
        return e.getWidth() === 0 ? !1 : this._optionsService.rawOptions.wordSeparator.indexOf(e.getChars()) >= 0;
    }
    _selectLineAt(e) {
        let i = this._bufferService.buffer.getWrappedRangeForLine(e), r = {
            start: {
                x: 0,
                y: i.first
            },
            end: {
                x: this._bufferService.cols - 1,
                y: i.last
            }
        };
        this._model.selectionStart = [
            0,
            i.first
        ], this._model.selectionEnd = void 0, this._model.selectionStartLength = $5c2a9584e51cbabf$var$ws(r, this._bufferService.cols);
    }
};
$5c2a9584e51cbabf$var$ei = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(5, $5c2a9584e51cbabf$var$Dt),
    $5c2a9584e51cbabf$var$S(6, $5c2a9584e51cbabf$var$H),
    $5c2a9584e51cbabf$var$S(7, $5c2a9584e51cbabf$var$ce),
    $5c2a9584e51cbabf$var$S(8, $5c2a9584e51cbabf$var$ae)
], $5c2a9584e51cbabf$var$ei);
var $5c2a9584e51cbabf$var$Hi = class {
    constructor(){
        this._data = {};
    }
    set(t1, e, i) {
        this._data[t1] || (this._data[t1] = {}), this._data[t1][e] = i;
    }
    get(t1, e) {
        return this._data[t1] ? this._data[t1][e] : void 0;
    }
    clear() {
        this._data = {};
    }
};
var $5c2a9584e51cbabf$var$Wi = class {
    constructor(){
        this._color = new $5c2a9584e51cbabf$var$Hi;
        this._css = new $5c2a9584e51cbabf$var$Hi;
    }
    setCss(t1, e, i) {
        this._css.set(t1, e, i);
    }
    getCss(t1, e) {
        return this._css.get(t1, e);
    }
    setColor(t1, e, i) {
        this._color.set(t1, e, i);
    }
    getColor(t1, e) {
        return this._color.get(t1, e);
    }
    clear() {
        this._color.clear(), this._css.clear();
    }
};
var $5c2a9584e51cbabf$var$re = Object.freeze((()=>{
    let s = [
        $5c2a9584e51cbabf$var$z.toColor("#2e3436"),
        $5c2a9584e51cbabf$var$z.toColor("#cc0000"),
        $5c2a9584e51cbabf$var$z.toColor("#4e9a06"),
        $5c2a9584e51cbabf$var$z.toColor("#c4a000"),
        $5c2a9584e51cbabf$var$z.toColor("#3465a4"),
        $5c2a9584e51cbabf$var$z.toColor("#75507b"),
        $5c2a9584e51cbabf$var$z.toColor("#06989a"),
        $5c2a9584e51cbabf$var$z.toColor("#d3d7cf"),
        $5c2a9584e51cbabf$var$z.toColor("#555753"),
        $5c2a9584e51cbabf$var$z.toColor("#ef2929"),
        $5c2a9584e51cbabf$var$z.toColor("#8ae234"),
        $5c2a9584e51cbabf$var$z.toColor("#fce94f"),
        $5c2a9584e51cbabf$var$z.toColor("#729fcf"),
        $5c2a9584e51cbabf$var$z.toColor("#ad7fa8"),
        $5c2a9584e51cbabf$var$z.toColor("#34e2e2"),
        $5c2a9584e51cbabf$var$z.toColor("#eeeeec")
    ], t1 = [
        0,
        95,
        135,
        175,
        215,
        255
    ];
    for(let e = 0; e < 216; e++){
        let i = t1[e / 36 % 6 | 0], r = t1[e / 6 % 6 | 0], n = t1[e % 6];
        s.push({
            css: $5c2a9584e51cbabf$var$j.toCss(i, r, n),
            rgba: $5c2a9584e51cbabf$var$j.toRgba(i, r, n)
        });
    }
    for(let e = 0; e < 24; e++){
        let i = 8 + e * 10;
        s.push({
            css: $5c2a9584e51cbabf$var$j.toCss(i, i, i),
            rgba: $5c2a9584e51cbabf$var$j.toRgba(i, i, i)
        });
    }
    return s;
})());
var $5c2a9584e51cbabf$var$St = $5c2a9584e51cbabf$var$z.toColor("#ffffff"), $5c2a9584e51cbabf$var$Ki = $5c2a9584e51cbabf$var$z.toColor("#000000"), $5c2a9584e51cbabf$var$tl = $5c2a9584e51cbabf$var$z.toColor("#ffffff"), $5c2a9584e51cbabf$var$il = $5c2a9584e51cbabf$var$Ki, $5c2a9584e51cbabf$var$Ui = {
    css: "rgba(255, 255, 255, 0.3)",
    rgba: 4294967117
}, $5c2a9584e51cbabf$var$Qa = $5c2a9584e51cbabf$var$St, $5c2a9584e51cbabf$var$ti = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._optionsService = e;
        this._contrastCache = new $5c2a9584e51cbabf$var$Wi;
        this._halfContrastCache = new $5c2a9584e51cbabf$var$Wi;
        this._onChangeColors = this._register(new $5c2a9584e51cbabf$var$v);
        this.onChangeColors = this._onChangeColors.event;
        this._colors = {
            foreground: $5c2a9584e51cbabf$var$St,
            background: $5c2a9584e51cbabf$var$Ki,
            cursor: $5c2a9584e51cbabf$var$tl,
            cursorAccent: $5c2a9584e51cbabf$var$il,
            selectionForeground: void 0,
            selectionBackgroundTransparent: $5c2a9584e51cbabf$var$Ui,
            selectionBackgroundOpaque: $5c2a9584e51cbabf$var$U.blend($5c2a9584e51cbabf$var$Ki, $5c2a9584e51cbabf$var$Ui),
            selectionInactiveBackgroundTransparent: $5c2a9584e51cbabf$var$Ui,
            selectionInactiveBackgroundOpaque: $5c2a9584e51cbabf$var$U.blend($5c2a9584e51cbabf$var$Ki, $5c2a9584e51cbabf$var$Ui),
            scrollbarSliderBackground: $5c2a9584e51cbabf$var$U.opacity($5c2a9584e51cbabf$var$St, .2),
            scrollbarSliderHoverBackground: $5c2a9584e51cbabf$var$U.opacity($5c2a9584e51cbabf$var$St, .4),
            scrollbarSliderActiveBackground: $5c2a9584e51cbabf$var$U.opacity($5c2a9584e51cbabf$var$St, .5),
            overviewRulerBorder: $5c2a9584e51cbabf$var$St,
            ansi: $5c2a9584e51cbabf$var$re.slice(),
            contrastCache: this._contrastCache,
            halfContrastCache: this._halfContrastCache
        }, this._updateRestoreColors(), this._setTheme(this._optionsService.rawOptions.theme), this._register(this._optionsService.onSpecificOptionChange("minimumContrastRatio", ()=>this._contrastCache.clear())), this._register(this._optionsService.onSpecificOptionChange("theme", ()=>this._setTheme(this._optionsService.rawOptions.theme)));
    }
    get colors() {
        return this._colors;
    }
    _setTheme(e = {}) {
        let i = this._colors;
        if (i.foreground = $5c2a9584e51cbabf$var$K(e.foreground, $5c2a9584e51cbabf$var$St), i.background = $5c2a9584e51cbabf$var$K(e.background, $5c2a9584e51cbabf$var$Ki), i.cursor = $5c2a9584e51cbabf$var$U.blend(i.background, $5c2a9584e51cbabf$var$K(e.cursor, $5c2a9584e51cbabf$var$tl)), i.cursorAccent = $5c2a9584e51cbabf$var$U.blend(i.background, $5c2a9584e51cbabf$var$K(e.cursorAccent, $5c2a9584e51cbabf$var$il)), i.selectionBackgroundTransparent = $5c2a9584e51cbabf$var$K(e.selectionBackground, $5c2a9584e51cbabf$var$Ui), i.selectionBackgroundOpaque = $5c2a9584e51cbabf$var$U.blend(i.background, i.selectionBackgroundTransparent), i.selectionInactiveBackgroundTransparent = $5c2a9584e51cbabf$var$K(e.selectionInactiveBackground, i.selectionBackgroundTransparent), i.selectionInactiveBackgroundOpaque = $5c2a9584e51cbabf$var$U.blend(i.background, i.selectionInactiveBackgroundTransparent), i.selectionForeground = e.selectionForeground ? $5c2a9584e51cbabf$var$K(e.selectionForeground, $5c2a9584e51cbabf$var$ps) : void 0, i.selectionForeground === $5c2a9584e51cbabf$var$ps && (i.selectionForeground = void 0), $5c2a9584e51cbabf$var$U.isOpaque(i.selectionBackgroundTransparent) && (i.selectionBackgroundTransparent = $5c2a9584e51cbabf$var$U.opacity(i.selectionBackgroundTransparent, .3)), $5c2a9584e51cbabf$var$U.isOpaque(i.selectionInactiveBackgroundTransparent) && (i.selectionInactiveBackgroundTransparent = $5c2a9584e51cbabf$var$U.opacity(i.selectionInactiveBackgroundTransparent, .3)), i.scrollbarSliderBackground = $5c2a9584e51cbabf$var$K(e.scrollbarSliderBackground, $5c2a9584e51cbabf$var$U.opacity(i.foreground, .2)), i.scrollbarSliderHoverBackground = $5c2a9584e51cbabf$var$K(e.scrollbarSliderHoverBackground, $5c2a9584e51cbabf$var$U.opacity(i.foreground, .4)), i.scrollbarSliderActiveBackground = $5c2a9584e51cbabf$var$K(e.scrollbarSliderActiveBackground, $5c2a9584e51cbabf$var$U.opacity(i.foreground, .5)), i.overviewRulerBorder = $5c2a9584e51cbabf$var$K(e.overviewRulerBorder, $5c2a9584e51cbabf$var$Qa), i.ansi = $5c2a9584e51cbabf$var$re.slice(), i.ansi[0] = $5c2a9584e51cbabf$var$K(e.black, $5c2a9584e51cbabf$var$re[0]), i.ansi[1] = $5c2a9584e51cbabf$var$K(e.red, $5c2a9584e51cbabf$var$re[1]), i.ansi[2] = $5c2a9584e51cbabf$var$K(e.green, $5c2a9584e51cbabf$var$re[2]), i.ansi[3] = $5c2a9584e51cbabf$var$K(e.yellow, $5c2a9584e51cbabf$var$re[3]), i.ansi[4] = $5c2a9584e51cbabf$var$K(e.blue, $5c2a9584e51cbabf$var$re[4]), i.ansi[5] = $5c2a9584e51cbabf$var$K(e.magenta, $5c2a9584e51cbabf$var$re[5]), i.ansi[6] = $5c2a9584e51cbabf$var$K(e.cyan, $5c2a9584e51cbabf$var$re[6]), i.ansi[7] = $5c2a9584e51cbabf$var$K(e.white, $5c2a9584e51cbabf$var$re[7]), i.ansi[8] = $5c2a9584e51cbabf$var$K(e.brightBlack, $5c2a9584e51cbabf$var$re[8]), i.ansi[9] = $5c2a9584e51cbabf$var$K(e.brightRed, $5c2a9584e51cbabf$var$re[9]), i.ansi[10] = $5c2a9584e51cbabf$var$K(e.brightGreen, $5c2a9584e51cbabf$var$re[10]), i.ansi[11] = $5c2a9584e51cbabf$var$K(e.brightYellow, $5c2a9584e51cbabf$var$re[11]), i.ansi[12] = $5c2a9584e51cbabf$var$K(e.brightBlue, $5c2a9584e51cbabf$var$re[12]), i.ansi[13] = $5c2a9584e51cbabf$var$K(e.brightMagenta, $5c2a9584e51cbabf$var$re[13]), i.ansi[14] = $5c2a9584e51cbabf$var$K(e.brightCyan, $5c2a9584e51cbabf$var$re[14]), i.ansi[15] = $5c2a9584e51cbabf$var$K(e.brightWhite, $5c2a9584e51cbabf$var$re[15]), e.extendedAnsi) {
            let r = Math.min(i.ansi.length - 16, e.extendedAnsi.length);
            for(let n = 0; n < r; n++)i.ansi[n + 16] = $5c2a9584e51cbabf$var$K(e.extendedAnsi[n], $5c2a9584e51cbabf$var$re[n + 16]);
        }
        this._contrastCache.clear(), this._halfContrastCache.clear(), this._updateRestoreColors(), this._onChangeColors.fire(this.colors);
    }
    restoreColor(e) {
        this._restoreColor(e), this._onChangeColors.fire(this.colors);
    }
    _restoreColor(e) {
        if (e === void 0) {
            for(let i = 0; i < this._restoreColors.ansi.length; ++i)this._colors.ansi[i] = this._restoreColors.ansi[i];
            return;
        }
        switch(e){
            case 256:
                this._colors.foreground = this._restoreColors.foreground;
                break;
            case 257:
                this._colors.background = this._restoreColors.background;
                break;
            case 258:
                this._colors.cursor = this._restoreColors.cursor;
                break;
            default:
                this._colors.ansi[e] = this._restoreColors.ansi[e];
        }
    }
    modifyColors(e) {
        e(this._colors), this._onChangeColors.fire(this.colors);
    }
    _updateRestoreColors() {
        this._restoreColors = {
            foreground: this._colors.foreground,
            background: this._colors.background,
            cursor: this._colors.cursor,
            ansi: this._colors.ansi.slice()
        };
    }
};
$5c2a9584e51cbabf$var$ti = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$ti);
function $5c2a9584e51cbabf$var$K(s, t1) {
    if (s !== void 0) try {
        return $5c2a9584e51cbabf$var$z.toColor(s);
    } catch  {}
    return t1;
}
var $5c2a9584e51cbabf$var$Rs = class {
    constructor(...t1){
        this._entries = new Map;
        for (let [e, i] of t1)this.set(e, i);
    }
    set(t1, e) {
        let i = this._entries.get(t1);
        return this._entries.set(t1, e), i;
    }
    forEach(t1) {
        for (let [e, i] of this._entries.entries())t1(e, i);
    }
    has(t1) {
        return this._entries.has(t1);
    }
    get(t1) {
        return this._entries.get(t1);
    }
}, $5c2a9584e51cbabf$var$ln = class {
    constructor(){
        this._services = new $5c2a9584e51cbabf$var$Rs;
        this._services.set($5c2a9584e51cbabf$var$xt, this);
    }
    setService(t1, e) {
        this._services.set(t1, e);
    }
    getService(t1) {
        return this._services.get(t1);
    }
    createInstance(t1, ...e) {
        let i = $5c2a9584e51cbabf$var$Xs(t1).sort((o, l)=>o.index - l.index), r = [];
        for (let o of i){
            let l = this._services.get(o.id);
            if (!l) throw new Error(`[createInstance] ${t1.name} depends on UNKNOWN service ${o.id._id}.`);
            r.push(l);
        }
        let n = i.length > 0 ? i[0].index : e.length;
        if (e.length !== n) throw new Error(`[createInstance] First service dependency of ${t1.name} at position ${n + 1} conflicts with ${e.length} static arguments`);
        return new t1(...e, ...r);
    }
};
var $5c2a9584e51cbabf$var$ec = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    off: 5
}, $5c2a9584e51cbabf$var$tc = "xterm.js: ", $5c2a9584e51cbabf$var$ii = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._optionsService = e;
        this._logLevel = 5;
        this._updateLogLevel(), this._register(this._optionsService.onSpecificOptionChange("logLevel", ()=>this._updateLogLevel())), $5c2a9584e51cbabf$var$ic = this;
    }
    get logLevel() {
        return this._logLevel;
    }
    _updateLogLevel() {
        this._logLevel = $5c2a9584e51cbabf$var$ec[this._optionsService.rawOptions.logLevel];
    }
    _evalLazyOptionalParams(e) {
        for(let i = 0; i < e.length; i++)typeof e[i] == "function" && (e[i] = e[i]());
    }
    _log(e, i, r) {
        this._evalLazyOptionalParams(r), e.call(console, (this._optionsService.options.logger ? "" : $5c2a9584e51cbabf$var$tc) + i, ...r);
    }
    trace(e, ...i) {
        this._logLevel <= 0 && this._log(this._optionsService.options.logger?.trace.bind(this._optionsService.options.logger) ?? console.log, e, i);
    }
    debug(e, ...i) {
        this._logLevel <= 1 && this._log(this._optionsService.options.logger?.debug.bind(this._optionsService.options.logger) ?? console.log, e, i);
    }
    info(e, ...i) {
        this._logLevel <= 2 && this._log(this._optionsService.options.logger?.info.bind(this._optionsService.options.logger) ?? console.info, e, i);
    }
    warn(e, ...i) {
        this._logLevel <= 3 && this._log(this._optionsService.options.logger?.warn.bind(this._optionsService.options.logger) ?? console.warn, e, i);
    }
    error(e, ...i) {
        this._logLevel <= 4 && this._log(this._optionsService.options.logger?.error.bind(this._optionsService.options.logger) ?? console.error, e, i);
    }
};
$5c2a9584e51cbabf$var$ii = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$ii);
var $5c2a9584e51cbabf$var$ic;
var $5c2a9584e51cbabf$var$zi = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._maxLength = e;
        this.onDeleteEmitter = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDelete = this.onDeleteEmitter.event;
        this.onInsertEmitter = this._register(new $5c2a9584e51cbabf$var$v);
        this.onInsert = this.onInsertEmitter.event;
        this.onTrimEmitter = this._register(new $5c2a9584e51cbabf$var$v);
        this.onTrim = this.onTrimEmitter.event;
        this._array = new Array(this._maxLength), this._startIndex = 0, this._length = 0;
    }
    get maxLength() {
        return this._maxLength;
    }
    set maxLength(e) {
        if (this._maxLength === e) return;
        let i = new Array(e);
        for(let r = 0; r < Math.min(e, this.length); r++)i[r] = this._array[this._getCyclicIndex(r)];
        this._array = i, this._maxLength = e, this._startIndex = 0;
    }
    get length() {
        return this._length;
    }
    set length(e) {
        if (e > this._length) for(let i = this._length; i < e; i++)this._array[i] = void 0;
        this._length = e;
    }
    get(e) {
        return this._array[this._getCyclicIndex(e)];
    }
    set(e, i) {
        this._array[this._getCyclicIndex(e)] = i;
    }
    push(e) {
        this._array[this._getCyclicIndex(this._length)] = e, this._length === this._maxLength ? (this._startIndex = ++this._startIndex % this._maxLength, this.onTrimEmitter.fire(1)) : this._length++;
    }
    recycle() {
        if (this._length !== this._maxLength) throw new Error("Can only recycle when the buffer is full");
        return this._startIndex = ++this._startIndex % this._maxLength, this.onTrimEmitter.fire(1), this._array[this._getCyclicIndex(this._length - 1)];
    }
    get isFull() {
        return this._length === this._maxLength;
    }
    pop() {
        return this._array[this._getCyclicIndex(this._length-- - 1)];
    }
    splice(e, i, ...r) {
        if (i) {
            for(let n = e; n < this._length - i; n++)this._array[this._getCyclicIndex(n)] = this._array[this._getCyclicIndex(n + i)];
            this._length -= i, this.onDeleteEmitter.fire({
                index: e,
                amount: i
            });
        }
        for(let n = this._length - 1; n >= e; n--)this._array[this._getCyclicIndex(n + r.length)] = this._array[this._getCyclicIndex(n)];
        for(let n = 0; n < r.length; n++)this._array[this._getCyclicIndex(e + n)] = r[n];
        if (r.length && this.onInsertEmitter.fire({
            index: e,
            amount: r.length
        }), this._length + r.length > this._maxLength) {
            let n = this._length + r.length - this._maxLength;
            this._startIndex += n, this._length = this._maxLength, this.onTrimEmitter.fire(n);
        } else this._length += r.length;
    }
    trimStart(e) {
        e > this._length && (e = this._length), this._startIndex += e, this._length -= e, this.onTrimEmitter.fire(e);
    }
    shiftElements(e, i, r) {
        if (!(i <= 0)) {
            if (e < 0 || e >= this._length) throw new Error("start argument out of range");
            if (e + r < 0) throw new Error("Cannot shift elements in list beyond index 0");
            if (r > 0) {
                for(let o = i - 1; o >= 0; o--)this.set(e + o + r, this.get(e + o));
                let n = e + i + r - this._length;
                if (n > 0) for(this._length += n; this._length > this._maxLength;)this._length--, this._startIndex++, this.onTrimEmitter.fire(1);
            } else for(let n = 0; n < i; n++)this.set(e + n + r, this.get(e + n));
        }
    }
    _getCyclicIndex(e) {
        return (this._startIndex + e) % this._maxLength;
    }
};
var $5c2a9584e51cbabf$var$B = 3;
var $5c2a9584e51cbabf$var$X = Object.freeze(new $5c2a9584e51cbabf$var$De), $5c2a9584e51cbabf$var$an = 0, $5c2a9584e51cbabf$var$Ls = 2, $5c2a9584e51cbabf$var$Ze = class s {
    constructor(t1, e, i = !1){
        this.isWrapped = i;
        this._combined = {};
        this._extendedAttrs = {};
        this._data = new Uint32Array(t1 * $5c2a9584e51cbabf$var$B);
        let r = e || $5c2a9584e51cbabf$var$q.fromCharData([
            0,
            $5c2a9584e51cbabf$var$ir,
            1,
            0
        ]);
        for(let n = 0; n < t1; ++n)this.setCell(n, r);
        this.length = t1;
    }
    get(t1) {
        let e = this._data[t1 * $5c2a9584e51cbabf$var$B + 0], i = e & 2097151;
        return [
            this._data[t1 * $5c2a9584e51cbabf$var$B + 1],
            e & 2097152 ? this._combined[t1] : i ? $5c2a9584e51cbabf$var$Ce(i) : "",
            e >> 22,
            e & 2097152 ? this._combined[t1].charCodeAt(this._combined[t1].length - 1) : i
        ];
    }
    set(t1, e) {
        this._data[t1 * $5c2a9584e51cbabf$var$B + 1] = e[0], e[1].length > 1 ? (this._combined[t1] = e[1], this._data[t1 * $5c2a9584e51cbabf$var$B + 0] = t1 | 2097152 | e[2] << 22) : this._data[t1 * $5c2a9584e51cbabf$var$B + 0] = e[1].charCodeAt(0) | e[2] << 22;
    }
    getWidth(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 0] >> 22;
    }
    hasWidth(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 0] & 12582912;
    }
    getFg(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 1];
    }
    getBg(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 2];
    }
    hasContent(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 0] & 4194303;
    }
    getCodePoint(t1) {
        let e = this._data[t1 * $5c2a9584e51cbabf$var$B + 0];
        return e & 2097152 ? this._combined[t1].charCodeAt(this._combined[t1].length - 1) : e & 2097151;
    }
    isCombined(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 0] & 2097152;
    }
    getString(t1) {
        let e = this._data[t1 * $5c2a9584e51cbabf$var$B + 0];
        return e & 2097152 ? this._combined[t1] : e & 2097151 ? $5c2a9584e51cbabf$var$Ce(e & 2097151) : "";
    }
    isProtected(t1) {
        return this._data[t1 * $5c2a9584e51cbabf$var$B + 2] & 536870912;
    }
    loadCell(t1, e) {
        return $5c2a9584e51cbabf$var$an = t1 * $5c2a9584e51cbabf$var$B, e.content = this._data[$5c2a9584e51cbabf$var$an + 0], e.fg = this._data[$5c2a9584e51cbabf$var$an + 1], e.bg = this._data[$5c2a9584e51cbabf$var$an + 2], e.content & 2097152 && (e.combinedData = this._combined[t1]), e.bg & 268435456 && (e.extended = this._extendedAttrs[t1]), e;
    }
    setCell(t1, e) {
        e.content & 2097152 && (this._combined[t1] = e.combinedData), e.bg & 268435456 && (this._extendedAttrs[t1] = e.extended), this._data[t1 * $5c2a9584e51cbabf$var$B + 0] = e.content, this._data[t1 * $5c2a9584e51cbabf$var$B + 1] = e.fg, this._data[t1 * $5c2a9584e51cbabf$var$B + 2] = e.bg;
    }
    setCellFromCodepoint(t1, e, i, r) {
        r.bg & 268435456 && (this._extendedAttrs[t1] = r.extended), this._data[t1 * $5c2a9584e51cbabf$var$B + 0] = e | i << 22, this._data[t1 * $5c2a9584e51cbabf$var$B + 1] = r.fg, this._data[t1 * $5c2a9584e51cbabf$var$B + 2] = r.bg;
    }
    addCodepointToCell(t1, e, i) {
        let r = this._data[t1 * $5c2a9584e51cbabf$var$B + 0];
        r & 2097152 ? this._combined[t1] += $5c2a9584e51cbabf$var$Ce(e) : r & 2097151 ? (this._combined[t1] = $5c2a9584e51cbabf$var$Ce(r & 2097151) + $5c2a9584e51cbabf$var$Ce(e), r &= -2097152, r |= 2097152) : r = e | 4194304, i && (r &= -12582913, r |= i << 22), this._data[t1 * $5c2a9584e51cbabf$var$B + 0] = r;
    }
    insertCells(t1, e, i) {
        if (t1 %= this.length, t1 && this.getWidth(t1 - 1) === 2 && this.setCellFromCodepoint(t1 - 1, 0, 1, i), e < this.length - t1) {
            let r = new $5c2a9584e51cbabf$var$q;
            for(let n = this.length - t1 - e - 1; n >= 0; --n)this.setCell(t1 + e + n, this.loadCell(t1 + n, r));
            for(let n = 0; n < e; ++n)this.setCell(t1 + n, i);
        } else for(let r = t1; r < this.length; ++r)this.setCell(r, i);
        this.getWidth(this.length - 1) === 2 && this.setCellFromCodepoint(this.length - 1, 0, 1, i);
    }
    deleteCells(t1, e, i) {
        if (t1 %= this.length, e < this.length - t1) {
            let r = new $5c2a9584e51cbabf$var$q;
            for(let n = 0; n < this.length - t1 - e; ++n)this.setCell(t1 + n, this.loadCell(t1 + e + n, r));
            for(let n = this.length - e; n < this.length; ++n)this.setCell(n, i);
        } else for(let r = t1; r < this.length; ++r)this.setCell(r, i);
        t1 && this.getWidth(t1 - 1) === 2 && this.setCellFromCodepoint(t1 - 1, 0, 1, i), this.getWidth(t1) === 0 && !this.hasContent(t1) && this.setCellFromCodepoint(t1, 0, 1, i);
    }
    replaceCells(t1, e, i, r = !1) {
        if (r) {
            for(t1 && this.getWidth(t1 - 1) === 2 && !this.isProtected(t1 - 1) && this.setCellFromCodepoint(t1 - 1, 0, 1, i), e < this.length && this.getWidth(e - 1) === 2 && !this.isProtected(e) && this.setCellFromCodepoint(e, 0, 1, i); t1 < e && t1 < this.length;)this.isProtected(t1) || this.setCell(t1, i), t1++;
            return;
        }
        for(t1 && this.getWidth(t1 - 1) === 2 && this.setCellFromCodepoint(t1 - 1, 0, 1, i), e < this.length && this.getWidth(e - 1) === 2 && this.setCellFromCodepoint(e, 0, 1, i); t1 < e && t1 < this.length;)this.setCell(t1++, i);
    }
    resize(t1, e) {
        if (t1 === this.length) return this._data.length * 4 * $5c2a9584e51cbabf$var$Ls < this._data.buffer.byteLength;
        let i = t1 * $5c2a9584e51cbabf$var$B;
        if (t1 > this.length) {
            if (this._data.buffer.byteLength >= i * 4) this._data = new Uint32Array(this._data.buffer, 0, i);
            else {
                let r = new Uint32Array(i);
                r.set(this._data), this._data = r;
            }
            for(let r = this.length; r < t1; ++r)this.setCell(r, e);
        } else {
            this._data = this._data.subarray(0, i);
            let r = Object.keys(this._combined);
            for(let o = 0; o < r.length; o++){
                let l = parseInt(r[o], 10);
                l >= t1 && delete this._combined[l];
            }
            let n = Object.keys(this._extendedAttrs);
            for(let o = 0; o < n.length; o++){
                let l = parseInt(n[o], 10);
                l >= t1 && delete this._extendedAttrs[l];
            }
        }
        return this.length = t1, i * 4 * $5c2a9584e51cbabf$var$Ls < this._data.buffer.byteLength;
    }
    cleanupMemory() {
        if (this._data.length * 4 * $5c2a9584e51cbabf$var$Ls < this._data.buffer.byteLength) {
            let t1 = new Uint32Array(this._data.length);
            return t1.set(this._data), this._data = t1, 1;
        }
        return 0;
    }
    fill(t1, e = !1) {
        if (e) {
            for(let i = 0; i < this.length; ++i)this.isProtected(i) || this.setCell(i, t1);
            return;
        }
        this._combined = {}, this._extendedAttrs = {};
        for(let i = 0; i < this.length; ++i)this.setCell(i, t1);
    }
    copyFrom(t1) {
        this.length !== t1.length ? this._data = new Uint32Array(t1._data) : this._data.set(t1._data), this.length = t1.length, this._combined = {};
        for(let e in t1._combined)this._combined[e] = t1._combined[e];
        this._extendedAttrs = {};
        for(let e in t1._extendedAttrs)this._extendedAttrs[e] = t1._extendedAttrs[e];
        this.isWrapped = t1.isWrapped;
    }
    clone() {
        let t1 = new s(0);
        t1._data = new Uint32Array(this._data), t1.length = this.length;
        for(let e in this._combined)t1._combined[e] = this._combined[e];
        for(let e in this._extendedAttrs)t1._extendedAttrs[e] = this._extendedAttrs[e];
        return t1.isWrapped = this.isWrapped, t1;
    }
    getTrimmedLength() {
        for(let t1 = this.length - 1; t1 >= 0; --t1)if (this._data[t1 * $5c2a9584e51cbabf$var$B + 0] & 4194303) return t1 + (this._data[t1 * $5c2a9584e51cbabf$var$B + 0] >> 22);
        return 0;
    }
    getNoBgTrimmedLength() {
        for(let t1 = this.length - 1; t1 >= 0; --t1)if (this._data[t1 * $5c2a9584e51cbabf$var$B + 0] & 4194303 || this._data[t1 * $5c2a9584e51cbabf$var$B + 2] & 50331648) return t1 + (this._data[t1 * $5c2a9584e51cbabf$var$B + 0] >> 22);
        return 0;
    }
    copyCellsFrom(t1, e, i, r, n) {
        let o = t1._data;
        if (n) for(let a = r - 1; a >= 0; a--){
            for(let u = 0; u < $5c2a9584e51cbabf$var$B; u++)this._data[(i + a) * $5c2a9584e51cbabf$var$B + u] = o[(e + a) * $5c2a9584e51cbabf$var$B + u];
            o[(e + a) * $5c2a9584e51cbabf$var$B + 2] & 268435456 && (this._extendedAttrs[i + a] = t1._extendedAttrs[e + a]);
        }
        else for(let a = 0; a < r; a++){
            for(let u = 0; u < $5c2a9584e51cbabf$var$B; u++)this._data[(i + a) * $5c2a9584e51cbabf$var$B + u] = o[(e + a) * $5c2a9584e51cbabf$var$B + u];
            o[(e + a) * $5c2a9584e51cbabf$var$B + 2] & 268435456 && (this._extendedAttrs[i + a] = t1._extendedAttrs[e + a]);
        }
        let l = Object.keys(t1._combined);
        for(let a = 0; a < l.length; a++){
            let u = parseInt(l[a], 10);
            u >= e && (this._combined[u - e + i] = t1._combined[u]);
        }
    }
    translateToString(t1, e, i, r) {
        e = e ?? 0, i = i ?? this.length, t1 && (i = Math.min(i, this.getTrimmedLength())), r && (r.length = 0);
        let n = "";
        for(; e < i;){
            let o = this._data[e * $5c2a9584e51cbabf$var$B + 0], l = o & 2097151, a = o & 2097152 ? this._combined[e] : l ? $5c2a9584e51cbabf$var$Ce(l) : $5c2a9584e51cbabf$var$we;
            if (n += a, r) for(let u = 0; u < a.length; ++u)r.push(e);
            e += o >> 22 || 1;
        }
        return r && r.push(e), n;
    }
};
function $5c2a9584e51cbabf$var$sl(s, t1, e, i, r, n) {
    let o = [];
    for(let l = 0; l < s.length - 1; l++){
        let a = l, u = s.get(++a);
        if (!u.isWrapped) continue;
        let h = [
            s.get(l)
        ];
        for(; a < s.length && u.isWrapped;)h.push(u), u = s.get(++a);
        if (!n && i >= l && i < a) {
            l += h.length - 1;
            continue;
        }
        let c = 0, d = $5c2a9584e51cbabf$var$ri(h, c, t1), _ = 1, p = 0;
        for(; _ < h.length;){
            let f = $5c2a9584e51cbabf$var$ri(h, _, t1), A = f - p, R = e - d, O = Math.min(A, R);
            h[c].copyCellsFrom(h[_], p, d, O, !1), d += O, d === e && (c++, d = 0), p += O, p === f && (_++, p = 0), d === 0 && c !== 0 && h[c - 1].getWidth(e - 1) === 2 && (h[c].copyCellsFrom(h[c - 1], e - 1, d++, 1, !1), h[c - 1].setCell(e - 1, r));
        }
        h[c].replaceCells(d, e, r);
        let m = 0;
        for(let f = h.length - 1; f > 0 && (f > c || h[f].getTrimmedLength() === 0); f--)m++;
        m > 0 && (o.push(l + h.length - m), o.push(m)), l += h.length - 1;
    }
    return o;
}
function $5c2a9584e51cbabf$var$ol(s, t1) {
    let e = [], i = 0, r = t1[i], n = 0;
    for(let o = 0; o < s.length; o++)if (r === o) {
        let l = t1[++i];
        s.onDeleteEmitter.fire({
            index: o - n,
            amount: l
        }), o += l - 1, n += l, r = t1[++i];
    } else e.push(o);
    return {
        layout: e,
        countRemoved: n
    };
}
function $5c2a9584e51cbabf$var$ll(s, t1) {
    let e = [];
    for(let i = 0; i < t1.length; i++)e.push(s.get(t1[i]));
    for(let i = 0; i < e.length; i++)s.set(i, e[i]);
    s.length = t1.length;
}
function $5c2a9584e51cbabf$var$al(s, t1, e) {
    let i = [], r = s.map((a, u)=>$5c2a9584e51cbabf$var$ri(s, u, t1)).reduce((a, u)=>a + u), n = 0, o = 0, l = 0;
    for(; l < r;){
        if (r - l < e) {
            i.push(r - l);
            break;
        }
        n += e;
        let a = $5c2a9584e51cbabf$var$ri(s, o, t1);
        n > a && (n -= a, o++);
        let u = s[o].getWidth(n - 1) === 2;
        u && n--;
        let h = u ? e - 1 : e;
        i.push(h), l += h;
    }
    return i;
}
function $5c2a9584e51cbabf$var$ri(s, t1, e) {
    if (t1 === s.length - 1) return s[t1].getTrimmedLength();
    let i = !s[t1].hasContent(e - 1) && s[t1].getWidth(e - 1) === 1, r = s[t1 + 1].getWidth(0) === 2;
    return i && r ? e - 1 : e;
}
var $5c2a9584e51cbabf$var$un = class un {
    constructor(t1){
        this.line = t1;
        this.isDisposed = !1;
        this._disposables = [];
        this._id = un._nextId++;
        this._onDispose = this.register(new $5c2a9584e51cbabf$var$v);
        this.onDispose = this._onDispose.event;
    }
    get id() {
        return this._id;
    }
    dispose() {
        this.isDisposed || (this.isDisposed = !0, this.line = -1, this._onDispose.fire(), $5c2a9584e51cbabf$var$Ne(this._disposables), this._disposables.length = 0);
    }
    register(t1) {
        return this._disposables.push(t1), t1;
    }
};
$5c2a9584e51cbabf$var$un._nextId = 1;
var $5c2a9584e51cbabf$var$cn = $5c2a9584e51cbabf$var$un;
var $5c2a9584e51cbabf$var$ne = {}, $5c2a9584e51cbabf$var$Je = $5c2a9584e51cbabf$var$ne.B;
$5c2a9584e51cbabf$var$ne[0] = {
    "`": "\u25C6",
    a: "\u2592",
    b: "\u2409",
    c: "\u240C",
    d: "\u240D",
    e: "\u240A",
    f: "\xB0",
    g: "\xB1",
    h: "\u2424",
    i: "\u240B",
    j: "\u2518",
    k: "\u2510",
    l: "\u250C",
    m: "\u2514",
    n: "\u253C",
    o: "\u23BA",
    p: "\u23BB",
    q: "\u2500",
    r: "\u23BC",
    s: "\u23BD",
    t: "\u251C",
    u: "\u2524",
    v: "\u2534",
    w: "\u252C",
    x: "\u2502",
    y: "\u2264",
    z: "\u2265",
    "{": "\u03C0",
    "|": "\u2260",
    "}": "\xA3",
    "~": "\xB7"
};
$5c2a9584e51cbabf$var$ne.A = {
    "#": "\xA3"
};
$5c2a9584e51cbabf$var$ne.B = void 0;
$5c2a9584e51cbabf$var$ne[4] = {
    "#": "\xA3",
    "@": "\xBE",
    "[": "ij",
    "\\": "\xBD",
    "]": "|",
    "{": "\xA8",
    "|": "f",
    "}": "\xBC",
    "~": "\xB4"
};
$5c2a9584e51cbabf$var$ne.C = $5c2a9584e51cbabf$var$ne[5] = {
    "[": "\xC4",
    "\\": "\xD6",
    "]": "\xC5",
    "^": "\xDC",
    "`": "\xE9",
    "{": "\xE4",
    "|": "\xF6",
    "}": "\xE5",
    "~": "\xFC"
};
$5c2a9584e51cbabf$var$ne.R = {
    "#": "\xA3",
    "@": "\xE0",
    "[": "\xB0",
    "\\": "\xE7",
    "]": "\xA7",
    "{": "\xE9",
    "|": "\xF9",
    "}": "\xE8",
    "~": "\xA8"
};
$5c2a9584e51cbabf$var$ne.Q = {
    "@": "\xE0",
    "[": "\xE2",
    "\\": "\xE7",
    "]": "\xEA",
    "^": "\xEE",
    "`": "\xF4",
    "{": "\xE9",
    "|": "\xF9",
    "}": "\xE8",
    "~": "\xFB"
};
$5c2a9584e51cbabf$var$ne.K = {
    "@": "\xA7",
    "[": "\xC4",
    "\\": "\xD6",
    "]": "\xDC",
    "{": "\xE4",
    "|": "\xF6",
    "}": "\xFC",
    "~": "\xDF"
};
$5c2a9584e51cbabf$var$ne.Y = {
    "#": "\xA3",
    "@": "\xA7",
    "[": "\xB0",
    "\\": "\xE7",
    "]": "\xE9",
    "`": "\xF9",
    "{": "\xE0",
    "|": "\xF2",
    "}": "\xE8",
    "~": "\xEC"
};
$5c2a9584e51cbabf$var$ne.E = $5c2a9584e51cbabf$var$ne[6] = {
    "@": "\xC4",
    "[": "\xC6",
    "\\": "\xD8",
    "]": "\xC5",
    "^": "\xDC",
    "`": "\xE4",
    "{": "\xE6",
    "|": "\xF8",
    "}": "\xE5",
    "~": "\xFC"
};
$5c2a9584e51cbabf$var$ne.Z = {
    "#": "\xA3",
    "@": "\xA7",
    "[": "\xA1",
    "\\": "\xD1",
    "]": "\xBF",
    "{": "\xB0",
    "|": "\xF1",
    "}": "\xE7"
};
$5c2a9584e51cbabf$var$ne.H = $5c2a9584e51cbabf$var$ne[7] = {
    "@": "\xC9",
    "[": "\xC4",
    "\\": "\xD6",
    "]": "\xC5",
    "^": "\xDC",
    "`": "\xE9",
    "{": "\xE4",
    "|": "\xF6",
    "}": "\xE5",
    "~": "\xFC"
};
$5c2a9584e51cbabf$var$ne["="] = {
    "#": "\xF9",
    "@": "\xE0",
    "[": "\xE9",
    "\\": "\xE7",
    "]": "\xEA",
    "^": "\xEE",
    _: "\xE8",
    "`": "\xF4",
    "{": "\xE4",
    "|": "\xF6",
    "}": "\xFC",
    "~": "\xFB"
};
var $5c2a9584e51cbabf$var$cl = 4294967295, $5c2a9584e51cbabf$var$$i = class {
    constructor(t1, e, i){
        this._hasScrollback = t1;
        this._optionsService = e;
        this._bufferService = i;
        this.ydisp = 0;
        this.ybase = 0;
        this.y = 0;
        this.x = 0;
        this.tabs = {};
        this.savedY = 0;
        this.savedX = 0;
        this.savedCurAttrData = $5c2a9584e51cbabf$var$X.clone();
        this.savedCharset = $5c2a9584e51cbabf$var$Je;
        this.markers = [];
        this._nullCell = $5c2a9584e51cbabf$var$q.fromCharData([
            0,
            $5c2a9584e51cbabf$var$ir,
            1,
            0
        ]);
        this._whitespaceCell = $5c2a9584e51cbabf$var$q.fromCharData([
            0,
            $5c2a9584e51cbabf$var$we,
            1,
            32
        ]);
        this._isClearing = !1;
        this._memoryCleanupQueue = new $5c2a9584e51cbabf$var$Jt;
        this._memoryCleanupPosition = 0;
        this._cols = this._bufferService.cols, this._rows = this._bufferService.rows, this.lines = new $5c2a9584e51cbabf$var$zi(this._getCorrectBufferLength(this._rows)), this.scrollTop = 0, this.scrollBottom = this._rows - 1, this.setupTabStops();
    }
    getNullCell(t1) {
        return t1 ? (this._nullCell.fg = t1.fg, this._nullCell.bg = t1.bg, this._nullCell.extended = t1.extended) : (this._nullCell.fg = 0, this._nullCell.bg = 0, this._nullCell.extended = new $5c2a9584e51cbabf$var$rt), this._nullCell;
    }
    getWhitespaceCell(t1) {
        return t1 ? (this._whitespaceCell.fg = t1.fg, this._whitespaceCell.bg = t1.bg, this._whitespaceCell.extended = t1.extended) : (this._whitespaceCell.fg = 0, this._whitespaceCell.bg = 0, this._whitespaceCell.extended = new $5c2a9584e51cbabf$var$rt), this._whitespaceCell;
    }
    getBlankLine(t1, e) {
        return new $5c2a9584e51cbabf$var$Ze(this._bufferService.cols, this.getNullCell(t1), e);
    }
    get hasScrollback() {
        return this._hasScrollback && this.lines.maxLength > this._rows;
    }
    get isCursorInViewport() {
        let e = this.ybase + this.y - this.ydisp;
        return e >= 0 && e < this._rows;
    }
    _getCorrectBufferLength(t1) {
        if (!this._hasScrollback) return t1;
        let e = t1 + this._optionsService.rawOptions.scrollback;
        return e > $5c2a9584e51cbabf$var$cl ? $5c2a9584e51cbabf$var$cl : e;
    }
    fillViewportRows(t1) {
        if (this.lines.length === 0) {
            t1 === void 0 && (t1 = $5c2a9584e51cbabf$var$X);
            let e = this._rows;
            for(; e--;)this.lines.push(this.getBlankLine(t1));
        }
    }
    clear() {
        this.ydisp = 0, this.ybase = 0, this.y = 0, this.x = 0, this.lines = new $5c2a9584e51cbabf$var$zi(this._getCorrectBufferLength(this._rows)), this.scrollTop = 0, this.scrollBottom = this._rows - 1, this.setupTabStops();
    }
    resize(t1, e) {
        let i = this.getNullCell($5c2a9584e51cbabf$var$X), r = 0, n = this._getCorrectBufferLength(e);
        if (n > this.lines.maxLength && (this.lines.maxLength = n), this.lines.length > 0) {
            if (this._cols < t1) for(let l = 0; l < this.lines.length; l++)r += +this.lines.get(l).resize(t1, i);
            let o = 0;
            if (this._rows < e) for(let l = this._rows; l < e; l++)this.lines.length < e + this.ybase && (this._optionsService.rawOptions.windowsMode || this._optionsService.rawOptions.windowsPty.backend !== void 0 || this._optionsService.rawOptions.windowsPty.buildNumber !== void 0 ? this.lines.push(new $5c2a9584e51cbabf$var$Ze(t1, i)) : this.ybase > 0 && this.lines.length <= this.ybase + this.y + o + 1 ? (this.ybase--, o++, this.ydisp > 0 && this.ydisp--) : this.lines.push(new $5c2a9584e51cbabf$var$Ze(t1, i)));
            else for(let l = this._rows; l > e; l--)this.lines.length > e + this.ybase && (this.lines.length > this.ybase + this.y + 1 ? this.lines.pop() : (this.ybase++, this.ydisp++));
            if (n < this.lines.maxLength) {
                let l = this.lines.length - n;
                l > 0 && (this.lines.trimStart(l), this.ybase = Math.max(this.ybase - l, 0), this.ydisp = Math.max(this.ydisp - l, 0), this.savedY = Math.max(this.savedY - l, 0)), this.lines.maxLength = n;
            }
            this.x = Math.min(this.x, t1 - 1), this.y = Math.min(this.y, e - 1), o && (this.y += o), this.savedX = Math.min(this.savedX, t1 - 1), this.scrollTop = 0;
        }
        if (this.scrollBottom = e - 1, this._isReflowEnabled && (this._reflow(t1, e), this._cols > t1)) for(let o = 0; o < this.lines.length; o++)r += +this.lines.get(o).resize(t1, i);
        this._cols = t1, this._rows = e, this._memoryCleanupQueue.clear(), r > .1 * this.lines.length && (this._memoryCleanupPosition = 0, this._memoryCleanupQueue.enqueue(()=>this._batchedMemoryCleanup()));
    }
    _batchedMemoryCleanup() {
        let t1 = !0;
        this._memoryCleanupPosition >= this.lines.length && (this._memoryCleanupPosition = 0, t1 = !1);
        let e = 0;
        for(; this._memoryCleanupPosition < this.lines.length;)if (e += this.lines.get(this._memoryCleanupPosition++).cleanupMemory(), e > 100) return !0;
        return t1;
    }
    get _isReflowEnabled() {
        let t1 = this._optionsService.rawOptions.windowsPty;
        return t1 && t1.buildNumber ? this._hasScrollback && t1.backend === "conpty" && t1.buildNumber >= 21376 : this._hasScrollback && !this._optionsService.rawOptions.windowsMode;
    }
    _reflow(t1, e) {
        this._cols !== t1 && (t1 > this._cols ? this._reflowLarger(t1, e) : this._reflowSmaller(t1, e));
    }
    _reflowLarger(t1, e) {
        let i = this._optionsService.rawOptions.reflowCursorLine, r = $5c2a9584e51cbabf$var$sl(this.lines, this._cols, t1, this.ybase + this.y, this.getNullCell($5c2a9584e51cbabf$var$X), i);
        if (r.length > 0) {
            let n = $5c2a9584e51cbabf$var$ol(this.lines, r);
            $5c2a9584e51cbabf$var$ll(this.lines, n.layout), this._reflowLargerAdjustViewport(t1, e, n.countRemoved);
        }
    }
    _reflowLargerAdjustViewport(t1, e, i) {
        let r = this.getNullCell($5c2a9584e51cbabf$var$X), n = i;
        for(; n-- > 0;)this.ybase === 0 ? (this.y > 0 && this.y--, this.lines.length < e && this.lines.push(new $5c2a9584e51cbabf$var$Ze(t1, r))) : (this.ydisp === this.ybase && this.ydisp--, this.ybase--);
        this.savedY = Math.max(this.savedY - i, 0);
    }
    _reflowSmaller(t1, e) {
        let i = this._optionsService.rawOptions.reflowCursorLine, r = this.getNullCell($5c2a9584e51cbabf$var$X), n = [], o = 0;
        for(let l = this.lines.length - 1; l >= 0; l--){
            let a = this.lines.get(l);
            if (!a || !a.isWrapped && a.getTrimmedLength() <= t1) continue;
            let u = [
                a
            ];
            for(; a.isWrapped && l > 0;)a = this.lines.get(--l), u.unshift(a);
            if (!i) {
                let I = this.ybase + this.y;
                if (I >= l && I < l + u.length) continue;
            }
            let h = u[u.length - 1].getTrimmedLength(), c = $5c2a9584e51cbabf$var$al(u, this._cols, t1), d = c.length - u.length, _;
            this.ybase === 0 && this.y !== this.lines.length - 1 ? _ = Math.max(0, this.y - this.lines.maxLength + d) : _ = Math.max(0, this.lines.length - this.lines.maxLength + d);
            let p = [];
            for(let I = 0; I < d; I++){
                let k = this.getBlankLine($5c2a9584e51cbabf$var$X, !0);
                p.push(k);
            }
            p.length > 0 && (n.push({
                start: l + u.length + o,
                newLines: p
            }), o += p.length), u.push(...p);
            let m = c.length - 1, f = c[m];
            f === 0 && (m--, f = c[m]);
            let A = u.length - d - 1, R = h;
            for(; A >= 0;){
                let I = Math.min(R, f);
                if (u[m] === void 0) break;
                if (u[m].copyCellsFrom(u[A], R - I, f - I, I, !0), f -= I, f === 0 && (m--, f = c[m]), R -= I, R === 0) {
                    A--;
                    let k = Math.max(A, 0);
                    R = $5c2a9584e51cbabf$var$ri(u, k, this._cols);
                }
            }
            for(let I = 0; I < u.length; I++)c[I] < t1 && u[I].setCell(c[I], r);
            let O = d - _;
            for(; O-- > 0;)this.ybase === 0 ? this.y < e - 1 ? (this.y++, this.lines.pop()) : (this.ybase++, this.ydisp++) : this.ybase < Math.min(this.lines.maxLength, this.lines.length + o) - e && (this.ybase === this.ydisp && this.ydisp++, this.ybase++);
            this.savedY = Math.min(this.savedY + d, this.ybase + e - 1);
        }
        if (n.length > 0) {
            let l = [], a = [];
            for(let f = 0; f < this.lines.length; f++)a.push(this.lines.get(f));
            let u = this.lines.length, h = u - 1, c = 0, d = n[c];
            this.lines.length = Math.min(this.lines.maxLength, this.lines.length + o);
            let _ = 0;
            for(let f = Math.min(this.lines.maxLength - 1, u + o - 1); f >= 0; f--)if (d && d.start > h + _) {
                for(let A = d.newLines.length - 1; A >= 0; A--)this.lines.set(f--, d.newLines[A]);
                f++, l.push({
                    index: h + 1,
                    amount: d.newLines.length
                }), _ += d.newLines.length, d = n[++c];
            } else this.lines.set(f, a[h--]);
            let p = 0;
            for(let f = l.length - 1; f >= 0; f--)l[f].index += p, this.lines.onInsertEmitter.fire(l[f]), p += l[f].amount;
            let m = Math.max(0, u + o - this.lines.maxLength);
            m > 0 && this.lines.onTrimEmitter.fire(m);
        }
    }
    translateBufferLineToString(t1, e, i = 0, r) {
        let n = this.lines.get(t1);
        return n ? n.translateToString(e, i, r) : "";
    }
    getWrappedRangeForLine(t1) {
        let e = t1, i = t1;
        for(; e > 0 && this.lines.get(e).isWrapped;)e--;
        for(; i + 1 < this.lines.length && this.lines.get(i + 1).isWrapped;)i++;
        return {
            first: e,
            last: i
        };
    }
    setupTabStops(t1) {
        for(t1 != null ? this.tabs[t1] || (t1 = this.prevStop(t1)) : (this.tabs = {}, t1 = 0); t1 < this._cols; t1 += this._optionsService.rawOptions.tabStopWidth)this.tabs[t1] = !0;
    }
    prevStop(t1) {
        for(t1 == null && (t1 = this.x); !this.tabs[--t1] && t1 > 0;);
        return t1 >= this._cols ? this._cols - 1 : t1 < 0 ? 0 : t1;
    }
    nextStop(t1) {
        for(t1 == null && (t1 = this.x); !this.tabs[++t1] && t1 < this._cols;);
        return t1 >= this._cols ? this._cols - 1 : t1 < 0 ? 0 : t1;
    }
    clearMarkers(t1) {
        this._isClearing = !0;
        for(let e = 0; e < this.markers.length; e++)this.markers[e].line === t1 && (this.markers[e].dispose(), this.markers.splice(e--, 1));
        this._isClearing = !1;
    }
    clearAllMarkers() {
        this._isClearing = !0;
        for(let t1 = 0; t1 < this.markers.length; t1++)this.markers[t1].dispose();
        this.markers.length = 0, this._isClearing = !1;
    }
    addMarker(t1) {
        let e = new $5c2a9584e51cbabf$var$cn(t1);
        return this.markers.push(e), e.register(this.lines.onTrim((i)=>{
            e.line -= i, e.line < 0 && e.dispose();
        })), e.register(this.lines.onInsert((i)=>{
            e.line >= i.index && (e.line += i.amount);
        })), e.register(this.lines.onDelete((i)=>{
            e.line >= i.index && e.line < i.index + i.amount && e.dispose(), e.line > i.index && (e.line -= i.amount);
        })), e.register(e.onDispose(()=>this._removeMarker(e))), e;
    }
    _removeMarker(t1) {
        this._isClearing || this.markers.splice(this.markers.indexOf(t1), 1);
    }
};
var $5c2a9584e51cbabf$var$hn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i){
        super();
        this._optionsService = e;
        this._bufferService = i;
        this._onBufferActivate = this._register(new $5c2a9584e51cbabf$var$v);
        this.onBufferActivate = this._onBufferActivate.event;
        this.reset(), this._register(this._optionsService.onSpecificOptionChange("scrollback", ()=>this.resize(this._bufferService.cols, this._bufferService.rows))), this._register(this._optionsService.onSpecificOptionChange("tabStopWidth", ()=>this.setupTabStops()));
    }
    reset() {
        this._normal = new $5c2a9584e51cbabf$var$$i(!0, this._optionsService, this._bufferService), this._normal.fillViewportRows(), this._alt = new $5c2a9584e51cbabf$var$$i(!1, this._optionsService, this._bufferService), this._activeBuffer = this._normal, this._onBufferActivate.fire({
            activeBuffer: this._normal,
            inactiveBuffer: this._alt
        }), this.setupTabStops();
    }
    get alt() {
        return this._alt;
    }
    get active() {
        return this._activeBuffer;
    }
    get normal() {
        return this._normal;
    }
    activateNormalBuffer() {
        this._activeBuffer !== this._normal && (this._normal.x = this._alt.x, this._normal.y = this._alt.y, this._alt.clearAllMarkers(), this._alt.clear(), this._activeBuffer = this._normal, this._onBufferActivate.fire({
            activeBuffer: this._normal,
            inactiveBuffer: this._alt
        }));
    }
    activateAltBuffer(e) {
        this._activeBuffer !== this._alt && (this._alt.fillViewportRows(e), this._alt.x = this._normal.x, this._alt.y = this._normal.y, this._activeBuffer = this._alt, this._onBufferActivate.fire({
            activeBuffer: this._alt,
            inactiveBuffer: this._normal
        }));
    }
    resize(e, i) {
        this._normal.resize(e, i), this._alt.resize(e, i), this.setupTabStops(e);
    }
    setupTabStops(e) {
        this._normal.setupTabStops(e), this._alt.setupTabStops(e);
    }
};
var $5c2a9584e51cbabf$var$ks = 2, $5c2a9584e51cbabf$var$Cs = 1, $5c2a9584e51cbabf$var$ni = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this.isUserScrolling = !1;
        this._onResize = this._register(new $5c2a9584e51cbabf$var$v);
        this.onResize = this._onResize.event;
        this._onScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this.onScroll = this._onScroll.event;
        this.cols = Math.max(e.rawOptions.cols || 0, $5c2a9584e51cbabf$var$ks), this.rows = Math.max(e.rawOptions.rows || 0, $5c2a9584e51cbabf$var$Cs), this.buffers = this._register(new $5c2a9584e51cbabf$var$hn(e, this)), this._register(this.buffers.onBufferActivate((i)=>{
            this._onScroll.fire(i.activeBuffer.ydisp);
        }));
    }
    get buffer() {
        return this.buffers.active;
    }
    resize(e, i) {
        let r = this.cols !== e, n = this.rows !== i;
        this.cols = e, this.rows = i, this.buffers.resize(e, i), this._onResize.fire({
            cols: e,
            rows: i,
            colsChanged: r,
            rowsChanged: n
        });
    }
    reset() {
        this.buffers.reset(), this.isUserScrolling = !1;
    }
    scroll(e, i = !1) {
        let r = this.buffer, n;
        n = this._cachedBlankLine, (!n || n.length !== this.cols || n.getFg(0) !== e.fg || n.getBg(0) !== e.bg) && (n = r.getBlankLine(e, i), this._cachedBlankLine = n), n.isWrapped = i;
        let o = r.ybase + r.scrollTop, l = r.ybase + r.scrollBottom;
        if (r.scrollTop === 0) {
            let a = r.lines.isFull;
            l === r.lines.length - 1 ? a ? r.lines.recycle().copyFrom(n) : r.lines.push(n.clone()) : r.lines.splice(l + 1, 0, n.clone()), a ? this.isUserScrolling && (r.ydisp = Math.max(r.ydisp - 1, 0)) : (r.ybase++, this.isUserScrolling || r.ydisp++);
        } else {
            let a = l - o + 1;
            r.lines.shiftElements(o + 1, a - 1, -1), r.lines.set(l, n.clone());
        }
        this.isUserScrolling || (r.ydisp = r.ybase), this._onScroll.fire(r.ydisp);
    }
    scrollLines(e, i) {
        let r = this.buffer;
        if (e < 0) {
            if (r.ydisp === 0) return;
            this.isUserScrolling = !0;
        } else e + r.ydisp >= r.ybase && (this.isUserScrolling = !1);
        let n = r.ydisp;
        r.ydisp = Math.max(Math.min(r.ydisp + e, r.ybase), 0), n !== r.ydisp && (i || this._onScroll.fire(r.ydisp));
    }
};
$5c2a9584e51cbabf$var$ni = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$ni);
var $5c2a9584e51cbabf$var$si = {
    cols: 80,
    rows: 24,
    cursorBlink: !1,
    cursorStyle: "block",
    cursorWidth: 1,
    cursorInactiveStyle: "outline",
    customGlyphs: !0,
    drawBoldTextInBrightColors: !0,
    documentOverride: null,
    fastScrollModifier: "alt",
    fastScrollSensitivity: 5,
    fontFamily: "monospace",
    fontSize: 15,
    fontWeight: "normal",
    fontWeightBold: "bold",
    ignoreBracketedPasteMode: !1,
    lineHeight: 1,
    letterSpacing: 0,
    linkHandler: null,
    logLevel: "info",
    logger: null,
    scrollback: 1e3,
    scrollOnEraseInDisplay: !1,
    scrollOnUserInput: !0,
    scrollSensitivity: 1,
    screenReaderMode: !1,
    smoothScrollDuration: 0,
    macOptionIsMeta: !1,
    macOptionClickForcesSelection: !1,
    minimumContrastRatio: 1,
    disableStdin: !1,
    allowProposedApi: !1,
    allowTransparency: !1,
    tabStopWidth: 8,
    theme: {},
    reflowCursorLine: !1,
    rescaleOverlappingGlyphs: !1,
    rightClickSelectsWord: $5c2a9584e51cbabf$var$Zt,
    windowOptions: {},
    windowsMode: !1,
    windowsPty: {},
    wordSeparator: " ()[]{}',\"`",
    altClickMovesCursor: !0,
    convertEol: !1,
    termName: "xterm",
    cancelEvents: !1,
    overviewRuler: {}
}, $5c2a9584e51cbabf$var$nc = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
], $5c2a9584e51cbabf$var$dn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._onOptionChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onOptionChange = this._onOptionChange.event;
        let i = {
            ...$5c2a9584e51cbabf$var$si
        };
        for(let r in e)if (r in i) try {
            let n = e[r];
            i[r] = this._sanitizeAndValidateOption(r, n);
        } catch (n) {
            console.error(n);
        }
        this.rawOptions = i, this.options = {
            ...i
        }, this._setupOptions(), this._register($5c2a9584e51cbabf$var$C(()=>{
            this.rawOptions.linkHandler = null, this.rawOptions.documentOverride = null;
        }));
    }
    onSpecificOptionChange(e, i) {
        return this.onOptionChange((r)=>{
            r === e && i(this.rawOptions[e]);
        });
    }
    onMultipleOptionChange(e, i) {
        return this.onOptionChange((r)=>{
            e.indexOf(r) !== -1 && i();
        });
    }
    _setupOptions() {
        let e = (r)=>{
            if (!(r in $5c2a9584e51cbabf$var$si)) throw new Error(`No option with key "${r}"`);
            return this.rawOptions[r];
        }, i = (r, n)=>{
            if (!(r in $5c2a9584e51cbabf$var$si)) throw new Error(`No option with key "${r}"`);
            n = this._sanitizeAndValidateOption(r, n), this.rawOptions[r] !== n && (this.rawOptions[r] = n, this._onOptionChange.fire(r));
        };
        for(let r in this.rawOptions){
            let n = {
                get: e.bind(this, r),
                set: i.bind(this, r)
            };
            Object.defineProperty(this.options, r, n);
        }
    }
    _sanitizeAndValidateOption(e, i) {
        switch(e){
            case "cursorStyle":
                if (i || (i = $5c2a9584e51cbabf$var$si[e]), !$5c2a9584e51cbabf$var$sc(i)) throw new Error(`"${i}" is not a valid value for ${e}`);
                break;
            case "wordSeparator":
                i || (i = $5c2a9584e51cbabf$var$si[e]);
                break;
            case "fontWeight":
            case "fontWeightBold":
                if (typeof i == "number" && 1 <= i && i <= 1e3) break;
                i = $5c2a9584e51cbabf$var$nc.includes(i) ? i : $5c2a9584e51cbabf$var$si[e];
                break;
            case "cursorWidth":
                i = Math.floor(i);
            case "lineHeight":
            case "tabStopWidth":
                if (i < 1) throw new Error(`${e} cannot be less than 1, value: ${i}`);
                break;
            case "minimumContrastRatio":
                i = Math.max(1, Math.min(21, Math.round(i * 10) / 10));
                break;
            case "scrollback":
                if (i = Math.min(i, 4294967295), i < 0) throw new Error(`${e} cannot be less than 0, value: ${i}`);
                break;
            case "fastScrollSensitivity":
            case "scrollSensitivity":
                if (i <= 0) throw new Error(`${e} cannot be less than or equal to 0, value: ${i}`);
                break;
            case "rows":
            case "cols":
                if (!i && i !== 0) throw new Error(`${e} must be numeric, value: ${i}`);
                break;
            case "windowsPty":
                i = i ?? {};
                break;
        }
        return i;
    }
};
function $5c2a9584e51cbabf$var$sc(s) {
    return s === "block" || s === "underline" || s === "bar";
}
function $5c2a9584e51cbabf$var$oi(s, t1 = 5) {
    if (typeof s != "object") return s;
    let e = Array.isArray(s) ? [] : {};
    for(let i in s)e[i] = t1 <= 1 ? s[i] : s[i] && $5c2a9584e51cbabf$var$oi(s[i], t1 - 1);
    return e;
}
var $5c2a9584e51cbabf$var$ul = Object.freeze({
    insertMode: !1
}), $5c2a9584e51cbabf$var$hl = Object.freeze({
    applicationCursorKeys: !1,
    applicationKeypad: !1,
    bracketedPasteMode: !1,
    cursorBlink: void 0,
    cursorStyle: void 0,
    origin: !1,
    reverseWraparound: !1,
    sendFocus: !1,
    synchronizedOutput: !1,
    wraparound: !0
}), $5c2a9584e51cbabf$var$li = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r){
        super();
        this._bufferService = e;
        this._logService = i;
        this._optionsService = r;
        this.isCursorInitialized = !1;
        this.isCursorHidden = !1;
        this._onData = this._register(new $5c2a9584e51cbabf$var$v);
        this.onData = this._onData.event;
        this._onUserInput = this._register(new $5c2a9584e51cbabf$var$v);
        this.onUserInput = this._onUserInput.event;
        this._onBinary = this._register(new $5c2a9584e51cbabf$var$v);
        this.onBinary = this._onBinary.event;
        this._onRequestScrollToBottom = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestScrollToBottom = this._onRequestScrollToBottom.event;
        this.modes = $5c2a9584e51cbabf$var$oi($5c2a9584e51cbabf$var$ul), this.decPrivateModes = $5c2a9584e51cbabf$var$oi($5c2a9584e51cbabf$var$hl);
    }
    reset() {
        this.modes = $5c2a9584e51cbabf$var$oi($5c2a9584e51cbabf$var$ul), this.decPrivateModes = $5c2a9584e51cbabf$var$oi($5c2a9584e51cbabf$var$hl);
    }
    triggerDataEvent(e, i = !1) {
        if (this._optionsService.rawOptions.disableStdin) return;
        let r = this._bufferService.buffer;
        i && this._optionsService.rawOptions.scrollOnUserInput && r.ybase !== r.ydisp && this._onRequestScrollToBottom.fire(), i && this._onUserInput.fire(), this._logService.debug(`sending data "${e}"`), this._logService.trace("sending data (codes)", ()=>e.split("").map((n)=>n.charCodeAt(0))), this._onData.fire(e);
    }
    triggerBinaryEvent(e) {
        this._optionsService.rawOptions.disableStdin || (this._logService.debug(`sending binary "${e}"`), this._logService.trace("sending binary (codes)", ()=>e.split("").map((i)=>i.charCodeAt(0))), this._onBinary.fire(e));
    }
};
$5c2a9584e51cbabf$var$li = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$nr),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$li);
var $5c2a9584e51cbabf$var$dl = {
    NONE: {
        events: 0,
        restrict: ()=>!1
    },
    X10: {
        events: 1,
        restrict: (s)=>s.button === 4 || s.action !== 1 ? !1 : (s.ctrl = !1, s.alt = !1, s.shift = !1, !0)
    },
    VT200: {
        events: 19,
        restrict: (s)=>s.action !== 32
    },
    DRAG: {
        events: 23,
        restrict: (s)=>!(s.action === 32 && s.button === 3)
    },
    ANY: {
        events: 31,
        restrict: (s)=>!0
    }
};
function $5c2a9584e51cbabf$var$Ms(s, t1) {
    let e = (s.ctrl ? 16 : 0) | (s.shift ? 4 : 0) | (s.alt ? 8 : 0);
    return s.button === 4 ? (e |= 64, e |= s.action) : (e |= s.button & 3, s.button & 4 && (e |= 64), s.button & 8 && (e |= 128), s.action === 32 ? e |= 32 : s.action === 0 && !t1 && (e |= 3)), e;
}
var $5c2a9584e51cbabf$var$Ps = String.fromCharCode, $5c2a9584e51cbabf$var$fl = {
    DEFAULT: (s)=>{
        let t1 = [
            $5c2a9584e51cbabf$var$Ms(s, !1) + 32,
            s.col + 32,
            s.row + 32
        ];
        return t1[0] > 255 || t1[1] > 255 || t1[2] > 255 ? "" : `\x1B[M${$5c2a9584e51cbabf$var$Ps(t1[0])}${$5c2a9584e51cbabf$var$Ps(t1[1])}${$5c2a9584e51cbabf$var$Ps(t1[2])}`;
    },
    SGR: (s)=>{
        let t1 = s.action === 0 && s.button !== 4 ? "m" : "M";
        return `\x1B[<${$5c2a9584e51cbabf$var$Ms(s, !0)};${s.col};${s.row}${t1}`;
    },
    SGR_PIXELS: (s)=>{
        let t1 = s.action === 0 && s.button !== 4 ? "m" : "M";
        return `\x1B[<${$5c2a9584e51cbabf$var$Ms(s, !0)};${s.x};${s.y}${t1}`;
    }
}, $5c2a9584e51cbabf$var$ai = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r){
        super();
        this._bufferService = e;
        this._coreService = i;
        this._optionsService = r;
        this._protocols = {};
        this._encodings = {};
        this._activeProtocol = "";
        this._activeEncoding = "";
        this._lastEvent = null;
        this._wheelPartialScroll = 0;
        this._onProtocolChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onProtocolChange = this._onProtocolChange.event;
        for (let n of Object.keys($5c2a9584e51cbabf$var$dl))this.addProtocol(n, $5c2a9584e51cbabf$var$dl[n]);
        for (let n of Object.keys($5c2a9584e51cbabf$var$fl))this.addEncoding(n, $5c2a9584e51cbabf$var$fl[n]);
        this.reset();
    }
    addProtocol(e, i) {
        this._protocols[e] = i;
    }
    addEncoding(e, i) {
        this._encodings[e] = i;
    }
    get activeProtocol() {
        return this._activeProtocol;
    }
    get areMouseEventsActive() {
        return this._protocols[this._activeProtocol].events !== 0;
    }
    set activeProtocol(e) {
        if (!this._protocols[e]) throw new Error(`unknown protocol "${e}"`);
        this._activeProtocol = e, this._onProtocolChange.fire(this._protocols[e].events);
    }
    get activeEncoding() {
        return this._activeEncoding;
    }
    set activeEncoding(e) {
        if (!this._encodings[e]) throw new Error(`unknown encoding "${e}"`);
        this._activeEncoding = e;
    }
    reset() {
        this.activeProtocol = "NONE", this.activeEncoding = "DEFAULT", this._lastEvent = null, this._wheelPartialScroll = 0;
    }
    consumeWheelEvent(e, i, r) {
        if (e.deltaY === 0 || e.shiftKey || i === void 0 || r === void 0) return 0;
        let n = i / r, o = this._applyScrollModifier(e.deltaY, e);
        return e.deltaMode === WheelEvent.DOM_DELTA_PIXEL ? (o /= n + 0, Math.abs(e.deltaY) < 50 && (o *= .3), this._wheelPartialScroll += o, o = Math.floor(Math.abs(this._wheelPartialScroll)) * (this._wheelPartialScroll > 0 ? 1 : -1), this._wheelPartialScroll %= 1) : e.deltaMode === WheelEvent.DOM_DELTA_PAGE && (o *= this._bufferService.rows), o;
    }
    _applyScrollModifier(e, i) {
        return i.altKey || i.ctrlKey || i.shiftKey ? e * this._optionsService.rawOptions.fastScrollSensitivity * this._optionsService.rawOptions.scrollSensitivity : e * this._optionsService.rawOptions.scrollSensitivity;
    }
    triggerMouseEvent(e) {
        if (e.col < 0 || e.col >= this._bufferService.cols || e.row < 0 || e.row >= this._bufferService.rows || e.button === 4 && e.action === 32 || e.button === 3 && e.action !== 32 || e.button !== 4 && (e.action === 2 || e.action === 3) || (e.col++, e.row++, e.action === 32 && this._lastEvent && this._equalEvents(this._lastEvent, e, this._activeEncoding === "SGR_PIXELS")) || !this._protocols[this._activeProtocol].restrict(e)) return !1;
        let i = this._encodings[this._activeEncoding](e);
        return i && (this._activeEncoding === "DEFAULT" ? this._coreService.triggerBinaryEvent(i) : this._coreService.triggerDataEvent(i, !0)), this._lastEvent = e, !0;
    }
    explainEvents(e) {
        return {
            down: !!(e & 1),
            up: !!(e & 2),
            drag: !!(e & 4),
            move: !!(e & 8),
            wheel: !!(e & 16)
        };
    }
    _equalEvents(e, i, r) {
        if (r) {
            if (e.x !== i.x || e.y !== i.y) return !1;
        } else if (e.col !== i.col || e.row !== i.row) return !1;
        return !(e.button !== i.button || e.action !== i.action || e.ctrl !== i.ctrl || e.alt !== i.alt || e.shift !== i.shift);
    }
};
$5c2a9584e51cbabf$var$ai = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$ge),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$H)
], $5c2a9584e51cbabf$var$ai);
var $5c2a9584e51cbabf$var$Os = [
    [
        768,
        879
    ],
    [
        1155,
        1158
    ],
    [
        1160,
        1161
    ],
    [
        1425,
        1469
    ],
    [
        1471,
        1471
    ],
    [
        1473,
        1474
    ],
    [
        1476,
        1477
    ],
    [
        1479,
        1479
    ],
    [
        1536,
        1539
    ],
    [
        1552,
        1557
    ],
    [
        1611,
        1630
    ],
    [
        1648,
        1648
    ],
    [
        1750,
        1764
    ],
    [
        1767,
        1768
    ],
    [
        1770,
        1773
    ],
    [
        1807,
        1807
    ],
    [
        1809,
        1809
    ],
    [
        1840,
        1866
    ],
    [
        1958,
        1968
    ],
    [
        2027,
        2035
    ],
    [
        2305,
        2306
    ],
    [
        2364,
        2364
    ],
    [
        2369,
        2376
    ],
    [
        2381,
        2381
    ],
    [
        2385,
        2388
    ],
    [
        2402,
        2403
    ],
    [
        2433,
        2433
    ],
    [
        2492,
        2492
    ],
    [
        2497,
        2500
    ],
    [
        2509,
        2509
    ],
    [
        2530,
        2531
    ],
    [
        2561,
        2562
    ],
    [
        2620,
        2620
    ],
    [
        2625,
        2626
    ],
    [
        2631,
        2632
    ],
    [
        2635,
        2637
    ],
    [
        2672,
        2673
    ],
    [
        2689,
        2690
    ],
    [
        2748,
        2748
    ],
    [
        2753,
        2757
    ],
    [
        2759,
        2760
    ],
    [
        2765,
        2765
    ],
    [
        2786,
        2787
    ],
    [
        2817,
        2817
    ],
    [
        2876,
        2876
    ],
    [
        2879,
        2879
    ],
    [
        2881,
        2883
    ],
    [
        2893,
        2893
    ],
    [
        2902,
        2902
    ],
    [
        2946,
        2946
    ],
    [
        3008,
        3008
    ],
    [
        3021,
        3021
    ],
    [
        3134,
        3136
    ],
    [
        3142,
        3144
    ],
    [
        3146,
        3149
    ],
    [
        3157,
        3158
    ],
    [
        3260,
        3260
    ],
    [
        3263,
        3263
    ],
    [
        3270,
        3270
    ],
    [
        3276,
        3277
    ],
    [
        3298,
        3299
    ],
    [
        3393,
        3395
    ],
    [
        3405,
        3405
    ],
    [
        3530,
        3530
    ],
    [
        3538,
        3540
    ],
    [
        3542,
        3542
    ],
    [
        3633,
        3633
    ],
    [
        3636,
        3642
    ],
    [
        3655,
        3662
    ],
    [
        3761,
        3761
    ],
    [
        3764,
        3769
    ],
    [
        3771,
        3772
    ],
    [
        3784,
        3789
    ],
    [
        3864,
        3865
    ],
    [
        3893,
        3893
    ],
    [
        3895,
        3895
    ],
    [
        3897,
        3897
    ],
    [
        3953,
        3966
    ],
    [
        3968,
        3972
    ],
    [
        3974,
        3975
    ],
    [
        3984,
        3991
    ],
    [
        3993,
        4028
    ],
    [
        4038,
        4038
    ],
    [
        4141,
        4144
    ],
    [
        4146,
        4146
    ],
    [
        4150,
        4151
    ],
    [
        4153,
        4153
    ],
    [
        4184,
        4185
    ],
    [
        4448,
        4607
    ],
    [
        4959,
        4959
    ],
    [
        5906,
        5908
    ],
    [
        5938,
        5940
    ],
    [
        5970,
        5971
    ],
    [
        6002,
        6003
    ],
    [
        6068,
        6069
    ],
    [
        6071,
        6077
    ],
    [
        6086,
        6086
    ],
    [
        6089,
        6099
    ],
    [
        6109,
        6109
    ],
    [
        6155,
        6157
    ],
    [
        6313,
        6313
    ],
    [
        6432,
        6434
    ],
    [
        6439,
        6440
    ],
    [
        6450,
        6450
    ],
    [
        6457,
        6459
    ],
    [
        6679,
        6680
    ],
    [
        6912,
        6915
    ],
    [
        6964,
        6964
    ],
    [
        6966,
        6970
    ],
    [
        6972,
        6972
    ],
    [
        6978,
        6978
    ],
    [
        7019,
        7027
    ],
    [
        7616,
        7626
    ],
    [
        7678,
        7679
    ],
    [
        8203,
        8207
    ],
    [
        8234,
        8238
    ],
    [
        8288,
        8291
    ],
    [
        8298,
        8303
    ],
    [
        8400,
        8431
    ],
    [
        12330,
        12335
    ],
    [
        12441,
        12442
    ],
    [
        43014,
        43014
    ],
    [
        43019,
        43019
    ],
    [
        43045,
        43046
    ],
    [
        64286,
        64286
    ],
    [
        65024,
        65039
    ],
    [
        65056,
        65059
    ],
    [
        65279,
        65279
    ],
    [
        65529,
        65531
    ]
], $5c2a9584e51cbabf$var$ac = [
    [
        68097,
        68099
    ],
    [
        68101,
        68102
    ],
    [
        68108,
        68111
    ],
    [
        68152,
        68154
    ],
    [
        68159,
        68159
    ],
    [
        119143,
        119145
    ],
    [
        119155,
        119170
    ],
    [
        119173,
        119179
    ],
    [
        119210,
        119213
    ],
    [
        119362,
        119364
    ],
    [
        917505,
        917505
    ],
    [
        917536,
        917631
    ],
    [
        917760,
        917999
    ]
], $5c2a9584e51cbabf$var$se;
function $5c2a9584e51cbabf$var$cc(s, t1) {
    let e = 0, i = t1.length - 1, r;
    if (s < t1[0][0] || s > t1[i][1]) return !1;
    for(; i >= e;)if (r = e + i >> 1, s > t1[r][1]) e = r + 1;
    else if (s < t1[r][0]) i = r - 1;
    else return !0;
    return !1;
}
var $5c2a9584e51cbabf$var$fn = class {
    constructor(){
        this.version = "6";
        if (!$5c2a9584e51cbabf$var$se) {
            $5c2a9584e51cbabf$var$se = new Uint8Array(65536), $5c2a9584e51cbabf$var$se.fill(1), $5c2a9584e51cbabf$var$se[0] = 0, $5c2a9584e51cbabf$var$se.fill(0, 1, 32), $5c2a9584e51cbabf$var$se.fill(0, 127, 160), $5c2a9584e51cbabf$var$se.fill(2, 4352, 4448), $5c2a9584e51cbabf$var$se[9001] = 2, $5c2a9584e51cbabf$var$se[9002] = 2, $5c2a9584e51cbabf$var$se.fill(2, 11904, 42192), $5c2a9584e51cbabf$var$se[12351] = 1, $5c2a9584e51cbabf$var$se.fill(2, 44032, 55204), $5c2a9584e51cbabf$var$se.fill(2, 63744, 64256), $5c2a9584e51cbabf$var$se.fill(2, 65040, 65050), $5c2a9584e51cbabf$var$se.fill(2, 65072, 65136), $5c2a9584e51cbabf$var$se.fill(2, 65280, 65377), $5c2a9584e51cbabf$var$se.fill(2, 65504, 65511);
            for(let t1 = 0; t1 < $5c2a9584e51cbabf$var$Os.length; ++t1)$5c2a9584e51cbabf$var$se.fill(0, $5c2a9584e51cbabf$var$Os[t1][0], $5c2a9584e51cbabf$var$Os[t1][1] + 1);
        }
    }
    wcwidth(t1) {
        return t1 < 32 ? 0 : t1 < 127 ? 1 : t1 < 65536 ? $5c2a9584e51cbabf$var$se[t1] : $5c2a9584e51cbabf$var$cc(t1, $5c2a9584e51cbabf$var$ac) ? 0 : t1 >= 131072 && t1 <= 196605 || t1 >= 196608 && t1 <= 262141 ? 2 : 1;
    }
    charProperties(t1, e) {
        let i = this.wcwidth(t1), r = i === 0 && e !== 0;
        if (r) {
            let n = $5c2a9584e51cbabf$var$Ae.extractWidth(e);
            n === 0 ? r = !1 : n > i && (i = n);
        }
        return $5c2a9584e51cbabf$var$Ae.createPropertyValue(0, i, r);
    }
};
var $5c2a9584e51cbabf$var$Ae = class s {
    constructor(){
        this._providers = Object.create(null);
        this._active = "";
        this._onChange = new $5c2a9584e51cbabf$var$v;
        this.onChange = this._onChange.event;
        let t1 = new $5c2a9584e51cbabf$var$fn;
        this.register(t1), this._active = t1.version, this._activeProvider = t1;
    }
    static extractShouldJoin(t1) {
        return (t1 & 1) !== 0;
    }
    static extractWidth(t1) {
        return t1 >> 1 & 3;
    }
    static extractCharKind(t1) {
        return t1 >> 3;
    }
    static createPropertyValue(t1, e, i = !1) {
        return (t1 & 16777215) << 3 | (e & 3) << 1 | (i ? 1 : 0);
    }
    dispose() {
        this._onChange.dispose();
    }
    get versions() {
        return Object.keys(this._providers);
    }
    get activeVersion() {
        return this._active;
    }
    set activeVersion(t1) {
        if (!this._providers[t1]) throw new Error(`unknown Unicode version "${t1}"`);
        this._active = t1, this._activeProvider = this._providers[t1], this._onChange.fire(t1);
    }
    register(t1) {
        this._providers[t1.version] = t1;
    }
    wcwidth(t1) {
        return this._activeProvider.wcwidth(t1);
    }
    getStringCellWidth(t1) {
        let e = 0, i = 0, r = t1.length;
        for(let n = 0; n < r; ++n){
            let o = t1.charCodeAt(n);
            if (55296 <= o && o <= 56319) {
                if (++n >= r) return e + this.wcwidth(o);
                let u = t1.charCodeAt(n);
                56320 <= u && u <= 57343 ? o = (o - 55296) * 1024 + u - 56320 + 65536 : e += this.wcwidth(u);
            }
            let l = this.charProperties(o, i), a = s.extractWidth(l);
            s.extractShouldJoin(l) && (a -= s.extractWidth(i)), e += a, i = l;
        }
        return e;
    }
    charProperties(t1, e) {
        return this._activeProvider.charProperties(t1, e);
    }
};
var $5c2a9584e51cbabf$var$pn = class {
    constructor(){
        this.glevel = 0;
        this._charsets = [];
    }
    reset() {
        this.charset = void 0, this._charsets = [], this.glevel = 0;
    }
    setgLevel(t1) {
        this.glevel = t1, this.charset = this._charsets[t1];
    }
    setgCharset(t1, e) {
        this._charsets[t1] = e, this.glevel === t1 && (this.charset = e);
    }
};
function $5c2a9584e51cbabf$var$Bs(s) {
    let e = s.buffer.lines.get(s.buffer.ybase + s.buffer.y - 1)?.get(s.cols - 1), i = s.buffer.lines.get(s.buffer.ybase + s.buffer.y);
    i && e && (i.isWrapped = e[3] !== 0 && e[3] !== 32);
}
var $5c2a9584e51cbabf$var$Vi = 2147483647, $5c2a9584e51cbabf$var$uc = 256, $5c2a9584e51cbabf$var$ci = class s {
    constructor(t1 = 32, e = 32){
        this.maxLength = t1;
        this.maxSubParamsLength = e;
        if (e > $5c2a9584e51cbabf$var$uc) throw new Error("maxSubParamsLength must not be greater than 256");
        this.params = new Int32Array(t1), this.length = 0, this._subParams = new Int32Array(e), this._subParamsLength = 0, this._subParamsIdx = new Uint16Array(t1), this._rejectDigits = !1, this._rejectSubDigits = !1, this._digitIsSub = !1;
    }
    static fromArray(t1) {
        let e = new s;
        if (!t1.length) return e;
        for(let i = Array.isArray(t1[0]) ? 1 : 0; i < t1.length; ++i){
            let r = t1[i];
            if (Array.isArray(r)) for(let n = 0; n < r.length; ++n)e.addSubParam(r[n]);
            else e.addParam(r);
        }
        return e;
    }
    clone() {
        let t1 = new s(this.maxLength, this.maxSubParamsLength);
        return t1.params.set(this.params), t1.length = this.length, t1._subParams.set(this._subParams), t1._subParamsLength = this._subParamsLength, t1._subParamsIdx.set(this._subParamsIdx), t1._rejectDigits = this._rejectDigits, t1._rejectSubDigits = this._rejectSubDigits, t1._digitIsSub = this._digitIsSub, t1;
    }
    toArray() {
        let t1 = [];
        for(let e = 0; e < this.length; ++e){
            t1.push(this.params[e]);
            let i = this._subParamsIdx[e] >> 8, r = this._subParamsIdx[e] & 255;
            r - i > 0 && t1.push(Array.prototype.slice.call(this._subParams, i, r));
        }
        return t1;
    }
    reset() {
        this.length = 0, this._subParamsLength = 0, this._rejectDigits = !1, this._rejectSubDigits = !1, this._digitIsSub = !1;
    }
    addParam(t1) {
        if (this._digitIsSub = !1, this.length >= this.maxLength) {
            this._rejectDigits = !0;
            return;
        }
        if (t1 < -1) throw new Error("values lesser than -1 are not allowed");
        this._subParamsIdx[this.length] = this._subParamsLength << 8 | this._subParamsLength, this.params[this.length++] = t1 > $5c2a9584e51cbabf$var$Vi ? $5c2a9584e51cbabf$var$Vi : t1;
    }
    addSubParam(t1) {
        if (this._digitIsSub = !0, !!this.length) {
            if (this._rejectDigits || this._subParamsLength >= this.maxSubParamsLength) {
                this._rejectSubDigits = !0;
                return;
            }
            if (t1 < -1) throw new Error("values lesser than -1 are not allowed");
            this._subParams[this._subParamsLength++] = t1 > $5c2a9584e51cbabf$var$Vi ? $5c2a9584e51cbabf$var$Vi : t1, this._subParamsIdx[this.length - 1]++;
        }
    }
    hasSubParams(t1) {
        return (this._subParamsIdx[t1] & 255) - (this._subParamsIdx[t1] >> 8) > 0;
    }
    getSubParams(t1) {
        let e = this._subParamsIdx[t1] >> 8, i = this._subParamsIdx[t1] & 255;
        return i - e > 0 ? this._subParams.subarray(e, i) : null;
    }
    getSubParamsAll() {
        let t1 = {};
        for(let e = 0; e < this.length; ++e){
            let i = this._subParamsIdx[e] >> 8, r = this._subParamsIdx[e] & 255;
            r - i > 0 && (t1[e] = this._subParams.slice(i, r));
        }
        return t1;
    }
    addDigit(t1) {
        let e;
        if (this._rejectDigits || !(e = this._digitIsSub ? this._subParamsLength : this.length) || this._digitIsSub && this._rejectSubDigits) return;
        let i = this._digitIsSub ? this._subParams : this.params, r = i[e - 1];
        i[e - 1] = ~r ? Math.min(r * 10 + t1, $5c2a9584e51cbabf$var$Vi) : t1;
    }
};
var $5c2a9584e51cbabf$var$qi = [], $5c2a9584e51cbabf$var$mn = class {
    constructor(){
        this._state = 0;
        this._active = $5c2a9584e51cbabf$var$qi;
        this._id = -1;
        this._handlers = Object.create(null);
        this._handlerFb = ()=>{};
        this._stack = {
            paused: !1,
            loopPosition: 0,
            fallThrough: !1
        };
    }
    registerHandler(t1, e) {
        this._handlers[t1] === void 0 && (this._handlers[t1] = []);
        let i = this._handlers[t1];
        return i.push(e), {
            dispose: ()=>{
                let r = i.indexOf(e);
                r !== -1 && i.splice(r, 1);
            }
        };
    }
    clearHandler(t1) {
        this._handlers[t1] && delete this._handlers[t1];
    }
    setHandlerFallback(t1) {
        this._handlerFb = t1;
    }
    dispose() {
        this._handlers = Object.create(null), this._handlerFb = ()=>{}, this._active = $5c2a9584e51cbabf$var$qi;
    }
    reset() {
        if (this._state === 2) for(let t1 = this._stack.paused ? this._stack.loopPosition - 1 : this._active.length - 1; t1 >= 0; --t1)this._active[t1].end(!1);
        this._stack.paused = !1, this._active = $5c2a9584e51cbabf$var$qi, this._id = -1, this._state = 0;
    }
    _start() {
        if (this._active = this._handlers[this._id] || $5c2a9584e51cbabf$var$qi, !this._active.length) this._handlerFb(this._id, "START");
        else for(let t1 = this._active.length - 1; t1 >= 0; t1--)this._active[t1].start();
    }
    _put(t1, e, i) {
        if (!this._active.length) this._handlerFb(this._id, "PUT", $5c2a9584e51cbabf$var$It(t1, e, i));
        else for(let r = this._active.length - 1; r >= 0; r--)this._active[r].put(t1, e, i);
    }
    start() {
        this.reset(), this._state = 1;
    }
    put(t1, e, i) {
        if (this._state !== 3) {
            if (this._state === 1) for(; e < i;){
                let r = t1[e++];
                if (r === 59) {
                    this._state = 2, this._start();
                    break;
                }
                if (r < 48 || 57 < r) {
                    this._state = 3;
                    return;
                }
                this._id === -1 && (this._id = 0), this._id = this._id * 10 + r - 48;
            }
            this._state === 2 && i - e > 0 && this._put(t1, e, i);
        }
    }
    end(t1, e = !0) {
        if (this._state !== 0) {
            if (this._state !== 3) {
                if (this._state === 1 && this._start(), !this._active.length) this._handlerFb(this._id, "END", t1);
                else {
                    let i = !1, r = this._active.length - 1, n = !1;
                    if (this._stack.paused && (r = this._stack.loopPosition - 1, i = e, n = this._stack.fallThrough, this._stack.paused = !1), !n && i === !1) {
                        for(; r >= 0 && (i = this._active[r].end(t1), i !== !0); r--)if (i instanceof Promise) return this._stack.paused = !0, this._stack.loopPosition = r, this._stack.fallThrough = !1, i;
                        r--;
                    }
                    for(; r >= 0; r--)if (i = this._active[r].end(!1), i instanceof Promise) return this._stack.paused = !0, this._stack.loopPosition = r, this._stack.fallThrough = !0, i;
                }
            }
            this._active = $5c2a9584e51cbabf$var$qi, this._id = -1, this._state = 0;
        }
    }
}, $5c2a9584e51cbabf$var$pe = class {
    constructor(t1){
        this._handler = t1;
        this._data = "";
        this._hitLimit = !1;
    }
    start() {
        this._data = "", this._hitLimit = !1;
    }
    put(t1, e, i) {
        this._hitLimit || (this._data += $5c2a9584e51cbabf$var$It(t1, e, i), this._data.length > 1e7 && (this._data = "", this._hitLimit = !0));
    }
    end(t1) {
        let e = !1;
        if (this._hitLimit) e = !1;
        else if (t1 && (e = this._handler(this._data), e instanceof Promise)) return e.then((i)=>(this._data = "", this._hitLimit = !1, i));
        return this._data = "", this._hitLimit = !1, e;
    }
};
var $5c2a9584e51cbabf$var$Yi = [], $5c2a9584e51cbabf$var$_n = class {
    constructor(){
        this._handlers = Object.create(null);
        this._active = $5c2a9584e51cbabf$var$Yi;
        this._ident = 0;
        this._handlerFb = ()=>{};
        this._stack = {
            paused: !1,
            loopPosition: 0,
            fallThrough: !1
        };
    }
    dispose() {
        this._handlers = Object.create(null), this._handlerFb = ()=>{}, this._active = $5c2a9584e51cbabf$var$Yi;
    }
    registerHandler(t1, e) {
        this._handlers[t1] === void 0 && (this._handlers[t1] = []);
        let i = this._handlers[t1];
        return i.push(e), {
            dispose: ()=>{
                let r = i.indexOf(e);
                r !== -1 && i.splice(r, 1);
            }
        };
    }
    clearHandler(t1) {
        this._handlers[t1] && delete this._handlers[t1];
    }
    setHandlerFallback(t1) {
        this._handlerFb = t1;
    }
    reset() {
        if (this._active.length) for(let t1 = this._stack.paused ? this._stack.loopPosition - 1 : this._active.length - 1; t1 >= 0; --t1)this._active[t1].unhook(!1);
        this._stack.paused = !1, this._active = $5c2a9584e51cbabf$var$Yi, this._ident = 0;
    }
    hook(t1, e) {
        if (this.reset(), this._ident = t1, this._active = this._handlers[t1] || $5c2a9584e51cbabf$var$Yi, !this._active.length) this._handlerFb(this._ident, "HOOK", e);
        else for(let i = this._active.length - 1; i >= 0; i--)this._active[i].hook(e);
    }
    put(t1, e, i) {
        if (!this._active.length) this._handlerFb(this._ident, "PUT", $5c2a9584e51cbabf$var$It(t1, e, i));
        else for(let r = this._active.length - 1; r >= 0; r--)this._active[r].put(t1, e, i);
    }
    unhook(t1, e = !0) {
        if (!this._active.length) this._handlerFb(this._ident, "UNHOOK", t1);
        else {
            let i = !1, r = this._active.length - 1, n = !1;
            if (this._stack.paused && (r = this._stack.loopPosition - 1, i = e, n = this._stack.fallThrough, this._stack.paused = !1), !n && i === !1) {
                for(; r >= 0 && (i = this._active[r].unhook(t1), i !== !0); r--)if (i instanceof Promise) return this._stack.paused = !0, this._stack.loopPosition = r, this._stack.fallThrough = !1, i;
                r--;
            }
            for(; r >= 0; r--)if (i = this._active[r].unhook(!1), i instanceof Promise) return this._stack.paused = !0, this._stack.loopPosition = r, this._stack.fallThrough = !0, i;
        }
        this._active = $5c2a9584e51cbabf$var$Yi, this._ident = 0;
    }
}, $5c2a9584e51cbabf$var$ji = new $5c2a9584e51cbabf$var$ci;
$5c2a9584e51cbabf$var$ji.addParam(0);
var $5c2a9584e51cbabf$var$Xi = class {
    constructor(t1){
        this._handler = t1;
        this._data = "";
        this._params = $5c2a9584e51cbabf$var$ji;
        this._hitLimit = !1;
    }
    hook(t1) {
        this._params = t1.length > 1 || t1.params[0] ? t1.clone() : $5c2a9584e51cbabf$var$ji, this._data = "", this._hitLimit = !1;
    }
    put(t1, e, i) {
        this._hitLimit || (this._data += $5c2a9584e51cbabf$var$It(t1, e, i), this._data.length > 1e7 && (this._data = "", this._hitLimit = !0));
    }
    unhook(t1) {
        let e = !1;
        if (this._hitLimit) e = !1;
        else if (t1 && (e = this._handler(this._data, this._params), e instanceof Promise)) return e.then((i)=>(this._params = $5c2a9584e51cbabf$var$ji, this._data = "", this._hitLimit = !1, i));
        return this._params = $5c2a9584e51cbabf$var$ji, this._data = "", this._hitLimit = !1, e;
    }
};
var $5c2a9584e51cbabf$var$Fs = class {
    constructor(t1){
        this.table = new Uint8Array(t1);
    }
    setDefault(t1, e) {
        this.table.fill(t1 << 4 | e);
    }
    add(t1, e, i, r) {
        this.table[e << 8 | t1] = i << 4 | r;
    }
    addMany(t1, e, i, r) {
        for(let n = 0; n < t1.length; n++)this.table[e << 8 | t1[n]] = i << 4 | r;
    }
}, $5c2a9584e51cbabf$var$ke = 160, $5c2a9584e51cbabf$var$hc = function() {
    let s = new $5c2a9584e51cbabf$var$Fs(4095), e = Array.apply(null, Array(256)).map((a, u)=>u), i = (a, u)=>e.slice(a, u), r = i(32, 127), n = i(0, 24);
    n.push(25), n.push.apply(n, i(28, 32));
    let o = i(0, 14), l;
    s.setDefault(1, 0), s.addMany(r, 0, 2, 0);
    for(l in o)s.addMany([
        24,
        26,
        153,
        154
    ], l, 3, 0), s.addMany(i(128, 144), l, 3, 0), s.addMany(i(144, 152), l, 3, 0), s.add(156, l, 0, 0), s.add(27, l, 11, 1), s.add(157, l, 4, 8), s.addMany([
        152,
        158,
        159
    ], l, 0, 7), s.add(155, l, 11, 3), s.add(144, l, 11, 9);
    return s.addMany(n, 0, 3, 0), s.addMany(n, 1, 3, 1), s.add(127, 1, 0, 1), s.addMany(n, 8, 0, 8), s.addMany(n, 3, 3, 3), s.add(127, 3, 0, 3), s.addMany(n, 4, 3, 4), s.add(127, 4, 0, 4), s.addMany(n, 6, 3, 6), s.addMany(n, 5, 3, 5), s.add(127, 5, 0, 5), s.addMany(n, 2, 3, 2), s.add(127, 2, 0, 2), s.add(93, 1, 4, 8), s.addMany(r, 8, 5, 8), s.add(127, 8, 5, 8), s.addMany([
        156,
        27,
        24,
        26,
        7
    ], 8, 6, 0), s.addMany(i(28, 32), 8, 0, 8), s.addMany([
        88,
        94,
        95
    ], 1, 0, 7), s.addMany(r, 7, 0, 7), s.addMany(n, 7, 0, 7), s.add(156, 7, 0, 0), s.add(127, 7, 0, 7), s.add(91, 1, 11, 3), s.addMany(i(64, 127), 3, 7, 0), s.addMany(i(48, 60), 3, 8, 4), s.addMany([
        60,
        61,
        62,
        63
    ], 3, 9, 4), s.addMany(i(48, 60), 4, 8, 4), s.addMany(i(64, 127), 4, 7, 0), s.addMany([
        60,
        61,
        62,
        63
    ], 4, 0, 6), s.addMany(i(32, 64), 6, 0, 6), s.add(127, 6, 0, 6), s.addMany(i(64, 127), 6, 0, 0), s.addMany(i(32, 48), 3, 9, 5), s.addMany(i(32, 48), 5, 9, 5), s.addMany(i(48, 64), 5, 0, 6), s.addMany(i(64, 127), 5, 7, 0), s.addMany(i(32, 48), 4, 9, 5), s.addMany(i(32, 48), 1, 9, 2), s.addMany(i(32, 48), 2, 9, 2), s.addMany(i(48, 127), 2, 10, 0), s.addMany(i(48, 80), 1, 10, 0), s.addMany(i(81, 88), 1, 10, 0), s.addMany([
        89,
        90,
        92
    ], 1, 10, 0), s.addMany(i(96, 127), 1, 10, 0), s.add(80, 1, 11, 9), s.addMany(n, 9, 0, 9), s.add(127, 9, 0, 9), s.addMany(i(28, 32), 9, 0, 9), s.addMany(i(32, 48), 9, 9, 12), s.addMany(i(48, 60), 9, 8, 10), s.addMany([
        60,
        61,
        62,
        63
    ], 9, 9, 10), s.addMany(n, 11, 0, 11), s.addMany(i(32, 128), 11, 0, 11), s.addMany(i(28, 32), 11, 0, 11), s.addMany(n, 10, 0, 10), s.add(127, 10, 0, 10), s.addMany(i(28, 32), 10, 0, 10), s.addMany(i(48, 60), 10, 8, 10), s.addMany([
        60,
        61,
        62,
        63
    ], 10, 0, 11), s.addMany(i(32, 48), 10, 9, 12), s.addMany(n, 12, 0, 12), s.add(127, 12, 0, 12), s.addMany(i(28, 32), 12, 0, 12), s.addMany(i(32, 48), 12, 9, 12), s.addMany(i(48, 64), 12, 0, 11), s.addMany(i(64, 127), 12, 12, 13), s.addMany(i(64, 127), 10, 12, 13), s.addMany(i(64, 127), 9, 12, 13), s.addMany(n, 13, 13, 13), s.addMany(r, 13, 13, 13), s.add(127, 13, 0, 13), s.addMany([
        27,
        156,
        24,
        26
    ], 13, 14, 0), s.add($5c2a9584e51cbabf$var$ke, 0, 2, 0), s.add($5c2a9584e51cbabf$var$ke, 8, 5, 8), s.add($5c2a9584e51cbabf$var$ke, 6, 0, 6), s.add($5c2a9584e51cbabf$var$ke, 11, 0, 11), s.add($5c2a9584e51cbabf$var$ke, 13, 13, 13), s;
}(), $5c2a9584e51cbabf$var$bn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e = $5c2a9584e51cbabf$var$hc){
        super();
        this._transitions = e;
        this._parseStack = {
            state: 0,
            handlers: [],
            handlerPos: 0,
            transition: 0,
            chunkPos: 0
        };
        this.initialState = 0, this.currentState = this.initialState, this._params = new $5c2a9584e51cbabf$var$ci, this._params.addParam(0), this._collect = 0, this.precedingJoinState = 0, this._printHandlerFb = (i, r, n)=>{}, this._executeHandlerFb = (i)=>{}, this._csiHandlerFb = (i, r)=>{}, this._escHandlerFb = (i)=>{}, this._errorHandlerFb = (i)=>i, this._printHandler = this._printHandlerFb, this._executeHandlers = Object.create(null), this._csiHandlers = Object.create(null), this._escHandlers = Object.create(null), this._register($5c2a9584e51cbabf$var$C(()=>{
            this._csiHandlers = Object.create(null), this._executeHandlers = Object.create(null), this._escHandlers = Object.create(null);
        })), this._oscParser = this._register(new $5c2a9584e51cbabf$var$mn), this._dcsParser = this._register(new $5c2a9584e51cbabf$var$_n), this._errorHandler = this._errorHandlerFb, this.registerEscHandler({
            final: "\\"
        }, ()=>!0);
    }
    _identifier(e, i = [
        64,
        126
    ]) {
        let r = 0;
        if (e.prefix) {
            if (e.prefix.length > 1) throw new Error("only one byte as prefix supported");
            if (r = e.prefix.charCodeAt(0), r && 60 > r || r > 63) throw new Error("prefix must be in range 0x3c .. 0x3f");
        }
        if (e.intermediates) {
            if (e.intermediates.length > 2) throw new Error("only two bytes as intermediates are supported");
            for(let o = 0; o < e.intermediates.length; ++o){
                let l = e.intermediates.charCodeAt(o);
                if (32 > l || l > 47) throw new Error("intermediate must be in range 0x20 .. 0x2f");
                r <<= 8, r |= l;
            }
        }
        if (e.final.length !== 1) throw new Error("final must be a single byte");
        let n = e.final.charCodeAt(0);
        if (i[0] > n || n > i[1]) throw new Error(`final must be in range ${i[0]} .. ${i[1]}`);
        return r <<= 8, r |= n, r;
    }
    identToString(e) {
        let i = [];
        for(; e;)i.push(String.fromCharCode(e & 255)), e >>= 8;
        return i.reverse().join("");
    }
    setPrintHandler(e) {
        this._printHandler = e;
    }
    clearPrintHandler() {
        this._printHandler = this._printHandlerFb;
    }
    registerEscHandler(e, i) {
        let r = this._identifier(e, [
            48,
            126
        ]);
        this._escHandlers[r] === void 0 && (this._escHandlers[r] = []);
        let n = this._escHandlers[r];
        return n.push(i), {
            dispose: ()=>{
                let o = n.indexOf(i);
                o !== -1 && n.splice(o, 1);
            }
        };
    }
    clearEscHandler(e) {
        this._escHandlers[this._identifier(e, [
            48,
            126
        ])] && delete this._escHandlers[this._identifier(e, [
            48,
            126
        ])];
    }
    setEscHandlerFallback(e) {
        this._escHandlerFb = e;
    }
    setExecuteHandler(e, i) {
        this._executeHandlers[e.charCodeAt(0)] = i;
    }
    clearExecuteHandler(e) {
        this._executeHandlers[e.charCodeAt(0)] && delete this._executeHandlers[e.charCodeAt(0)];
    }
    setExecuteHandlerFallback(e) {
        this._executeHandlerFb = e;
    }
    registerCsiHandler(e, i) {
        let r = this._identifier(e);
        this._csiHandlers[r] === void 0 && (this._csiHandlers[r] = []);
        let n = this._csiHandlers[r];
        return n.push(i), {
            dispose: ()=>{
                let o = n.indexOf(i);
                o !== -1 && n.splice(o, 1);
            }
        };
    }
    clearCsiHandler(e) {
        this._csiHandlers[this._identifier(e)] && delete this._csiHandlers[this._identifier(e)];
    }
    setCsiHandlerFallback(e) {
        this._csiHandlerFb = e;
    }
    registerDcsHandler(e, i) {
        return this._dcsParser.registerHandler(this._identifier(e), i);
    }
    clearDcsHandler(e) {
        this._dcsParser.clearHandler(this._identifier(e));
    }
    setDcsHandlerFallback(e) {
        this._dcsParser.setHandlerFallback(e);
    }
    registerOscHandler(e, i) {
        return this._oscParser.registerHandler(e, i);
    }
    clearOscHandler(e) {
        this._oscParser.clearHandler(e);
    }
    setOscHandlerFallback(e) {
        this._oscParser.setHandlerFallback(e);
    }
    setErrorHandler(e) {
        this._errorHandler = e;
    }
    clearErrorHandler() {
        this._errorHandler = this._errorHandlerFb;
    }
    reset() {
        this.currentState = this.initialState, this._oscParser.reset(), this._dcsParser.reset(), this._params.reset(), this._params.addParam(0), this._collect = 0, this.precedingJoinState = 0, this._parseStack.state !== 0 && (this._parseStack.state = 2, this._parseStack.handlers = []);
    }
    _preserveStack(e, i, r, n, o) {
        this._parseStack.state = e, this._parseStack.handlers = i, this._parseStack.handlerPos = r, this._parseStack.transition = n, this._parseStack.chunkPos = o;
    }
    parse(e, i, r) {
        let n = 0, o = 0, l = 0, a;
        if (this._parseStack.state) {
            if (this._parseStack.state === 2) this._parseStack.state = 0, l = this._parseStack.chunkPos + 1;
            else {
                if (r === void 0 || this._parseStack.state === 1) throw this._parseStack.state = 1, new Error("improper continuation due to previous async handler, giving up parsing");
                let u = this._parseStack.handlers, h = this._parseStack.handlerPos - 1;
                switch(this._parseStack.state){
                    case 3:
                        if (r === !1 && h > -1) {
                            for(; h >= 0 && (a = u[h](this._params), a !== !0); h--)if (a instanceof Promise) return this._parseStack.handlerPos = h, a;
                        }
                        this._parseStack.handlers = [];
                        break;
                    case 4:
                        if (r === !1 && h > -1) {
                            for(; h >= 0 && (a = u[h](), a !== !0); h--)if (a instanceof Promise) return this._parseStack.handlerPos = h, a;
                        }
                        this._parseStack.handlers = [];
                        break;
                    case 6:
                        if (n = e[this._parseStack.chunkPos], a = this._dcsParser.unhook(n !== 24 && n !== 26, r), a) return a;
                        n === 27 && (this._parseStack.transition |= 1), this._params.reset(), this._params.addParam(0), this._collect = 0;
                        break;
                    case 5:
                        if (n = e[this._parseStack.chunkPos], a = this._oscParser.end(n !== 24 && n !== 26, r), a) return a;
                        n === 27 && (this._parseStack.transition |= 1), this._params.reset(), this._params.addParam(0), this._collect = 0;
                        break;
                }
                this._parseStack.state = 0, l = this._parseStack.chunkPos + 1, this.precedingJoinState = 0, this.currentState = this._parseStack.transition & 15;
            }
        }
        for(let u = l; u < i; ++u){
            switch(n = e[u], o = this._transitions.table[this.currentState << 8 | (n < 160 ? n : $5c2a9584e51cbabf$var$ke)], o >> 4){
                case 2:
                    for(let m = u + 1;; ++m){
                        if (m >= i || (n = e[m]) < 32 || n > 126 && n < $5c2a9584e51cbabf$var$ke) {
                            this._printHandler(e, u, m), u = m - 1;
                            break;
                        }
                        if (++m >= i || (n = e[m]) < 32 || n > 126 && n < $5c2a9584e51cbabf$var$ke) {
                            this._printHandler(e, u, m), u = m - 1;
                            break;
                        }
                        if (++m >= i || (n = e[m]) < 32 || n > 126 && n < $5c2a9584e51cbabf$var$ke) {
                            this._printHandler(e, u, m), u = m - 1;
                            break;
                        }
                        if (++m >= i || (n = e[m]) < 32 || n > 126 && n < $5c2a9584e51cbabf$var$ke) {
                            this._printHandler(e, u, m), u = m - 1;
                            break;
                        }
                    }
                    break;
                case 3:
                    this._executeHandlers[n] ? this._executeHandlers[n]() : this._executeHandlerFb(n), this.precedingJoinState = 0;
                    break;
                case 0:
                    break;
                case 1:
                    if (this._errorHandler({
                        position: u,
                        code: n,
                        currentState: this.currentState,
                        collect: this._collect,
                        params: this._params,
                        abort: !1
                    }).abort) return;
                    break;
                case 7:
                    let c = this._csiHandlers[this._collect << 8 | n], d = c ? c.length - 1 : -1;
                    for(; d >= 0 && (a = c[d](this._params), a !== !0); d--)if (a instanceof Promise) return this._preserveStack(3, c, d, o, u), a;
                    d < 0 && this._csiHandlerFb(this._collect << 8 | n, this._params), this.precedingJoinState = 0;
                    break;
                case 8:
                    do switch(n){
                        case 59:
                            this._params.addParam(0);
                            break;
                        case 58:
                            this._params.addSubParam(-1);
                            break;
                        default:
                            this._params.addDigit(n - 48);
                    }
                    while (++u < i && (n = e[u]) > 47 && n < 60);
                    u--;
                    break;
                case 9:
                    this._collect <<= 8, this._collect |= n;
                    break;
                case 10:
                    let _ = this._escHandlers[this._collect << 8 | n], p = _ ? _.length - 1 : -1;
                    for(; p >= 0 && (a = _[p](), a !== !0); p--)if (a instanceof Promise) return this._preserveStack(4, _, p, o, u), a;
                    p < 0 && this._escHandlerFb(this._collect << 8 | n), this.precedingJoinState = 0;
                    break;
                case 11:
                    this._params.reset(), this._params.addParam(0), this._collect = 0;
                    break;
                case 12:
                    this._dcsParser.hook(this._collect << 8 | n, this._params);
                    break;
                case 13:
                    for(let m = u + 1;; ++m)if (m >= i || (n = e[m]) === 24 || n === 26 || n === 27 || n > 127 && n < $5c2a9584e51cbabf$var$ke) {
                        this._dcsParser.put(e, u, m), u = m - 1;
                        break;
                    }
                    break;
                case 14:
                    if (a = this._dcsParser.unhook(n !== 24 && n !== 26), a) return this._preserveStack(6, [], 0, o, u), a;
                    n === 27 && (o |= 1), this._params.reset(), this._params.addParam(0), this._collect = 0, this.precedingJoinState = 0;
                    break;
                case 4:
                    this._oscParser.start();
                    break;
                case 5:
                    for(let m = u + 1;; m++)if (m >= i || (n = e[m]) < 32 || n > 127 && n < $5c2a9584e51cbabf$var$ke) {
                        this._oscParser.put(e, u, m), u = m - 1;
                        break;
                    }
                    break;
                case 6:
                    if (a = this._oscParser.end(n !== 24 && n !== 26), a) return this._preserveStack(5, [], 0, o, u), a;
                    n === 27 && (o |= 1), this._params.reset(), this._params.addParam(0), this._collect = 0, this.precedingJoinState = 0;
                    break;
            }
            this.currentState = o & 15;
        }
    }
};
var $5c2a9584e51cbabf$var$dc = /^([\da-f])\/([\da-f])\/([\da-f])$|^([\da-f]{2})\/([\da-f]{2})\/([\da-f]{2})$|^([\da-f]{3})\/([\da-f]{3})\/([\da-f]{3})$|^([\da-f]{4})\/([\da-f]{4})\/([\da-f]{4})$/, $5c2a9584e51cbabf$var$fc = /^[\da-f]+$/;
function $5c2a9584e51cbabf$var$Ws(s) {
    if (!s) return;
    let t1 = s.toLowerCase();
    if (t1.indexOf("rgb:") === 0) {
        t1 = t1.slice(4);
        let e = $5c2a9584e51cbabf$var$dc.exec(t1);
        if (e) {
            let i = e[1] ? 15 : e[4] ? 255 : e[7] ? 4095 : 65535;
            return [
                Math.round(parseInt(e[1] || e[4] || e[7] || e[10], 16) / i * 255),
                Math.round(parseInt(e[2] || e[5] || e[8] || e[11], 16) / i * 255),
                Math.round(parseInt(e[3] || e[6] || e[9] || e[12], 16) / i * 255)
            ];
        }
    } else if (t1.indexOf("#") === 0 && (t1 = t1.slice(1), $5c2a9584e51cbabf$var$fc.exec(t1) && [
        3,
        6,
        9,
        12
    ].includes(t1.length))) {
        let e = t1.length / 3, i = [
            0,
            0,
            0
        ];
        for(let r = 0; r < 3; ++r){
            let n = parseInt(t1.slice(e * r, e * r + e), 16);
            i[r] = e === 1 ? n << 4 : e === 2 ? n : e === 3 ? n >> 4 : n >> 8;
        }
        return i;
    }
}
function $5c2a9584e51cbabf$var$Hs(s, t1) {
    let e = s.toString(16), i = e.length < 2 ? "0" + e : e;
    switch(t1){
        case 4:
            return e[0];
        case 8:
            return i;
        case 12:
            return (i + i).slice(0, 3);
        default:
            return i + i;
    }
}
function $5c2a9584e51cbabf$var$ml(s, t1 = 16) {
    let [e, i, r] = s;
    return `rgb:${$5c2a9584e51cbabf$var$Hs(e, t1)}/${$5c2a9584e51cbabf$var$Hs(i, t1)}/${$5c2a9584e51cbabf$var$Hs(r, t1)}`;
}
var $5c2a9584e51cbabf$var$mc = {
    "(": 0,
    ")": 1,
    "*": 2,
    "+": 3,
    "-": 1,
    ".": 2
}, $5c2a9584e51cbabf$var$ut = 131072, $5c2a9584e51cbabf$var$_l = 10;
function $5c2a9584e51cbabf$var$bl(s, t1) {
    if (s > 24) return t1.setWinLines || !1;
    switch(s){
        case 1:
            return !!t1.restoreWin;
        case 2:
            return !!t1.minimizeWin;
        case 3:
            return !!t1.setWinPosition;
        case 4:
            return !!t1.setWinSizePixels;
        case 5:
            return !!t1.raiseWin;
        case 6:
            return !!t1.lowerWin;
        case 7:
            return !!t1.refreshWin;
        case 8:
            return !!t1.setWinSizeChars;
        case 9:
            return !!t1.maximizeWin;
        case 10:
            return !!t1.fullscreenWin;
        case 11:
            return !!t1.getWinState;
        case 13:
            return !!t1.getWinPosition;
        case 14:
            return !!t1.getWinSizePixels;
        case 15:
            return !!t1.getScreenSizePixels;
        case 16:
            return !!t1.getCellSizePixels;
        case 18:
            return !!t1.getWinSizeChars;
        case 19:
            return !!t1.getScreenSizeChars;
        case 20:
            return !!t1.getIconTitle;
        case 21:
            return !!t1.getWinTitle;
        case 22:
            return !!t1.pushTitle;
        case 23:
            return !!t1.popTitle;
        case 24:
            return !!t1.setWinLines;
    }
    return !1;
}
var $5c2a9584e51cbabf$var$vl = 5e3, $5c2a9584e51cbabf$var$gl = 0, $5c2a9584e51cbabf$var$vn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o, l, a, u, h = new $5c2a9584e51cbabf$var$bn){
        super();
        this._bufferService = e;
        this._charsetService = i;
        this._coreService = r;
        this._logService = n;
        this._optionsService = o;
        this._oscLinkService = l;
        this._coreMouseService = a;
        this._unicodeService = u;
        this._parser = h;
        this._parseBuffer = new Uint32Array(4096);
        this._stringDecoder = new $5c2a9584e51cbabf$var$er;
        this._utf8Decoder = new $5c2a9584e51cbabf$var$tr;
        this._windowTitle = "";
        this._iconName = "";
        this._windowTitleStack = [];
        this._iconNameStack = [];
        this._curAttrData = $5c2a9584e51cbabf$var$X.clone();
        this._eraseAttrDataInternal = $5c2a9584e51cbabf$var$X.clone();
        this._onRequestBell = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestBell = this._onRequestBell.event;
        this._onRequestRefreshRows = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestRefreshRows = this._onRequestRefreshRows.event;
        this._onRequestReset = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestReset = this._onRequestReset.event;
        this._onRequestSendFocus = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestSendFocus = this._onRequestSendFocus.event;
        this._onRequestSyncScrollBar = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestSyncScrollBar = this._onRequestSyncScrollBar.event;
        this._onRequestWindowsOptionsReport = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRequestWindowsOptionsReport = this._onRequestWindowsOptionsReport.event;
        this._onA11yChar = this._register(new $5c2a9584e51cbabf$var$v);
        this.onA11yChar = this._onA11yChar.event;
        this._onA11yTab = this._register(new $5c2a9584e51cbabf$var$v);
        this.onA11yTab = this._onA11yTab.event;
        this._onCursorMove = this._register(new $5c2a9584e51cbabf$var$v);
        this.onCursorMove = this._onCursorMove.event;
        this._onLineFeed = this._register(new $5c2a9584e51cbabf$var$v);
        this.onLineFeed = this._onLineFeed.event;
        this._onScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this.onScroll = this._onScroll.event;
        this._onTitleChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onTitleChange = this._onTitleChange.event;
        this._onColor = this._register(new $5c2a9584e51cbabf$var$v);
        this.onColor = this._onColor.event;
        this._parseStack = {
            paused: !1,
            cursorStartX: 0,
            cursorStartY: 0,
            decodedLength: 0,
            position: 0
        };
        this._specialColors = [
            256,
            257,
            258
        ];
        this._register(this._parser), this._dirtyRowTracker = new $5c2a9584e51cbabf$var$Zi(this._bufferService), this._activeBuffer = this._bufferService.buffer, this._register(this._bufferService.buffers.onBufferActivate((c)=>this._activeBuffer = c.activeBuffer)), this._parser.setCsiHandlerFallback((c, d)=>{
            this._logService.debug("Unknown CSI code: ", {
                identifier: this._parser.identToString(c),
                params: d.toArray()
            });
        }), this._parser.setEscHandlerFallback((c)=>{
            this._logService.debug("Unknown ESC code: ", {
                identifier: this._parser.identToString(c)
            });
        }), this._parser.setExecuteHandlerFallback((c)=>{
            this._logService.debug("Unknown EXECUTE code: ", {
                code: c
            });
        }), this._parser.setOscHandlerFallback((c, d, _)=>{
            this._logService.debug("Unknown OSC code: ", {
                identifier: c,
                action: d,
                data: _
            });
        }), this._parser.setDcsHandlerFallback((c, d, _)=>{
            d === "HOOK" && (_ = _.toArray()), this._logService.debug("Unknown DCS code: ", {
                identifier: this._parser.identToString(c),
                action: d,
                payload: _
            });
        }), this._parser.setPrintHandler((c, d, _)=>this.print(c, d, _)), this._parser.registerCsiHandler({
            final: "@"
        }, (c)=>this.insertChars(c)), this._parser.registerCsiHandler({
            intermediates: " ",
            final: "@"
        }, (c)=>this.scrollLeft(c)), this._parser.registerCsiHandler({
            final: "A"
        }, (c)=>this.cursorUp(c)), this._parser.registerCsiHandler({
            intermediates: " ",
            final: "A"
        }, (c)=>this.scrollRight(c)), this._parser.registerCsiHandler({
            final: "B"
        }, (c)=>this.cursorDown(c)), this._parser.registerCsiHandler({
            final: "C"
        }, (c)=>this.cursorForward(c)), this._parser.registerCsiHandler({
            final: "D"
        }, (c)=>this.cursorBackward(c)), this._parser.registerCsiHandler({
            final: "E"
        }, (c)=>this.cursorNextLine(c)), this._parser.registerCsiHandler({
            final: "F"
        }, (c)=>this.cursorPrecedingLine(c)), this._parser.registerCsiHandler({
            final: "G"
        }, (c)=>this.cursorCharAbsolute(c)), this._parser.registerCsiHandler({
            final: "H"
        }, (c)=>this.cursorPosition(c)), this._parser.registerCsiHandler({
            final: "I"
        }, (c)=>this.cursorForwardTab(c)), this._parser.registerCsiHandler({
            final: "J"
        }, (c)=>this.eraseInDisplay(c, !1)), this._parser.registerCsiHandler({
            prefix: "?",
            final: "J"
        }, (c)=>this.eraseInDisplay(c, !0)), this._parser.registerCsiHandler({
            final: "K"
        }, (c)=>this.eraseInLine(c, !1)), this._parser.registerCsiHandler({
            prefix: "?",
            final: "K"
        }, (c)=>this.eraseInLine(c, !0)), this._parser.registerCsiHandler({
            final: "L"
        }, (c)=>this.insertLines(c)), this._parser.registerCsiHandler({
            final: "M"
        }, (c)=>this.deleteLines(c)), this._parser.registerCsiHandler({
            final: "P"
        }, (c)=>this.deleteChars(c)), this._parser.registerCsiHandler({
            final: "S"
        }, (c)=>this.scrollUp(c)), this._parser.registerCsiHandler({
            final: "T"
        }, (c)=>this.scrollDown(c)), this._parser.registerCsiHandler({
            final: "X"
        }, (c)=>this.eraseChars(c)), this._parser.registerCsiHandler({
            final: "Z"
        }, (c)=>this.cursorBackwardTab(c)), this._parser.registerCsiHandler({
            final: "`"
        }, (c)=>this.charPosAbsolute(c)), this._parser.registerCsiHandler({
            final: "a"
        }, (c)=>this.hPositionRelative(c)), this._parser.registerCsiHandler({
            final: "b"
        }, (c)=>this.repeatPrecedingCharacter(c)), this._parser.registerCsiHandler({
            final: "c"
        }, (c)=>this.sendDeviceAttributesPrimary(c)), this._parser.registerCsiHandler({
            prefix: ">",
            final: "c"
        }, (c)=>this.sendDeviceAttributesSecondary(c)), this._parser.registerCsiHandler({
            final: "d"
        }, (c)=>this.linePosAbsolute(c)), this._parser.registerCsiHandler({
            final: "e"
        }, (c)=>this.vPositionRelative(c)), this._parser.registerCsiHandler({
            final: "f"
        }, (c)=>this.hVPosition(c)), this._parser.registerCsiHandler({
            final: "g"
        }, (c)=>this.tabClear(c)), this._parser.registerCsiHandler({
            final: "h"
        }, (c)=>this.setMode(c)), this._parser.registerCsiHandler({
            prefix: "?",
            final: "h"
        }, (c)=>this.setModePrivate(c)), this._parser.registerCsiHandler({
            final: "l"
        }, (c)=>this.resetMode(c)), this._parser.registerCsiHandler({
            prefix: "?",
            final: "l"
        }, (c)=>this.resetModePrivate(c)), this._parser.registerCsiHandler({
            final: "m"
        }, (c)=>this.charAttributes(c)), this._parser.registerCsiHandler({
            final: "n"
        }, (c)=>this.deviceStatus(c)), this._parser.registerCsiHandler({
            prefix: "?",
            final: "n"
        }, (c)=>this.deviceStatusPrivate(c)), this._parser.registerCsiHandler({
            intermediates: "!",
            final: "p"
        }, (c)=>this.softReset(c)), this._parser.registerCsiHandler({
            intermediates: " ",
            final: "q"
        }, (c)=>this.setCursorStyle(c)), this._parser.registerCsiHandler({
            final: "r"
        }, (c)=>this.setScrollRegion(c)), this._parser.registerCsiHandler({
            final: "s"
        }, (c)=>this.saveCursor(c)), this._parser.registerCsiHandler({
            final: "t"
        }, (c)=>this.windowOptions(c)), this._parser.registerCsiHandler({
            final: "u"
        }, (c)=>this.restoreCursor(c)), this._parser.registerCsiHandler({
            intermediates: "'",
            final: "}"
        }, (c)=>this.insertColumns(c)), this._parser.registerCsiHandler({
            intermediates: "'",
            final: "~"
        }, (c)=>this.deleteColumns(c)), this._parser.registerCsiHandler({
            intermediates: '"',
            final: "q"
        }, (c)=>this.selectProtected(c)), this._parser.registerCsiHandler({
            intermediates: "$",
            final: "p"
        }, (c)=>this.requestMode(c, !0)), this._parser.registerCsiHandler({
            prefix: "?",
            intermediates: "$",
            final: "p"
        }, (c)=>this.requestMode(c, !1)), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.BEL, ()=>this.bell()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.LF, ()=>this.lineFeed()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.VT, ()=>this.lineFeed()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.FF, ()=>this.lineFeed()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.CR, ()=>this.carriageReturn()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.BS, ()=>this.backspace()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.HT, ()=>this.tab()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.SO, ()=>this.shiftOut()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$b.SI, ()=>this.shiftIn()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$Ai.IND, ()=>this.index()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$Ai.NEL, ()=>this.nextLine()), this._parser.setExecuteHandler($5c2a9584e51cbabf$var$Ai.HTS, ()=>this.tabSet()), this._parser.registerOscHandler(0, new $5c2a9584e51cbabf$var$pe((c)=>(this.setTitle(c), this.setIconName(c), !0))), this._parser.registerOscHandler(1, new $5c2a9584e51cbabf$var$pe((c)=>this.setIconName(c))), this._parser.registerOscHandler(2, new $5c2a9584e51cbabf$var$pe((c)=>this.setTitle(c))), this._parser.registerOscHandler(4, new $5c2a9584e51cbabf$var$pe((c)=>this.setOrReportIndexedColor(c))), this._parser.registerOscHandler(8, new $5c2a9584e51cbabf$var$pe((c)=>this.setHyperlink(c))), this._parser.registerOscHandler(10, new $5c2a9584e51cbabf$var$pe((c)=>this.setOrReportFgColor(c))), this._parser.registerOscHandler(11, new $5c2a9584e51cbabf$var$pe((c)=>this.setOrReportBgColor(c))), this._parser.registerOscHandler(12, new $5c2a9584e51cbabf$var$pe((c)=>this.setOrReportCursorColor(c))), this._parser.registerOscHandler(104, new $5c2a9584e51cbabf$var$pe((c)=>this.restoreIndexedColor(c))), this._parser.registerOscHandler(110, new $5c2a9584e51cbabf$var$pe((c)=>this.restoreFgColor(c))), this._parser.registerOscHandler(111, new $5c2a9584e51cbabf$var$pe((c)=>this.restoreBgColor(c))), this._parser.registerOscHandler(112, new $5c2a9584e51cbabf$var$pe((c)=>this.restoreCursorColor(c))), this._parser.registerEscHandler({
            final: "7"
        }, ()=>this.saveCursor()), this._parser.registerEscHandler({
            final: "8"
        }, ()=>this.restoreCursor()), this._parser.registerEscHandler({
            final: "D"
        }, ()=>this.index()), this._parser.registerEscHandler({
            final: "E"
        }, ()=>this.nextLine()), this._parser.registerEscHandler({
            final: "H"
        }, ()=>this.tabSet()), this._parser.registerEscHandler({
            final: "M"
        }, ()=>this.reverseIndex()), this._parser.registerEscHandler({
            final: "="
        }, ()=>this.keypadApplicationMode()), this._parser.registerEscHandler({
            final: ">"
        }, ()=>this.keypadNumericMode()), this._parser.registerEscHandler({
            final: "c"
        }, ()=>this.fullReset()), this._parser.registerEscHandler({
            final: "n"
        }, ()=>this.setgLevel(2)), this._parser.registerEscHandler({
            final: "o"
        }, ()=>this.setgLevel(3)), this._parser.registerEscHandler({
            final: "|"
        }, ()=>this.setgLevel(3)), this._parser.registerEscHandler({
            final: "}"
        }, ()=>this.setgLevel(2)), this._parser.registerEscHandler({
            final: "~"
        }, ()=>this.setgLevel(1)), this._parser.registerEscHandler({
            intermediates: "%",
            final: "@"
        }, ()=>this.selectDefaultCharset()), this._parser.registerEscHandler({
            intermediates: "%",
            final: "G"
        }, ()=>this.selectDefaultCharset());
        for(let c in $5c2a9584e51cbabf$var$ne)this._parser.registerEscHandler({
            intermediates: "(",
            final: c
        }, ()=>this.selectCharset("(" + c)), this._parser.registerEscHandler({
            intermediates: ")",
            final: c
        }, ()=>this.selectCharset(")" + c)), this._parser.registerEscHandler({
            intermediates: "*",
            final: c
        }, ()=>this.selectCharset("*" + c)), this._parser.registerEscHandler({
            intermediates: "+",
            final: c
        }, ()=>this.selectCharset("+" + c)), this._parser.registerEscHandler({
            intermediates: "-",
            final: c
        }, ()=>this.selectCharset("-" + c)), this._parser.registerEscHandler({
            intermediates: ".",
            final: c
        }, ()=>this.selectCharset("." + c)), this._parser.registerEscHandler({
            intermediates: "/",
            final: c
        }, ()=>this.selectCharset("/" + c));
        this._parser.registerEscHandler({
            intermediates: "#",
            final: "8"
        }, ()=>this.screenAlignmentPattern()), this._parser.setErrorHandler((c)=>(this._logService.error("Parsing error: ", c), c)), this._parser.registerDcsHandler({
            intermediates: "$",
            final: "q"
        }, new $5c2a9584e51cbabf$var$Xi((c, d)=>this.requestStatusString(c, d)));
    }
    getAttrData() {
        return this._curAttrData;
    }
    _preserveStack(e, i, r, n) {
        this._parseStack.paused = !0, this._parseStack.cursorStartX = e, this._parseStack.cursorStartY = i, this._parseStack.decodedLength = r, this._parseStack.position = n;
    }
    _logSlowResolvingAsync(e) {
        this._logService.logLevel <= 3 && Promise.race([
            e,
            new Promise((i, r)=>setTimeout(()=>r("#SLOW_TIMEOUT"), $5c2a9584e51cbabf$var$vl))
        ]).catch((i)=>{
            if (i !== "#SLOW_TIMEOUT") throw i;
            console.warn(`async parser handler taking longer than ${$5c2a9584e51cbabf$var$vl} ms`);
        });
    }
    _getCurrentLinkId() {
        return this._curAttrData.extended.urlId;
    }
    parse(e, i) {
        let r, n = this._activeBuffer.x, o = this._activeBuffer.y, l = 0, a = this._parseStack.paused;
        if (a) {
            if (r = this._parser.parse(this._parseBuffer, this._parseStack.decodedLength, i)) return this._logSlowResolvingAsync(r), r;
            n = this._parseStack.cursorStartX, o = this._parseStack.cursorStartY, this._parseStack.paused = !1, e.length > $5c2a9584e51cbabf$var$ut && (l = this._parseStack.position + $5c2a9584e51cbabf$var$ut);
        }
        if (this._logService.logLevel <= 1 && this._logService.debug(`parsing data ${typeof e == "string" ? ` "${e}"` : ` "${Array.prototype.map.call(e, (c)=>String.fromCharCode(c)).join("")}"`}`), this._logService.logLevel === 0 && this._logService.trace("parsing data (codes)", typeof e == "string" ? e.split("").map((c)=>c.charCodeAt(0)) : e), this._parseBuffer.length < e.length && this._parseBuffer.length < $5c2a9584e51cbabf$var$ut && (this._parseBuffer = new Uint32Array(Math.min(e.length, $5c2a9584e51cbabf$var$ut))), a || this._dirtyRowTracker.clearRange(), e.length > $5c2a9584e51cbabf$var$ut) for(let c = l; c < e.length; c += $5c2a9584e51cbabf$var$ut){
            let d = c + $5c2a9584e51cbabf$var$ut < e.length ? c + $5c2a9584e51cbabf$var$ut : e.length, _ = typeof e == "string" ? this._stringDecoder.decode(e.substring(c, d), this._parseBuffer) : this._utf8Decoder.decode(e.subarray(c, d), this._parseBuffer);
            if (r = this._parser.parse(this._parseBuffer, _)) return this._preserveStack(n, o, _, c), this._logSlowResolvingAsync(r), r;
        }
        else if (!a) {
            let c = typeof e == "string" ? this._stringDecoder.decode(e, this._parseBuffer) : this._utf8Decoder.decode(e, this._parseBuffer);
            if (r = this._parser.parse(this._parseBuffer, c)) return this._preserveStack(n, o, c, 0), this._logSlowResolvingAsync(r), r;
        }
        (this._activeBuffer.x !== n || this._activeBuffer.y !== o) && this._onCursorMove.fire();
        let u = this._dirtyRowTracker.end + (this._bufferService.buffer.ybase - this._bufferService.buffer.ydisp), h = this._dirtyRowTracker.start + (this._bufferService.buffer.ybase - this._bufferService.buffer.ydisp);
        h < this._bufferService.rows && this._onRequestRefreshRows.fire({
            start: Math.min(h, this._bufferService.rows - 1),
            end: Math.min(u, this._bufferService.rows - 1)
        });
    }
    print(e, i, r) {
        let n, o, l = this._charsetService.charset, a = this._optionsService.rawOptions.screenReaderMode, u = this._bufferService.cols, h = this._coreService.decPrivateModes.wraparound, c = this._coreService.modes.insertMode, d = this._curAttrData, _ = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y);
        this._dirtyRowTracker.markDirty(this._activeBuffer.y), this._activeBuffer.x && r - i > 0 && _.getWidth(this._activeBuffer.x - 1) === 2 && _.setCellFromCodepoint(this._activeBuffer.x - 1, 0, 1, d);
        let p = this._parser.precedingJoinState;
        for(let m = i; m < r; ++m){
            if (n = e[m], n < 127 && l) {
                let O = l[String.fromCharCode(n)];
                O && (n = O.charCodeAt(0));
            }
            let f = this._unicodeService.charProperties(n, p);
            o = $5c2a9584e51cbabf$var$Ae.extractWidth(f);
            let A = $5c2a9584e51cbabf$var$Ae.extractShouldJoin(f), R = A ? $5c2a9584e51cbabf$var$Ae.extractWidth(p) : 0;
            if (p = f, a && this._onA11yChar.fire($5c2a9584e51cbabf$var$Ce(n)), this._getCurrentLinkId() && this._oscLinkService.addLineToLink(this._getCurrentLinkId(), this._activeBuffer.ybase + this._activeBuffer.y), this._activeBuffer.x + o - R > u) {
                if (h) {
                    let O = _, I = this._activeBuffer.x - R;
                    for(this._activeBuffer.x = R, this._activeBuffer.y++, this._activeBuffer.y === this._activeBuffer.scrollBottom + 1 ? (this._activeBuffer.y--, this._bufferService.scroll(this._eraseAttrData(), !0)) : (this._activeBuffer.y >= this._bufferService.rows && (this._activeBuffer.y = this._bufferService.rows - 1), this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y).isWrapped = !0), _ = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y), R > 0 && _ instanceof $5c2a9584e51cbabf$var$Ze && _.copyCellsFrom(O, I, 0, R, !1); I < u;)O.setCellFromCodepoint(I++, 0, 1, d);
                } else if (this._activeBuffer.x = u - 1, o === 2) continue;
            }
            if (A && this._activeBuffer.x) {
                let O = _.getWidth(this._activeBuffer.x - 1) ? 1 : 2;
                _.addCodepointToCell(this._activeBuffer.x - O, n, o);
                for(let I = o - R; --I >= 0;)_.setCellFromCodepoint(this._activeBuffer.x++, 0, 0, d);
                continue;
            }
            if (c && (_.insertCells(this._activeBuffer.x, o - R, this._activeBuffer.getNullCell(d)), _.getWidth(u - 1) === 2 && _.setCellFromCodepoint(u - 1, 0, 1, d)), _.setCellFromCodepoint(this._activeBuffer.x++, n, o, d), o > 0) for(; --o;)_.setCellFromCodepoint(this._activeBuffer.x++, 0, 0, d);
        }
        this._parser.precedingJoinState = p, this._activeBuffer.x < u && r - i > 0 && _.getWidth(this._activeBuffer.x) === 0 && !_.hasContent(this._activeBuffer.x) && _.setCellFromCodepoint(this._activeBuffer.x, 0, 1, d), this._dirtyRowTracker.markDirty(this._activeBuffer.y);
    }
    registerCsiHandler(e, i) {
        return e.final === "t" && !e.prefix && !e.intermediates ? this._parser.registerCsiHandler(e, (r)=>$5c2a9584e51cbabf$var$bl(r.params[0], this._optionsService.rawOptions.windowOptions) ? i(r) : !0) : this._parser.registerCsiHandler(e, i);
    }
    registerDcsHandler(e, i) {
        return this._parser.registerDcsHandler(e, new $5c2a9584e51cbabf$var$Xi(i));
    }
    registerEscHandler(e, i) {
        return this._parser.registerEscHandler(e, i);
    }
    registerOscHandler(e, i) {
        return this._parser.registerOscHandler(e, new $5c2a9584e51cbabf$var$pe(i));
    }
    bell() {
        return this._onRequestBell.fire(), !0;
    }
    lineFeed() {
        return this._dirtyRowTracker.markDirty(this._activeBuffer.y), this._optionsService.rawOptions.convertEol && (this._activeBuffer.x = 0), this._activeBuffer.y++, this._activeBuffer.y === this._activeBuffer.scrollBottom + 1 ? (this._activeBuffer.y--, this._bufferService.scroll(this._eraseAttrData())) : this._activeBuffer.y >= this._bufferService.rows ? this._activeBuffer.y = this._bufferService.rows - 1 : this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y).isWrapped = !1, this._activeBuffer.x >= this._bufferService.cols && this._activeBuffer.x--, this._dirtyRowTracker.markDirty(this._activeBuffer.y), this._onLineFeed.fire(), !0;
    }
    carriageReturn() {
        return this._activeBuffer.x = 0, !0;
    }
    backspace() {
        if (!this._coreService.decPrivateModes.reverseWraparound) return this._restrictCursor(), this._activeBuffer.x > 0 && this._activeBuffer.x--, !0;
        if (this._restrictCursor(this._bufferService.cols), this._activeBuffer.x > 0) this._activeBuffer.x--;
        else if (this._activeBuffer.x === 0 && this._activeBuffer.y > this._activeBuffer.scrollTop && this._activeBuffer.y <= this._activeBuffer.scrollBottom && this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y)?.isWrapped) {
            this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y).isWrapped = !1, this._activeBuffer.y--, this._activeBuffer.x = this._bufferService.cols - 1;
            let e = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y);
            e.hasWidth(this._activeBuffer.x) && !e.hasContent(this._activeBuffer.x) && this._activeBuffer.x--;
        }
        return this._restrictCursor(), !0;
    }
    tab() {
        if (this._activeBuffer.x >= this._bufferService.cols) return !0;
        let e = this._activeBuffer.x;
        return this._activeBuffer.x = this._activeBuffer.nextStop(), this._optionsService.rawOptions.screenReaderMode && this._onA11yTab.fire(this._activeBuffer.x - e), !0;
    }
    shiftOut() {
        return this._charsetService.setgLevel(1), !0;
    }
    shiftIn() {
        return this._charsetService.setgLevel(0), !0;
    }
    _restrictCursor(e = this._bufferService.cols - 1) {
        this._activeBuffer.x = Math.min(e, Math.max(0, this._activeBuffer.x)), this._activeBuffer.y = this._coreService.decPrivateModes.origin ? Math.min(this._activeBuffer.scrollBottom, Math.max(this._activeBuffer.scrollTop, this._activeBuffer.y)) : Math.min(this._bufferService.rows - 1, Math.max(0, this._activeBuffer.y)), this._dirtyRowTracker.markDirty(this._activeBuffer.y);
    }
    _setCursor(e, i) {
        this._dirtyRowTracker.markDirty(this._activeBuffer.y), this._coreService.decPrivateModes.origin ? (this._activeBuffer.x = e, this._activeBuffer.y = this._activeBuffer.scrollTop + i) : (this._activeBuffer.x = e, this._activeBuffer.y = i), this._restrictCursor(), this._dirtyRowTracker.markDirty(this._activeBuffer.y);
    }
    _moveCursor(e, i) {
        this._restrictCursor(), this._setCursor(this._activeBuffer.x + e, this._activeBuffer.y + i);
    }
    cursorUp(e) {
        let i = this._activeBuffer.y - this._activeBuffer.scrollTop;
        return i >= 0 ? this._moveCursor(0, -Math.min(i, e.params[0] || 1)) : this._moveCursor(0, -(e.params[0] || 1)), !0;
    }
    cursorDown(e) {
        let i = this._activeBuffer.scrollBottom - this._activeBuffer.y;
        return i >= 0 ? this._moveCursor(0, Math.min(i, e.params[0] || 1)) : this._moveCursor(0, e.params[0] || 1), !0;
    }
    cursorForward(e) {
        return this._moveCursor(e.params[0] || 1, 0), !0;
    }
    cursorBackward(e) {
        return this._moveCursor(-(e.params[0] || 1), 0), !0;
    }
    cursorNextLine(e) {
        return this.cursorDown(e), this._activeBuffer.x = 0, !0;
    }
    cursorPrecedingLine(e) {
        return this.cursorUp(e), this._activeBuffer.x = 0, !0;
    }
    cursorCharAbsolute(e) {
        return this._setCursor((e.params[0] || 1) - 1, this._activeBuffer.y), !0;
    }
    cursorPosition(e) {
        return this._setCursor(e.length >= 2 ? (e.params[1] || 1) - 1 : 0, (e.params[0] || 1) - 1), !0;
    }
    charPosAbsolute(e) {
        return this._setCursor((e.params[0] || 1) - 1, this._activeBuffer.y), !0;
    }
    hPositionRelative(e) {
        return this._moveCursor(e.params[0] || 1, 0), !0;
    }
    linePosAbsolute(e) {
        return this._setCursor(this._activeBuffer.x, (e.params[0] || 1) - 1), !0;
    }
    vPositionRelative(e) {
        return this._moveCursor(0, e.params[0] || 1), !0;
    }
    hVPosition(e) {
        return this.cursorPosition(e), !0;
    }
    tabClear(e) {
        let i = e.params[0];
        return i === 0 ? delete this._activeBuffer.tabs[this._activeBuffer.x] : i === 3 && (this._activeBuffer.tabs = {}), !0;
    }
    cursorForwardTab(e) {
        if (this._activeBuffer.x >= this._bufferService.cols) return !0;
        let i = e.params[0] || 1;
        for(; i--;)this._activeBuffer.x = this._activeBuffer.nextStop();
        return !0;
    }
    cursorBackwardTab(e) {
        if (this._activeBuffer.x >= this._bufferService.cols) return !0;
        let i = e.params[0] || 1;
        for(; i--;)this._activeBuffer.x = this._activeBuffer.prevStop();
        return !0;
    }
    selectProtected(e) {
        let i = e.params[0];
        return i === 1 && (this._curAttrData.bg |= 536870912), (i === 2 || i === 0) && (this._curAttrData.bg &= -536870913), !0;
    }
    _eraseInBufferLine(e, i, r, n = !1, o = !1) {
        let l = this._activeBuffer.lines.get(this._activeBuffer.ybase + e);
        l.replaceCells(i, r, this._activeBuffer.getNullCell(this._eraseAttrData()), o), n && (l.isWrapped = !1);
    }
    _resetBufferLine(e, i = !1) {
        let r = this._activeBuffer.lines.get(this._activeBuffer.ybase + e);
        r && (r.fill(this._activeBuffer.getNullCell(this._eraseAttrData()), i), this._bufferService.buffer.clearMarkers(this._activeBuffer.ybase + e), r.isWrapped = !1);
    }
    eraseInDisplay(e, i = !1) {
        this._restrictCursor(this._bufferService.cols);
        let r;
        switch(e.params[0]){
            case 0:
                for(r = this._activeBuffer.y, this._dirtyRowTracker.markDirty(r), this._eraseInBufferLine(r++, this._activeBuffer.x, this._bufferService.cols, this._activeBuffer.x === 0, i); r < this._bufferService.rows; r++)this._resetBufferLine(r, i);
                this._dirtyRowTracker.markDirty(r);
                break;
            case 1:
                for(r = this._activeBuffer.y, this._dirtyRowTracker.markDirty(r), this._eraseInBufferLine(r, 0, this._activeBuffer.x + 1, !0, i), this._activeBuffer.x + 1 >= this._bufferService.cols && (this._activeBuffer.lines.get(r + 1).isWrapped = !1); r--;)this._resetBufferLine(r, i);
                this._dirtyRowTracker.markDirty(0);
                break;
            case 2:
                if (this._optionsService.rawOptions.scrollOnEraseInDisplay) {
                    for(r = this._bufferService.rows, this._dirtyRowTracker.markRangeDirty(0, r - 1); r-- && !this._activeBuffer.lines.get(this._activeBuffer.ybase + r)?.getTrimmedLength(););
                    for(; r >= 0; r--)this._bufferService.scroll(this._eraseAttrData());
                } else {
                    for(r = this._bufferService.rows, this._dirtyRowTracker.markDirty(r - 1); r--;)this._resetBufferLine(r, i);
                    this._dirtyRowTracker.markDirty(0);
                }
                break;
            case 3:
                let n = this._activeBuffer.lines.length - this._bufferService.rows;
                n > 0 && (this._activeBuffer.lines.trimStart(n), this._activeBuffer.ybase = Math.max(this._activeBuffer.ybase - n, 0), this._activeBuffer.ydisp = Math.max(this._activeBuffer.ydisp - n, 0), this._onScroll.fire(0));
                break;
        }
        return !0;
    }
    eraseInLine(e, i = !1) {
        switch(this._restrictCursor(this._bufferService.cols), e.params[0]){
            case 0:
                this._eraseInBufferLine(this._activeBuffer.y, this._activeBuffer.x, this._bufferService.cols, this._activeBuffer.x === 0, i);
                break;
            case 1:
                this._eraseInBufferLine(this._activeBuffer.y, 0, this._activeBuffer.x + 1, !1, i);
                break;
            case 2:
                this._eraseInBufferLine(this._activeBuffer.y, 0, this._bufferService.cols, !0, i);
                break;
        }
        return this._dirtyRowTracker.markDirty(this._activeBuffer.y), !0;
    }
    insertLines(e) {
        this._restrictCursor();
        let i = e.params[0] || 1;
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let r = this._activeBuffer.ybase + this._activeBuffer.y, n = this._bufferService.rows - 1 - this._activeBuffer.scrollBottom, o = this._bufferService.rows - 1 + this._activeBuffer.ybase - n + 1;
        for(; i--;)this._activeBuffer.lines.splice(o - 1, 1), this._activeBuffer.lines.splice(r, 0, this._activeBuffer.getBlankLine(this._eraseAttrData()));
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.y, this._activeBuffer.scrollBottom), this._activeBuffer.x = 0, !0;
    }
    deleteLines(e) {
        this._restrictCursor();
        let i = e.params[0] || 1;
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let r = this._activeBuffer.ybase + this._activeBuffer.y, n;
        for(n = this._bufferService.rows - 1 - this._activeBuffer.scrollBottom, n = this._bufferService.rows - 1 + this._activeBuffer.ybase - n; i--;)this._activeBuffer.lines.splice(r, 1), this._activeBuffer.lines.splice(n, 0, this._activeBuffer.getBlankLine(this._eraseAttrData()));
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.y, this._activeBuffer.scrollBottom), this._activeBuffer.x = 0, !0;
    }
    insertChars(e) {
        this._restrictCursor();
        let i = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y);
        return i && (i.insertCells(this._activeBuffer.x, e.params[0] || 1, this._activeBuffer.getNullCell(this._eraseAttrData())), this._dirtyRowTracker.markDirty(this._activeBuffer.y)), !0;
    }
    deleteChars(e) {
        this._restrictCursor();
        let i = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y);
        return i && (i.deleteCells(this._activeBuffer.x, e.params[0] || 1, this._activeBuffer.getNullCell(this._eraseAttrData())), this._dirtyRowTracker.markDirty(this._activeBuffer.y)), !0;
    }
    scrollUp(e) {
        let i = e.params[0] || 1;
        for(; i--;)this._activeBuffer.lines.splice(this._activeBuffer.ybase + this._activeBuffer.scrollTop, 1), this._activeBuffer.lines.splice(this._activeBuffer.ybase + this._activeBuffer.scrollBottom, 0, this._activeBuffer.getBlankLine(this._eraseAttrData()));
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    scrollDown(e) {
        let i = e.params[0] || 1;
        for(; i--;)this._activeBuffer.lines.splice(this._activeBuffer.ybase + this._activeBuffer.scrollBottom, 1), this._activeBuffer.lines.splice(this._activeBuffer.ybase + this._activeBuffer.scrollTop, 0, this._activeBuffer.getBlankLine($5c2a9584e51cbabf$var$X));
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    scrollLeft(e) {
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let i = e.params[0] || 1;
        for(let r = this._activeBuffer.scrollTop; r <= this._activeBuffer.scrollBottom; ++r){
            let n = this._activeBuffer.lines.get(this._activeBuffer.ybase + r);
            n.deleteCells(0, i, this._activeBuffer.getNullCell(this._eraseAttrData())), n.isWrapped = !1;
        }
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    scrollRight(e) {
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let i = e.params[0] || 1;
        for(let r = this._activeBuffer.scrollTop; r <= this._activeBuffer.scrollBottom; ++r){
            let n = this._activeBuffer.lines.get(this._activeBuffer.ybase + r);
            n.insertCells(0, i, this._activeBuffer.getNullCell(this._eraseAttrData())), n.isWrapped = !1;
        }
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    insertColumns(e) {
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let i = e.params[0] || 1;
        for(let r = this._activeBuffer.scrollTop; r <= this._activeBuffer.scrollBottom; ++r){
            let n = this._activeBuffer.lines.get(this._activeBuffer.ybase + r);
            n.insertCells(this._activeBuffer.x, i, this._activeBuffer.getNullCell(this._eraseAttrData())), n.isWrapped = !1;
        }
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    deleteColumns(e) {
        if (this._activeBuffer.y > this._activeBuffer.scrollBottom || this._activeBuffer.y < this._activeBuffer.scrollTop) return !0;
        let i = e.params[0] || 1;
        for(let r = this._activeBuffer.scrollTop; r <= this._activeBuffer.scrollBottom; ++r){
            let n = this._activeBuffer.lines.get(this._activeBuffer.ybase + r);
            n.deleteCells(this._activeBuffer.x, i, this._activeBuffer.getNullCell(this._eraseAttrData())), n.isWrapped = !1;
        }
        return this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom), !0;
    }
    eraseChars(e) {
        this._restrictCursor();
        let i = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y);
        return i && (i.replaceCells(this._activeBuffer.x, this._activeBuffer.x + (e.params[0] || 1), this._activeBuffer.getNullCell(this._eraseAttrData())), this._dirtyRowTracker.markDirty(this._activeBuffer.y)), !0;
    }
    repeatPrecedingCharacter(e) {
        let i = this._parser.precedingJoinState;
        if (!i) return !0;
        let r = e.params[0] || 1, n = $5c2a9584e51cbabf$var$Ae.extractWidth(i), o = this._activeBuffer.x - n, a = this._activeBuffer.lines.get(this._activeBuffer.ybase + this._activeBuffer.y).getString(o), u = new Uint32Array(a.length * r), h = 0;
        for(let d = 0; d < a.length;){
            let _ = a.codePointAt(d) || 0;
            u[h++] = _, d += _ > 65535 ? 2 : 1;
        }
        let c = h;
        for(let d = 1; d < r; ++d)u.copyWithin(c, 0, h), c += h;
        return this.print(u, 0, c), !0;
    }
    sendDeviceAttributesPrimary(e) {
        return e.params[0] > 0 || (this._is("xterm") || this._is("rxvt-unicode") || this._is("screen") ? this._coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[?1;2c") : this._is("linux") && this._coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[?6c")), !0;
    }
    sendDeviceAttributesSecondary(e) {
        return e.params[0] > 0 || (this._is("xterm") ? this._coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[>0;276;0c") : this._is("rxvt-unicode") ? this._coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[>85;95;0c") : this._is("linux") ? this._coreService.triggerDataEvent(e.params[0] + "c") : this._is("screen") && this._coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[>83;40003;0c")), !0;
    }
    _is(e) {
        return (this._optionsService.rawOptions.termName + "").indexOf(e) === 0;
    }
    setMode(e) {
        for(let i = 0; i < e.length; i++)switch(e.params[i]){
            case 4:
                this._coreService.modes.insertMode = !0;
                break;
            case 20:
                this._optionsService.options.convertEol = !0;
                break;
        }
        return !0;
    }
    setModePrivate(e) {
        for(let i = 0; i < e.length; i++)switch(e.params[i]){
            case 1:
                this._coreService.decPrivateModes.applicationCursorKeys = !0;
                break;
            case 2:
                this._charsetService.setgCharset(0, $5c2a9584e51cbabf$var$Je), this._charsetService.setgCharset(1, $5c2a9584e51cbabf$var$Je), this._charsetService.setgCharset(2, $5c2a9584e51cbabf$var$Je), this._charsetService.setgCharset(3, $5c2a9584e51cbabf$var$Je);
                break;
            case 3:
                this._optionsService.rawOptions.windowOptions.setWinLines && (this._bufferService.resize(132, this._bufferService.rows), this._onRequestReset.fire());
                break;
            case 6:
                this._coreService.decPrivateModes.origin = !0, this._setCursor(0, 0);
                break;
            case 7:
                this._coreService.decPrivateModes.wraparound = !0;
                break;
            case 12:
                this._optionsService.options.cursorBlink = !0;
                break;
            case 45:
                this._coreService.decPrivateModes.reverseWraparound = !0;
                break;
            case 66:
                this._logService.debug("Serial port requested application keypad."), this._coreService.decPrivateModes.applicationKeypad = !0, this._onRequestSyncScrollBar.fire();
                break;
            case 9:
                this._coreMouseService.activeProtocol = "X10";
                break;
            case 1e3:
                this._coreMouseService.activeProtocol = "VT200";
                break;
            case 1002:
                this._coreMouseService.activeProtocol = "DRAG";
                break;
            case 1003:
                this._coreMouseService.activeProtocol = "ANY";
                break;
            case 1004:
                this._coreService.decPrivateModes.sendFocus = !0, this._onRequestSendFocus.fire();
                break;
            case 1005:
                this._logService.debug("DECSET 1005 not supported (see #2507)");
                break;
            case 1006:
                this._coreMouseService.activeEncoding = "SGR";
                break;
            case 1015:
                this._logService.debug("DECSET 1015 not supported (see #2507)");
                break;
            case 1016:
                this._coreMouseService.activeEncoding = "SGR_PIXELS";
                break;
            case 25:
                this._coreService.isCursorHidden = !1;
                break;
            case 1048:
                this.saveCursor();
                break;
            case 1049:
                this.saveCursor();
            case 47:
            case 1047:
                this._bufferService.buffers.activateAltBuffer(this._eraseAttrData()), this._coreService.isCursorInitialized = !0, this._onRequestRefreshRows.fire(void 0), this._onRequestSyncScrollBar.fire();
                break;
            case 2004:
                this._coreService.decPrivateModes.bracketedPasteMode = !0;
                break;
            case 2026:
                this._coreService.decPrivateModes.synchronizedOutput = !0;
                break;
        }
        return !0;
    }
    resetMode(e) {
        for(let i = 0; i < e.length; i++)switch(e.params[i]){
            case 4:
                this._coreService.modes.insertMode = !1;
                break;
            case 20:
                this._optionsService.options.convertEol = !1;
                break;
        }
        return !0;
    }
    resetModePrivate(e) {
        for(let i = 0; i < e.length; i++)switch(e.params[i]){
            case 1:
                this._coreService.decPrivateModes.applicationCursorKeys = !1;
                break;
            case 3:
                this._optionsService.rawOptions.windowOptions.setWinLines && (this._bufferService.resize(80, this._bufferService.rows), this._onRequestReset.fire());
                break;
            case 6:
                this._coreService.decPrivateModes.origin = !1, this._setCursor(0, 0);
                break;
            case 7:
                this._coreService.decPrivateModes.wraparound = !1;
                break;
            case 12:
                this._optionsService.options.cursorBlink = !1;
                break;
            case 45:
                this._coreService.decPrivateModes.reverseWraparound = !1;
                break;
            case 66:
                this._logService.debug("Switching back to normal keypad."), this._coreService.decPrivateModes.applicationKeypad = !1, this._onRequestSyncScrollBar.fire();
                break;
            case 9:
            case 1e3:
            case 1002:
            case 1003:
                this._coreMouseService.activeProtocol = "NONE";
                break;
            case 1004:
                this._coreService.decPrivateModes.sendFocus = !1;
                break;
            case 1005:
                this._logService.debug("DECRST 1005 not supported (see #2507)");
                break;
            case 1006:
                this._coreMouseService.activeEncoding = "DEFAULT";
                break;
            case 1015:
                this._logService.debug("DECRST 1015 not supported (see #2507)");
                break;
            case 1016:
                this._coreMouseService.activeEncoding = "DEFAULT";
                break;
            case 25:
                this._coreService.isCursorHidden = !0;
                break;
            case 1048:
                this.restoreCursor();
                break;
            case 1049:
            case 47:
            case 1047:
                this._bufferService.buffers.activateNormalBuffer(), e.params[i] === 1049 && this.restoreCursor(), this._coreService.isCursorInitialized = !0, this._onRequestRefreshRows.fire(void 0), this._onRequestSyncScrollBar.fire();
                break;
            case 2004:
                this._coreService.decPrivateModes.bracketedPasteMode = !1;
                break;
            case 2026:
                this._coreService.decPrivateModes.synchronizedOutput = !1, this._onRequestRefreshRows.fire(void 0);
                break;
        }
        return !0;
    }
    requestMode(e, i) {
        let r;
        ((P)=>(P[P.NOT_RECOGNIZED = 0] = "NOT_RECOGNIZED", P[P.SET = 1] = "SET", P[P.RESET = 2] = "RESET", P[P.PERMANENTLY_SET = 3] = "PERMANENTLY_SET", P[P.PERMANENTLY_RESET = 4] = "PERMANENTLY_RESET"))(r ||= {});
        let n = this._coreService.decPrivateModes, { activeProtocol: o, activeEncoding: l } = this._coreMouseService, a = this._coreService, { buffers: u, cols: h } = this._bufferService, { active: c, alt: d } = u, _ = this._optionsService.rawOptions, p = (A, R)=>(a.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[${i ? "" : "?"}${A};${R}$y`), !0), m = (A)=>A ? 1 : 2, f = e.params[0];
        return i ? f === 2 ? p(f, 4) : f === 4 ? p(f, m(a.modes.insertMode)) : f === 12 ? p(f, 3) : f === 20 ? p(f, m(_.convertEol)) : p(f, 0) : f === 1 ? p(f, m(n.applicationCursorKeys)) : f === 3 ? p(f, _.windowOptions.setWinLines ? h === 80 ? 2 : h === 132 ? 1 : 0 : 0) : f === 6 ? p(f, m(n.origin)) : f === 7 ? p(f, m(n.wraparound)) : f === 8 ? p(f, 3) : f === 9 ? p(f, m(o === "X10")) : f === 12 ? p(f, m(_.cursorBlink)) : f === 25 ? p(f, m(!a.isCursorHidden)) : f === 45 ? p(f, m(n.reverseWraparound)) : f === 66 ? p(f, m(n.applicationKeypad)) : f === 67 ? p(f, 4) : f === 1e3 ? p(f, m(o === "VT200")) : f === 1002 ? p(f, m(o === "DRAG")) : f === 1003 ? p(f, m(o === "ANY")) : f === 1004 ? p(f, m(n.sendFocus)) : f === 1005 ? p(f, 4) : f === 1006 ? p(f, m(l === "SGR")) : f === 1015 ? p(f, 4) : f === 1016 ? p(f, m(l === "SGR_PIXELS")) : f === 1048 ? p(f, 1) : f === 47 || f === 1047 || f === 1049 ? p(f, m(c === d)) : f === 2004 ? p(f, m(n.bracketedPasteMode)) : f === 2026 ? p(f, m(n.synchronizedOutput)) : p(f, 0);
    }
    _updateAttrColor(e, i, r, n, o) {
        return i === 2 ? (e |= 50331648, e &= -16777216, e |= $5c2a9584e51cbabf$var$De.fromColorRGB([
            r,
            n,
            o
        ])) : i === 5 && (e &= -50331904, e |= 33554432 | r & 255), e;
    }
    _extractColor(e, i, r) {
        let n = [
            0,
            0,
            -1,
            0,
            0,
            0
        ], o = 0, l = 0;
        do {
            if (n[l + o] = e.params[i + l], e.hasSubParams(i + l)) {
                let a = e.getSubParams(i + l), u = 0;
                do n[1] === 5 && (o = 1), n[l + u + 1 + o] = a[u];
                while (++u < a.length && u + l + 1 + o < n.length);
                break;
            }
            if (n[1] === 5 && l + o >= 2 || n[1] === 2 && l + o >= 5) break;
            n[1] && (o = 1);
        }while (++l + i < e.length && l + o < n.length);
        for(let a = 2; a < n.length; ++a)n[a] === -1 && (n[a] = 0);
        switch(n[0]){
            case 38:
                r.fg = this._updateAttrColor(r.fg, n[1], n[3], n[4], n[5]);
                break;
            case 48:
                r.bg = this._updateAttrColor(r.bg, n[1], n[3], n[4], n[5]);
                break;
            case 58:
                r.extended = r.extended.clone(), r.extended.underlineColor = this._updateAttrColor(r.extended.underlineColor, n[1], n[3], n[4], n[5]);
        }
        return l;
    }
    _processUnderline(e, i) {
        i.extended = i.extended.clone(), (!~e || e > 5) && (e = 1), i.extended.underlineStyle = e, i.fg |= 268435456, e === 0 && (i.fg &= -268435457), i.updateExtended();
    }
    _processSGR0(e) {
        e.fg = $5c2a9584e51cbabf$var$X.fg, e.bg = $5c2a9584e51cbabf$var$X.bg, e.extended = e.extended.clone(), e.extended.underlineStyle = 0, e.extended.underlineColor &= -67108864, e.updateExtended();
    }
    charAttributes(e) {
        if (e.length === 1 && e.params[0] === 0) return this._processSGR0(this._curAttrData), !0;
        let i = e.length, r, n = this._curAttrData;
        for(let o = 0; o < i; o++)r = e.params[o], r >= 30 && r <= 37 ? (n.fg &= -50331904, n.fg |= 16777216 | r - 30) : r >= 40 && r <= 47 ? (n.bg &= -50331904, n.bg |= 16777216 | r - 40) : r >= 90 && r <= 97 ? (n.fg &= -50331904, n.fg |= 16777216 | r - 90 | 8) : r >= 100 && r <= 107 ? (n.bg &= -50331904, n.bg |= 16777216 | r - 100 | 8) : r === 0 ? this._processSGR0(n) : r === 1 ? n.fg |= 134217728 : r === 3 ? n.bg |= 67108864 : r === 4 ? (n.fg |= 268435456, this._processUnderline(e.hasSubParams(o) ? e.getSubParams(o)[0] : 1, n)) : r === 5 ? n.fg |= 536870912 : r === 7 ? n.fg |= 67108864 : r === 8 ? n.fg |= 1073741824 : r === 9 ? n.fg |= 2147483648 : r === 2 ? n.bg |= 134217728 : r === 21 ? this._processUnderline(2, n) : r === 22 ? (n.fg &= -134217729, n.bg &= -134217729) : r === 23 ? n.bg &= -67108865 : r === 24 ? (n.fg &= -268435457, this._processUnderline(0, n)) : r === 25 ? n.fg &= -536870913 : r === 27 ? n.fg &= -67108865 : r === 28 ? n.fg &= -1073741825 : r === 29 ? n.fg &= 2147483647 : r === 39 ? (n.fg &= -67108864, n.fg |= $5c2a9584e51cbabf$var$X.fg & 16777215) : r === 49 ? (n.bg &= -67108864, n.bg |= $5c2a9584e51cbabf$var$X.bg & 16777215) : r === 38 || r === 48 || r === 58 ? o += this._extractColor(e, o, n) : r === 53 ? n.bg |= 1073741824 : r === 55 ? n.bg &= -1073741825 : r === 59 ? (n.extended = n.extended.clone(), n.extended.underlineColor = -1, n.updateExtended()) : r === 100 ? (n.fg &= -67108864, n.fg |= $5c2a9584e51cbabf$var$X.fg & 16777215, n.bg &= -67108864, n.bg |= $5c2a9584e51cbabf$var$X.bg & 16777215) : this._logService.debug("Unknown SGR attribute: %d.", r);
        return !0;
    }
    deviceStatus(e) {
        switch(e.params[0]){
            case 5:
                this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[0n`);
                break;
            case 6:
                let i = this._activeBuffer.y + 1, r = this._activeBuffer.x + 1;
                this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[${i};${r}R`);
                break;
        }
        return !0;
    }
    deviceStatusPrivate(e) {
        switch(e.params[0]){
            case 6:
                let i = this._activeBuffer.y + 1, r = this._activeBuffer.x + 1;
                this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[?${i};${r}R`);
                break;
            case 15:
                break;
            case 25:
                break;
            case 26:
                break;
            case 53:
                break;
        }
        return !0;
    }
    softReset(e) {
        return this._coreService.isCursorHidden = !1, this._onRequestSyncScrollBar.fire(), this._activeBuffer.scrollTop = 0, this._activeBuffer.scrollBottom = this._bufferService.rows - 1, this._curAttrData = $5c2a9584e51cbabf$var$X.clone(), this._coreService.reset(), this._charsetService.reset(), this._activeBuffer.savedX = 0, this._activeBuffer.savedY = this._activeBuffer.ybase, this._activeBuffer.savedCurAttrData.fg = this._curAttrData.fg, this._activeBuffer.savedCurAttrData.bg = this._curAttrData.bg, this._activeBuffer.savedCharset = this._charsetService.charset, this._coreService.decPrivateModes.origin = !1, !0;
    }
    setCursorStyle(e) {
        let i = e.length === 0 ? 1 : e.params[0];
        if (i === 0) this._coreService.decPrivateModes.cursorStyle = void 0, this._coreService.decPrivateModes.cursorBlink = void 0;
        else {
            switch(i){
                case 1:
                case 2:
                    this._coreService.decPrivateModes.cursorStyle = "block";
                    break;
                case 3:
                case 4:
                    this._coreService.decPrivateModes.cursorStyle = "underline";
                    break;
                case 5:
                case 6:
                    this._coreService.decPrivateModes.cursorStyle = "bar";
                    break;
            }
            let r = i % 2 === 1;
            this._coreService.decPrivateModes.cursorBlink = r;
        }
        return !0;
    }
    setScrollRegion(e) {
        let i = e.params[0] || 1, r;
        return (e.length < 2 || (r = e.params[1]) > this._bufferService.rows || r === 0) && (r = this._bufferService.rows), r > i && (this._activeBuffer.scrollTop = i - 1, this._activeBuffer.scrollBottom = r - 1, this._setCursor(0, 0)), !0;
    }
    windowOptions(e) {
        if (!$5c2a9584e51cbabf$var$bl(e.params[0], this._optionsService.rawOptions.windowOptions)) return !0;
        let i = e.length > 1 ? e.params[1] : 0;
        switch(e.params[0]){
            case 14:
                i !== 2 && this._onRequestWindowsOptionsReport.fire(0);
                break;
            case 16:
                this._onRequestWindowsOptionsReport.fire(1);
                break;
            case 18:
                this._bufferService && this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[8;${this._bufferService.rows};${this._bufferService.cols}t`);
                break;
            case 22:
                (i === 0 || i === 2) && (this._windowTitleStack.push(this._windowTitle), this._windowTitleStack.length > $5c2a9584e51cbabf$var$_l && this._windowTitleStack.shift()), (i === 0 || i === 1) && (this._iconNameStack.push(this._iconName), this._iconNameStack.length > $5c2a9584e51cbabf$var$_l && this._iconNameStack.shift());
                break;
            case 23:
                (i === 0 || i === 2) && this._windowTitleStack.length && this.setTitle(this._windowTitleStack.pop()), (i === 0 || i === 1) && this._iconNameStack.length && this.setIconName(this._iconNameStack.pop());
                break;
        }
        return !0;
    }
    saveCursor(e) {
        return this._activeBuffer.savedX = this._activeBuffer.x, this._activeBuffer.savedY = this._activeBuffer.ybase + this._activeBuffer.y, this._activeBuffer.savedCurAttrData.fg = this._curAttrData.fg, this._activeBuffer.savedCurAttrData.bg = this._curAttrData.bg, this._activeBuffer.savedCharset = this._charsetService.charset, !0;
    }
    restoreCursor(e) {
        return this._activeBuffer.x = this._activeBuffer.savedX || 0, this._activeBuffer.y = Math.max(this._activeBuffer.savedY - this._activeBuffer.ybase, 0), this._curAttrData.fg = this._activeBuffer.savedCurAttrData.fg, this._curAttrData.bg = this._activeBuffer.savedCurAttrData.bg, this._charsetService.charset = this._savedCharset, this._activeBuffer.savedCharset && (this._charsetService.charset = this._activeBuffer.savedCharset), this._restrictCursor(), !0;
    }
    setTitle(e) {
        return this._windowTitle = e, this._onTitleChange.fire(e), !0;
    }
    setIconName(e) {
        return this._iconName = e, !0;
    }
    setOrReportIndexedColor(e) {
        let i = [], r = e.split(";");
        for(; r.length > 1;){
            let n = r.shift(), o = r.shift();
            if (/^\d+$/.exec(n)) {
                let l = parseInt(n);
                if ($5c2a9584e51cbabf$var$Sl(l)) {
                    if (o === "?") i.push({
                        type: 0,
                        index: l
                    });
                    else {
                        let a = $5c2a9584e51cbabf$var$Ws(o);
                        a && i.push({
                            type: 1,
                            index: l,
                            color: a
                        });
                    }
                }
            }
        }
        return i.length && this._onColor.fire(i), !0;
    }
    setHyperlink(e) {
        let i = e.indexOf(";");
        if (i === -1) return !0;
        let r = e.slice(0, i).trim(), n = e.slice(i + 1);
        return n ? this._createHyperlink(r, n) : r.trim() ? !1 : this._finishHyperlink();
    }
    _createHyperlink(e, i) {
        this._getCurrentLinkId() && this._finishHyperlink();
        let r = e.split(":"), n, o = r.findIndex((l)=>l.startsWith("id="));
        return o !== -1 && (n = r[o].slice(3) || void 0), this._curAttrData.extended = this._curAttrData.extended.clone(), this._curAttrData.extended.urlId = this._oscLinkService.registerLink({
            id: n,
            uri: i
        }), this._curAttrData.updateExtended(), !0;
    }
    _finishHyperlink() {
        return this._curAttrData.extended = this._curAttrData.extended.clone(), this._curAttrData.extended.urlId = 0, this._curAttrData.updateExtended(), !0;
    }
    _setOrReportSpecialColor(e, i) {
        let r = e.split(";");
        for(let n = 0; n < r.length && !(i >= this._specialColors.length); ++n, ++i)if (r[n] === "?") this._onColor.fire([
            {
                type: 0,
                index: this._specialColors[i]
            }
        ]);
        else {
            let o = $5c2a9584e51cbabf$var$Ws(r[n]);
            o && this._onColor.fire([
                {
                    type: 1,
                    index: this._specialColors[i],
                    color: o
                }
            ]);
        }
        return !0;
    }
    setOrReportFgColor(e) {
        return this._setOrReportSpecialColor(e, 0);
    }
    setOrReportBgColor(e) {
        return this._setOrReportSpecialColor(e, 1);
    }
    setOrReportCursorColor(e) {
        return this._setOrReportSpecialColor(e, 2);
    }
    restoreIndexedColor(e) {
        if (!e) return this._onColor.fire([
            {
                type: 2
            }
        ]), !0;
        let i = [], r = e.split(";");
        for(let n = 0; n < r.length; ++n)if (/^\d+$/.exec(r[n])) {
            let o = parseInt(r[n]);
            $5c2a9584e51cbabf$var$Sl(o) && i.push({
                type: 2,
                index: o
            });
        }
        return i.length && this._onColor.fire(i), !0;
    }
    restoreFgColor(e) {
        return this._onColor.fire([
            {
                type: 2,
                index: 256
            }
        ]), !0;
    }
    restoreBgColor(e) {
        return this._onColor.fire([
            {
                type: 2,
                index: 257
            }
        ]), !0;
    }
    restoreCursorColor(e) {
        return this._onColor.fire([
            {
                type: 2,
                index: 258
            }
        ]), !0;
    }
    nextLine() {
        return this._activeBuffer.x = 0, this.index(), !0;
    }
    keypadApplicationMode() {
        return this._logService.debug("Serial port requested application keypad."), this._coreService.decPrivateModes.applicationKeypad = !0, this._onRequestSyncScrollBar.fire(), !0;
    }
    keypadNumericMode() {
        return this._logService.debug("Switching back to normal keypad."), this._coreService.decPrivateModes.applicationKeypad = !1, this._onRequestSyncScrollBar.fire(), !0;
    }
    selectDefaultCharset() {
        return this._charsetService.setgLevel(0), this._charsetService.setgCharset(0, $5c2a9584e51cbabf$var$Je), !0;
    }
    selectCharset(e) {
        return e.length !== 2 ? (this.selectDefaultCharset(), !0) : (e[0] === "/" || this._charsetService.setgCharset($5c2a9584e51cbabf$var$mc[e[0]], $5c2a9584e51cbabf$var$ne[e[1]] || $5c2a9584e51cbabf$var$Je), !0);
    }
    index() {
        return this._restrictCursor(), this._activeBuffer.y++, this._activeBuffer.y === this._activeBuffer.scrollBottom + 1 ? (this._activeBuffer.y--, this._bufferService.scroll(this._eraseAttrData())) : this._activeBuffer.y >= this._bufferService.rows && (this._activeBuffer.y = this._bufferService.rows - 1), this._restrictCursor(), !0;
    }
    tabSet() {
        return this._activeBuffer.tabs[this._activeBuffer.x] = !0, !0;
    }
    reverseIndex() {
        if (this._restrictCursor(), this._activeBuffer.y === this._activeBuffer.scrollTop) {
            let e = this._activeBuffer.scrollBottom - this._activeBuffer.scrollTop;
            this._activeBuffer.lines.shiftElements(this._activeBuffer.ybase + this._activeBuffer.y, e, 1), this._activeBuffer.lines.set(this._activeBuffer.ybase + this._activeBuffer.y, this._activeBuffer.getBlankLine(this._eraseAttrData())), this._dirtyRowTracker.markRangeDirty(this._activeBuffer.scrollTop, this._activeBuffer.scrollBottom);
        } else this._activeBuffer.y--, this._restrictCursor();
        return !0;
    }
    fullReset() {
        return this._parser.reset(), this._onRequestReset.fire(), !0;
    }
    reset() {
        this._curAttrData = $5c2a9584e51cbabf$var$X.clone(), this._eraseAttrDataInternal = $5c2a9584e51cbabf$var$X.clone();
    }
    _eraseAttrData() {
        return this._eraseAttrDataInternal.bg &= -67108864, this._eraseAttrDataInternal.bg |= this._curAttrData.bg & 67108863, this._eraseAttrDataInternal;
    }
    setgLevel(e) {
        return this._charsetService.setgLevel(e), !0;
    }
    screenAlignmentPattern() {
        let e = new $5c2a9584e51cbabf$var$q;
        e.content = 4194373, e.fg = this._curAttrData.fg, e.bg = this._curAttrData.bg, this._setCursor(0, 0);
        for(let i = 0; i < this._bufferService.rows; ++i){
            let r = this._activeBuffer.ybase + this._activeBuffer.y + i, n = this._activeBuffer.lines.get(r);
            n && (n.fill(e), n.isWrapped = !1);
        }
        return this._dirtyRowTracker.markAllDirty(), this._setCursor(0, 0), !0;
    }
    requestStatusString(e, i) {
        let r = (a)=>(this._coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}${a}${$5c2a9584e51cbabf$var$b.ESC}\\`), !0), n = this._bufferService.buffer, o = this._optionsService.rawOptions, l = {
            block: 2,
            underline: 4,
            bar: 6
        };
        return r(e === '"q' ? `P1$r${this._curAttrData.isProtected() ? 1 : 0}"q` : e === '"p' ? 'P1$r61;1"p' : e === "r" ? `P1$r${n.scrollTop + 1};${n.scrollBottom + 1}r` : e === "m" ? "P1$r0m" : e === " q" ? `P1$r${l[o.cursorStyle] - (o.cursorBlink ? 1 : 0)} q` : "P0$r");
    }
    markRangeDirty(e, i) {
        this._dirtyRowTracker.markRangeDirty(e, i);
    }
}, $5c2a9584e51cbabf$var$Zi = class {
    constructor(t1){
        this._bufferService = t1;
        this.clearRange();
    }
    clearRange() {
        this.start = this._bufferService.buffer.y, this.end = this._bufferService.buffer.y;
    }
    markDirty(t1) {
        t1 < this.start ? this.start = t1 : t1 > this.end && (this.end = t1);
    }
    markRangeDirty(t1, e) {
        t1 > e && ($5c2a9584e51cbabf$var$gl = t1, t1 = e, e = $5c2a9584e51cbabf$var$gl), t1 < this.start && (this.start = t1), e > this.end && (this.end = e);
    }
    markAllDirty() {
        this.markRangeDirty(0, this._bufferService.rows - 1);
    }
};
$5c2a9584e51cbabf$var$Zi = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F)
], $5c2a9584e51cbabf$var$Zi);
function $5c2a9584e51cbabf$var$Sl(s) {
    return 0 <= s && s < 256;
}
var $5c2a9584e51cbabf$var$_c = 5e7, $5c2a9584e51cbabf$var$El = 12, $5c2a9584e51cbabf$var$bc = 50, $5c2a9584e51cbabf$var$gn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._action = e;
        this._writeBuffer = [];
        this._callbacks = [];
        this._pendingData = 0;
        this._bufferOffset = 0;
        this._isSyncWriting = !1;
        this._syncCalls = 0;
        this._didUserInput = !1;
        this._onWriteParsed = this._register(new $5c2a9584e51cbabf$var$v);
        this.onWriteParsed = this._onWriteParsed.event;
    }
    handleUserInput() {
        this._didUserInput = !0;
    }
    writeSync(e, i) {
        if (i !== void 0 && this._syncCalls > i) {
            this._syncCalls = 0;
            return;
        }
        if (this._pendingData += e.length, this._writeBuffer.push(e), this._callbacks.push(void 0), this._syncCalls++, this._isSyncWriting) return;
        this._isSyncWriting = !0;
        let r;
        for(; r = this._writeBuffer.shift();){
            this._action(r);
            let n = this._callbacks.shift();
            n && n();
        }
        this._pendingData = 0, this._bufferOffset = 2147483647, this._isSyncWriting = !1, this._syncCalls = 0;
    }
    write(e, i) {
        if (this._pendingData > $5c2a9584e51cbabf$var$_c) throw new Error("write data discarded, use flow control to avoid losing data");
        if (!this._writeBuffer.length) {
            if (this._bufferOffset = 0, this._didUserInput) {
                this._didUserInput = !1, this._pendingData += e.length, this._writeBuffer.push(e), this._callbacks.push(i), this._innerWrite();
                return;
            }
            setTimeout(()=>this._innerWrite());
        }
        this._pendingData += e.length, this._writeBuffer.push(e), this._callbacks.push(i);
    }
    _innerWrite(e = 0, i = !0) {
        let r = e || performance.now();
        for(; this._writeBuffer.length > this._bufferOffset;){
            let n = this._writeBuffer[this._bufferOffset], o = this._action(n, i);
            if (o) {
                let a = (u)=>performance.now() - r >= $5c2a9584e51cbabf$var$El ? setTimeout(()=>this._innerWrite(0, u)) : this._innerWrite(r, u);
                o.catch((u)=>(queueMicrotask(()=>{
                        throw u;
                    }), Promise.resolve(!1))).then(a);
                return;
            }
            let l = this._callbacks[this._bufferOffset];
            if (l && l(), this._bufferOffset++, this._pendingData -= n.length, performance.now() - r >= $5c2a9584e51cbabf$var$El) break;
        }
        this._writeBuffer.length > this._bufferOffset ? (this._bufferOffset > $5c2a9584e51cbabf$var$bc && (this._writeBuffer = this._writeBuffer.slice(this._bufferOffset), this._callbacks = this._callbacks.slice(this._bufferOffset), this._bufferOffset = 0), setTimeout(()=>this._innerWrite())) : (this._writeBuffer.length = 0, this._callbacks.length = 0, this._pendingData = 0, this._bufferOffset = 0), this._onWriteParsed.fire();
    }
};
var $5c2a9584e51cbabf$var$ui = class {
    constructor(t1){
        this._bufferService = t1;
        this._nextId = 1;
        this._entriesWithId = new Map;
        this._dataByLinkId = new Map;
    }
    registerLink(t1) {
        let e = this._bufferService.buffer;
        if (t1.id === void 0) {
            let a = e.addMarker(e.ybase + e.y), u = {
                data: t1,
                id: this._nextId++,
                lines: [
                    a
                ]
            };
            return a.onDispose(()=>this._removeMarkerFromLink(u, a)), this._dataByLinkId.set(u.id, u), u.id;
        }
        let i = t1, r = this._getEntryIdKey(i), n = this._entriesWithId.get(r);
        if (n) return this.addLineToLink(n.id, e.ybase + e.y), n.id;
        let o = e.addMarker(e.ybase + e.y), l = {
            id: this._nextId++,
            key: this._getEntryIdKey(i),
            data: i,
            lines: [
                o
            ]
        };
        return o.onDispose(()=>this._removeMarkerFromLink(l, o)), this._entriesWithId.set(l.key, l), this._dataByLinkId.set(l.id, l), l.id;
    }
    addLineToLink(t1, e) {
        let i = this._dataByLinkId.get(t1);
        if (i && i.lines.every((r)=>r.line !== e)) {
            let r = this._bufferService.buffer.addMarker(e);
            i.lines.push(r), r.onDispose(()=>this._removeMarkerFromLink(i, r));
        }
    }
    getLinkData(t1) {
        return this._dataByLinkId.get(t1)?.data;
    }
    _getEntryIdKey(t1) {
        return `${t1.id};;${t1.uri}`;
    }
    _removeMarkerFromLink(t1, e) {
        let i = t1.lines.indexOf(e);
        i !== -1 && (t1.lines.splice(i, 1), t1.lines.length === 0 && (t1.data.id !== void 0 && this._entriesWithId.delete(t1.key), this._dataByLinkId.delete(t1.id)));
    }
};
$5c2a9584e51cbabf$var$ui = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(0, $5c2a9584e51cbabf$var$F)
], $5c2a9584e51cbabf$var$ui);
var $5c2a9584e51cbabf$var$Tl = !1, $5c2a9584e51cbabf$var$Sn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._windowsWrappingHeuristics = this._register(new $5c2a9584e51cbabf$var$ye);
        this._onBinary = this._register(new $5c2a9584e51cbabf$var$v);
        this.onBinary = this._onBinary.event;
        this._onData = this._register(new $5c2a9584e51cbabf$var$v);
        this.onData = this._onData.event;
        this._onLineFeed = this._register(new $5c2a9584e51cbabf$var$v);
        this.onLineFeed = this._onLineFeed.event;
        this._onResize = this._register(new $5c2a9584e51cbabf$var$v);
        this.onResize = this._onResize.event;
        this._onWriteParsed = this._register(new $5c2a9584e51cbabf$var$v);
        this.onWriteParsed = this._onWriteParsed.event;
        this._onScroll = this._register(new $5c2a9584e51cbabf$var$v);
        this._instantiationService = new $5c2a9584e51cbabf$var$ln, this.optionsService = this._register(new $5c2a9584e51cbabf$var$dn(e)), this._instantiationService.setService($5c2a9584e51cbabf$var$H, this.optionsService), this._bufferService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$ni)), this._instantiationService.setService($5c2a9584e51cbabf$var$F, this._bufferService), this._logService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$ii)), this._instantiationService.setService($5c2a9584e51cbabf$var$nr, this._logService), this.coreService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$li)), this._instantiationService.setService($5c2a9584e51cbabf$var$ge, this.coreService), this.coreMouseService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$ai)), this._instantiationService.setService($5c2a9584e51cbabf$var$rr, this.coreMouseService), this.unicodeService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$Ae)), this._instantiationService.setService($5c2a9584e51cbabf$var$Js, this.unicodeService), this._charsetService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$pn), this._instantiationService.setService($5c2a9584e51cbabf$var$Zs, this._charsetService), this._oscLinkService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$ui), this._instantiationService.setService($5c2a9584e51cbabf$var$sr, this._oscLinkService), this._inputHandler = this._register(new $5c2a9584e51cbabf$var$vn(this._bufferService, this._charsetService, this.coreService, this._logService, this.optionsService, this._oscLinkService, this.coreMouseService, this.unicodeService)), this._register($5c2a9584e51cbabf$var$$.forward(this._inputHandler.onLineFeed, this._onLineFeed)), this._register(this._inputHandler), this._register($5c2a9584e51cbabf$var$$.forward(this._bufferService.onResize, this._onResize)), this._register($5c2a9584e51cbabf$var$$.forward(this.coreService.onData, this._onData)), this._register($5c2a9584e51cbabf$var$$.forward(this.coreService.onBinary, this._onBinary)), this._register(this.coreService.onRequestScrollToBottom(()=>this.scrollToBottom(!0))), this._register(this.coreService.onUserInput(()=>this._writeBuffer.handleUserInput())), this._register(this.optionsService.onMultipleOptionChange([
            "windowsMode",
            "windowsPty"
        ], ()=>this._handleWindowsPtyOptionChange())), this._register(this._bufferService.onScroll(()=>{
            this._onScroll.fire({
                position: this._bufferService.buffer.ydisp
            }), this._inputHandler.markRangeDirty(this._bufferService.buffer.scrollTop, this._bufferService.buffer.scrollBottom);
        })), this._writeBuffer = this._register(new $5c2a9584e51cbabf$var$gn((i, r)=>this._inputHandler.parse(i, r))), this._register($5c2a9584e51cbabf$var$$.forward(this._writeBuffer.onWriteParsed, this._onWriteParsed));
    }
    get onScroll() {
        return this._onScrollApi || (this._onScrollApi = this._register(new $5c2a9584e51cbabf$var$v), this._onScroll.event((e)=>{
            this._onScrollApi?.fire(e.position);
        })), this._onScrollApi.event;
    }
    get cols() {
        return this._bufferService.cols;
    }
    get rows() {
        return this._bufferService.rows;
    }
    get buffers() {
        return this._bufferService.buffers;
    }
    get options() {
        return this.optionsService.options;
    }
    set options(e) {
        for(let i in e)this.optionsService.options[i] = e[i];
    }
    write(e, i) {
        this._writeBuffer.write(e, i);
    }
    writeSync(e, i) {
        this._logService.logLevel <= 3 && !$5c2a9584e51cbabf$var$Tl && (this._logService.warn("writeSync is unreliable and will be removed soon."), $5c2a9584e51cbabf$var$Tl = !0), this._writeBuffer.writeSync(e, i);
    }
    input(e, i = !0) {
        this.coreService.triggerDataEvent(e, i);
    }
    resize(e, i) {
        isNaN(e) || isNaN(i) || (e = Math.max(e, $5c2a9584e51cbabf$var$ks), i = Math.max(i, $5c2a9584e51cbabf$var$Cs), this._bufferService.resize(e, i));
    }
    scroll(e, i = !1) {
        this._bufferService.scroll(e, i);
    }
    scrollLines(e, i) {
        this._bufferService.scrollLines(e, i);
    }
    scrollPages(e) {
        this.scrollLines(e * (this.rows - 1));
    }
    scrollToTop() {
        this.scrollLines(-this._bufferService.buffer.ydisp);
    }
    scrollToBottom(e) {
        this.scrollLines(this._bufferService.buffer.ybase - this._bufferService.buffer.ydisp);
    }
    scrollToLine(e) {
        let i = e - this._bufferService.buffer.ydisp;
        i !== 0 && this.scrollLines(i);
    }
    registerEscHandler(e, i) {
        return this._inputHandler.registerEscHandler(e, i);
    }
    registerDcsHandler(e, i) {
        return this._inputHandler.registerDcsHandler(e, i);
    }
    registerCsiHandler(e, i) {
        return this._inputHandler.registerCsiHandler(e, i);
    }
    registerOscHandler(e, i) {
        return this._inputHandler.registerOscHandler(e, i);
    }
    _setup() {
        this._handleWindowsPtyOptionChange();
    }
    reset() {
        this._inputHandler.reset(), this._bufferService.reset(), this._charsetService.reset(), this.coreService.reset(), this.coreMouseService.reset();
    }
    _handleWindowsPtyOptionChange() {
        let e = !1, i = this.optionsService.rawOptions.windowsPty;
        i && i.buildNumber !== void 0 && i.buildNumber !== void 0 ? e = i.backend === "conpty" && i.buildNumber < 21376 : this.optionsService.rawOptions.windowsMode && (e = !0), e ? this._enableWindowsWrappingHeuristics() : this._windowsWrappingHeuristics.clear();
    }
    _enableWindowsWrappingHeuristics() {
        if (!this._windowsWrappingHeuristics.value) {
            let e = [];
            e.push(this.onLineFeed($5c2a9584e51cbabf$var$Bs.bind(null, this._bufferService))), e.push(this.registerCsiHandler({
                final: "H"
            }, ()=>($5c2a9584e51cbabf$var$Bs(this._bufferService), !1))), this._windowsWrappingHeuristics.value = $5c2a9584e51cbabf$var$C(()=>{
                for (let i of e)i.dispose();
            });
        }
    }
};
var $5c2a9584e51cbabf$var$gc = {
    48: [
        "0",
        ")"
    ],
    49: [
        "1",
        "!"
    ],
    50: [
        "2",
        "@"
    ],
    51: [
        "3",
        "#"
    ],
    52: [
        "4",
        "$"
    ],
    53: [
        "5",
        "%"
    ],
    54: [
        "6",
        "^"
    ],
    55: [
        "7",
        "&"
    ],
    56: [
        "8",
        "*"
    ],
    57: [
        "9",
        "("
    ],
    186: [
        ";",
        ":"
    ],
    187: [
        "=",
        "+"
    ],
    188: [
        ",",
        "<"
    ],
    189: [
        "-",
        "_"
    ],
    190: [
        ".",
        ">"
    ],
    191: [
        "/",
        "?"
    ],
    192: [
        "`",
        "~"
    ],
    219: [
        "[",
        "{"
    ],
    220: [
        "\\",
        "|"
    ],
    221: [
        "]",
        "}"
    ],
    222: [
        "'",
        '"'
    ]
};
function $5c2a9584e51cbabf$var$Il(s, t1, e, i) {
    let r = {
        type: 0,
        cancel: !1,
        key: void 0
    }, n = (s.shiftKey ? 1 : 0) | (s.altKey ? 2 : 0) | (s.ctrlKey ? 4 : 0) | (s.metaKey ? 8 : 0);
    switch(s.keyCode){
        case 0:
            s.key === "UIKeyInputUpArrow" ? t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OA" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[A" : s.key === "UIKeyInputLeftArrow" ? t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OD" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[D" : s.key === "UIKeyInputRightArrow" ? t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OC" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[C" : s.key === "UIKeyInputDownArrow" && (t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OB" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[B");
            break;
        case 8:
            r.key = s.ctrlKey ? "\b" : $5c2a9584e51cbabf$var$b.DEL, s.altKey && (r.key = $5c2a9584e51cbabf$var$b.ESC + r.key);
            break;
        case 9:
            if (s.shiftKey) {
                r.key = $5c2a9584e51cbabf$var$b.ESC + "[Z";
                break;
            }
            r.key = $5c2a9584e51cbabf$var$b.HT, r.cancel = !0;
            break;
        case 13:
            r.key = s.altKey ? $5c2a9584e51cbabf$var$b.ESC + $5c2a9584e51cbabf$var$b.CR : $5c2a9584e51cbabf$var$b.CR, r.cancel = !0;
            break;
        case 27:
            r.key = $5c2a9584e51cbabf$var$b.ESC, s.altKey && (r.key = $5c2a9584e51cbabf$var$b.ESC + $5c2a9584e51cbabf$var$b.ESC), r.cancel = !0;
            break;
        case 37:
            if (s.metaKey) break;
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "D" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OD" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[D";
            break;
        case 39:
            if (s.metaKey) break;
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "C" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OC" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[C";
            break;
        case 38:
            if (s.metaKey) break;
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "A" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OA" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[A";
            break;
        case 40:
            if (s.metaKey) break;
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "B" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OB" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[B";
            break;
        case 45:
            !s.shiftKey && !s.ctrlKey && (r.key = $5c2a9584e51cbabf$var$b.ESC + "[2~");
            break;
        case 46:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[3;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[3~";
            break;
        case 36:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "H" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OH" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[H";
            break;
        case 35:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "F" : t1 ? r.key = $5c2a9584e51cbabf$var$b.ESC + "OF" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[F";
            break;
        case 33:
            s.shiftKey ? r.type = 2 : s.ctrlKey ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[5;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[5~";
            break;
        case 34:
            s.shiftKey ? r.type = 3 : s.ctrlKey ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[6;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[6~";
            break;
        case 112:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "P" : r.key = $5c2a9584e51cbabf$var$b.ESC + "OP";
            break;
        case 113:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "Q" : r.key = $5c2a9584e51cbabf$var$b.ESC + "OQ";
            break;
        case 114:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "R" : r.key = $5c2a9584e51cbabf$var$b.ESC + "OR";
            break;
        case 115:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[1;" + (n + 1) + "S" : r.key = $5c2a9584e51cbabf$var$b.ESC + "OS";
            break;
        case 116:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[15;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[15~";
            break;
        case 117:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[17;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[17~";
            break;
        case 118:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[18;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[18~";
            break;
        case 119:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[19;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[19~";
            break;
        case 120:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[20;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[20~";
            break;
        case 121:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[21;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[21~";
            break;
        case 122:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[23;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[23~";
            break;
        case 123:
            n ? r.key = $5c2a9584e51cbabf$var$b.ESC + "[24;" + (n + 1) + "~" : r.key = $5c2a9584e51cbabf$var$b.ESC + "[24~";
            break;
        default:
            if (s.ctrlKey && !s.shiftKey && !s.altKey && !s.metaKey) s.keyCode >= 65 && s.keyCode <= 90 ? r.key = String.fromCharCode(s.keyCode - 64) : s.keyCode === 32 ? r.key = $5c2a9584e51cbabf$var$b.NUL : s.keyCode >= 51 && s.keyCode <= 55 ? r.key = String.fromCharCode(s.keyCode - 51 + 27) : s.keyCode === 56 ? r.key = $5c2a9584e51cbabf$var$b.DEL : s.keyCode === 219 ? r.key = $5c2a9584e51cbabf$var$b.ESC : s.keyCode === 220 ? r.key = $5c2a9584e51cbabf$var$b.FS : s.keyCode === 221 && (r.key = $5c2a9584e51cbabf$var$b.GS);
            else if ((!e || i) && s.altKey && !s.metaKey) {
                let l = $5c2a9584e51cbabf$var$gc[s.keyCode]?.[s.shiftKey ? 1 : 0];
                if (l) r.key = $5c2a9584e51cbabf$var$b.ESC + l;
                else if (s.keyCode >= 65 && s.keyCode <= 90) {
                    let a = s.ctrlKey ? s.keyCode - 64 : s.keyCode + 32, u = String.fromCharCode(a);
                    s.shiftKey && (u = u.toUpperCase()), r.key = $5c2a9584e51cbabf$var$b.ESC + u;
                } else if (s.keyCode === 32) r.key = $5c2a9584e51cbabf$var$b.ESC + (s.ctrlKey ? $5c2a9584e51cbabf$var$b.NUL : " ");
                else if (s.key === "Dead" && s.code.startsWith("Key")) {
                    let a = s.code.slice(3, 4);
                    s.shiftKey || (a = a.toLowerCase()), r.key = $5c2a9584e51cbabf$var$b.ESC + a, r.cancel = !0;
                }
            } else e && !s.altKey && !s.ctrlKey && !s.shiftKey && s.metaKey ? s.keyCode === 65 && (r.type = 1) : s.key && !s.ctrlKey && !s.altKey && !s.metaKey && s.keyCode >= 48 && s.key.length === 1 ? r.key = s.key : s.key && s.ctrlKey && (s.key === "_" && (r.key = $5c2a9584e51cbabf$var$b.US), s.key === "@" && (r.key = $5c2a9584e51cbabf$var$b.NUL));
            break;
    }
    return r;
}
var $5c2a9584e51cbabf$var$ee = 0, $5c2a9584e51cbabf$var$En = class {
    constructor(t1){
        this._getKey = t1;
        this._array = [];
        this._insertedValues = [];
        this._flushInsertedTask = new $5c2a9584e51cbabf$var$Jt;
        this._isFlushingInserted = !1;
        this._deletedIndices = [];
        this._flushDeletedTask = new $5c2a9584e51cbabf$var$Jt;
        this._isFlushingDeleted = !1;
    }
    clear() {
        this._array.length = 0, this._insertedValues.length = 0, this._flushInsertedTask.clear(), this._isFlushingInserted = !1, this._deletedIndices.length = 0, this._flushDeletedTask.clear(), this._isFlushingDeleted = !1;
    }
    insert(t1) {
        this._flushCleanupDeleted(), this._insertedValues.length === 0 && this._flushInsertedTask.enqueue(()=>this._flushInserted()), this._insertedValues.push(t1);
    }
    _flushInserted() {
        let t1 = this._insertedValues.sort((n, o)=>this._getKey(n) - this._getKey(o)), e = 0, i = 0, r = new Array(this._array.length + this._insertedValues.length);
        for(let n = 0; n < r.length; n++)i >= this._array.length || this._getKey(t1[e]) <= this._getKey(this._array[i]) ? (r[n] = t1[e], e++) : r[n] = this._array[i++];
        this._array = r, this._insertedValues.length = 0;
    }
    _flushCleanupInserted() {
        !this._isFlushingInserted && this._insertedValues.length > 0 && this._flushInsertedTask.flush();
    }
    delete(t1) {
        if (this._flushCleanupInserted(), this._array.length === 0) return !1;
        let e = this._getKey(t1);
        if (e === void 0 || ($5c2a9584e51cbabf$var$ee = this._search(e), $5c2a9584e51cbabf$var$ee === -1) || this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) !== e) return !1;
        do if (this._array[$5c2a9584e51cbabf$var$ee] === t1) return this._deletedIndices.length === 0 && this._flushDeletedTask.enqueue(()=>this._flushDeleted()), this._deletedIndices.push($5c2a9584e51cbabf$var$ee), !0;
        while (++$5c2a9584e51cbabf$var$ee < this._array.length && this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) === e);
        return !1;
    }
    _flushDeleted() {
        this._isFlushingDeleted = !0;
        let t1 = this._deletedIndices.sort((n, o)=>n - o), e = 0, i = new Array(this._array.length - t1.length), r = 0;
        for(let n = 0; n < this._array.length; n++)t1[e] === n ? e++ : i[r++] = this._array[n];
        this._array = i, this._deletedIndices.length = 0, this._isFlushingDeleted = !1;
    }
    _flushCleanupDeleted() {
        !this._isFlushingDeleted && this._deletedIndices.length > 0 && this._flushDeletedTask.flush();
    }
    *getKeyIterator(t1) {
        if (this._flushCleanupInserted(), this._flushCleanupDeleted(), this._array.length !== 0 && ($5c2a9584e51cbabf$var$ee = this._search(t1), !($5c2a9584e51cbabf$var$ee < 0 || $5c2a9584e51cbabf$var$ee >= this._array.length) && this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) === t1)) do yield this._array[$5c2a9584e51cbabf$var$ee];
        while (++$5c2a9584e51cbabf$var$ee < this._array.length && this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) === t1);
    }
    forEachByKey(t1, e) {
        if (this._flushCleanupInserted(), this._flushCleanupDeleted(), this._array.length !== 0 && ($5c2a9584e51cbabf$var$ee = this._search(t1), !($5c2a9584e51cbabf$var$ee < 0 || $5c2a9584e51cbabf$var$ee >= this._array.length) && this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) === t1)) do e(this._array[$5c2a9584e51cbabf$var$ee]);
        while (++$5c2a9584e51cbabf$var$ee < this._array.length && this._getKey(this._array[$5c2a9584e51cbabf$var$ee]) === t1);
    }
    values() {
        return this._flushCleanupInserted(), this._flushCleanupDeleted(), [
            ...this._array
        ].values();
    }
    _search(t1) {
        let e = 0, i = this._array.length - 1;
        for(; i >= e;){
            let r = e + i >> 1, n = this._getKey(this._array[r]);
            if (n > t1) i = r - 1;
            else if (n < t1) e = r + 1;
            else {
                for(; r > 0 && this._getKey(this._array[r - 1]) === t1;)r--;
                return r;
            }
        }
        return e;
    }
};
var $5c2a9584e51cbabf$var$Us = 0, $5c2a9584e51cbabf$var$yl = 0, $5c2a9584e51cbabf$var$Tn = class extends $5c2a9584e51cbabf$var$D {
    constructor(){
        super();
        this._decorations = new $5c2a9584e51cbabf$var$En((e)=>e?.marker.line);
        this._onDecorationRegistered = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDecorationRegistered = this._onDecorationRegistered.event;
        this._onDecorationRemoved = this._register(new $5c2a9584e51cbabf$var$v);
        this.onDecorationRemoved = this._onDecorationRemoved.event;
        this._register($5c2a9584e51cbabf$var$C(()=>this.reset()));
    }
    get decorations() {
        return this._decorations.values();
    }
    registerDecoration(e) {
        if (e.marker.isDisposed) return;
        let i = new $5c2a9584e51cbabf$var$Ks(e);
        if (i) {
            let r = i.marker.onDispose(()=>i.dispose()), n = i.onDispose(()=>{
                n.dispose(), i && (this._decorations.delete(i) && this._onDecorationRemoved.fire(i), r.dispose());
            });
            this._decorations.insert(i), this._onDecorationRegistered.fire(i);
        }
        return i;
    }
    reset() {
        for (let e of this._decorations.values())e.dispose();
        this._decorations.clear();
    }
    *getDecorationsAtCell(e, i, r) {
        let n = 0, o = 0;
        for (let l of this._decorations.getKeyIterator(i))n = l.options.x ?? 0, o = n + (l.options.width ?? 1), e >= n && e < o && (!r || (l.options.layer ?? "bottom") === r) && (yield l);
    }
    forEachDecorationAtCell(e, i, r, n) {
        this._decorations.forEachByKey(i, (o)=>{
            $5c2a9584e51cbabf$var$Us = o.options.x ?? 0, $5c2a9584e51cbabf$var$yl = $5c2a9584e51cbabf$var$Us + (o.options.width ?? 1), e >= $5c2a9584e51cbabf$var$Us && e < $5c2a9584e51cbabf$var$yl && (!r || (o.options.layer ?? "bottom") === r) && n(o);
        });
    }
}, $5c2a9584e51cbabf$var$Ks = class extends $5c2a9584e51cbabf$var$Ee {
    constructor(e){
        super();
        this.options = e;
        this.onRenderEmitter = this.add(new $5c2a9584e51cbabf$var$v);
        this.onRender = this.onRenderEmitter.event;
        this._onDispose = this.add(new $5c2a9584e51cbabf$var$v);
        this.onDispose = this._onDispose.event;
        this._cachedBg = null;
        this._cachedFg = null;
        this.marker = e.marker, this.options.overviewRulerOptions && !this.options.overviewRulerOptions.position && (this.options.overviewRulerOptions.position = "full");
    }
    get backgroundColorRGB() {
        return this._cachedBg === null && (this.options.backgroundColor ? this._cachedBg = $5c2a9584e51cbabf$var$z.toColor(this.options.backgroundColor) : this._cachedBg = void 0), this._cachedBg;
    }
    get foregroundColorRGB() {
        return this._cachedFg === null && (this.options.foregroundColor ? this._cachedFg = $5c2a9584e51cbabf$var$z.toColor(this.options.foregroundColor) : this._cachedFg = void 0), this._cachedFg;
    }
    dispose() {
        this._onDispose.fire(), super.dispose();
    }
};
var $5c2a9584e51cbabf$var$Sc = 1e3, $5c2a9584e51cbabf$var$In = class {
    constructor(t1, e = $5c2a9584e51cbabf$var$Sc){
        this._renderCallback = t1;
        this._debounceThresholdMS = e;
        this._lastRefreshMs = 0;
        this._additionalRefreshRequested = !1;
    }
    dispose() {
        this._refreshTimeoutID && clearTimeout(this._refreshTimeoutID);
    }
    refresh(t1, e, i) {
        this._rowCount = i, t1 = t1 !== void 0 ? t1 : 0, e = e !== void 0 ? e : this._rowCount - 1, this._rowStart = this._rowStart !== void 0 ? Math.min(this._rowStart, t1) : t1, this._rowEnd = this._rowEnd !== void 0 ? Math.max(this._rowEnd, e) : e;
        let r = performance.now();
        if (r - this._lastRefreshMs >= this._debounceThresholdMS) this._lastRefreshMs = r, this._innerRefresh();
        else if (!this._additionalRefreshRequested) {
            let n = r - this._lastRefreshMs, o = this._debounceThresholdMS - n;
            this._additionalRefreshRequested = !0, this._refreshTimeoutID = window.setTimeout(()=>{
                this._lastRefreshMs = performance.now(), this._innerRefresh(), this._additionalRefreshRequested = !1, this._refreshTimeoutID = void 0;
            }, o);
        }
    }
    _innerRefresh() {
        if (this._rowStart === void 0 || this._rowEnd === void 0 || this._rowCount === void 0) return;
        let t1 = Math.max(this._rowStart, 0), e = Math.min(this._rowEnd, this._rowCount - 1);
        this._rowStart = void 0, this._rowEnd = void 0, this._renderCallback(t1, e);
    }
};
var $5c2a9584e51cbabf$var$xl = 20;
var $5c2a9584e51cbabf$var$wl = !1, $5c2a9584e51cbabf$var$Tt = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n){
        super();
        this._terminal = e;
        this._coreBrowserService = r;
        this._renderService = n;
        this._rowColumns = new WeakMap;
        this._liveRegionLineCount = 0;
        this._charsToConsume = [];
        this._charsToAnnounce = "";
        let o = this._coreBrowserService.mainDocument;
        this._accessibilityContainer = o.createElement("div"), this._accessibilityContainer.classList.add("xterm-accessibility"), this._rowContainer = o.createElement("div"), this._rowContainer.setAttribute("role", "list"), this._rowContainer.classList.add("xterm-accessibility-tree"), this._rowElements = [];
        for(let l = 0; l < this._terminal.rows; l++)this._rowElements[l] = this._createAccessibilityTreeNode(), this._rowContainer.appendChild(this._rowElements[l]);
        if (this._topBoundaryFocusListener = (l)=>this._handleBoundaryFocus(l, 0), this._bottomBoundaryFocusListener = (l)=>this._handleBoundaryFocus(l, 1), this._rowElements[0].addEventListener("focus", this._topBoundaryFocusListener), this._rowElements[this._rowElements.length - 1].addEventListener("focus", this._bottomBoundaryFocusListener), this._accessibilityContainer.appendChild(this._rowContainer), this._liveRegion = o.createElement("div"), this._liveRegion.classList.add("live-region"), this._liveRegion.setAttribute("aria-live", "assertive"), this._accessibilityContainer.appendChild(this._liveRegion), this._liveRegionDebouncer = this._register(new $5c2a9584e51cbabf$var$In(this._renderRows.bind(this))), !this._terminal.element) throw new Error("Cannot enable accessibility before Terminal.open");
        $5c2a9584e51cbabf$var$wl ? (this._accessibilityContainer.classList.add("debug"), this._rowContainer.classList.add("debug"), this._debugRootContainer = o.createElement("div"), this._debugRootContainer.classList.add("xterm"), this._debugRootContainer.appendChild(o.createTextNode("------start a11y------")), this._debugRootContainer.appendChild(this._accessibilityContainer), this._debugRootContainer.appendChild(o.createTextNode("------end a11y------")), this._terminal.element.insertAdjacentElement("afterend", this._debugRootContainer)) : this._terminal.element.insertAdjacentElement("afterbegin", this._accessibilityContainer), this._register(this._terminal.onResize((l)=>this._handleResize(l.rows))), this._register(this._terminal.onRender((l)=>this._refreshRows(l.start, l.end))), this._register(this._terminal.onScroll(()=>this._refreshRows())), this._register(this._terminal.onA11yChar((l)=>this._handleChar(l))), this._register(this._terminal.onLineFeed(()=>this._handleChar(`
`))), this._register(this._terminal.onA11yTab((l)=>this._handleTab(l))), this._register(this._terminal.onKey((l)=>this._handleKey(l.key))), this._register(this._terminal.onBlur(()=>this._clearLiveRegion())), this._register(this._renderService.onDimensionsChange(()=>this._refreshRowsDimensions())), this._register($5c2a9584e51cbabf$var$L(o, "selectionchange", ()=>this._handleSelectionChange())), this._register(this._coreBrowserService.onDprChange(()=>this._refreshRowsDimensions())), this._refreshRowsDimensions(), this._refreshRows(), this._register($5c2a9584e51cbabf$var$C(()=>{
            $5c2a9584e51cbabf$var$wl ? this._debugRootContainer.remove() : this._accessibilityContainer.remove(), this._rowElements.length = 0;
        }));
    }
    _handleTab(e) {
        for(let i = 0; i < e; i++)this._handleChar(" ");
    }
    _handleChar(e) {
        this._liveRegionLineCount < $5c2a9584e51cbabf$var$xl + 1 && (this._charsToConsume.length > 0 ? this._charsToConsume.shift() !== e && (this._charsToAnnounce += e) : this._charsToAnnounce += e, e === `
` && (this._liveRegionLineCount++, this._liveRegionLineCount === $5c2a9584e51cbabf$var$xl + 1 && (this._liveRegion.textContent += $5c2a9584e51cbabf$var$_i.get())));
    }
    _clearLiveRegion() {
        this._liveRegion.textContent = "", this._liveRegionLineCount = 0;
    }
    _handleKey(e) {
        this._clearLiveRegion(), /\p{Control}/u.test(e) || this._charsToConsume.push(e);
    }
    _refreshRows(e, i) {
        this._liveRegionDebouncer.refresh(e, i, this._terminal.rows);
    }
    _renderRows(e, i) {
        let r = this._terminal.buffer, n = r.lines.length.toString();
        for(let o = e; o <= i; o++){
            let l = r.lines.get(r.ydisp + o), a = [], u = l?.translateToString(!0, void 0, void 0, a) || "", h = (r.ydisp + o + 1).toString(), c = this._rowElements[o];
            c && (u.length === 0 ? (c.textContent = "\xA0", this._rowColumns.set(c, [
                0,
                1
            ])) : (c.textContent = u, this._rowColumns.set(c, a)), c.setAttribute("aria-posinset", h), c.setAttribute("aria-setsize", n), this._alignRowWidth(c));
        }
        this._announceCharacters();
    }
    _announceCharacters() {
        this._charsToAnnounce.length !== 0 && (this._liveRegion.textContent += this._charsToAnnounce, this._charsToAnnounce = "");
    }
    _handleBoundaryFocus(e, i) {
        let r = e.target, n = this._rowElements[i === 0 ? 1 : this._rowElements.length - 2], o = r.getAttribute("aria-posinset"), l = i === 0 ? "1" : `${this._terminal.buffer.lines.length}`;
        if (o === l || e.relatedTarget !== n) return;
        let a, u;
        if (i === 0 ? (a = r, u = this._rowElements.pop(), this._rowContainer.removeChild(u)) : (a = this._rowElements.shift(), u = r, this._rowContainer.removeChild(a)), a.removeEventListener("focus", this._topBoundaryFocusListener), u.removeEventListener("focus", this._bottomBoundaryFocusListener), i === 0) {
            let h = this._createAccessibilityTreeNode();
            this._rowElements.unshift(h), this._rowContainer.insertAdjacentElement("afterbegin", h);
        } else {
            let h = this._createAccessibilityTreeNode();
            this._rowElements.push(h), this._rowContainer.appendChild(h);
        }
        this._rowElements[0].addEventListener("focus", this._topBoundaryFocusListener), this._rowElements[this._rowElements.length - 1].addEventListener("focus", this._bottomBoundaryFocusListener), this._terminal.scrollLines(i === 0 ? -1 : 1), this._rowElements[i === 0 ? 1 : this._rowElements.length - 2].focus(), e.preventDefault(), e.stopImmediatePropagation();
    }
    _handleSelectionChange() {
        if (this._rowElements.length === 0) return;
        let e = this._coreBrowserService.mainDocument.getSelection();
        if (!e) return;
        if (e.isCollapsed) {
            this._rowContainer.contains(e.anchorNode) && this._terminal.clearSelection();
            return;
        }
        if (!e.anchorNode || !e.focusNode) {
            console.error("anchorNode and/or focusNode are null");
            return;
        }
        let i = {
            node: e.anchorNode,
            offset: e.anchorOffset
        }, r = {
            node: e.focusNode,
            offset: e.focusOffset
        };
        if ((i.node.compareDocumentPosition(r.node) & Node.DOCUMENT_POSITION_PRECEDING || i.node === r.node && i.offset > r.offset) && ([i, r] = [
            r,
            i
        ]), i.node.compareDocumentPosition(this._rowElements[0]) & (Node.DOCUMENT_POSITION_CONTAINED_BY | Node.DOCUMENT_POSITION_FOLLOWING) && (i = {
            node: this._rowElements[0].childNodes[0],
            offset: 0
        }), !this._rowContainer.contains(i.node)) return;
        let n = this._rowElements.slice(-1)[0];
        if (r.node.compareDocumentPosition(n) & (Node.DOCUMENT_POSITION_CONTAINED_BY | Node.DOCUMENT_POSITION_PRECEDING) && (r = {
            node: n,
            offset: n.textContent?.length ?? 0
        }), !this._rowContainer.contains(r.node)) return;
        let o = ({ node: u, offset: h })=>{
            let c = u instanceof Text ? u.parentNode : u, d = parseInt(c?.getAttribute("aria-posinset"), 10) - 1;
            if (isNaN(d)) return console.warn("row is invalid. Race condition?"), null;
            let _ = this._rowColumns.get(c);
            if (!_) return console.warn("columns is null. Race condition?"), null;
            let p = h < _.length ? _[h] : _.slice(-1)[0] + 1;
            return p >= this._terminal.cols && (++d, p = 0), {
                row: d,
                column: p
            };
        }, l = o(i), a = o(r);
        if (!(!l || !a)) {
            if (l.row > a.row || l.row === a.row && l.column >= a.column) throw new Error("invalid range");
            this._terminal.select(l.column, l.row, (a.row - l.row) * this._terminal.cols - l.column + a.column);
        }
    }
    _handleResize(e) {
        this._rowElements[this._rowElements.length - 1].removeEventListener("focus", this._bottomBoundaryFocusListener);
        for(let i = this._rowContainer.children.length; i < this._terminal.rows; i++)this._rowElements[i] = this._createAccessibilityTreeNode(), this._rowContainer.appendChild(this._rowElements[i]);
        for(; this._rowElements.length > e;)this._rowContainer.removeChild(this._rowElements.pop());
        this._rowElements[this._rowElements.length - 1].addEventListener("focus", this._bottomBoundaryFocusListener), this._refreshRowsDimensions();
    }
    _createAccessibilityTreeNode() {
        let e = this._coreBrowserService.mainDocument.createElement("div");
        return e.setAttribute("role", "listitem"), e.tabIndex = -1, this._refreshRowDimensions(e), e;
    }
    _refreshRowsDimensions() {
        if (this._renderService.dimensions.css.cell.height) {
            Object.assign(this._accessibilityContainer.style, {
                width: `${this._renderService.dimensions.css.canvas.width}px`,
                fontSize: `${this._terminal.options.fontSize}px`
            }), this._rowElements.length !== this._terminal.rows && this._handleResize(this._terminal.rows);
            for(let e = 0; e < this._terminal.rows; e++)this._refreshRowDimensions(this._rowElements[e]), this._alignRowWidth(this._rowElements[e]);
        }
    }
    _refreshRowDimensions(e) {
        e.style.height = `${this._renderService.dimensions.css.cell.height}px`;
    }
    _alignRowWidth(e) {
        e.style.transform = "";
        let i = e.getBoundingClientRect().width, r = this._rowColumns.get(e)?.slice(-1)?.[0];
        if (!r) return;
        let n = r * this._renderService.dimensions.css.cell.width;
        e.style.transform = `scaleX(${n / i})`;
    }
};
$5c2a9584e51cbabf$var$Tt = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$xt),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$ae),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$ce)
], $5c2a9584e51cbabf$var$Tt);
var $5c2a9584e51cbabf$var$hi = class extends $5c2a9584e51cbabf$var$D {
    constructor(e, i, r, n, o){
        super();
        this._element = e;
        this._mouseService = i;
        this._renderService = r;
        this._bufferService = n;
        this._linkProviderService = o;
        this._linkCacheDisposables = [];
        this._isMouseOut = !0;
        this._wasResized = !1;
        this._activeLine = -1;
        this._onShowLinkUnderline = this._register(new $5c2a9584e51cbabf$var$v);
        this.onShowLinkUnderline = this._onShowLinkUnderline.event;
        this._onHideLinkUnderline = this._register(new $5c2a9584e51cbabf$var$v);
        this.onHideLinkUnderline = this._onHideLinkUnderline.event;
        this._register($5c2a9584e51cbabf$var$C(()=>{
            $5c2a9584e51cbabf$var$Ne(this._linkCacheDisposables), this._linkCacheDisposables.length = 0, this._lastMouseEvent = void 0, this._activeProviderReplies?.clear();
        })), this._register(this._bufferService.onResize(()=>{
            this._clearCurrentLink(), this._wasResized = !0;
        })), this._register($5c2a9584e51cbabf$var$L(this._element, "mouseleave", ()=>{
            this._isMouseOut = !0, this._clearCurrentLink();
        })), this._register($5c2a9584e51cbabf$var$L(this._element, "mousemove", this._handleMouseMove.bind(this))), this._register($5c2a9584e51cbabf$var$L(this._element, "mousedown", this._handleMouseDown.bind(this))), this._register($5c2a9584e51cbabf$var$L(this._element, "mouseup", this._handleMouseUp.bind(this)));
    }
    get currentLink() {
        return this._currentLink;
    }
    _handleMouseMove(e) {
        this._lastMouseEvent = e;
        let i = this._positionFromMouseEvent(e, this._element, this._mouseService);
        if (!i) return;
        this._isMouseOut = !1;
        let r = e.composedPath();
        for(let n = 0; n < r.length; n++){
            let o = r[n];
            if (o.classList.contains("xterm")) break;
            if (o.classList.contains("xterm-hover")) return;
        }
        (!this._lastBufferCell || i.x !== this._lastBufferCell.x || i.y !== this._lastBufferCell.y) && (this._handleHover(i), this._lastBufferCell = i);
    }
    _handleHover(e) {
        if (this._activeLine !== e.y || this._wasResized) {
            this._clearCurrentLink(), this._askForLink(e, !1), this._wasResized = !1;
            return;
        }
        this._currentLink && this._linkAtPosition(this._currentLink.link, e) || (this._clearCurrentLink(), this._askForLink(e, !0));
    }
    _askForLink(e, i) {
        (!this._activeProviderReplies || !i) && (this._activeProviderReplies?.forEach((n)=>{
            n?.forEach((o)=>{
                o.link.dispose && o.link.dispose();
            });
        }), this._activeProviderReplies = new Map, this._activeLine = e.y);
        let r = !1;
        for (let [n, o] of this._linkProviderService.linkProviders.entries())i ? this._activeProviderReplies?.get(n) && (r = this._checkLinkProviderResult(n, e, r)) : o.provideLinks(e.y, (l)=>{
            if (this._isMouseOut) return;
            let a = l?.map((u)=>({
                    link: u
                }));
            this._activeProviderReplies?.set(n, a), r = this._checkLinkProviderResult(n, e, r), this._activeProviderReplies?.size === this._linkProviderService.linkProviders.length && this._removeIntersectingLinks(e.y, this._activeProviderReplies);
        });
    }
    _removeIntersectingLinks(e, i) {
        let r = new Set;
        for(let n = 0; n < i.size; n++){
            let o = i.get(n);
            if (o) for(let l = 0; l < o.length; l++){
                let a = o[l], u = a.link.range.start.y < e ? 0 : a.link.range.start.x, h = a.link.range.end.y > e ? this._bufferService.cols : a.link.range.end.x;
                for(let c = u; c <= h; c++){
                    if (r.has(c)) {
                        o.splice(l--, 1);
                        break;
                    }
                    r.add(c);
                }
            }
        }
    }
    _checkLinkProviderResult(e, i, r) {
        if (!this._activeProviderReplies) return r;
        let n = this._activeProviderReplies.get(e), o = !1;
        for(let l = 0; l < e; l++)(!this._activeProviderReplies.has(l) || this._activeProviderReplies.get(l)) && (o = !0);
        if (!o && n) {
            let l = n.find((a)=>this._linkAtPosition(a.link, i));
            l && (r = !0, this._handleNewLink(l));
        }
        if (this._activeProviderReplies.size === this._linkProviderService.linkProviders.length && !r) for(let l = 0; l < this._activeProviderReplies.size; l++){
            let a = this._activeProviderReplies.get(l)?.find((u)=>this._linkAtPosition(u.link, i));
            if (a) {
                r = !0, this._handleNewLink(a);
                break;
            }
        }
        return r;
    }
    _handleMouseDown() {
        this._mouseDownLink = this._currentLink;
    }
    _handleMouseUp(e) {
        if (!this._currentLink) return;
        let i = this._positionFromMouseEvent(e, this._element, this._mouseService);
        i && this._mouseDownLink && $5c2a9584e51cbabf$var$Ec(this._mouseDownLink.link, this._currentLink.link) && this._linkAtPosition(this._currentLink.link, i) && this._currentLink.link.activate(e, this._currentLink.link.text);
    }
    _clearCurrentLink(e, i) {
        !this._currentLink || !this._lastMouseEvent || (!e || !i || this._currentLink.link.range.start.y >= e && this._currentLink.link.range.end.y <= i) && (this._linkLeave(this._element, this._currentLink.link, this._lastMouseEvent), this._currentLink = void 0, $5c2a9584e51cbabf$var$Ne(this._linkCacheDisposables), this._linkCacheDisposables.length = 0);
    }
    _handleNewLink(e) {
        if (!this._lastMouseEvent) return;
        let i = this._positionFromMouseEvent(this._lastMouseEvent, this._element, this._mouseService);
        i && this._linkAtPosition(e.link, i) && (this._currentLink = e, this._currentLink.state = {
            decorations: {
                underline: e.link.decorations === void 0 ? !0 : e.link.decorations.underline,
                pointerCursor: e.link.decorations === void 0 ? !0 : e.link.decorations.pointerCursor
            },
            isHovered: !0
        }, this._linkHover(this._element, e.link, this._lastMouseEvent), e.link.decorations = {}, Object.defineProperties(e.link.decorations, {
            pointerCursor: {
                get: ()=>this._currentLink?.state?.decorations.pointerCursor,
                set: (r)=>{
                    this._currentLink?.state && this._currentLink.state.decorations.pointerCursor !== r && (this._currentLink.state.decorations.pointerCursor = r, this._currentLink.state.isHovered && this._element.classList.toggle("xterm-cursor-pointer", r));
                }
            },
            underline: {
                get: ()=>this._currentLink?.state?.decorations.underline,
                set: (r)=>{
                    this._currentLink?.state && this._currentLink?.state?.decorations.underline !== r && (this._currentLink.state.decorations.underline = r, this._currentLink.state.isHovered && this._fireUnderlineEvent(e.link, r));
                }
            }
        }), this._linkCacheDisposables.push(this._renderService.onRenderedViewportChange((r)=>{
            if (!this._currentLink) return;
            let n = r.start === 0 ? 0 : r.start + 1 + this._bufferService.buffer.ydisp, o = this._bufferService.buffer.ydisp + 1 + r.end;
            if (this._currentLink.link.range.start.y >= n && this._currentLink.link.range.end.y <= o && (this._clearCurrentLink(n, o), this._lastMouseEvent)) {
                let l = this._positionFromMouseEvent(this._lastMouseEvent, this._element, this._mouseService);
                l && this._askForLink(l, !1);
            }
        })));
    }
    _linkHover(e, i, r) {
        this._currentLink?.state && (this._currentLink.state.isHovered = !0, this._currentLink.state.decorations.underline && this._fireUnderlineEvent(i, !0), this._currentLink.state.decorations.pointerCursor && e.classList.add("xterm-cursor-pointer")), i.hover && i.hover(r, i.text);
    }
    _fireUnderlineEvent(e, i) {
        let r = e.range, n = this._bufferService.buffer.ydisp, o = this._createLinkUnderlineEvent(r.start.x - 1, r.start.y - n - 1, r.end.x, r.end.y - n - 1, void 0);
        (i ? this._onShowLinkUnderline : this._onHideLinkUnderline).fire(o);
    }
    _linkLeave(e, i, r) {
        this._currentLink?.state && (this._currentLink.state.isHovered = !1, this._currentLink.state.decorations.underline && this._fireUnderlineEvent(i, !1), this._currentLink.state.decorations.pointerCursor && e.classList.remove("xterm-cursor-pointer")), i.leave && i.leave(r, i.text);
    }
    _linkAtPosition(e, i) {
        let r = e.range.start.y * this._bufferService.cols + e.range.start.x, n = e.range.end.y * this._bufferService.cols + e.range.end.x, o = i.y * this._bufferService.cols + i.x;
        return r <= o && o <= n;
    }
    _positionFromMouseEvent(e, i, r) {
        let n = r.getCoords(e, i, this._bufferService.cols, this._bufferService.rows);
        if (n) return {
            x: n[0],
            y: n[1] + this._bufferService.buffer.ydisp
        };
    }
    _createLinkUnderlineEvent(e, i, r, n, o) {
        return {
            x1: e,
            y1: i,
            x2: r,
            y2: n,
            cols: this._bufferService.cols,
            fg: o
        };
    }
};
$5c2a9584e51cbabf$var$hi = $5c2a9584e51cbabf$var$M([
    $5c2a9584e51cbabf$var$S(1, $5c2a9584e51cbabf$var$Dt),
    $5c2a9584e51cbabf$var$S(2, $5c2a9584e51cbabf$var$ce),
    $5c2a9584e51cbabf$var$S(3, $5c2a9584e51cbabf$var$F),
    $5c2a9584e51cbabf$var$S(4, $5c2a9584e51cbabf$var$lr)
], $5c2a9584e51cbabf$var$hi);
function $5c2a9584e51cbabf$var$Ec(s, t1) {
    return s.text === t1.text && s.range.start.x === t1.range.start.x && s.range.start.y === t1.range.start.y && s.range.end.x === t1.range.end.x && s.range.end.y === t1.range.end.y;
}
var $5c2a9584e51cbabf$var$yn = class extends $5c2a9584e51cbabf$var$Sn {
    constructor(e = {}){
        super(e);
        this._linkifier = this._register(new $5c2a9584e51cbabf$var$ye);
        this.browser = $5c2a9584e51cbabf$var$tn;
        this._keyDownHandled = !1;
        this._keyDownSeen = !1;
        this._keyPressHandled = !1;
        this._unprocessedDeadKey = !1;
        this._accessibilityManager = this._register(new $5c2a9584e51cbabf$var$ye);
        this._onCursorMove = this._register(new $5c2a9584e51cbabf$var$v);
        this.onCursorMove = this._onCursorMove.event;
        this._onKey = this._register(new $5c2a9584e51cbabf$var$v);
        this.onKey = this._onKey.event;
        this._onRender = this._register(new $5c2a9584e51cbabf$var$v);
        this.onRender = this._onRender.event;
        this._onSelectionChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onSelectionChange = this._onSelectionChange.event;
        this._onTitleChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onTitleChange = this._onTitleChange.event;
        this._onBell = this._register(new $5c2a9584e51cbabf$var$v);
        this.onBell = this._onBell.event;
        this._onFocus = this._register(new $5c2a9584e51cbabf$var$v);
        this._onBlur = this._register(new $5c2a9584e51cbabf$var$v);
        this._onA11yCharEmitter = this._register(new $5c2a9584e51cbabf$var$v);
        this._onA11yTabEmitter = this._register(new $5c2a9584e51cbabf$var$v);
        this._onWillOpen = this._register(new $5c2a9584e51cbabf$var$v);
        this._setup(), this._decorationService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$Tn), this._instantiationService.setService($5c2a9584e51cbabf$var$Be, this._decorationService), this._linkProviderService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$Qr), this._instantiationService.setService($5c2a9584e51cbabf$var$lr, this._linkProviderService), this._linkProviderService.registerLinkProvider(this._instantiationService.createInstance($5c2a9584e51cbabf$var$wt)), this._register(this._inputHandler.onRequestBell(()=>this._onBell.fire())), this._register(this._inputHandler.onRequestRefreshRows((i)=>this.refresh(i?.start ?? 0, i?.end ?? this.rows - 1))), this._register(this._inputHandler.onRequestSendFocus(()=>this._reportFocus())), this._register(this._inputHandler.onRequestReset(()=>this.reset())), this._register(this._inputHandler.onRequestWindowsOptionsReport((i)=>this._reportWindowsOptions(i))), this._register(this._inputHandler.onColor((i)=>this._handleColorEvent(i))), this._register($5c2a9584e51cbabf$var$$.forward(this._inputHandler.onCursorMove, this._onCursorMove)), this._register($5c2a9584e51cbabf$var$$.forward(this._inputHandler.onTitleChange, this._onTitleChange)), this._register($5c2a9584e51cbabf$var$$.forward(this._inputHandler.onA11yChar, this._onA11yCharEmitter)), this._register($5c2a9584e51cbabf$var$$.forward(this._inputHandler.onA11yTab, this._onA11yTabEmitter)), this._register(this._bufferService.onResize((i)=>this._afterResize(i.cols, i.rows))), this._register($5c2a9584e51cbabf$var$C(()=>{
            this._customKeyEventHandler = void 0, this.element?.parentNode?.removeChild(this.element);
        }));
    }
    get linkifier() {
        return this._linkifier.value;
    }
    get onFocus() {
        return this._onFocus.event;
    }
    get onBlur() {
        return this._onBlur.event;
    }
    get onA11yChar() {
        return this._onA11yCharEmitter.event;
    }
    get onA11yTab() {
        return this._onA11yTabEmitter.event;
    }
    get onWillOpen() {
        return this._onWillOpen.event;
    }
    _handleColorEvent(e) {
        if (this._themeService) for (let i of e){
            let r, n = "";
            switch(i.index){
                case 256:
                    r = "foreground", n = "10";
                    break;
                case 257:
                    r = "background", n = "11";
                    break;
                case 258:
                    r = "cursor", n = "12";
                    break;
                default:
                    r = "ansi", n = "4;" + i.index;
            }
            switch(i.type){
                case 0:
                    let o = $5c2a9584e51cbabf$var$U.toColorRGB(r === "ansi" ? this._themeService.colors.ansi[i.index] : this._themeService.colors[r]);
                    this.coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}]${n};${$5c2a9584e51cbabf$var$ml(o)}${$5c2a9584e51cbabf$var$fs.ST}`);
                    break;
                case 1:
                    if (r === "ansi") this._themeService.modifyColors((l)=>l.ansi[i.index] = $5c2a9584e51cbabf$var$j.toColor(...i.color));
                    else {
                        let l = r;
                        this._themeService.modifyColors((a)=>a[l] = $5c2a9584e51cbabf$var$j.toColor(...i.color));
                    }
                    break;
                case 2:
                    this._themeService.restoreColor(i.index);
                    break;
            }
        }
    }
    _setup() {
        super._setup(), this._customKeyEventHandler = void 0;
    }
    get buffer() {
        return this.buffers.active;
    }
    focus() {
        this.textarea && this.textarea.focus({
            preventScroll: !0
        });
    }
    _handleScreenReaderModeOptionChange(e) {
        e ? !this._accessibilityManager.value && this._renderService && (this._accessibilityManager.value = this._instantiationService.createInstance($5c2a9584e51cbabf$var$Tt, this)) : this._accessibilityManager.clear();
    }
    _handleTextAreaFocus(e) {
        this.coreService.decPrivateModes.sendFocus && this.coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[I"), this.element.classList.add("focus"), this._showCursor(), this._onFocus.fire();
    }
    blur() {
        return this.textarea?.blur();
    }
    _handleTextAreaBlur() {
        this.textarea.value = "", this.refresh(this.buffer.y, this.buffer.y), this.coreService.decPrivateModes.sendFocus && this.coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[O"), this.element.classList.remove("focus"), this._onBlur.fire();
    }
    _syncTextArea() {
        if (!this.textarea || !this.buffer.isCursorInViewport || this._compositionHelper.isComposing || !this._renderService) return;
        let e = this.buffer.ybase + this.buffer.y, i = this.buffer.lines.get(e);
        if (!i) return;
        let r = Math.min(this.buffer.x, this.cols - 1), n = this._renderService.dimensions.css.cell.height, o = i.getWidth(r), l = this._renderService.dimensions.css.cell.width * o, a = this.buffer.y * this._renderService.dimensions.css.cell.height, u = r * this._renderService.dimensions.css.cell.width;
        this.textarea.style.left = u + "px", this.textarea.style.top = a + "px", this.textarea.style.width = l + "px", this.textarea.style.height = n + "px", this.textarea.style.lineHeight = n + "px", this.textarea.style.zIndex = "-5";
    }
    _initGlobal() {
        this._bindKeys(), this._register($5c2a9584e51cbabf$var$L(this.element, "copy", (i)=>{
            this.hasSelection() && $5c2a9584e51cbabf$var$Vs(i, this._selectionService);
        }));
        let e = (i)=>$5c2a9584e51cbabf$var$qs(i, this.textarea, this.coreService, this.optionsService);
        this._register($5c2a9584e51cbabf$var$L(this.textarea, "paste", e)), this._register($5c2a9584e51cbabf$var$L(this.element, "paste", e)), $5c2a9584e51cbabf$var$Ss ? this._register($5c2a9584e51cbabf$var$L(this.element, "mousedown", (i)=>{
            i.button === 2 && $5c2a9584e51cbabf$var$Pn(i, this.textarea, this.screenElement, this._selectionService, this.options.rightClickSelectsWord);
        })) : this._register($5c2a9584e51cbabf$var$L(this.element, "contextmenu", (i)=>{
            $5c2a9584e51cbabf$var$Pn(i, this.textarea, this.screenElement, this._selectionService, this.options.rightClickSelectsWord);
        })), $5c2a9584e51cbabf$var$Bi && this._register($5c2a9584e51cbabf$var$L(this.element, "auxclick", (i)=>{
            i.button === 1 && $5c2a9584e51cbabf$var$Mn(i, this.textarea, this.screenElement);
        }));
    }
    _bindKeys() {
        this._register($5c2a9584e51cbabf$var$L(this.textarea, "keyup", (e)=>this._keyUp(e), !0)), this._register($5c2a9584e51cbabf$var$L(this.textarea, "keydown", (e)=>this._keyDown(e), !0)), this._register($5c2a9584e51cbabf$var$L(this.textarea, "keypress", (e)=>this._keyPress(e), !0)), this._register($5c2a9584e51cbabf$var$L(this.textarea, "compositionstart", ()=>this._compositionHelper.compositionstart())), this._register($5c2a9584e51cbabf$var$L(this.textarea, "compositionupdate", (e)=>this._compositionHelper.compositionupdate(e))), this._register($5c2a9584e51cbabf$var$L(this.textarea, "compositionend", ()=>this._compositionHelper.compositionend())), this._register($5c2a9584e51cbabf$var$L(this.textarea, "input", (e)=>this._inputEvent(e), !0)), this._register(this.onRender(()=>this._compositionHelper.updateCompositionElements()));
    }
    open(e) {
        if (!e) throw new Error("Terminal requires a parent element.");
        if (e.isConnected || this._logService.debug("Terminal.open was called on an element that was not attached to the DOM"), this.element?.ownerDocument.defaultView && this._coreBrowserService) {
            this.element.ownerDocument.defaultView !== this._coreBrowserService.window && (this._coreBrowserService.window = this.element.ownerDocument.defaultView);
            return;
        }
        this._document = e.ownerDocument, this.options.documentOverride && this.options.documentOverride instanceof Document && (this._document = this.optionsService.rawOptions.documentOverride), this.element = this._document.createElement("div"), this.element.dir = "ltr", this.element.classList.add("terminal"), this.element.classList.add("xterm"), e.appendChild(this.element);
        let i = this._document.createDocumentFragment();
        this._viewportElement = this._document.createElement("div"), this._viewportElement.classList.add("xterm-viewport"), i.appendChild(this._viewportElement), this.screenElement = this._document.createElement("div"), this.screenElement.classList.add("xterm-screen"), this._register($5c2a9584e51cbabf$var$L(this.screenElement, "mousemove", (o)=>this.updateCursorStyle(o))), this._helperContainer = this._document.createElement("div"), this._helperContainer.classList.add("xterm-helpers"), this.screenElement.appendChild(this._helperContainer), i.appendChild(this.screenElement);
        let r = this.textarea = this._document.createElement("textarea");
        this.textarea.classList.add("xterm-helper-textarea"), this.textarea.setAttribute("aria-label", $5c2a9584e51cbabf$var$mi.get()), $5c2a9584e51cbabf$var$Ts || this.textarea.setAttribute("aria-multiline", "false"), this.textarea.setAttribute("autocorrect", "off"), this.textarea.setAttribute("autocapitalize", "off"), this.textarea.setAttribute("spellcheck", "false"), this.textarea.tabIndex = 0, this._register(this.optionsService.onSpecificOptionChange("disableStdin", ()=>r.readOnly = this.optionsService.rawOptions.disableStdin)), this.textarea.readOnly = this.optionsService.rawOptions.disableStdin, this._coreBrowserService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$Jr, this.textarea, e.ownerDocument.defaultView ?? window, this._document ?? typeof window < "u" ? window.document : null)), this._instantiationService.setService($5c2a9584e51cbabf$var$ae, this._coreBrowserService), this._register($5c2a9584e51cbabf$var$L(this.textarea, "focus", (o)=>this._handleTextAreaFocus(o))), this._register($5c2a9584e51cbabf$var$L(this.textarea, "blur", ()=>this._handleTextAreaBlur())), this._helperContainer.appendChild(this.textarea), this._charSizeService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$jt, this._document, this._helperContainer), this._instantiationService.setService($5c2a9584e51cbabf$var$nt, this._charSizeService), this._themeService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$ti), this._instantiationService.setService($5c2a9584e51cbabf$var$Re, this._themeService), this._characterJoinerService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$ct), this._instantiationService.setService($5c2a9584e51cbabf$var$or, this._characterJoinerService), this._renderService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$Qt, this.rows, this.screenElement)), this._instantiationService.setService($5c2a9584e51cbabf$var$ce, this._renderService), this._register(this._renderService.onRenderedViewportChange((o)=>this._onRender.fire(o))), this.onResize((o)=>this._renderService.resize(o.cols, o.rows)), this._compositionView = this._document.createElement("div"), this._compositionView.classList.add("composition-view"), this._compositionHelper = this._instantiationService.createInstance($5c2a9584e51cbabf$var$$t, this.textarea, this._compositionView), this._helperContainer.appendChild(this._compositionView), this._mouseService = this._instantiationService.createInstance($5c2a9584e51cbabf$var$Xt), this._instantiationService.setService($5c2a9584e51cbabf$var$Dt, this._mouseService);
        let n = this._linkifier.value = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$hi, this.screenElement));
        this.element.appendChild(i);
        try {
            this._onWillOpen.fire(this.element);
        } catch  {}
        this._renderService.hasRenderer() || this._renderService.setRenderer(this._createRenderer()), this._register(this.onCursorMove(()=>{
            this._renderService.handleCursorMove(), this._syncTextArea();
        })), this._register(this.onResize(()=>this._renderService.handleResize(this.cols, this.rows))), this._register(this.onBlur(()=>this._renderService.handleBlur())), this._register(this.onFocus(()=>this._renderService.handleFocus())), this._viewport = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$zt, this.element, this.screenElement)), this._register(this._viewport.onRequestScrollLines((o)=>{
            super.scrollLines(o, !1), this.refresh(0, this.rows - 1);
        })), this._selectionService = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$ei, this.element, this.screenElement, n)), this._instantiationService.setService($5c2a9584e51cbabf$var$Qs, this._selectionService), this._register(this._selectionService.onRequestScrollLines((o)=>this.scrollLines(o.amount, o.suppressScrollEvent))), this._register(this._selectionService.onSelectionChange(()=>this._onSelectionChange.fire())), this._register(this._selectionService.onRequestRedraw((o)=>this._renderService.handleSelectionChanged(o.start, o.end, o.columnSelectMode))), this._register(this._selectionService.onLinuxMouseSelection((o)=>{
            this.textarea.value = o, this.textarea.focus(), this.textarea.select();
        })), this._register($5c2a9584e51cbabf$var$$.any(this._onScroll.event, this._inputHandler.onScroll)(()=>{
            this._selectionService.refresh(), this._viewport?.queueSync();
        })), this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$Gt, this.screenElement)), this._register($5c2a9584e51cbabf$var$L(this.element, "mousedown", (o)=>this._selectionService.handleMouseDown(o))), this.coreMouseService.areMouseEventsActive ? (this._selectionService.disable(), this.element.classList.add("enable-mouse-events")) : this._selectionService.enable(), this.options.screenReaderMode && (this._accessibilityManager.value = this._instantiationService.createInstance($5c2a9584e51cbabf$var$Tt, this)), this._register(this.optionsService.onSpecificOptionChange("screenReaderMode", (o)=>this._handleScreenReaderModeOptionChange(o))), this.options.overviewRuler.width && (this._overviewRulerRenderer = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$bt, this._viewportElement, this.screenElement))), this.optionsService.onSpecificOptionChange("overviewRuler", (o)=>{
            !this._overviewRulerRenderer && o && this._viewportElement && this.screenElement && (this._overviewRulerRenderer = this._register(this._instantiationService.createInstance($5c2a9584e51cbabf$var$bt, this._viewportElement, this.screenElement)));
        }), this._charSizeService.measure(), this.refresh(0, this.rows - 1), this._initGlobal(), this.bindMouse();
    }
    _createRenderer() {
        return this._instantiationService.createInstance($5c2a9584e51cbabf$var$Yt, this, this._document, this.element, this.screenElement, this._viewportElement, this._helperContainer, this.linkifier);
    }
    bindMouse() {
        let e = this, i = this.element;
        function r(l) {
            let a = e._mouseService.getMouseReportCoords(l, e.screenElement);
            if (!a) return !1;
            let u, h;
            switch(l.overrideType || l.type){
                case "mousemove":
                    h = 32, l.buttons === void 0 ? (u = 3, l.button !== void 0 && (u = l.button < 3 ? l.button : 3)) : u = l.buttons & 1 ? 0 : l.buttons & 4 ? 1 : l.buttons & 2 ? 2 : 3;
                    break;
                case "mouseup":
                    h = 0, u = l.button < 3 ? l.button : 3;
                    break;
                case "mousedown":
                    h = 1, u = l.button < 3 ? l.button : 3;
                    break;
                case "wheel":
                    if (e._customWheelEventHandler && e._customWheelEventHandler(l) === !1) return !1;
                    let c = l.deltaY;
                    if (c === 0 || e.coreMouseService.consumeWheelEvent(l, e._renderService?.dimensions?.device?.cell?.height, e._coreBrowserService?.dpr) === 0) return !1;
                    h = c < 0 ? 0 : 1, u = 4;
                    break;
                default:
                    return !1;
            }
            return h === void 0 || u === void 0 || u > 4 ? !1 : e.coreMouseService.triggerMouseEvent({
                col: a.col,
                row: a.row,
                x: a.x,
                y: a.y,
                button: u,
                action: h,
                ctrl: l.ctrlKey,
                alt: l.altKey,
                shift: l.shiftKey
            });
        }
        let n = {
            mouseup: null,
            wheel: null,
            mousedrag: null,
            mousemove: null
        }, o = {
            mouseup: (l)=>(r(l), l.buttons || (this._document.removeEventListener("mouseup", n.mouseup), n.mousedrag && this._document.removeEventListener("mousemove", n.mousedrag)), this.cancel(l)),
            wheel: (l)=>(r(l), this.cancel(l, !0)),
            mousedrag: (l)=>{
                l.buttons && r(l);
            },
            mousemove: (l)=>{
                l.buttons || r(l);
            }
        };
        this._register(this.coreMouseService.onProtocolChange((l)=>{
            l ? (this.optionsService.rawOptions.logLevel === "debug" && this._logService.debug("Binding to mouse events:", this.coreMouseService.explainEvents(l)), this.element.classList.add("enable-mouse-events"), this._selectionService.disable()) : (this._logService.debug("Unbinding from mouse events."), this.element.classList.remove("enable-mouse-events"), this._selectionService.enable()), l & 8 ? n.mousemove || (i.addEventListener("mousemove", o.mousemove), n.mousemove = o.mousemove) : (i.removeEventListener("mousemove", n.mousemove), n.mousemove = null), l & 16 ? n.wheel || (i.addEventListener("wheel", o.wheel, {
                passive: !1
            }), n.wheel = o.wheel) : (i.removeEventListener("wheel", n.wheel), n.wheel = null), l & 2 ? n.mouseup || (n.mouseup = o.mouseup) : (this._document.removeEventListener("mouseup", n.mouseup), n.mouseup = null), l & 4 ? n.mousedrag || (n.mousedrag = o.mousedrag) : (this._document.removeEventListener("mousemove", n.mousedrag), n.mousedrag = null);
        })), this.coreMouseService.activeProtocol = this.coreMouseService.activeProtocol, this._register($5c2a9584e51cbabf$var$L(i, "mousedown", (l)=>{
            if (l.preventDefault(), this.focus(), !(!this.coreMouseService.areMouseEventsActive || this._selectionService.shouldForceSelection(l))) return r(l), n.mouseup && this._document.addEventListener("mouseup", n.mouseup), n.mousedrag && this._document.addEventListener("mousemove", n.mousedrag), this.cancel(l);
        })), this._register($5c2a9584e51cbabf$var$L(i, "wheel", (l)=>{
            if (!n.wheel) {
                if (this._customWheelEventHandler && this._customWheelEventHandler(l) === !1) return !1;
                if (!this.buffer.hasScrollback) {
                    if (l.deltaY === 0) return !1;
                    if (e.coreMouseService.consumeWheelEvent(l, e._renderService?.dimensions?.device?.cell?.height, e._coreBrowserService?.dpr) === 0) return this.cancel(l, !0);
                    let h = $5c2a9584e51cbabf$var$b.ESC + (this.coreService.decPrivateModes.applicationCursorKeys ? "O" : "[") + (l.deltaY < 0 ? "A" : "B");
                    return this.coreService.triggerDataEvent(h, !0), this.cancel(l, !0);
                }
            }
        }, {
            passive: !1
        }));
    }
    refresh(e, i) {
        this._renderService?.refreshRows(e, i);
    }
    updateCursorStyle(e) {
        this._selectionService?.shouldColumnSelect(e) ? this.element.classList.add("column-select") : this.element.classList.remove("column-select");
    }
    _showCursor() {
        this.coreService.isCursorInitialized || (this.coreService.isCursorInitialized = !0, this.refresh(this.buffer.y, this.buffer.y));
    }
    scrollLines(e, i) {
        this._viewport ? this._viewport.scrollLines(e) : super.scrollLines(e, i), this.refresh(0, this.rows - 1);
    }
    scrollPages(e) {
        this.scrollLines(e * (this.rows - 1));
    }
    scrollToTop() {
        this.scrollLines(-this._bufferService.buffer.ydisp);
    }
    scrollToBottom(e) {
        e && this._viewport ? this._viewport.scrollToLine(this.buffer.ybase, !0) : this.scrollLines(this._bufferService.buffer.ybase - this._bufferService.buffer.ydisp);
    }
    scrollToLine(e) {
        let i = e - this._bufferService.buffer.ydisp;
        i !== 0 && this.scrollLines(i);
    }
    paste(e) {
        $5c2a9584e51cbabf$var$Cn(e, this.textarea, this.coreService, this.optionsService);
    }
    attachCustomKeyEventHandler(e) {
        this._customKeyEventHandler = e;
    }
    attachCustomWheelEventHandler(e) {
        this._customWheelEventHandler = e;
    }
    registerLinkProvider(e) {
        return this._linkProviderService.registerLinkProvider(e);
    }
    registerCharacterJoiner(e) {
        if (!this._characterJoinerService) throw new Error("Terminal must be opened first");
        let i = this._characterJoinerService.register(e);
        return this.refresh(0, this.rows - 1), i;
    }
    deregisterCharacterJoiner(e) {
        if (!this._characterJoinerService) throw new Error("Terminal must be opened first");
        this._characterJoinerService.deregister(e) && this.refresh(0, this.rows - 1);
    }
    get markers() {
        return this.buffer.markers;
    }
    registerMarker(e) {
        return this.buffer.addMarker(this.buffer.ybase + this.buffer.y + e);
    }
    registerDecoration(e) {
        return this._decorationService.registerDecoration(e);
    }
    hasSelection() {
        return this._selectionService ? this._selectionService.hasSelection : !1;
    }
    select(e, i, r) {
        this._selectionService.setSelection(e, i, r);
    }
    getSelection() {
        return this._selectionService ? this._selectionService.selectionText : "";
    }
    getSelectionPosition() {
        if (!(!this._selectionService || !this._selectionService.hasSelection)) return {
            start: {
                x: this._selectionService.selectionStart[0],
                y: this._selectionService.selectionStart[1]
            },
            end: {
                x: this._selectionService.selectionEnd[0],
                y: this._selectionService.selectionEnd[1]
            }
        };
    }
    clearSelection() {
        this._selectionService?.clearSelection();
    }
    selectAll() {
        this._selectionService?.selectAll();
    }
    selectLines(e, i) {
        this._selectionService?.selectLines(e, i);
    }
    _keyDown(e) {
        if (this._keyDownHandled = !1, this._keyDownSeen = !0, this._customKeyEventHandler && this._customKeyEventHandler(e) === !1) return !1;
        let i = this.browser.isMac && this.options.macOptionIsMeta && e.altKey;
        if (!i && !this._compositionHelper.keydown(e)) return this.options.scrollOnUserInput && this.buffer.ybase !== this.buffer.ydisp && this.scrollToBottom(!0), !1;
        !i && (e.key === "Dead" || e.key === "AltGraph") && (this._unprocessedDeadKey = !0);
        let r = $5c2a9584e51cbabf$var$Il(e, this.coreService.decPrivateModes.applicationCursorKeys, this.browser.isMac, this.options.macOptionIsMeta);
        if (this.updateCursorStyle(e), r.type === 3 || r.type === 2) {
            let n = this.rows - 1;
            return this.scrollLines(r.type === 2 ? -n : n), this.cancel(e, !0);
        }
        if (r.type === 1 && this.selectAll(), this._isThirdLevelShift(this.browser, e) || (r.cancel && this.cancel(e, !0), !r.key) || e.key && !e.ctrlKey && !e.altKey && !e.metaKey && e.key.length === 1 && e.key.charCodeAt(0) >= 65 && e.key.charCodeAt(0) <= 90) return !0;
        if (this._unprocessedDeadKey) return this._unprocessedDeadKey = !1, !0;
        if ((r.key === $5c2a9584e51cbabf$var$b.ETX || r.key === $5c2a9584e51cbabf$var$b.CR) && (this.textarea.value = ""), this._onKey.fire({
            key: r.key,
            domEvent: e
        }), this._showCursor(), this.coreService.triggerDataEvent(r.key, !0), !this.optionsService.rawOptions.screenReaderMode || e.altKey || e.ctrlKey) return this.cancel(e, !0);
        this._keyDownHandled = !0;
    }
    _isThirdLevelShift(e, i) {
        let r = e.isMac && !this.options.macOptionIsMeta && i.altKey && !i.ctrlKey && !i.metaKey || e.isWindows && i.altKey && i.ctrlKey && !i.metaKey || e.isWindows && i.getModifierState("AltGraph");
        return i.type === "keypress" ? r : r && (!i.keyCode || i.keyCode > 47);
    }
    _keyUp(e) {
        this._keyDownSeen = !1, !(this._customKeyEventHandler && this._customKeyEventHandler(e) === !1) && ($5c2a9584e51cbabf$var$Tc(e) || this.focus(), this.updateCursorStyle(e), this._keyPressHandled = !1);
    }
    _keyPress(e) {
        let i;
        if (this._keyPressHandled = !1, this._keyDownHandled || this._customKeyEventHandler && this._customKeyEventHandler(e) === !1) return !1;
        if (this.cancel(e), e.charCode) i = e.charCode;
        else if (e.which === null || e.which === void 0) i = e.keyCode;
        else if (e.which !== 0 && e.charCode !== 0) i = e.which;
        else return !1;
        return !i || (e.altKey || e.ctrlKey || e.metaKey) && !this._isThirdLevelShift(this.browser, e) ? !1 : (i = String.fromCharCode(i), this._onKey.fire({
            key: i,
            domEvent: e
        }), this._showCursor(), this.coreService.triggerDataEvent(i, !0), this._keyPressHandled = !0, this._unprocessedDeadKey = !1, !0);
    }
    _inputEvent(e) {
        if (e.data && e.inputType === "insertText" && (!e.composed || !this._keyDownSeen) && !this.optionsService.rawOptions.screenReaderMode) {
            if (this._keyPressHandled) return !1;
            this._unprocessedDeadKey = !1;
            let i = e.data;
            return this.coreService.triggerDataEvent(i, !0), this.cancel(e), !0;
        }
        return !1;
    }
    resize(e, i) {
        if (e === this.cols && i === this.rows) {
            this._charSizeService && !this._charSizeService.hasValidSize && this._charSizeService.measure();
            return;
        }
        super.resize(e, i);
    }
    _afterResize(e, i) {
        this._charSizeService?.measure();
    }
    clear() {
        if (!(this.buffer.ybase === 0 && this.buffer.y === 0)) {
            this.buffer.clearAllMarkers(), this.buffer.lines.set(0, this.buffer.lines.get(this.buffer.ybase + this.buffer.y)), this.buffer.lines.length = 1, this.buffer.ydisp = 0, this.buffer.ybase = 0, this.buffer.y = 0;
            for(let e = 1; e < this.rows; e++)this.buffer.lines.push(this.buffer.getBlankLine($5c2a9584e51cbabf$var$X));
            this._onScroll.fire({
                position: this.buffer.ydisp
            }), this.refresh(0, this.rows - 1);
        }
    }
    reset() {
        this.options.rows = this.rows, this.options.cols = this.cols;
        let e = this._customKeyEventHandler;
        this._setup(), super.reset(), this._selectionService?.reset(), this._decorationService.reset(), this._customKeyEventHandler = e, this.refresh(0, this.rows - 1);
    }
    clearTextureAtlas() {
        this._renderService?.clearTextureAtlas();
    }
    _reportFocus() {
        this.element?.classList.contains("focus") ? this.coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[I") : this.coreService.triggerDataEvent($5c2a9584e51cbabf$var$b.ESC + "[O");
    }
    _reportWindowsOptions(e) {
        if (this._renderService) switch(e){
            case 0:
                let i = this._renderService.dimensions.css.canvas.width.toFixed(0), r = this._renderService.dimensions.css.canvas.height.toFixed(0);
                this.coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[4;${r};${i}t`);
                break;
            case 1:
                let n = this._renderService.dimensions.css.cell.width.toFixed(0), o = this._renderService.dimensions.css.cell.height.toFixed(0);
                this.coreService.triggerDataEvent(`${$5c2a9584e51cbabf$var$b.ESC}[6;${o};${n}t`);
                break;
        }
    }
    cancel(e, i) {
        if (!(!this.options.cancelEvents && !i)) return e.preventDefault(), e.stopPropagation(), !1;
    }
};
function $5c2a9584e51cbabf$var$Tc(s) {
    return s.keyCode === 16 || s.keyCode === 17 || s.keyCode === 18;
}
var $5c2a9584e51cbabf$var$xn = class {
    constructor(){
        this._addons = [];
    }
    dispose() {
        for(let t1 = this._addons.length - 1; t1 >= 0; t1--)this._addons[t1].instance.dispose();
    }
    loadAddon(t1, e) {
        let i = {
            instance: e,
            dispose: e.dispose,
            isDisposed: !1
        };
        this._addons.push(i), e.dispose = ()=>this._wrappedAddonDispose(i), e.activate(t1);
    }
    _wrappedAddonDispose(t1) {
        if (t1.isDisposed) return;
        let e = -1;
        for(let i = 0; i < this._addons.length; i++)if (this._addons[i] === t1) {
            e = i;
            break;
        }
        if (e === -1) throw new Error("Could not dispose an addon that has not been loaded");
        t1.isDisposed = !0, t1.dispose.apply(t1.instance), this._addons.splice(e, 1);
    }
};
var $5c2a9584e51cbabf$var$wn = class {
    constructor(t1){
        this._line = t1;
    }
    get isWrapped() {
        return this._line.isWrapped;
    }
    get length() {
        return this._line.length;
    }
    getCell(t1, e) {
        if (!(t1 < 0 || t1 >= this._line.length)) return e ? (this._line.loadCell(t1, e), e) : this._line.loadCell(t1, new $5c2a9584e51cbabf$var$q);
    }
    translateToString(t1, e, i) {
        return this._line.translateToString(t1, e, i);
    }
};
var $5c2a9584e51cbabf$var$Ji = class {
    constructor(t1, e){
        this._buffer = t1;
        this.type = e;
    }
    init(t1) {
        return this._buffer = t1, this;
    }
    get cursorY() {
        return this._buffer.y;
    }
    get cursorX() {
        return this._buffer.x;
    }
    get viewportY() {
        return this._buffer.ydisp;
    }
    get baseY() {
        return this._buffer.ybase;
    }
    get length() {
        return this._buffer.lines.length;
    }
    getLine(t1) {
        let e = this._buffer.lines.get(t1);
        if (e) return new $5c2a9584e51cbabf$var$wn(e);
    }
    getNullCell() {
        return new $5c2a9584e51cbabf$var$q;
    }
};
var $5c2a9584e51cbabf$var$Dn = class extends $5c2a9584e51cbabf$var$D {
    constructor(e){
        super();
        this._core = e;
        this._onBufferChange = this._register(new $5c2a9584e51cbabf$var$v);
        this.onBufferChange = this._onBufferChange.event;
        this._normal = new $5c2a9584e51cbabf$var$Ji(this._core.buffers.normal, "normal"), this._alternate = new $5c2a9584e51cbabf$var$Ji(this._core.buffers.alt, "alternate"), this._core.buffers.onBufferActivate(()=>this._onBufferChange.fire(this.active));
    }
    get active() {
        if (this._core.buffers.active === this._core.buffers.normal) return this.normal;
        if (this._core.buffers.active === this._core.buffers.alt) return this.alternate;
        throw new Error("Active buffer is neither normal nor alternate");
    }
    get normal() {
        return this._normal.init(this._core.buffers.normal);
    }
    get alternate() {
        return this._alternate.init(this._core.buffers.alt);
    }
};
var $5c2a9584e51cbabf$var$Rn = class {
    constructor(t1){
        this._core = t1;
    }
    registerCsiHandler(t1, e) {
        return this._core.registerCsiHandler(t1, (i)=>e(i.toArray()));
    }
    addCsiHandler(t1, e) {
        return this.registerCsiHandler(t1, e);
    }
    registerDcsHandler(t1, e) {
        return this._core.registerDcsHandler(t1, (i, r)=>e(i, r.toArray()));
    }
    addDcsHandler(t1, e) {
        return this.registerDcsHandler(t1, e);
    }
    registerEscHandler(t1, e) {
        return this._core.registerEscHandler(t1, e);
    }
    addEscHandler(t1, e) {
        return this.registerEscHandler(t1, e);
    }
    registerOscHandler(t1, e) {
        return this._core.registerOscHandler(t1, e);
    }
    addOscHandler(t1, e) {
        return this.registerOscHandler(t1, e);
    }
};
var $5c2a9584e51cbabf$var$Ln = class {
    constructor(t1){
        this._core = t1;
    }
    register(t1) {
        this._core.unicodeService.register(t1);
    }
    get versions() {
        return this._core.unicodeService.versions;
    }
    get activeVersion() {
        return this._core.unicodeService.activeVersion;
    }
    set activeVersion(t1) {
        this._core.unicodeService.activeVersion = t1;
    }
};
var $5c2a9584e51cbabf$var$Ic = [
    "cols",
    "rows"
], $5c2a9584e51cbabf$var$Ue = 0, $5c2a9584e51cbabf$export$8dd80f06eb58bfe1 = class extends $5c2a9584e51cbabf$var$D {
    constructor(t1){
        super(), this._core = this._register(new $5c2a9584e51cbabf$var$yn(t1)), this._addonManager = this._register(new $5c2a9584e51cbabf$var$xn), this._publicOptions = {
            ...this._core.options
        };
        let e = (r)=>this._core.options[r], i = (r, n)=>{
            this._checkReadonlyOptions(r), this._core.options[r] = n;
        };
        for(let r in this._core.options){
            let n = {
                get: e.bind(this, r),
                set: i.bind(this, r)
            };
            Object.defineProperty(this._publicOptions, r, n);
        }
    }
    _checkReadonlyOptions(t1) {
        if ($5c2a9584e51cbabf$var$Ic.includes(t1)) throw new Error(`Option "${t1}" can only be set in the constructor`);
    }
    _checkProposedApi() {
        if (!this._core.optionsService.rawOptions.allowProposedApi) throw new Error("You must set the allowProposedApi option to true to use proposed API");
    }
    get onBell() {
        return this._core.onBell;
    }
    get onBinary() {
        return this._core.onBinary;
    }
    get onCursorMove() {
        return this._core.onCursorMove;
    }
    get onData() {
        return this._core.onData;
    }
    get onKey() {
        return this._core.onKey;
    }
    get onLineFeed() {
        return this._core.onLineFeed;
    }
    get onRender() {
        return this._core.onRender;
    }
    get onResize() {
        return this._core.onResize;
    }
    get onScroll() {
        return this._core.onScroll;
    }
    get onSelectionChange() {
        return this._core.onSelectionChange;
    }
    get onTitleChange() {
        return this._core.onTitleChange;
    }
    get onWriteParsed() {
        return this._core.onWriteParsed;
    }
    get element() {
        return this._core.element;
    }
    get parser() {
        return this._parser || (this._parser = new $5c2a9584e51cbabf$var$Rn(this._core)), this._parser;
    }
    get unicode() {
        return this._checkProposedApi(), new $5c2a9584e51cbabf$var$Ln(this._core);
    }
    get textarea() {
        return this._core.textarea;
    }
    get rows() {
        return this._core.rows;
    }
    get cols() {
        return this._core.cols;
    }
    get buffer() {
        return this._buffer || (this._buffer = this._register(new $5c2a9584e51cbabf$var$Dn(this._core))), this._buffer;
    }
    get markers() {
        return this._checkProposedApi(), this._core.markers;
    }
    get modes() {
        let t1 = this._core.coreService.decPrivateModes, e = "none";
        switch(this._core.coreMouseService.activeProtocol){
            case "X10":
                e = "x10";
                break;
            case "VT200":
                e = "vt200";
                break;
            case "DRAG":
                e = "drag";
                break;
            case "ANY":
                e = "any";
                break;
        }
        return {
            applicationCursorKeysMode: t1.applicationCursorKeys,
            applicationKeypadMode: t1.applicationKeypad,
            bracketedPasteMode: t1.bracketedPasteMode,
            insertMode: this._core.coreService.modes.insertMode,
            mouseTrackingMode: e,
            originMode: t1.origin,
            reverseWraparoundMode: t1.reverseWraparound,
            sendFocusMode: t1.sendFocus,
            synchronizedOutputMode: t1.synchronizedOutput,
            wraparoundMode: t1.wraparound
        };
    }
    get options() {
        return this._publicOptions;
    }
    set options(t1) {
        for(let e in t1)this._publicOptions[e] = t1[e];
    }
    blur() {
        this._core.blur();
    }
    focus() {
        this._core.focus();
    }
    input(t1, e = !0) {
        this._core.input(t1, e);
    }
    resize(t1, e) {
        this._verifyIntegers(t1, e), this._core.resize(t1, e);
    }
    open(t1) {
        this._core.open(t1);
    }
    attachCustomKeyEventHandler(t1) {
        this._core.attachCustomKeyEventHandler(t1);
    }
    attachCustomWheelEventHandler(t1) {
        this._core.attachCustomWheelEventHandler(t1);
    }
    registerLinkProvider(t1) {
        return this._core.registerLinkProvider(t1);
    }
    registerCharacterJoiner(t1) {
        return this._checkProposedApi(), this._core.registerCharacterJoiner(t1);
    }
    deregisterCharacterJoiner(t1) {
        this._checkProposedApi(), this._core.deregisterCharacterJoiner(t1);
    }
    registerMarker(t1 = 0) {
        return this._verifyIntegers(t1), this._core.registerMarker(t1);
    }
    registerDecoration(t1) {
        return this._checkProposedApi(), this._verifyPositiveIntegers(t1.x ?? 0, t1.width ?? 0, t1.height ?? 0), this._core.registerDecoration(t1);
    }
    hasSelection() {
        return this._core.hasSelection();
    }
    select(t1, e, i) {
        this._verifyIntegers(t1, e, i), this._core.select(t1, e, i);
    }
    getSelection() {
        return this._core.getSelection();
    }
    getSelectionPosition() {
        return this._core.getSelectionPosition();
    }
    clearSelection() {
        this._core.clearSelection();
    }
    selectAll() {
        this._core.selectAll();
    }
    selectLines(t1, e) {
        this._verifyIntegers(t1, e), this._core.selectLines(t1, e);
    }
    dispose() {
        super.dispose();
    }
    scrollLines(t1) {
        this._verifyIntegers(t1), this._core.scrollLines(t1);
    }
    scrollPages(t1) {
        this._verifyIntegers(t1), this._core.scrollPages(t1);
    }
    scrollToTop() {
        this._core.scrollToTop();
    }
    scrollToBottom() {
        this._core.scrollToBottom();
    }
    scrollToLine(t1) {
        this._verifyIntegers(t1), this._core.scrollToLine(t1);
    }
    clear() {
        this._core.clear();
    }
    write(t1, e) {
        this._core.write(t1, e);
    }
    writeln(t1, e) {
        this._core.write(t1), this._core.write(`\r
`, e);
    }
    paste(t1) {
        this._core.paste(t1);
    }
    refresh(t1, e) {
        this._verifyIntegers(t1, e), this._core.refresh(t1, e);
    }
    reset() {
        this._core.reset();
    }
    clearTextureAtlas() {
        this._core.clearTextureAtlas();
    }
    loadAddon(t1) {
        this._addonManager.loadAddon(this, t1);
    }
    static get strings() {
        return {
            get promptLabel () {
                return $5c2a9584e51cbabf$var$mi.get();
            },
            set promptLabel (t){
                $5c2a9584e51cbabf$var$mi.set(t);
            },
            get tooMuchOutput () {
                return $5c2a9584e51cbabf$var$_i.get();
            },
            set tooMuchOutput (t){
                $5c2a9584e51cbabf$var$_i.set(t);
            }
        };
    }
    _verifyIntegers(...t1) {
        for ($5c2a9584e51cbabf$var$Ue of t1)if ($5c2a9584e51cbabf$var$Ue === 1 / 0 || isNaN($5c2a9584e51cbabf$var$Ue) || $5c2a9584e51cbabf$var$Ue % 1 !== 0) throw new Error("This API only accepts integers");
    }
    _verifyPositiveIntegers(...t1) {
        for ($5c2a9584e51cbabf$var$Ue of t1)if ($5c2a9584e51cbabf$var$Ue && ($5c2a9584e51cbabf$var$Ue === 1 / 0 || isNaN($5c2a9584e51cbabf$var$Ue) || $5c2a9584e51cbabf$var$Ue % 1 !== 0 || $5c2a9584e51cbabf$var$Ue < 0)) throw new Error("This API only accepts positive integers");
    }
};




var $cgCz9 = parcelRequire("cgCz9");
const $b4e14b6b8da86996$var$serialLib = !navigator.serial && navigator.usb ? (0, $55a31c8eb06014ca$export$6c2c9a00e27c07e8) : navigator.serial;
// ── DOM References ──────────────────────────────────────────
const $b4e14b6b8da86996$var$baudrates = document.getElementById("baudrates");
const $b4e14b6b8da86996$var$connectButton = document.getElementById("connectButton");
const $b4e14b6b8da86996$var$disconnectButton = document.getElementById("disconnectButton");
const $b4e14b6b8da86996$var$traceButton = document.getElementById("copyTraceButton");
const $b4e14b6b8da86996$var$resetButton = document.getElementById("resetButton");
const $b4e14b6b8da86996$var$monitorButton = document.getElementById("monitorButton");
const $b4e14b6b8da86996$var$consoleStopButton = document.getElementById("consoleStopButton");
const $b4e14b6b8da86996$var$eraseButton = document.getElementById("eraseButton");
const $b4e14b6b8da86996$var$eraseConfirmButton = document.getElementById("eraseConfirmButton");
const $b4e14b6b8da86996$var$addFileButton = document.getElementById("addFile");
const $b4e14b6b8da86996$var$programButton = document.getElementById("programButton");
const $b4e14b6b8da86996$var$terminalEl = document.getElementById("terminal");
const $b4e14b6b8da86996$var$lblConnTo = document.getElementById("lblConnTo");
const $b4e14b6b8da86996$var$table = document.getElementById("fileTable");
const $b4e14b6b8da86996$var$debugLogging = document.getElementById("debugLogging");
// Layout elements
const $b4e14b6b8da86996$var$welcomePanel = document.getElementById("welcomePanel");
const $b4e14b6b8da86996$var$connectedControls = document.getElementById("connectedControls");
const $b4e14b6b8da86996$var$footerBaud = document.getElementById("footerBaud");
const $b4e14b6b8da86996$var$footerConnLabel = document.getElementById("footerConnLabel");
// Sidebar elements
const $b4e14b6b8da86996$var$sidebarChip = document.getElementById("sidebarChip");
const $b4e14b6b8da86996$var$sidebarChipName = document.getElementById("sidebarChipName");
const $b4e14b6b8da86996$var$sidebarChipDesc = document.getElementById("sidebarChipDesc");
const $b4e14b6b8da86996$var$sidebarMac = document.getElementById("sidebarMac");
const $b4e14b6b8da86996$var$sidebarStatusDot = document.getElementById("sidebarStatusDot");
const $b4e14b6b8da86996$var$sidebarStatusLabel = document.getElementById("sidebarStatusLabel");
const $b4e14b6b8da86996$var$sidebarBaud = document.getElementById("sidebarBaud");
// Device info elements
const $b4e14b6b8da86996$var$deviceChip = document.getElementById("deviceChip");
const $b4e14b6b8da86996$var$deviceChipDesc = document.getElementById("deviceChipDesc");
const $b4e14b6b8da86996$var$deviceArchBadge = document.getElementById("deviceArchBadge");
const $b4e14b6b8da86996$var$deviceMac = document.getElementById("deviceMac");
const $b4e14b6b8da86996$var$deviceFeaturesList = document.getElementById("deviceFeaturesList");
const $b4e14b6b8da86996$var$deviceArch = document.getElementById("deviceArch");
const $b4e14b6b8da86996$var$deviceCores = document.getElementById("deviceCores");
const $b4e14b6b8da86996$var$deviceMaxFreq = document.getElementById("deviceMaxFreq");
const $b4e14b6b8da86996$var$deviceFlashSize = document.getElementById("deviceFlashSize");
const $b4e14b6b8da86996$var$deviceCrystal = document.getElementById("deviceCrystal");
const $b4e14b6b8da86996$var$deviceFlashId = document.getElementById("deviceFlashId");
const $b4e14b6b8da86996$var$deviceFlashMfr = document.getElementById("deviceFlashMfr");
const $b4e14b6b8da86996$var$deviceBootOffset = document.getElementById("deviceBootOffset");
const $b4e14b6b8da86996$var$deviceBaud = document.getElementById("deviceBaud");
const $b4e14b6b8da86996$var$deviceUsb = document.getElementById("deviceUsb");
const $b4e14b6b8da86996$var$deviceLoading = document.getElementById("deviceLoading");
// Drag and drop
const $b4e14b6b8da86996$var$dropZone = document.getElementById("dropZone");
const $b4e14b6b8da86996$var$dropZoneContent = document.getElementById("dropZoneContent");
const $b4e14b6b8da86996$var$dropZoneActive = document.getElementById("dropZoneActive");
// Terminal toolbar controls
const $b4e14b6b8da86996$var$termFontDecrease = document.getElementById("termFontDecrease");
const $b4e14b6b8da86996$var$termFontIncrease = document.getElementById("termFontIncrease");
const $b4e14b6b8da86996$var$termFontSizeDisplay = document.getElementById("termFontSizeDisplay");
const $b4e14b6b8da86996$var$termTimestampCb = document.getElementById("termTimestamp");
const $b4e14b6b8da86996$var$termAutoScrollCb = document.getElementById("termAutoScroll");
// ── Static chip lookup table ───────────────────────────────
const $b4e14b6b8da86996$var$CHIP_STATIC = {
    "ESP32": {
        arch: "Xtensa LX6",
        cores: 2,
        maxFreq: "240 MHz"
    },
    "ESP32-S2": {
        arch: "Xtensa LX7",
        cores: 1,
        maxFreq: "240 MHz"
    },
    "ESP32-S3": {
        arch: "Xtensa LX7",
        cores: 2,
        maxFreq: "240 MHz"
    },
    "ESP32-C2": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "120 MHz"
    },
    "ESP32-C3": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "160 MHz"
    },
    "ESP32-C5": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "240 MHz"
    },
    "ESP32-C6": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "160 MHz"
    },
    "ESP32-C61": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "160 MHz"
    },
    "ESP32-H2": {
        arch: "RISC-V",
        cores: 1,
        maxFreq: "96 MHz"
    },
    "ESP32-P4": {
        arch: "RISC-V",
        cores: 2,
        maxFreq: "400 MHz"
    },
    "ESP8266": {
        arch: "Xtensa L106",
        cores: 1,
        maxFreq: "160 MHz"
    }
};
const $b4e14b6b8da86996$var$FLASH_MANUFACTURERS = {
    0x01: "Cypress / Spansion",
    0x04: "Fujitsu",
    0x0B: "XMC",
    0x1C: "EON",
    0x1F: "Atmel",
    0x20: "Micron / ST",
    0x37: "AMIC",
    0x46: "XMC",
    0x5E: "Zbit",
    0x68: "BOYA",
    0x85: "Puya",
    0x9D: "ISSI",
    0xA1: "Fudan Micro",
    0xC2: "Macronix",
    0xC8: "GigaDevice",
    0xEF: "Winbond"
};
// ── Terminal Setup ──────────────────────────────────────────
const $b4e14b6b8da86996$var$term = new (0, $5c2a9584e51cbabf$export$8dd80f06eb58bfe1)({
    cols: 120,
    rows: 40,
    cursorBlink: true,
    cursorStyle: "block",
    fontSize: 14,
    theme: {
        background: "#1a1b26"
    }
});
$b4e14b6b8da86996$var$term.open($b4e14b6b8da86996$var$terminalEl);
// ── Terminal Options ─────────────────────────────────────────
let $b4e14b6b8da86996$var$termFontSize = 14;
let $b4e14b6b8da86996$var$showTimestamps = false;
let $b4e14b6b8da86996$var$autoScroll = true;
let $b4e14b6b8da86996$var$timestampLineStart = true; // track whether next byte starts a new line
function $b4e14b6b8da86996$var$setFontSize(size) {
    $b4e14b6b8da86996$var$termFontSize = Math.min(24, Math.max(10, size));
    $b4e14b6b8da86996$var$term.options.fontSize = $b4e14b6b8da86996$var$termFontSize;
    if ($b4e14b6b8da86996$var$termFontSizeDisplay) $b4e14b6b8da86996$var$termFontSizeDisplay.textContent = String($b4e14b6b8da86996$var$termFontSize);
}
function $b4e14b6b8da86996$var$writeToTerminal(data) {
    // Capture scroll position BEFORE write so we can restore it if auto-scroll is off.
    // xterm scrolls to bottom on every write; the write() callback fires after rendering.
    const savedViewportY = $b4e14b6b8da86996$var$term.buffer.active.viewportY;
    const flush = (output)=>{
        if ($b4e14b6b8da86996$var$autoScroll) $b4e14b6b8da86996$var$term.write(output, ()=>$b4e14b6b8da86996$var$term.scrollToBottom());
        else $b4e14b6b8da86996$var$term.write(output, ()=>$b4e14b6b8da86996$var$term.scrollToLine(savedViewportY));
    };
    if (!$b4e14b6b8da86996$var$showTimestamps) flush(data);
    else {
        const str = typeof data === "string" ? data : new TextDecoder().decode(data);
        const now = new Date();
        const ts = `\x1b[2m[${now.toTimeString().slice(0, 8)}]\x1b[0m `;
        let out = "";
        for (const ch of str){
            if ($b4e14b6b8da86996$var$timestampLineStart) {
                out += ts;
                $b4e14b6b8da86996$var$timestampLineStart = false;
            }
            out += ch;
            if (ch === "\n") $b4e14b6b8da86996$var$timestampLineStart = true;
        }
        flush(out);
    }
}
let $b4e14b6b8da86996$var$currentState = "idle";
let $b4e14b6b8da86996$var$currentTab = "terminal";
let $b4e14b6b8da86996$var$device = null;
let $b4e14b6b8da86996$var$transport;
let $b4e14b6b8da86996$var$chip = null;
let $b4e14b6b8da86996$var$esploader;
let $b4e14b6b8da86996$var$isConsoleClosed = false;
// ── Toast Notifications ─────────────────────────────────────
function $b4e14b6b8da86996$var$showToast(message, type = "info", duration = 4000) {
    const container = document.getElementById("toast-container");
    const colors = {
        success: "bg-green-600 text-white",
        error: "bg-red-600 text-white",
        info: "bg-gray-800 text-white dark:bg-gray-700"
    };
    const icons = {
        success: `<svg class="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>`,
        error: `<svg class="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/></svg>`,
        info: `<svg class="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/></svg>`
    };
    const toast = document.createElement("div");
    toast.className = `pointer-events-auto flex items-center gap-2 px-4 py-2.5 rounded-lg shadow-lg text-sm font-medium ${colors[type]} transform translate-x-full transition-transform duration-300 ease-out`;
    toast.innerHTML = `${icons[type]}<span>${message}</span>`;
    container.appendChild(toast);
    // Animate in
    requestAnimationFrame(()=>{
        toast.classList.remove("translate-x-full");
        toast.classList.add("translate-x-0");
    });
    // Auto-dismiss
    setTimeout(()=>{
        toast.classList.remove("translate-x-0");
        toast.classList.add("translate-x-full");
        setTimeout(()=>toast.remove(), 300);
    }, duration);
}
// ── Theme Toggle ────────────────────────────────────────────
// function initTheme() {
//   const stored = localStorage.getItem("esp-tool-theme");
//   const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
//   const isDark = stored ? stored === "dark" : prefersDark;
//   document.documentElement.classList.toggle("dark", isDark);
//   updateThemeIcons(isDark);
// }
// function updateThemeIcons(isDark: boolean) {
//   const iconDark = document.getElementById("themeIconDark");
//   const iconLight = document.getElementById("themeIconLight");
//   iconDark.classList.toggle("hidden", !isDark);
//   iconLight.classList.toggle("hidden", isDark);
// }
// themeToggle.onclick = () => {
//   const isDark = document.documentElement.classList.toggle("dark");
//   localStorage.setItem("esp-tool-theme", isDark ? "dark" : "light");
//   updateThemeIcons(isDark);
// };
// initTheme();
// ── Tab Switching ───────────────────────────────────────────
function $b4e14b6b8da86996$var$switchTab(tabName) {
    $b4e14b6b8da86996$var$currentTab = tabName;
    // Update sidebar nav buttons
    document.querySelectorAll(".sidebar-nav-btn").forEach((btn)=>{
        const isActive = btn.getAttribute("data-tab") === tabName;
        btn.classList.toggle("sidebar-nav-active", isActive);
    });
    // Update panels
    document.querySelectorAll(".tab-panel").forEach((panel)=>{
        const panelId = panel.id.replace("panel-", "");
        if (panelId === tabName) {
            panel.classList.remove("hidden");
            panel.classList.add("flex");
        } else {
            panel.classList.add("hidden");
            panel.classList.remove("flex");
        }
    });
    // Re-fit terminal when switching back to it
    if (tabName === "terminal") {
        setTimeout(()=>$b4e14b6b8da86996$var$term.refresh(0, $b4e14b6b8da86996$var$term.rows - 1), 50);
        // Auto-start monitor when switching to terminal while in connected state
        if ($b4e14b6b8da86996$var$currentState === "connected") {
            $b4e14b6b8da86996$var$startMonitor();
            return;
        }
    }
}
document.querySelectorAll(".sidebar-nav-btn").forEach((btn)=>{
    btn.onclick = ()=>{
        $b4e14b6b8da86996$var$switchTab(btn.getAttribute("data-tab"));
    };
});
// ── UI State Management ─────────────────────────────────────
function $b4e14b6b8da86996$var$setConnectionStatus(connected, label) {
    const footerDot = document.getElementById("connected-status");
    footerDot.classList.toggle("bg-red-500", !connected);
    footerDot.classList.toggle("bg-green-500", connected);
    $b4e14b6b8da86996$var$sidebarStatusDot.classList.toggle("bg-red-500", !connected);
    $b4e14b6b8da86996$var$sidebarStatusDot.classList.toggle("bg-green-500", connected);
    const text = label || (connected ? "Connected" : "Disconnected");
    $b4e14b6b8da86996$var$footerConnLabel.textContent = text;
    $b4e14b6b8da86996$var$sidebarStatusLabel.textContent = text;
}
/** Swap between hidden ↔ inline-flex so both display utilities never coexist */ function $b4e14b6b8da86996$var$showBtn(btn, visible) {
    if (visible) {
        btn.classList.remove("hidden");
        btn.classList.add("inline-flex");
    } else {
        btn.classList.add("hidden");
        btn.classList.remove("inline-flex");
    }
}
function $b4e14b6b8da86996$var$enterState(state) {
    $b4e14b6b8da86996$var$currentState = state;
    const isIdle = state === "idle";
    const isConnected = state === "connected";
    const isConsole = state === "console";
    // Welcome panel (shown when idle) - hide all tab panels when idle
    $b4e14b6b8da86996$var$welcomePanel.classList.toggle("hidden", !isIdle);
    $b4e14b6b8da86996$var$welcomePanel.classList.toggle("flex", isIdle);
    if (isIdle) document.querySelectorAll(".tab-panel").forEach((panel)=>{
        panel.classList.add("hidden");
        panel.classList.remove("flex");
    });
    // Sidebar: show chip info only when connected
    $b4e14b6b8da86996$var$sidebarChip.classList.toggle("hidden", isIdle);
    // Sidebar nav buttons: disabled when idle
    document.querySelectorAll(".sidebar-nav-btn").forEach((btn)=>{
        btn.disabled = isIdle;
        btn.classList.toggle("opacity-40", isIdle);
        btn.classList.toggle("pointer-events-none", isIdle);
    });
    // Connected controls container (trace, erase, reset)
    if (isConnected || isConsole) {
        $b4e14b6b8da86996$var$connectedControls.classList.remove("hidden");
        $b4e14b6b8da86996$var$connectedControls.classList.add("flex");
    } else {
        $b4e14b6b8da86996$var$connectedControls.classList.add("hidden");
        $b4e14b6b8da86996$var$connectedControls.classList.remove("flex");
    }
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$traceButton, isConnected);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$eraseButton, isConnected);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$monitorButton, isConnected);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$resetButton, isConsole);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$connectButton, isIdle);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$disconnectButton, isConnected);
    $b4e14b6b8da86996$var$showBtn($b4e14b6b8da86996$var$consoleStopButton, isConsole);
    // Footer / header status
    if (isIdle) {
        $b4e14b6b8da86996$var$lblConnTo.classList.add("hidden");
        document.getElementById("footerTagline")?.classList.remove("hidden");
        $b4e14b6b8da86996$var$footerBaud.classList.add("hidden");
        $b4e14b6b8da86996$var$sidebarBaud.classList.add("hidden");
        $b4e14b6b8da86996$var$setConnectionStatus(false);
    }
    $b4e14b6b8da86996$var$debugLogging.disabled = false; // always editable via settings dropdown
    if (!isIdle) $b4e14b6b8da86996$var$switchTab("device");
}
// ── Settings dropdown toggle ────────────────────────────────
const $b4e14b6b8da86996$var$settingsToggle = document.getElementById("settingsToggle");
const $b4e14b6b8da86996$var$settingsDropdown = document.getElementById("settingsDropdown");
$b4e14b6b8da86996$var$settingsToggle.addEventListener("click", (e)=>{
    e.stopPropagation();
    $b4e14b6b8da86996$var$settingsDropdown.classList.toggle("hidden");
});
document.addEventListener("click", (e)=>{
    if (!$b4e14b6b8da86996$var$settingsDropdown.contains(e.target) && e.target !== $b4e14b6b8da86996$var$settingsToggle) $b4e14b6b8da86996$var$settingsDropdown.classList.add("hidden");
});
$b4e14b6b8da86996$var$termFontDecrease.onclick = ()=>$b4e14b6b8da86996$var$setFontSize($b4e14b6b8da86996$var$termFontSize - 1);
$b4e14b6b8da86996$var$termFontIncrease.onclick = ()=>$b4e14b6b8da86996$var$setFontSize($b4e14b6b8da86996$var$termFontSize + 1);
$b4e14b6b8da86996$var$termTimestampCb.onchange = ()=>{
    $b4e14b6b8da86996$var$showTimestamps = $b4e14b6b8da86996$var$termTimestampCb.checked;
};
$b4e14b6b8da86996$var$termAutoScrollCb.onchange = ()=>{
    $b4e14b6b8da86996$var$autoScroll = $b4e14b6b8da86996$var$termAutoScrollCb.checked;
};
// ── ESP Loader Terminal Adapter ─────────────────────────────
const $b4e14b6b8da86996$var$espLoaderTerminal = {
    clean () {
        $b4e14b6b8da86996$var$term.clear();
    },
    writeLine (data) {
        $b4e14b6b8da86996$var$term.writeln(data);
    },
    write (data) {
        $b4e14b6b8da86996$var$term.write(data);
    }
};
// ── File Handling ───────────────────────────────────────────
function $b4e14b6b8da86996$var$handleFileSelect(evt) {
    const input = evt.target;
    const file = input.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev)=>{
        input.data = ev.target.result;
    };
    reader.readAsBinaryString(file);
}
// ── Add File Row ────────────────────────────────────────────
function $b4e14b6b8da86996$var$addFileRow(fileName, fileData) {
    const rowCount = $b4e14b6b8da86996$var$table.rows.length;
    const row = $b4e14b6b8da86996$var$table.insertRow(rowCount);
    // Column 1 - Offset
    const cell1 = row.insertCell(0);
    cell1.className = "pr-3 py-1.5";
    const offsetInput = document.createElement("input");
    offsetInput.type = "text";
    offsetInput.id = "offset" + rowCount;
    offsetInput.value = "0x1000";
    offsetInput.className = "w-full text-sm bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-1.5 text-gray-900 dark:text-white focus:ring-blue-500 focus:border-blue-500";
    cell1.appendChild(offsetInput);
    // Column 2 - File selector
    const cell2 = row.insertCell(1);
    cell2.className = "pr-3 py-1.5";
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.id = "selectFile" + rowCount;
    fileInput.name = "selected_File" + rowCount;
    fileInput.accept = ".bin,.img,.elf";
    fileInput.addEventListener("change", $b4e14b6b8da86996$var$handleFileSelect, false);
    fileInput.className = "w-full text-sm text-gray-500 dark:text-gray-400 file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 dark:file:bg-gray-700 dark:file:text-gray-300 hover:file:bg-blue-100";
    cell2.appendChild(fileInput);
    // If file data was provided (drag-and-drop), set it
    if (fileData && fileName) {
        fileInput.data = fileData;
        // Show file name in a label since we can't set file input value
        const label = document.createElement("span");
        label.className = "block text-xs text-gray-500 dark:text-gray-400 mt-1";
        label.textContent = fileName;
        cell2.appendChild(label);
    }
    // Column 3 - Progress
    const cell3 = row.insertCell(2);
    cell3.className = "py-1.5 text-center";
    cell3.style.display = "none";
    const progress = document.createElement("div");
    progress.className = "w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2";
    progress.innerHTML = `<div class="bg-blue-600 h-2 rounded-full transition-all duration-200" style="width: 0%"></div>`;
    cell3.appendChild(progress);
    // Column 4 - Remove
    const cell4 = row.insertCell(3);
    cell4.className = "py-1.5 text-center";
    if (rowCount > 1) {
        const removeBtn = document.createElement("button");
        removeBtn.type = "button";
        removeBtn.title = "Remove file";
        removeBtn.className = "p-1.5 rounded-md text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors";
        removeBtn.innerHTML = `<svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"/></svg>`;
        removeBtn.onclick = ()=>{
            const idx = Array.from($b4e14b6b8da86996$var$table.rows).indexOf(row);
            $b4e14b6b8da86996$var$table.deleteRow(idx);
        };
        cell4.appendChild(removeBtn);
    }
}
$b4e14b6b8da86996$var$addFileButton.onclick = ()=>$b4e14b6b8da86996$var$addFileRow();
// ── Drag and Drop ───────────────────────────────────────────
function $b4e14b6b8da86996$var$setupDragAndDrop() {
    let dragCounter = 0;
    $b4e14b6b8da86996$var$dropZone.addEventListener("dragenter", (e)=>{
        e.preventDefault();
        dragCounter++;
        $b4e14b6b8da86996$var$dropZoneContent.classList.add("hidden");
        $b4e14b6b8da86996$var$dropZoneActive.classList.remove("hidden");
        $b4e14b6b8da86996$var$dropZoneActive.classList.add("flex");
    });
    $b4e14b6b8da86996$var$dropZone.addEventListener("dragleave", (e)=>{
        e.preventDefault();
        dragCounter--;
        if (dragCounter === 0) {
            $b4e14b6b8da86996$var$dropZoneContent.classList.remove("hidden");
            $b4e14b6b8da86996$var$dropZoneActive.classList.add("hidden");
            $b4e14b6b8da86996$var$dropZoneActive.classList.remove("flex");
        }
    });
    $b4e14b6b8da86996$var$dropZone.addEventListener("dragover", (e)=>{
        e.preventDefault();
    });
    $b4e14b6b8da86996$var$dropZone.addEventListener("drop", (e)=>{
        e.preventDefault();
        dragCounter = 0;
        $b4e14b6b8da86996$var$dropZoneContent.classList.remove("hidden");
        $b4e14b6b8da86996$var$dropZoneActive.classList.add("hidden");
        $b4e14b6b8da86996$var$dropZoneActive.classList.remove("flex");
        const files = e.dataTransfer?.files;
        if (!files) return;
        for(let i = 0; i < files.length; i++){
            const file = files[i];
            if (!file.name.match(/\.(bin|img|elf)$/i)) {
                $b4e14b6b8da86996$var$showToast(`Skipped ${file.name} - only .bin, .img, .elf files`, "error");
                continue;
            }
            const reader = new FileReader();
            reader.onload = (ev)=>{
                $b4e14b6b8da86996$var$addFileRow(file.name, ev.target.result);
                $b4e14b6b8da86996$var$showToast(`Added ${file.name}`, "success", 2000);
            };
            reader.readAsBinaryString(file);
        }
    });
}
$b4e14b6b8da86996$var$setupDragAndDrop();
// ── Connect ─────────────────────────────────────────────────
$b4e14b6b8da86996$var$connectButton.onclick = async ()=>{
    try {
        if ($b4e14b6b8da86996$var$device === null) {
            $b4e14b6b8da86996$var$device = await $b4e14b6b8da86996$var$serialLib.requestPort({});
            $b4e14b6b8da86996$var$transport = new (0, $d59a45d20490e0bc$export$86495b081fef8e52)($b4e14b6b8da86996$var$device, true);
        }
        const loaderOptions = {
            transport: $b4e14b6b8da86996$var$transport,
            baudrate: parseInt($b4e14b6b8da86996$var$baudrates.value),
            terminal: $b4e14b6b8da86996$var$espLoaderTerminal,
            debugLogging: $b4e14b6b8da86996$var$debugLogging.checked
        };
        $b4e14b6b8da86996$var$esploader = new (0, $3dfdd479d6d4e3ee$export$b0f7a6c745790308)(loaderOptions);
        $b4e14b6b8da86996$var$chip = await $b4e14b6b8da86996$var$esploader.main();
        console.log("Settings done for: " + $b4e14b6b8da86996$var$chip);
        // Update UI state
        $b4e14b6b8da86996$var$enterState("connected");
        $b4e14b6b8da86996$var$setConnectionStatus(true, $b4e14b6b8da86996$var$chip);
        // Update footer
        $b4e14b6b8da86996$var$lblConnTo.textContent = $b4e14b6b8da86996$var$chip;
        $b4e14b6b8da86996$var$lblConnTo.classList.remove("hidden");
        document.getElementById("footerTagline")?.classList.add("hidden");
        $b4e14b6b8da86996$var$footerBaud.textContent = $b4e14b6b8da86996$var$baudrates.value + " baud";
        $b4e14b6b8da86996$var$footerBaud.classList.remove("hidden");
        // Set basic info immediately
        $b4e14b6b8da86996$var$deviceChip.textContent = $b4e14b6b8da86996$var$chip || "-";
        $b4e14b6b8da86996$var$deviceBaud.textContent = parseInt($b4e14b6b8da86996$var$baudrates.value).toLocaleString() + " bps";
        $b4e14b6b8da86996$var$showToast(`Connected to ${$b4e14b6b8da86996$var$chip}`, "success");
        // Fetch detailed device info in background
        $b4e14b6b8da86996$var$populateDeviceInfo();
    } catch (e) {
        console.error(e);
        $b4e14b6b8da86996$var$term.writeln(`Error: ${e.message}`);
        $b4e14b6b8da86996$var$showToast(`Connection failed: ${e.message}`, "error", 6000);
    }
};
// ── Populate device info panel ─────────────────────────────
async function $b4e14b6b8da86996$var$populateDeviceInfo() {
    $b4e14b6b8da86996$var$deviceLoading.classList.remove("hidden");
    $b4e14b6b8da86996$var$deviceLoading.classList.add("flex");
    try {
        const rom = $b4e14b6b8da86996$var$esploader.chip;
        // Chip description & variant
        const desc = await rom.getChipDescription($b4e14b6b8da86996$var$esploader);
        $b4e14b6b8da86996$var$deviceChipDesc.textContent = desc;
        // Architecture badge + static per-chip data
        const chipName = rom.CHIP_NAME;
        const staticInfo = $b4e14b6b8da86996$var$CHIP_STATIC[chipName];
        if (staticInfo) {
            $b4e14b6b8da86996$var$deviceArch.textContent = staticInfo.arch;
            $b4e14b6b8da86996$var$deviceCores.textContent = staticInfo.cores === 1 ? "1 (Single)" : `${staticInfo.cores} (Dual)`;
            $b4e14b6b8da86996$var$deviceMaxFreq.textContent = staticInfo.maxFreq;
            $b4e14b6b8da86996$var$deviceArchBadge.textContent = staticInfo.arch;
            $b4e14b6b8da86996$var$deviceArchBadge.classList.remove("hidden");
            $b4e14b6b8da86996$var$deviceArchBadge.classList.add("inline-flex");
        }
        // MAC address
        const mac = await rom.readMac($b4e14b6b8da86996$var$esploader);
        $b4e14b6b8da86996$var$deviceMac.textContent = mac;
        // Features as coloured badges
        const features = await rom.getChipFeatures($b4e14b6b8da86996$var$esploader);
        $b4e14b6b8da86996$var$deviceFeaturesList.innerHTML = features.map((f)=>`<span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400">${f}</span>`).join("");
        // Crystal frequency
        const xtal = await rom.getCrystalFreq($b4e14b6b8da86996$var$esploader);
        $b4e14b6b8da86996$var$deviceCrystal.textContent = xtal + " MHz";
        // Bootloader offset
        const offset = rom.BOOTLOADER_FLASH_OFFSET;
        $b4e14b6b8da86996$var$deviceBootOffset.textContent = `0x${offset.toString(16).toUpperCase()}`;
        // Flash ID → size + manufacturer
        try {
            const flashIdRaw = await $b4e14b6b8da86996$var$esploader.readFlashId();
            const mfrByte = flashIdRaw >> 16 & 0xff;
            const capacityByte = flashIdRaw & 0xff;
            const hexId = `0x${flashIdRaw.toString(16).toUpperCase().padStart(6, "0")}`;
            $b4e14b6b8da86996$var$deviceFlashId.textContent = hexId;
            const sizeStr = $b4e14b6b8da86996$var$esploader.DETECTED_FLASH_SIZES?.[capacityByte];
            $b4e14b6b8da86996$var$deviceFlashSize.textContent = sizeStr || "?";
            $b4e14b6b8da86996$var$deviceFlashMfr.textContent = $b4e14b6b8da86996$var$FLASH_MANUFACTURERS[mfrByte] || `Unknown (0x${mfrByte.toString(16).toUpperCase()})`;
        } catch  {
        // Flash ID read can fail on some configs - leave as -
        }
        // USB connection type (if available from port info)
        try {
            const portInfo = $b4e14b6b8da86996$var$device.getInfo?.();
            if (portInfo?.usbVendorId) $b4e14b6b8da86996$var$deviceUsb.textContent = `VID 0x${portInfo.usbVendorId.toString(16).toUpperCase()} / PID 0x${portInfo.usbProductId.toString(16).toUpperCase()}`;
        } catch  {
        // ignore
        }
        // Update sidebar with chip description + mac (reuse already-fetched values)
        $b4e14b6b8da86996$var$sidebarChipDesc.textContent = desc;
        $b4e14b6b8da86996$var$sidebarMac.textContent = mac;
    } catch (e) {
        console.warn("Device info fetch error:", e);
    } finally{
        $b4e14b6b8da86996$var$deviceLoading.classList.add("hidden");
        $b4e14b6b8da86996$var$deviceLoading.classList.remove("flex");
    }
}
// ── Disconnect ──────────────────────────────────────────────
$b4e14b6b8da86996$var$disconnectButton.onclick = async ()=>{
    if ($b4e14b6b8da86996$var$transport) await $b4e14b6b8da86996$var$transport.disconnect();
    $b4e14b6b8da86996$var$term.reset();
    $b4e14b6b8da86996$var$enterState("idle");
    $b4e14b6b8da86996$var$cleanUp();
    $b4e14b6b8da86996$var$showToast("Disconnected", "info", 2000);
};
// ── Trace ───────────────────────────────────────────────────
$b4e14b6b8da86996$var$traceButton.onclick = async ()=>{
    if ($b4e14b6b8da86996$var$transport) {
        $b4e14b6b8da86996$var$transport.returnTrace();
        $b4e14b6b8da86996$var$showToast("Trace copied", "success", 2000);
    }
};
// ── Reset ─────────────────────────────────────────────────
$b4e14b6b8da86996$var$resetButton.onclick = async ()=>{
    if ($b4e14b6b8da86996$var$transport) {
        // DTR → IO0 (keep HIGH = normal boot, not bootloader)
        // RTS → EN  (pull LOW to reset, then release)
        await $b4e14b6b8da86996$var$transport.setDTR(false); // IO0 = HIGH
        await $b4e14b6b8da86996$var$transport.setRTS(true); // EN  = LOW  (assert reset)
        await new Promise((resolve)=>setTimeout(resolve, 100));
        await $b4e14b6b8da86996$var$transport.setRTS(false); // EN  = HIGH (release reset)
        $b4e14b6b8da86996$var$showToast("ESP reset", "info", 2000);
    }
};
// ── Serial Monitor ──────────────────────────────────────
const $b4e14b6b8da86996$var$monitorEncoder = new TextEncoder();
let $b4e14b6b8da86996$var$monitorInputDispose = null;
const $b4e14b6b8da86996$var$serialInputBar = document.getElementById("serialInputBar");
const $b4e14b6b8da86996$var$serialInput = document.getElementById("serialInput");
const $b4e14b6b8da86996$var$serialSendBtn = document.getElementById("serialSendBtn");
async function $b4e14b6b8da86996$var$serialSend(text) {
    if (!text || !$b4e14b6b8da86996$var$device?.writable) return;
    const writer = $b4e14b6b8da86996$var$device.writable.getWriter();
    try {
        await writer.write($b4e14b6b8da86996$var$monitorEncoder.encode(text + "\n"));
    } finally{
        writer.releaseLock();
    }
}
$b4e14b6b8da86996$var$serialSendBtn.onclick = async ()=>{
    await $b4e14b6b8da86996$var$serialSend($b4e14b6b8da86996$var$serialInput.value);
    $b4e14b6b8da86996$var$serialInput.value = "";
    $b4e14b6b8da86996$var$serialInput.focus();
};
$b4e14b6b8da86996$var$serialInput.addEventListener("keydown", async (e)=>{
    if (e.key === "Enter") {
        await $b4e14b6b8da86996$var$serialSend($b4e14b6b8da86996$var$serialInput.value);
        $b4e14b6b8da86996$var$serialInput.value = "";
    }
});
async function $b4e14b6b8da86996$var$startMonitor() {
    try {
        $b4e14b6b8da86996$var$timestampLineStart = true; // reset timestamp state on (re)connect
        // Close the ESPLoader connection so we can reopen at monitor baud
        if ($b4e14b6b8da86996$var$transport) await $b4e14b6b8da86996$var$transport.disconnect();
        // Reconnect the same device at the configured baud rate
        $b4e14b6b8da86996$var$transport = new (0, $d59a45d20490e0bc$export$86495b081fef8e52)($b4e14b6b8da86996$var$device, true);
        const monitorBaud = parseInt($b4e14b6b8da86996$var$baudrates.value);
        await $b4e14b6b8da86996$var$transport.connect(monitorBaud);
        $b4e14b6b8da86996$var$enterState("console");
        $b4e14b6b8da86996$var$setConnectionStatus(true, $b4e14b6b8da86996$var$chip ? `${$b4e14b6b8da86996$var$chip} - Monitor` : "Monitor");
        $b4e14b6b8da86996$var$sidebarBaud.textContent = monitorBaud.toLocaleString() + " bps";
        $b4e14b6b8da86996$var$sidebarBaud.classList.remove("hidden");
        // Reset chip so user firmware runs (IO0 high = normal boot, RTS toggles EN)
        await $b4e14b6b8da86996$var$transport.setDTR(false); // IO0 = HIGH
        await $b4e14b6b8da86996$var$transport.setRTS(true); // EN  = LOW
        await new Promise((resolve)=>setTimeout(resolve, 100));
        await $b4e14b6b8da86996$var$transport.setRTS(false); // EN  = HIGH
        $b4e14b6b8da86996$var$isConsoleClosed = false;
        $b4e14b6b8da86996$var$switchTab("terminal");
        $b4e14b6b8da86996$var$showToast("Serial monitor started - type to send", "info", 2000);
        // Show input bar
        $b4e14b6b8da86996$var$serialInputBar.classList.remove("hidden");
        $b4e14b6b8da86996$var$serialInputBar.classList.add("flex");
        $b4e14b6b8da86996$var$serialInput.focus();
        // Wire keyboard input → raw serial write (bypass SLIP encoding)
        if ($b4e14b6b8da86996$var$monitorInputDispose) $b4e14b6b8da86996$var$monitorInputDispose.dispose();
        $b4e14b6b8da86996$var$monitorInputDispose = $b4e14b6b8da86996$var$term.onData(async (data)=>{
            if ($b4e14b6b8da86996$var$currentState !== "console" || !$b4e14b6b8da86996$var$device?.writable) return;
            const writer = $b4e14b6b8da86996$var$device.writable.getWriter();
            try {
                await writer.write($b4e14b6b8da86996$var$monitorEncoder.encode(data));
            } finally{
                writer.releaseLock();
            }
        });
        // Focus terminal so keypresses are captured immediately
        $b4e14b6b8da86996$var$term.focus();
        // Read loop
        while(!$b4e14b6b8da86996$var$isConsoleClosed){
            const readLoop = $b4e14b6b8da86996$var$transport.rawRead();
            const { value: value, done: done } = await readLoop.next();
            if (done || !value) break;
            $b4e14b6b8da86996$var$writeToTerminal(value);
        }
        $b4e14b6b8da86996$var$monitorInputDispose?.dispose();
        $b4e14b6b8da86996$var$monitorInputDispose = null;
        $b4e14b6b8da86996$var$serialInputBar.classList.add("hidden");
        $b4e14b6b8da86996$var$serialInputBar.classList.remove("flex");
        $b4e14b6b8da86996$var$serialInput.value = "";
        if (!$b4e14b6b8da86996$var$isConsoleClosed) {
            $b4e14b6b8da86996$var$enterState("idle");
            $b4e14b6b8da86996$var$cleanUp();
        }
    } catch (e) {
        console.error(e);
        $b4e14b6b8da86996$var$term.writeln(`\x1b[31mMonitor error: ${e.message}\x1b[0m`);
        $b4e14b6b8da86996$var$showToast(`Monitor error: ${e.message}`, "error");
        $b4e14b6b8da86996$var$monitorInputDispose?.dispose();
        $b4e14b6b8da86996$var$monitorInputDispose = null;
        $b4e14b6b8da86996$var$serialInputBar.classList.add("hidden");
        $b4e14b6b8da86996$var$serialInputBar.classList.remove("flex");
        $b4e14b6b8da86996$var$serialInput.value = "";
        $b4e14b6b8da86996$var$enterState("idle");
        $b4e14b6b8da86996$var$cleanUp();
    }
}
$b4e14b6b8da86996$var$monitorButton.onclick = ()=>$b4e14b6b8da86996$var$startMonitor();
// ── Device panel CTAs ───────────────────────────────────────
document.getElementById("ctaFlash")?.addEventListener("click", ()=>$b4e14b6b8da86996$var$switchTab("flash"));
document.getElementById("ctaMonitor")?.addEventListener("click", ()=>$b4e14b6b8da86996$var$switchTab("terminal"));
// ── Erase Flash ─────────────────────────────────────────────
$b4e14b6b8da86996$var$eraseConfirmButton?.addEventListener("click", async ()=>{
    try {
        $b4e14b6b8da86996$var$showToast("Erasing flash\u2026", "info", 10000);
        await $b4e14b6b8da86996$var$esploader.eraseFlash();
        $b4e14b6b8da86996$var$showToast("Flash erased successfully", "success");
    } catch (e) {
        console.error(e);
        $b4e14b6b8da86996$var$term.writeln(`Error: ${e.message}`);
        $b4e14b6b8da86996$var$showToast(`Erase failed: ${e.message}`, "error", 6000);
    }
});
// ── Stop Monitor ────────────────────────────────────────────
$b4e14b6b8da86996$var$consoleStopButton.onclick = async ()=>{
    $b4e14b6b8da86996$var$isConsoleClosed = true;
    $b4e14b6b8da86996$var$monitorInputDispose?.dispose();
    $b4e14b6b8da86996$var$monitorInputDispose = null;
    $b4e14b6b8da86996$var$serialInputBar.classList.add("hidden");
    $b4e14b6b8da86996$var$serialInputBar.classList.remove("flex");
    $b4e14b6b8da86996$var$serialInput.value = "";
    if ($b4e14b6b8da86996$var$transport) {
        await $b4e14b6b8da86996$var$transport.disconnect();
        await $b4e14b6b8da86996$var$transport.waitForUnlock(1500);
    }
    $b4e14b6b8da86996$var$term.reset();
    $b4e14b6b8da86996$var$enterState("idle");
    $b4e14b6b8da86996$var$cleanUp();
    $b4e14b6b8da86996$var$showToast("Monitor stopped", "info", 2000);
};
// ── Cleanup ─────────────────────────────────────────────────
function $b4e14b6b8da86996$var$cleanUp() {
    $b4e14b6b8da86996$var$device = null;
    $b4e14b6b8da86996$var$transport = null;
    $b4e14b6b8da86996$var$chip = null;
    // Reset device info panel
    const dash = "-";
    $b4e14b6b8da86996$var$deviceChip.textContent = dash;
    $b4e14b6b8da86996$var$deviceChipDesc.textContent = dash;
    $b4e14b6b8da86996$var$deviceMac.textContent = dash;
    $b4e14b6b8da86996$var$deviceFeaturesList.innerHTML = `<span class="text-sm text-gray-400 dark:text-gray-500">-</span>`;
    $b4e14b6b8da86996$var$deviceArch.textContent = dash;
    $b4e14b6b8da86996$var$deviceCores.textContent = dash;
    $b4e14b6b8da86996$var$deviceMaxFreq.textContent = dash;
    $b4e14b6b8da86996$var$deviceFlashSize.textContent = dash;
    $b4e14b6b8da86996$var$deviceCrystal.textContent = dash;
    $b4e14b6b8da86996$var$deviceFlashId.textContent = dash;
    $b4e14b6b8da86996$var$deviceFlashMfr.textContent = dash;
    $b4e14b6b8da86996$var$deviceBootOffset.textContent = dash;
    $b4e14b6b8da86996$var$deviceBaud.textContent = dash;
    $b4e14b6b8da86996$var$deviceUsb.textContent = dash;
    $b4e14b6b8da86996$var$deviceArchBadge.classList.add("hidden");
    $b4e14b6b8da86996$var$deviceArchBadge.classList.remove("inline-flex");
    // Reset sidebar chip info
    $b4e14b6b8da86996$var$sidebarChipName.textContent = "";
    $b4e14b6b8da86996$var$sidebarChipDesc.textContent = "";
    $b4e14b6b8da86996$var$sidebarMac.textContent = "";
}
// ── Program Button Disable/Enable ───────────────────────────
function $b4e14b6b8da86996$var$disableButton(element, disable) {
    element.disabled = disable;
    element.classList.toggle("opacity-50", disable);
    element.classList.toggle("cursor-not-allowed", disable);
    element.classList.toggle("pointer-events-none", disable);
}
// ── Validate Program Inputs ─────────────────────────────────
function $b4e14b6b8da86996$var$validateProgramInputs() {
    const offsetArr = [];
    const rowCount = $b4e14b6b8da86996$var$table.rows.length;
    for(let index = 1; index < rowCount; index++){
        const row = $b4e14b6b8da86996$var$table.rows[index];
        const offSetObj = row.cells[0].childNodes[0];
        const offset = parseInt(offSetObj.value);
        if (Number.isNaN(offset)) return `Offset in row ${index} is not a valid address`;
        if (offsetArr.includes(offset)) return `Offset in row ${index} is already in use`;
        offsetArr.push(offset);
        const fileObj = row.cells[1].childNodes[0];
        if (!fileObj.data) return `No file selected for row ${index}`;
    }
    return "success";
}
// ── Program ─────────────────────────────────────────────────
$b4e14b6b8da86996$var$programButton.onclick = async ()=>{
    const err = $b4e14b6b8da86996$var$validateProgramInputs();
    if (err !== "success") {
        $b4e14b6b8da86996$var$showToast(err, "error", 5000);
        return;
    }
    $b4e14b6b8da86996$var$disableButton($b4e14b6b8da86996$var$programButton, true);
    $b4e14b6b8da86996$var$disableButton($b4e14b6b8da86996$var$addFileButton, true);
    $b4e14b6b8da86996$var$table.style.pointerEvents = "none";
    const fileArray = [];
    const progressBars = [];
    for(let index = 1; index < $b4e14b6b8da86996$var$table.rows.length; index++){
        const row = $b4e14b6b8da86996$var$table.rows[index];
        const offSetObj = row.cells[0].childNodes[0];
        const offset = parseInt(offSetObj.value);
        const fileObj = row.cells[1].childNodes[0];
        // Show progress bar
        row.cells[2].style.display = "table-cell";
        row.cells[3].style.display = "none";
        const progressBarInner = row.cells[2].querySelector(".bg-blue-600");
        progressBarInner.style.width = "0%";
        progressBars.push(progressBarInner);
        fileArray.push({
            data: fileObj.data,
            address: offset
        });
    }
    let flashedOk = false;
    try {
        $b4e14b6b8da86996$var$showToast("Flashing\u2026", "info", 30000);
        const flashOptions = {
            fileArray: fileArray,
            flashSize: "keep",
            eraseAll: false,
            compress: true,
            reportProgress: (fileIndex, written, total)=>{
                const pct = Math.round(written / total * 100);
                progressBars[fileIndex].style.width = pct + "%";
            },
            calculateMD5Hash: (image)=>(0, (/*@__PURE__*/$parcel$interopDefault($cgCz9))).MD5((0, (/*@__PURE__*/$parcel$interopDefault($cgCz9))).enc.Latin1.parse(image))
        };
        await $b4e14b6b8da86996$var$esploader.writeFlash(flashOptions);
        await $b4e14b6b8da86996$var$esploader.after();
        $b4e14b6b8da86996$var$showToast("Flashed successfully! Starting monitor\u2026", "success", 4000);
        flashedOk = true;
    } catch (e) {
        console.error(e);
        $b4e14b6b8da86996$var$term.writeln(`Error: ${e.message}`);
        $b4e14b6b8da86996$var$showToast(`Flash failed: ${e.message}`, "error", 8000);
    } finally{
        for(let index = 1; index < $b4e14b6b8da86996$var$table.rows.length; index++){
            $b4e14b6b8da86996$var$table.rows[index].cells[2].style.display = "none";
            $b4e14b6b8da86996$var$table.rows[index].cells[3].style.display = "table-cell";
        }
        $b4e14b6b8da86996$var$disableButton($b4e14b6b8da86996$var$programButton, false);
        $b4e14b6b8da86996$var$disableButton($b4e14b6b8da86996$var$addFileButton, false);
        $b4e14b6b8da86996$var$table.style.pointerEvents = "all";
        // Auto-start serial monitor after successful flash
        if (flashedOk) $b4e14b6b8da86996$var$startMonitor();
    }
};
// ── Initialize ──────────────────────────────────────────────
document.getElementById("connectButtonWelcome")?.addEventListener("click", ()=>$b4e14b6b8da86996$var$connectButton.click());
$b4e14b6b8da86996$var$enterState("idle");
$b4e14b6b8da86996$var$addFileRow(); // Add initial file row


//# sourceMappingURL=typescript.ae4f6193.js.map
